import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Long: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

/** A connection to a list of items. */
export type AllProjectsConnection = {
  __typename?: 'AllProjectsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AllProjectsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AllProjectsEdge = {
  __typename?: 'AllProjectsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

/** A connection to a list of items. */
export type ArchivedItemsConnection = {
  __typename?: 'ArchivedItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ArchivedItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ArchivedItemsEdge = {
  __typename?: 'ArchivedItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Tag>;
};

/** A connection to a list of items. */
export type ArchivedTagListConnection = {
  __typename?: 'ArchivedTagListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ArchivedTagListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ArchivedTagListEdge = {
  __typename?: 'ArchivedTagListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Tag>;
};

/** A connection to a list of items. */
export type AssignedRequestsConnection = {
  __typename?: 'AssignedRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AssignedRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContentVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AssignedRequestsEdge = {
  __typename?: 'AssignedRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentVersion>;
};

/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type Attachment = {
  __typename?: 'Attachment';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Returns a pre-signed download URL for this attachment, valid for 168 hours (7 days). */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The file extension (e.g., '.rfa', '.png'). */
  extension?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the attachment, used as the blob storage key. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Attachment>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The file name without extension. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type AttachmentAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type AttachmentCreateArgs = {
  item?: InputMaybe<AttachmentInput>;
};


/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type AttachmentDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type AttachmentDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type AttachmentItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type AttachmentItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AttachmentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<AttachmentFilterInput>;
};


/** A file attachment stored in blob storage, such as a Revit family file or thumbnail image. */
export type AttachmentSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AttachmentFilterInput = {
  and?: InputMaybe<Array<AttachmentFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AttachmentFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type AttachmentInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type AttachmentListConnection = {
  __typename?: 'AttachmentListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AttachmentListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Attachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AttachmentListEdge = {
  __typename?: 'AttachmentListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Attachment>;
};

export type AttachmentSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  extension?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type Classification = {
  __typename?: 'Classification';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** The classification code (e.g., 'Ss_25_10_30' for Uniclass). */
  code?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The primary group within the classification system. */
  group?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the classification. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Classification>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the classification entry. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** The secondary sub-group within the classification system. */
  subGroup?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The official title of the classification entry. */
  title?: Maybe<Scalars['String']['output']>;
  /** Retrieves the classification system type this entry belongs to. */
  type?: Maybe<ClassificationType>;
  /** The ID of the classification type/system this entry belongs to. */
  typeId?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type ClassificationAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type ClassificationCreateArgs = {
  item?: InputMaybe<ClassificationInput>;
};


/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type ClassificationDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type ClassificationDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type ClassificationItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type ClassificationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClassificationSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ClassificationFilterInput>;
};


/** A classification entry conforming to a classification system (e.g., Uniclass, OmniClass), used to categorize content by industry standards. */
export type ClassificationSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClassificationFilterInput = {
  and?: InputMaybe<Array<ClassificationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClassificationFilterInput>>;
  subGroup?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  typeId?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type ClassificationInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subGroup?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type ClassificationListConnection = {
  __typename?: 'ClassificationListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClassificationListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Classification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClassificationListEdge = {
  __typename?: 'ClassificationListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Classification>;
};

export type ClassificationSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  subGroup?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  typeId?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationType = {
  __typename?: 'ClassificationType';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the classification type. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<ClassificationType>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the classification system. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationTypeAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationTypeCreateArgs = {
  item?: InputMaybe<ClassificationTypeInput>;
};


/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationTypeDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationTypeDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationTypeItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationTypeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClassificationTypeSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ClassificationTypeFilterInput>;
};


/** A classification system type (e.g., 'Uniclass 2015', 'OmniClass') that groups classification entries. */
export type ClassificationTypeSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClassificationTypeFilterInput = {
  and?: InputMaybe<Array<ClassificationTypeFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClassificationTypeFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type ClassificationTypeInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type ClassificationTypeListConnection = {
  __typename?: 'ClassificationTypeListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClassificationTypeListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClassificationType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClassificationTypeListEdge = {
  __typename?: 'ClassificationTypeListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClassificationType>;
};

export type ClassificationTypeSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A client organization that owns libraries, projects, and manages users. */
export type Client = {
  __typename?: 'Client';
  /** List of user IDs who are administrators of this client. */
  adminIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the users who are administrators of this client. */
  admins?: Maybe<Array<Maybe<User>>>;
  /** Assigns health checks to multiple clients. Supports overwriting existing assignments. Requires system admin access. */
  assignHealthChecks?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Retrieves the default content library for this client. */
  defaultLibrary?: Maybe<Library>;
  /** The ID of the default content library for this client. */
  defaultLibraryId?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes users from the client admin list. Requires client admin access. */
  deleteAdmins?: Maybe<Scalars['Float']['output']>;
  /** Removes health check assignments from this client. Requires client admin access. */
  deleteHealthChecks?: Maybe<Scalars['Float']['output']>;
  /** Deletes libraries and all their content and versions from this client. Requires client admin access. */
  deleteLibraries?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this client. Requires client admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** Removes workset configurations from this client. Requires client admin access. */
  deleteWorksets?: Maybe<Scalars['Float']['output']>;
  /** A free-text description of the client. */
  description?: Maybe<Scalars['String']['output']>;
  /** List of health check IDs assigned to this client. */
  healthCheckIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the health check entities assigned to this client. */
  healthChecks?: Maybe<Array<Maybe<HealthCheck>>>;
  /** The unique identifier of the client. */
  id?: Maybe<Scalars['String']['output']>;
  /** Returns whether the current authenticated user is an admin of this client. */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this client is private. Private clients are only visible to their admins. */
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Client>;
  /** Retrieves all clients. Non-admin users only see public clients and clients they administer. */
  items?: Maybe<ItemsConnection>;
  /** The full/formal name of the client organization. */
  longName?: Maybe<Scalars['String']['output']>;
  /** The short display name of the client organization. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds a user as an admin of this client. Requires client admin access. */
  setAdmin?: Maybe<Scalars['Float']['output']>;
  /** Sets the default content library for this client. Requires client admin access. */
  setDefaultLibrary?: Maybe<Scalars['Float']['output']>;
  /** Updates the description of this client. Requires client admin access. */
  setDescription?: Maybe<Scalars['Float']['output']>;
  /** Updates the full/formal name of this client. Requires client admin access. */
  setLongName?: Maybe<Scalars['Float']['output']>;
  /** Updates the short name of this client. Requires client admin access. */
  setName?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this client. Requires client admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** Adds a workset configuration to this client. Requires client admin access. */
  setWorkset?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Toggles the private visibility of this client. Requires client admin access. */
  togglePrivate?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** Workset definitions configured for this client. */
  worksets?: Maybe<Array<Maybe<Workset>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientAssignHealthChecksArgs = {
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientCreateArgs = {
  item?: InputMaybe<ClientInput>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientDeleteAdminsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientDeleteHealthChecksArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientDeleteLibrariesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientDeleteWorksetsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClientSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ClientFilterInput>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientSetAdminArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientSetDefaultLibraryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientSetDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientSetLongNameArgs = {
  longName?: InputMaybe<Scalars['String']['input']>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A client organization that owns libraries, projects, and manages users. */
export type ClientSetWorksetArgs = {
  workset?: InputMaybe<WorksetInput>;
};

export type ClientFilterInput = {
  adminIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<ClientFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  defaultLibraryId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  healthCheckIds?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isPrivate?: InputMaybe<BooleanOperationFilterInput>;
  longName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ClientFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
  worksets?: InputMaybe<ListFilterInputTypeOfWorksetFilterInput>;
};

export type ClientInput = {
  adminIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  defaultLibraryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
  worksets?: InputMaybe<Array<InputMaybe<WorksetInput>>>;
};

/** A connection to a list of items. */
export type ClientListConnection = {
  __typename?: 'ClientListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClientListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Client>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClientListEdge = {
  __typename?: 'ClientListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Client>;
};

export type ClientSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  defaultLibraryId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPrivate?: InputMaybe<SortEnumType>;
  longName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type CloseContentRequestInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  resolution: RequestResolutionEnum;
};

/** A command definition used in parameter mappings for content placement. */
export type Command = {
  __typename?: 'Command';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the command. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Command>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the command. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The command type classification. */
  type?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A command definition used in parameter mappings for content placement. */
export type CommandAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A command definition used in parameter mappings for content placement. */
export type CommandCreateArgs = {
  item?: InputMaybe<CommandInput>;
};


/** A command definition used in parameter mappings for content placement. */
export type CommandDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A command definition used in parameter mappings for content placement. */
export type CommandDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A command definition used in parameter mappings for content placement. */
export type CommandItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A command definition used in parameter mappings for content placement. */
export type CommandItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommandSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<CommandFilterInput>;
};


/** A command definition used in parameter mappings for content placement. */
export type CommandSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CommandFilterInput = {
  and?: InputMaybe<Array<CommandFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommandFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type CommandInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type CommandListConnection = {
  __typename?: 'CommandListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CommandListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Command>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CommandListEdge = {
  __typename?: 'CommandListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Command>;
};

export type CommandSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type ComparableNullableOfInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type Content = {
  __typename?: 'Content';
  /** Retrieves the BIM application name from the current version. */
  applicationName?: Maybe<Scalars['String']['output']>;
  /** Retrieves the distinct list of application names across all current content versions. */
  applicationNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assigns classification IDs to the specified content items. Requires content admin access. */
  assignClassifications?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the distinct list of content categories across all current content versions. */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the category from the current version, falling back to the content-level category. */
  category?: Maybe<Scalars['String']['output']>;
  /** List of classification IDs assigned to this content for standards-based categorization. */
  classificationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the classifications assigned to this content. */
  classifications?: Maybe<Array<Maybe<Classification>>>;
  /** Retrieves all content items using a client secret for service-to-service authentication. Does not require user auth. */
  contents?: Maybe<ContentsConnection>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new content item in the specified library. Requires admin or library admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  /** The ID of the user who created this content. */
  createdById?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp (seconds) of when this content was created. */
  createdTime?: Maybe<Scalars['String']['output']>;
  currentRequestId?: Maybe<Scalars['String']['output']>;
  /** The ID of the currently active content version. */
  currentVersionId?: Maybe<Scalars['String']['output']>;
  /** Deletes content items and all their versions. Requires system admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes related content items from this content. Requires content admin access. */
  deleteRelatedContents?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this content item. Requires content admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** Removes content type variants by their IDs from the current version. Requires content admin access. */
  deleteTypes?: Maybe<Scalars['Float']['output']>;
  /** A free-text description of the content item. */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the download URL for the family file attachment from the current version. */
  familyFile?: Maybe<Scalars['String']['output']>;
  /** Retrieves the file attachment from the current version. */
  file?: Maybe<Attachment>;
  /** List of group IDs this content is associated with. */
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the groups this content is associated with. */
  groups?: Maybe<Array<Maybe<Group>>>;
  /** The unique identifier of the content item. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves the IFC entity classification from the current version. */
  ifcEntity?: Maybe<Ifc>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Content>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** Retrieves the library this content belongs to. */
  library?: Maybe<Library>;
  /** The ID of the library this content belongs to. */
  libraryId?: Maybe<Scalars['String']['output']>;
  /** Retrieves the parameter mapping associated with this content. Currently returns null. */
  map?: Maybe<Map>;
  /** The display name of the content item. */
  name?: Maybe<Scalars['String']['output']>;
  /** Retrieves the IFC properties associated with this content. Currently returns an empty list. */
  properties?: Maybe<Array<Maybe<IfcProperty>>>;
  /** List of content IDs that are related to this content item. */
  relatedContentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the content items related to this content, including items that reference this content in their related list. */
  relatedContents?: Maybe<Array<Maybe<Content>>>;
  /** Records a file download request and returns a pre-signed URL for the current version's attachment. */
  requestFileDownload?: Maybe<Scalars['String']['output']>;
  /** Updates the application name on the current version of this content item. Requires system admin access. */
  setApplicationName?: Maybe<Scalars['Float']['output']>;
  /** Updates the content description. */
  setDescription?: Maybe<Scalars['Float']['output']>;
  /** Uploads a new file attachment for the current version. Returns a pre-signed upload URL. Requires content admin access. */
  setFile?: Maybe<Scalars['String']['output']>;
  /** Updates the display name of this content item. Requires content admin access. */
  setName?: Maybe<Scalars['Float']['output']>;
  /** Links other content items to this content. Requires content admin access. */
  setRelatedContents?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this content item. Requires content admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** Uploads a new thumbnail for the current version. Returns a pre-signed upload URL. Requires content admin access. */
  setThumbnail?: Maybe<Scalars['String']['output']>;
  /** Adds a new content type variant to the current version. Requires content admin access. */
  setType?: Maybe<ContentType>;
  /** Updates the description of a specific content type variant. Requires content admin access. */
  setTypeDescription?: Maybe<Scalars['Float']['output']>;
  /** Updates the name of a specific content type variant. Requires content admin access. */
  setTypeName?: Maybe<Scalars['Float']['output']>;
  /** Updates the settings JSON of a specific content type variant. Requires content admin access. */
  setTypeSettings?: Maybe<Scalars['Float']['output']>;
  /** Uploads a new thumbnail for a content type variant. Returns a pre-signed upload URL. Requires content admin access. */
  setTypeThumbnail?: Maybe<Scalars['String']['output']>;
  /** Retrieves the settings JSON from the current version. */
  settings?: Maybe<Scalars['String']['output']>;
  /** Retrieves the distinct list of content sub-categories across all current content versions. */
  subCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The secondary category classification for finer grouping. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** List of tag IDs used for filtering and categorization. */
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the thumbnail image attachment from the current version. */
  thumbnail?: Maybe<Attachment>;
  /** Retrieves the content type variants from the current version. */
  types?: Maybe<Array<Maybe<ContentType>>>;
  /** Retrieves the Uniclass classification from the current version. */
  uniclass?: Maybe<Uniclass>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  /** The ID of the user who last updated this content. */
  updatedById?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp (seconds) of the last update. */
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** The number of times this content item has been accessed or placed. */
  usageCount?: Maybe<Scalars['Int']['output']>;
  /** Retrieves the VBIS classification from the current version. */
  vBIS?: Maybe<Vbis>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentAssignClassificationsArgs = {
  classificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  secret?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentFilterInput>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentCreateArgs = {
  item?: InputMaybe<ContentInput>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentDeleteRelatedContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentDeleteTypesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentFilterInput>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetApplicationNameArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetFileArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetRelatedContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetThumbnailArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetTypeArgs = {
  type?: InputMaybe<ContentTypeInput>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetTypeDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetTypeNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetTypeSettingsArgs = {
  settings?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};


/** A content item within a library, representing a BIM object or component that can be placed in a project. */
export type ContentSetTypeThumbnailArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentFilterInput = {
  and?: InputMaybe<Array<ContentFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  classificationIds?: InputMaybe<ListStringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  currentRequestId?: InputMaybe<StringOperationFilterInput>;
  currentVersionId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  groupIds?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libraryId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContentFilterInput>>;
  relatedContentIds?: InputMaybe<ListStringOperationFilterInput>;
  subCategory?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
  usageCount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ContentInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  classificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  currentRequestId?: InputMaybe<Scalars['String']['input']>;
  currentVersionId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relatedContentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
  usageCount?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type ContentListConnection = {
  __typename?: 'ContentListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentListEdge = {
  __typename?: 'ContentListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

export enum ContentRequestTypeEnum {
  EditContent = 'EDIT_CONTENT',
  General = 'GENERAL',
  NewContent = 'NEW_CONTENT'
}

export type ContentSortInput = {
  category?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  currentRequestId?: InputMaybe<SortEnumType>;
  currentVersionId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libraryId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  subCategory?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
  usageCount?: InputMaybe<SortEnumType>;
};

/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentType = {
  __typename?: 'ContentType';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the IFC entity classification for this type. */
  iFCEntityId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of this content type. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<ContentType>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of this content type variant. */
  name?: Maybe<Scalars['String']['output']>;
  /** Updates the content type description. */
  setDescription?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** JSON string of type-specific settings/parameters. */
  settings?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The thumbnail image for this content type variant. */
  thumbnail?: Maybe<Attachment>;
  /** The ID of the Uniclass classification for this type. */
  uniclassId?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** The ID of the VBIS classification for this type. */
  vBISId?: Maybe<Scalars['String']['output']>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeCreateArgs = {
  item?: InputMaybe<ContentTypeInput>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentTypeSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentTypeFilterInput>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeSetDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** A variant or type within a content item, representing different configurations (e.g., different door sizes). */
export type ContentTypeSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentTypeFilterInput = {
  and?: InputMaybe<Array<ContentTypeFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  iFCEntityId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContentTypeFilterInput>>;
  settings?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  thumbnail?: InputMaybe<AttachmentFilterInput>;
  uniclassId?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
  vBISId?: InputMaybe<StringOperationFilterInput>;
};

export type ContentTypeInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iFCEntityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail?: InputMaybe<AttachmentInput>;
  uniclassId?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
  vBISId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type ContentTypeListConnection = {
  __typename?: 'ContentTypeListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentTypeListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContentType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentTypeListEdge = {
  __typename?: 'ContentTypeListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentType>;
};

export type ContentTypeSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  iFCEntityId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<SortEnumType>;
  thumbnail?: InputMaybe<AttachmentSortInput>;
  uniclassId?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
  vBISId?: InputMaybe<SortEnumType>;
};

/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersion = {
  __typename?: 'ContentVersion';
  /** Adds a history entry to this content version. */
  addHistory?: Maybe<Scalars['Float']['output']>;
  /** Adds tag IDs to a specific history entry within this content version. */
  addHistoryTags?: Maybe<Scalars['Float']['output']>;
  /** The BIM application this version targets (e.g., 'Revit', 'ArchiCAD'). */
  applicationName?: Maybe<Scalars['String']['output']>;
  /** Assigns a modeller to a verified request and moves it to InDevelopment status. Requires resource manager access. */
  assignResourceToRequest?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves requests currently assigned to the authenticated user. */
  assignedRequests?: Maybe<AssignedRequestsConnection>;
  /** Retrieves the user currently assigned to this request. */
  assignedTo?: Maybe<User>;
  assignedToId?: Maybe<Scalars['String']['output']>;
  /** The file attachment (e.g., Revit family file) for this version. */
  attachment?: Maybe<Attachment>;
  baseVersionId?: Maybe<Scalars['String']['output']>;
  /** Whether the current user explicitly administers this request's assigned library and can perform its current approval-stage action. */
  canApprove: Scalars['Boolean']['output'];
  /** The primary category classification for this version. */
  category?: Maybe<Scalars['String']['output']>;
  /** Retrieves the client organization this version was created for. */
  client?: Maybe<Client>;
  /** The ID of the client organization this version was created for. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Closes an open request. Only an administrator of its library may close it. */
  closeRequest?: Maybe<Scalars['String']['output']>;
  /** Retrieves the library administrator who closed this request. */
  closedBy?: Maybe<User>;
  closedById?: Maybe<Scalars['String']['output']>;
  closedTime?: Maybe<Scalars['String']['output']>;
  /** Retrieves the parent content item this version belongs to. */
  content?: Maybe<Content>;
  /** The ID of the parent content item this version belongs to. */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Creates an open content request assigned to the submitting user. */
  createRequest?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Deletes history entries from a ContentVersion by their IDs. Requires admin access. */
  deleteHistories?: Maybe<Scalars['Float']['output']>;
  /** Permanently deletes a request and clears its edit-request pointer from Content. Requires system admin access. */
  deleteRequest: Scalars['Boolean']['output'];
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** A description of this version or the request rationale. */
  description?: Maybe<Scalars['String']['output']>;
  /** Retrieves the modeller who developed this content. */
  developedBy?: Maybe<User>;
  /** The ID of the modeller assigned to develop this request. */
  developedById?: Maybe<Scalars['String']['output']>;
  /** The engineering discipline this version applies to. */
  discipline?: Maybe<DisciplineEnum>;
  /** Edits requester-controlled fields without changing the request's client or library assignment. */
  editRequest?: Maybe<Scalars['String']['output']>;
  /** Performs a final review on a request. Fast-tracks submitted requests or completes the workflow for developed requests. */
  finalReviewRequest?: Maybe<Scalars['Float']['output']>;
  /** The audit trail of workflow actions performed on this version. */
  histories?: Maybe<Array<Maybe<History>>>;
  /** The ID of the IFC entity classification assigned to this version. */
  iFCEntityId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of this content version. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves the IFC entity classification for this version. */
  ifcEntity?: Maybe<IfcEntity>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<ContentVersion>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** Retrieves the library this version belongs to. */
  library?: Maybe<Library>;
  /** The ID of the library this version belongs to. */
  libraryId?: Maybe<Scalars['String']['output']>;
  /** The ID of the parameter mapping associated with this version. */
  mapId?: Maybe<Scalars['String']['output']>;
  /** Advances a content version from InDevelopment to Developed status. Use after uploading the developed file directly to blob storage via a SAS URL. Throws if the version is not currently InDevelopment. */
  markDeveloped?: Maybe<Scalars['Float']['output']>;
  /** Retrieves content requests submitted by the current user. */
  myRequests?: Maybe<MyRequestsConnection>;
  /** The name of this content version. */
  name?: Maybe<Scalars['String']['output']>;
  /** Retrieves the union of requests actionable through library administration, resource management, or modeller assignment. */
  needActionRequests?: Maybe<NeedActionRequestsConnection>;
  /** Retrieves all open requests. */
  pendingRequests?: Maybe<PendingRequestsConnection>;
  /** Returns the count of all open requests. */
  pendingRequestsCount?: Maybe<Scalars['Long']['output']>;
  /** Reassigns an open request. Requires administration of the request's library. */
  reassignRequest?: Maybe<Scalars['String']['output']>;
  /** Recovers a rejected request by moving it back to Submitted status. */
  recoverRequest?: Maybe<Scalars['Float']['output']>;
  /** Rejects a request, moving it back to the previous workflow stage based on its current status. */
  rejectRequest?: Maybe<Scalars['Float']['output']>;
  requestType?: Maybe<ContentRequestTypeEnum>;
  /** Retrieves all content requests with optional filtering by state and discipline. */
  requests?: Maybe<RequestsConnection>;
  /** Returns the total count of requests, optionally filtered by state and discipline. */
  requestsCount?: Maybe<Scalars['Long']['output']>;
  resolution?: Maybe<RequestResolutionEnum>;
  /** Retrieves the user who performed the final review. */
  reviewedBy?: Maybe<User>;
  /** The ID of the user who performed the final review/approval. */
  reviewedById?: Maybe<Scalars['String']['output']>;
  /** Updates the target application name for this content version. */
  setApplicationName?: Maybe<Scalars['Float']['output']>;
  /** Uploads a file attachment to this content version and returns the attachment details. */
  setAttachment?: Maybe<Attachment>;
  /** Registers a named attachment on this content version and returns a SAS PUT URL for direct upload to blob storage. */
  setAttachmentUrl?: Maybe<Scalars['String']['output']>;
  /** Updates the primary category of this content version. */
  setCategory?: Maybe<Scalars['Float']['output']>;
  /** Registers a named attachment on a specific history entry and returns a SAS PUT URL for direct upload to blob storage. */
  setHistoryAttachmentUrl?: Maybe<Scalars['String']['output']>;
  /** Updates the settings JSON of this content version. */
  setSettings?: Maybe<Scalars['Float']['output']>;
  /** Updates the sub-category of this content version. */
  setSubCategory?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** JSON string of content settings/configuration for this version. */
  settings?: Maybe<Scalars['String']['output']>;
  state?: Maybe<RequestStateEnum>;
  /** The current workflow status of this content version request. */
  status?: Maybe<RequestStatusEnum>;
  /** The secondary category classification for this version. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** Adds a generated file as a new request history entry and latest working attachment without closing the request. */
  submitDraft?: Maybe<SubmitDraftPayload>;
  /** Retrieves the user who submitted this request. */
  submittedBy?: Maybe<User>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Assigns an open request to the current library administrator. */
  takeOwnership?: Maybe<Scalars['String']['output']>;
  /** The thumbnail image for this version. */
  thumbnail?: Maybe<Attachment>;
  /** The list of content type variants defined in this version. */
  types?: Maybe<Array<Maybe<ContentType>>>;
  /** Retrieves the Uniclass classification for this version. */
  uniclass?: Maybe<Uniclass>;
  /** The ID of the Uniclass classification assigned to this version. */
  uniclassId?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** Uploads a developed file to a request and moves it to Developed status. */
  uploadAttachmentToRequest?: Maybe<Scalars['Float']['output']>;
  /** Uploads a file attachment to a specific history entry within this content version. */
  uploadHistoryAttachment?: Maybe<Attachment>;
  /** Retrieves the VBIS classification for this version. */
  vBIS?: Maybe<Vbis>;
  /** The ID of the VBIS classification assigned to this version. */
  vBISId?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who verified this request. */
  verifiedBy?: Maybe<User>;
  /** The ID of the user who verified this request. */
  verifiedById?: Maybe<Scalars['String']['output']>;
  /** Marks a submitted content request as verified. Requires explicit administration of its assigned library. */
  verifyRequest?: Maybe<Scalars['Float']['output']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionAddHistoryArgs = {
  history?: InputMaybe<HistoryInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionAddHistoryTagsArgs = {
  historyId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionAssignResourceToRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modeller?: InputMaybe<UserInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionAssignedRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionCloseRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CloseContentRequestInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionCreateArgs = {
  item?: InputMaybe<ContentVersionInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionCreateRequestArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<CreateContentRequestInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionDeleteHistoriesArgs = {
  contentVersionId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionDeleteRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionEditRequestArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<EditContentRequestInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionFinalReviewRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionMarkDevelopedArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionMyRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionNeedActionRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  status?: InputMaybe<RequestStatusEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionPendingRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionReassignRequestArgs = {
  assignedToId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionRecoverRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionRejectRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionRequestsCountArgs = {
  discipline?: InputMaybe<DisciplineEnum>;
  state?: InputMaybe<RequestStateEnum>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetApplicationNameArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetAttachmentArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetAttachmentUrlArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetCategoryArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetHistoryAttachmentUrlArgs = {
  historyId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetSettingsArgs = {
  settings?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetSubCategoryArgs = {
  subCategory?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionSubmitDraftArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionTakeOwnershipArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionUploadAttachmentToRequestArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionUploadHistoryAttachmentArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  historyId?: InputMaybe<Scalars['String']['input']>;
};


/** A specific version of a content item, tracking its lifecycle through the request/approval workflow. */
export type ContentVersionVerifyRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type ContentVersionFilterInput = {
  and?: InputMaybe<Array<ContentVersionFilterInput>>;
  applicationName?: InputMaybe<StringOperationFilterInput>;
  assignedToId?: InputMaybe<StringOperationFilterInput>;
  attachment?: InputMaybe<AttachmentFilterInput>;
  baseVersionId?: InputMaybe<StringOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  closedById?: InputMaybe<StringOperationFilterInput>;
  closedTime?: InputMaybe<StringOperationFilterInput>;
  contentId?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  developedById?: InputMaybe<StringOperationFilterInput>;
  discipline?: InputMaybe<NullableOfDisciplineEnumOperationFilterInput>;
  histories?: InputMaybe<ListFilterInputTypeOfHistoryFilterInput>;
  iFCEntityId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libraryId?: InputMaybe<StringOperationFilterInput>;
  mapId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContentVersionFilterInput>>;
  requestType?: InputMaybe<NullableOfContentRequestTypeEnumOperationFilterInput>;
  resolution?: InputMaybe<NullableOfRequestResolutionEnumOperationFilterInput>;
  reviewedById?: InputMaybe<StringOperationFilterInput>;
  settings?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<NullableOfRequestStateEnumOperationFilterInput>;
  status?: InputMaybe<NullableOfRequestStatusEnumOperationFilterInput>;
  subCategory?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  thumbnail?: InputMaybe<AttachmentFilterInput>;
  types?: InputMaybe<ListFilterInputTypeOfContentTypeFilterInput>;
  uniclassId?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
  vBISId?: InputMaybe<StringOperationFilterInput>;
  verifiedById?: InputMaybe<StringOperationFilterInput>;
};

export type ContentVersionInput = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<AttachmentInput>;
  baseVersionId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  closedById?: InputMaybe<Scalars['String']['input']>;
  closedTime?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developedById?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  histories?: InputMaybe<Array<InputMaybe<HistoryInput>>>;
  iFCEntityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<ContentRequestTypeEnum>;
  resolution?: InputMaybe<RequestResolutionEnum>;
  reviewedById?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<RequestStateEnum>;
  status?: InputMaybe<RequestStatusEnum>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail?: InputMaybe<AttachmentInput>;
  types?: InputMaybe<Array<InputMaybe<ContentTypeInput>>>;
  uniclassId?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
  vBISId?: InputMaybe<Scalars['String']['input']>;
  verifiedById?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type ContentVersionListConnection = {
  __typename?: 'ContentVersionListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentVersionListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContentVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentVersionListEdge = {
  __typename?: 'ContentVersionListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentVersion>;
};

export type ContentVersionSortInput = {
  applicationName?: InputMaybe<SortEnumType>;
  assignedToId?: InputMaybe<SortEnumType>;
  attachment?: InputMaybe<AttachmentSortInput>;
  baseVersionId?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  clientId?: InputMaybe<SortEnumType>;
  closedById?: InputMaybe<SortEnumType>;
  closedTime?: InputMaybe<SortEnumType>;
  contentId?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  developedById?: InputMaybe<SortEnumType>;
  discipline?: InputMaybe<SortEnumType>;
  iFCEntityId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libraryId?: InputMaybe<SortEnumType>;
  mapId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  requestType?: InputMaybe<SortEnumType>;
  resolution?: InputMaybe<SortEnumType>;
  reviewedById?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subCategory?: InputMaybe<SortEnumType>;
  thumbnail?: InputMaybe<AttachmentSortInput>;
  uniclassId?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
  vBISId?: InputMaybe<SortEnumType>;
  verifiedById?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ContentsBySecretConnection = {
  __typename?: 'ContentsBySecretConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentsBySecretEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentsBySecretEdge = {
  __typename?: 'ContentsBySecretEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

/** A connection to a list of items. */
export type ContentsConnection = {
  __typename?: 'ContentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentsEdge = {
  __typename?: 'ContentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

/** A connection to a list of items. */
export type ContentsWithSecretConnection = {
  __typename?: 'ContentsWithSecretConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentsWithSecretEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentsWithSecretEdge = {
  __typename?: 'ContentsWithSecretEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

export type CreateContentRequestInput = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  iFCEntityId?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requestType?: InputMaybe<ContentRequestTypeEnum>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uniclassId?: InputMaybe<Scalars['String']['input']>;
  vBISId?: InputMaybe<Scalars['String']['input']>;
};

/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContent = {
  __typename?: 'CustomContent';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the content item this custom configuration is for. */
  content?: Maybe<Content>;
  /** The ID of the content item this configuration overrides. */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Retrieves a specific custom content type configuration by its ID. */
  customContentType?: Maybe<CustomContentType>;
  /** Custom content type configurations that override default type settings. */
  customContentTypes?: Maybe<Array<Maybe<CustomContentType>>>;
  /** JSON string of custom settings that override the default content settings. */
  customSettings?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes custom content type configurations by their IDs. Requires custom content admin access. */
  deleteCustomContentTypes?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the custom content configuration. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<CustomContent>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The ID of the library this configuration belongs to. */
  libraryId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Adds custom content type configurations. Requires custom content admin access. */
  setCustomContentTypes?: Maybe<Scalars['Float']['output']>;
  /** Updates the custom settings JSON for this content override. Requires custom content admin access. */
  setCustomSettings?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentCreateArgs = {
  item?: InputMaybe<CustomContentInput>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentCustomContentTypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentDeleteCustomContentTypesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomContentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<CustomContentFilterInput>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentSetCustomContentTypesArgs = {
  customContentTypes?: InputMaybe<Array<InputMaybe<CustomContentTypeInput>>>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentSetCustomSettingsArgs = {
  settings?: InputMaybe<Scalars['String']['input']>;
};


/** A custom configuration override for a content item within a library, allowing library-specific settings. */
export type CustomContentSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomContentFilterInput = {
  and?: InputMaybe<Array<CustomContentFilterInput>>;
  contentId?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  customContentTypes?: InputMaybe<ListFilterInputTypeOfCustomContentTypeFilterInput>;
  customSettings?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libraryId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomContentFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type CustomContentInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  customContentTypes?: InputMaybe<Array<InputMaybe<CustomContentTypeInput>>>;
  customSettings?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

export type CustomContentSortInput = {
  contentId?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  customSettings?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libraryId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentType = {
  __typename?: 'CustomContentType';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the content item this custom type configuration is for. */
  content?: Maybe<Content>;
  /** The ID of the parent content item. */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Retrieves the original content type this configuration overrides. */
  contentType?: Maybe<ContentType>;
  /** The ID of the content type this configuration overrides. */
  contentTypeId?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** JSON string of custom settings that override the default content type settings. */
  customSettings?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the custom content type configuration. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<CustomContentType>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  name?: Maybe<Scalars['String']['output']>;
  /** Updates the custom settings JSON for this content type override. Requires system admin access. */
  setCustomSettings?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeCreateArgs = {
  item?: InputMaybe<CustomContentTypeInput>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomContentTypeSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<CustomContentTypeFilterInput>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeSetCustomSettingsArgs = {
  settings?: InputMaybe<Scalars['String']['input']>;
};


/** A custom configuration override for a specific content type variant within a library. */
export type CustomContentTypeSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomContentTypeFilterInput = {
  and?: InputMaybe<Array<CustomContentTypeFilterInput>>;
  contentId?: InputMaybe<StringOperationFilterInput>;
  contentTypeId?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  customSettings?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomContentTypeFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type CustomContentTypeInput = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentTypeId?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  customSettings?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

export type CustomContentTypeSortInput = {
  contentId?: InputMaybe<SortEnumType>;
  contentTypeId?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  customSettings?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** System-wide default settings, including the default client and library for new projects. */
export type Default = {
  __typename?: 'Default';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the default client organization. */
  client?: Maybe<Client>;
  /** The ID of the default client assigned to newly created projects. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The fixed identifier for the system defaults (singleton). */
  id?: Maybe<Scalars['String']['output']>;
  /** Whether the project sub-name feature is enabled system-wide. */
  isProjSubNameEnabled: Scalars['Boolean']['output'];
  /** Retrieves the system-wide default settings. Creates defaults if they don't exist. */
  item?: Maybe<Default>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** Retrieves the default content library. */
  library?: Maybe<Library>;
  /** The ID of the default library assigned to newly created projects. */
  libraryId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Sets the default client organization. Requires system admin access. */
  setClient?: Maybe<Scalars['Float']['output']>;
  /** Sets the default content library. Requires system admin access. */
  setLibrary?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultCreateArgs = {
  item?: InputMaybe<DefaultInput>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DefaultSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<DefaultFilterInput>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultSetClientArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultSetLibraryArgs = {
  libraryId?: InputMaybe<Scalars['String']['input']>;
};


/** System-wide default settings, including the default client and library for new projects. */
export type DefaultSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DefaultFilterInput = {
  and?: InputMaybe<Array<DefaultFilterInput>>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isProjSubNameEnabled?: InputMaybe<BooleanOperationFilterInput>;
  libraryId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DefaultFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type DefaultInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isProjSubNameEnabled: Scalars['Boolean']['input'];
  libraryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type DefaultListConnection = {
  __typename?: 'DefaultListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DefaultListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Default>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DefaultListEdge = {
  __typename?: 'DefaultListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Default>;
};

export type DefaultSortInput = {
  clientId?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isProjSubNameEnabled?: InputMaybe<SortEnumType>;
  libraryId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DirectContentsConnection = {
  __typename?: 'DirectContentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DirectContentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DirectContentsEdge = {
  __typename?: 'DirectContentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

/** The engineering discipline classification for content requests and user specializations. */
export enum DisciplineEnum {
  /** Civil engineering discipline. */
  Civil = 'CIVIL',
  /** Electrical engineering discipline. */
  Electrical = 'ELECTRICAL',
  /** Hydraulics/plumbing engineering discipline. */
  Hydraulics = 'HYDRAULICS',
  /** Mechanical engineering discipline (HVAC, etc.). */
  Mechanical = 'MECHANICAL',
  /** No specific discipline assigned. */
  None = 'NONE',
  /** Structural engineering discipline. */
  Structure = 'STRUCTURE'
}

/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicData = {
  __typename?: 'DynamicData';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Returns a SAS download URL for this dynamic data entry. */
  data?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** The value/content of the dynamic data entry. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the dynamic data entry. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<DynamicData>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The key/name of the dynamic data entry. */
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  /** Returns a SAS upload URL for this dynamic data entry. Only available for owned entries (SharedById must be null). */
  setData?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  sharedById?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The data type classification of this entry. */
  type?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicDataAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicDataCreateArgs = {
  item?: InputMaybe<DynamicDataInput>;
};


/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicDataDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicDataDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicDataItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicDataItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DynamicDataSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<DynamicDataFilterInput>;
};


/** A custom dynamic data entry that can be attached to projects or users for flexible metadata storage. */
export type DynamicDataSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DynamicDataFilterInput = {
  and?: InputMaybe<Array<DynamicDataFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DynamicDataFilterInput>>;
  ownerId?: InputMaybe<StringOperationFilterInput>;
  sharedById?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type DynamicDataInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  sharedById?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicDataSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerId?: InputMaybe<SortEnumType>;
  sharedById?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type EditContentRequestInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  iFCEntityId?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uniclassId?: InputMaybe<Scalars['String']['input']>;
  vBISId?: InputMaybe<Scalars['String']['input']>;
};

/** A grouping entity used to organize content items into logical collections. */
export type Group = {
  __typename?: 'Group';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the group. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Group>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the group. */
  name?: Maybe<Scalars['String']['output']>;
  /** Updates the description of this group. Requires system admin access. */
  setDescription?: Maybe<Scalars['Float']['output']>;
  /** Updates the name of this group. Requires system admin access. */
  setName?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupCreateArgs = {
  item?: InputMaybe<GroupInput>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GroupSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<GroupFilterInput>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupSetDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A grouping entity used to organize content items into logical collections. */
export type GroupSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GroupFilterInput = {
  and?: InputMaybe<Array<GroupFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GroupFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type GroupInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type GroupListConnection = {
  __typename?: 'GroupListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GroupListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Group>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GroupListEdge = {
  __typename?: 'GroupListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Group>;
};

export type GroupSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheck = {
  __typename?: 'HealthCheck';
  /** Assigns tags to multiple health checks. Supports overwriting existing tags. Requires system admin access. */
  assignHealthChecksTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** A description of what this health check validates. */
  description?: Maybe<Scalars['String']['output']>;
  /** The display configuration or label for this health check in the UI. */
  display?: Maybe<Scalars['String']['output']>;
  /** The group/category this health check belongs to. */
  group?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the health check. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<HealthCheck>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The numeric threshold limit for this health check rule. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The display name of the health check rule. */
  name?: Maybe<Scalars['String']['output']>;
  /** Updates the description of this health check. Requires system admin access. */
  setDescription?: Maybe<Scalars['Float']['output']>;
  /** Updates the display configuration of this health check. Requires system admin access. */
  setDisplay?: Maybe<Scalars['Float']['output']>;
  /** Updates the group/category of this health check. Requires system admin access. */
  setGroup?: Maybe<Scalars['Float']['output']>;
  /** Updates the numeric threshold limit for this health check. Requires system admin access. */
  setLimit?: Maybe<Scalars['Float']['output']>;
  /** Updates the name of this health check. Requires system admin access. */
  setName?: Maybe<Scalars['Float']['output']>;
  /** Updates the settings JSON of this health check. Requires system admin access. */
  setSettings?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** JSON string of health check rule settings/parameters. */
  settings?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckAssignHealthChecksTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckCreateArgs = {
  item?: InputMaybe<HealthCheckInput>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HealthCheckSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<HealthCheckFilterInput>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckSetDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckSetDisplayArgs = {
  display?: InputMaybe<Scalars['String']['input']>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckSetGroupArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckSetLimitArgs = {
  limit: Scalars['Int']['input'];
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckSetSettingsArgs = {
  settings?: InputMaybe<Scalars['String']['input']>;
};


/** A health check rule definition used to validate BIM models against quality standards. */
export type HealthCheckSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HealthCheckFilterInput = {
  and?: InputMaybe<Array<HealthCheckFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  display?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  limit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HealthCheckFilterInput>>;
  settings?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type HealthCheckInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type HealthCheckListConnection = {
  __typename?: 'HealthCheckListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<HealthCheckListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<HealthCheck>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type HealthCheckListEdge = {
  __typename?: 'HealthCheckListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HealthCheck>;
};

export type HealthCheckSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  display?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  limit?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** An audit trail entry recording a workflow action performed on a content version request. */
export type History = {
  __typename?: 'History';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  attachment?: Maybe<Attachment>;
  /** Returns a pre-signed download URL for this history entry's attachment, valid for 168 hours (7 days). Returns null if no attachment exists. */
  attachmentDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  /** The ID of the user who performed this action. */
  createdById?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp (seconds) of when this action was performed. */
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the history entry. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<History>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** A message or comment associated with the workflow action. */
  message?: Maybe<Scalars['String']['output']>;
  /** The name/title of the workflow action (e.g., 'Create New Request', 'Verify Request'). */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** An audit trail entry recording a workflow action performed on a content version request. */
export type HistoryAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An audit trail entry recording a workflow action performed on a content version request. */
export type HistoryCreateArgs = {
  item?: InputMaybe<HistoryInput>;
};


/** An audit trail entry recording a workflow action performed on a content version request. */
export type HistoryDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An audit trail entry recording a workflow action performed on a content version request. */
export type HistoryDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An audit trail entry recording a workflow action performed on a content version request. */
export type HistoryItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An audit trail entry recording a workflow action performed on a content version request. */
export type HistoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HistorySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<HistoryFilterInput>;
};


/** An audit trail entry recording a workflow action performed on a content version request. */
export type HistorySetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HistoryFilterInput = {
  and?: InputMaybe<Array<HistoryFilterInput>>;
  attachment?: InputMaybe<AttachmentFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HistoryFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type HistoryInput = {
  attachment?: InputMaybe<AttachmentInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type HistoryListConnection = {
  __typename?: 'HistoryListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<HistoryListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<History>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type HistoryListEdge = {
  __typename?: 'HistoryListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<History>;
};

export type HistorySortInput = {
  attachment?: InputMaybe<AttachmentSortInput>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type Ifc = {
  __typename?: 'IFC';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the child IFC nodes in the classification hierarchy. */
  children?: Maybe<Array<Maybe<Ifc>>>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the IFC node. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Ifc>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The name of the IFC classification. */
  name?: Maybe<Scalars['String']['output']>;
  /** The ID of the parent IFC node in the hierarchy. */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Retrieves all parent/ancestor IFC nodes using a graph lookup. */
  parents?: Maybe<Array<Maybe<Ifc>>>;
  /** Retrieves the IFC property sets associated with this classification. */
  propertySets?: Maybe<Array<Maybe<IfcPset>>>;
  /** List of IFC property set IDs associated with this classification. */
  psetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type IfcAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type IfcCreateArgs = {
  item?: InputMaybe<IfcInput>;
};


/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type IfcDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type IfcDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type IfcItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type IfcItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcFilterInput>;
};


/** An IFC (Industry Foundation Classes) classification node used for legacy IFC mapping. */
export type IfcSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntity = {
  __typename?: 'IFCEntity';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The IFC domain this entity belongs to (e.g., 'SharedBldgElements'). */
  domain?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the IFC entity. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<IfcEntity>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The IFC entity name (e.g., 'IfcWall', 'IfcDoor'). */
  name?: Maybe<Scalars['String']['output']>;
  /** Retrieves the IFC property sets applicable to this entity. */
  propertySets?: Maybe<Array<Maybe<IfcPropertySet>>>;
  /** List of IFC property set IDs applicable to this entity. */
  psetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntityAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntityCreateArgs = {
  item?: InputMaybe<IfcEntityInput>;
};


/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntityDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntityDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntityItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntityItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcEntitySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcEntityFilterInput>;
};


/** An IFC entity definition (e.g., IfcWall, IfcDoor) from the IFC standard, used to classify content. */
export type IfcEntitySetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IfcEntityFilterInput = {
  and?: InputMaybe<Array<IfcEntityFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  domain?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IfcEntityFilterInput>>;
  psetIds?: InputMaybe<ListStringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type IfcEntityInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  psetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type IfcEntityListConnection = {
  __typename?: 'IFCEntityListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IfcEntityListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IfcEntity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IfcEntityListEdge = {
  __typename?: 'IFCEntityListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IfcEntity>;
};

export type IfcEntitySortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  domain?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type IfcFilterInput = {
  and?: InputMaybe<Array<IfcFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IfcFilterInput>>;
  parentId?: InputMaybe<StringOperationFilterInput>;
  psetIds?: InputMaybe<ListStringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type IfcInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  psetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type IfcListConnection = {
  __typename?: 'IFCListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IfcListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Ifc>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IfcListEdge = {
  __typename?: 'IFCListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Ifc>;
};

/** An IFC property definition used in legacy IFC mapping. */
export type IfcProp = {
  __typename?: 'IFCProp';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the IFC property. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<IfcProp>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The name of the IFC property. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The data type of the IFC property. */
  type?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** The list of allowed/default values for this property. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** An IFC property definition used in legacy IFC mapping. */
export type IfcPropAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property definition used in legacy IFC mapping. */
export type IfcPropCreateArgs = {
  item?: InputMaybe<IfcPropInput>;
};


/** An IFC property definition used in legacy IFC mapping. */
export type IfcPropDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property definition used in legacy IFC mapping. */
export type IfcPropDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property definition used in legacy IFC mapping. */
export type IfcPropItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An IFC property definition used in legacy IFC mapping. */
export type IfcPropItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPropSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPropFilterInput>;
};


/** An IFC property definition used in legacy IFC mapping. */
export type IfcPropSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IfcPropFilterInput = {
  and?: InputMaybe<Array<IfcPropFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IfcPropFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
  values?: InputMaybe<ListStringOperationFilterInput>;
};

export type IfcPropInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection to a list of items. */
export type IfcPropListConnection = {
  __typename?: 'IFCPropListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IfcPropListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IfcProp>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IfcPropListEdge = {
  __typename?: 'IFCPropListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IfcProp>;
};

export type IfcPropSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** An IFC property from the IFC standard property definitions. */
export type IfcProperty = {
  __typename?: 'IFCProperty';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** The IFC classes this property applies to. */
  classes?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The IFD (International Framework for Dictionaries) GUID for this property. */
  iFDGuid?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the IFC property. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<IfcProperty>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The property name as defined in the IFC standard. */
  name?: Maybe<Scalars['String']['output']>;
  /** An alternative GUID identifier for this property. */
  newGuid?: Maybe<Scalars['String']['output']>;
  /** The definition/description of this property from the IFC standard. */
  propertyDefinition?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** An optional tag for additional categorization. */
  tag?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The data type of this IFC property. */
  type?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** An IFC property from the IFC standard property definitions. */
export type IfcPropertyAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property from the IFC standard property definitions. */
export type IfcPropertyCreateArgs = {
  item?: InputMaybe<IfcPropertyInput>;
};


/** An IFC property from the IFC standard property definitions. */
export type IfcPropertyDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property from the IFC standard property definitions. */
export type IfcPropertyDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property from the IFC standard property definitions. */
export type IfcPropertyItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An IFC property from the IFC standard property definitions. */
export type IfcPropertyItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPropertySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPropertyFilterInput>;
};


/** An IFC property from the IFC standard property definitions. */
export type IfcPropertySetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IfcPropertyFilterInput = {
  and?: InputMaybe<Array<IfcPropertyFilterInput>>;
  classes?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  iFDGuid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  newGuid?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IfcPropertyFilterInput>>;
  propertyDefinition?: InputMaybe<StringOperationFilterInput>;
  tag?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type IfcPropertyInput = {
  classes?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iFDGuid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newGuid?: InputMaybe<Scalars['String']['input']>;
  propertyDefinition?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type IfcPropertyListConnection = {
  __typename?: 'IFCPropertyListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IfcPropertyListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IfcProperty>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IfcPropertyListEdge = {
  __typename?: 'IFCPropertyListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IfcProperty>;
};

/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySet = {
  __typename?: 'IFCPropertySet';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** The definition/description of this property set. */
  definition?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the IFC property set. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<IfcPropertySet>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The property set name as defined in the IFC standard. */
  name?: Maybe<Scalars['String']['output']>;
  /** Retrieves the IFC properties belonging to this property set. */
  properties?: Maybe<Array<Maybe<IfcProperty>>>;
  /** List of IFC property IDs belonging to this property set. */
  propertyIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySetAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySetCreateArgs = {
  item?: InputMaybe<IfcPropertySetInput>;
};


/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySetDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySetDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySetItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySetItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPropertySetSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPropertySetFilterInput>;
};


/** An IFC property set definition grouping related IFC properties together. */
export type IfcPropertySetSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IfcPropertySetFilterInput = {
  and?: InputMaybe<Array<IfcPropertySetFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  definition?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IfcPropertySetFilterInput>>;
  propertyIds?: InputMaybe<ListStringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type IfcPropertySetInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type IfcPropertySetListConnection = {
  __typename?: 'IFCPropertySetListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IfcPropertySetListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IfcPropertySet>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IfcPropertySetListEdge = {
  __typename?: 'IFCPropertySetListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IfcPropertySet>;
};

export type IfcPropertySetSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  definition?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type IfcPropertySortInput = {
  classes?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  iFDGuid?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  newGuid?: InputMaybe<SortEnumType>;
  propertyDefinition?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPset = {
  __typename?: 'IFCPset';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the IFC property set. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<IfcPset>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The name of the IFC property set. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of IFC property IDs belonging to this property set. */
  propIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the IFC properties belonging to this property set. */
  properties?: Maybe<Array<Maybe<IfcProperty>>>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPsetAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPsetCreateArgs = {
  item?: InputMaybe<IfcPsetInput>;
};


/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPsetDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPsetDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPsetItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPsetItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPsetSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPsetFilterInput>;
};


/** An IFC property set definition used in legacy IFC mapping. */
export type IfcPsetSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IfcPsetFilterInput = {
  and?: InputMaybe<Array<IfcPsetFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IfcPsetFilterInput>>;
  propIds?: InputMaybe<ListStringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type IfcPsetInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type IfcPsetListConnection = {
  __typename?: 'IFCPsetListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IfcPsetListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<IfcPset>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IfcPsetListEdge = {
  __typename?: 'IFCPsetListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IfcPset>;
};

export type IfcPsetSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type IfcSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type InheritedLibrariesConnection = {
  __typename?: 'InheritedLibrariesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InheritedLibrariesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Library>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InheritedLibrariesEdge = {
  __typename?: 'InheritedLibrariesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Library>;
};

/** A connection to a list of items. */
export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Client>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ItemsEdge = {
  __typename?: 'ItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Client>;
};

/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type Library = {
  __typename?: 'Library';
  /** List of user IDs who have admin access to this library. */
  adminIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the users who have admin access to this library. */
  admins?: Maybe<Array<Maybe<User>>>;
  /** Assigns classifications to content items within this library. Supports overwriting existing classifications. Requires library admin access. */
  assignContentClassifications?: Maybe<Scalars['Float']['output']>;
  /** Assigns groups to content items within this library. Supports overwriting existing groups. Requires library admin access. */
  assignContentGroups?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to content items within this library. Supports overwriting existing tags. Requires library admin access. */
  assignContentTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Unix timestamp (seconds) of when the library cache was last generated. */
  cacheCreatedTime?: Maybe<Scalars['String']['output']>;
  /** Returns the download URL for the gzipped raw-JSON cache blob (payloadEncoding 'json+gzip'). Preferred over GetCaches when the client can handle gzip decompression - the payload is typically ~13x smaller than the base64 blob. Returns a URL that will 404 for libraries whose cache predates the dual-write; clients should fall back to GetCaches in that case. */
  cacheJson?: Maybe<Scalars['String']['output']>;
  /** Returns the download URL for the manifest describing the gzipped JSON cache blob. Mirrors GetCacheManifest but for the '.json.gz' payload. */
  cacheJsonManifest?: Maybe<Scalars['String']['output']>;
  /** Returns the download URL for the cache manifest JSON. Mirrors GetCaches; manifest declares schemaVersion, contentSha256, nodeCount, and payloadEncoding for the companion cache blob. Returns a URL that will 404 if the manifest has not yet been produced for this library / software combination. */
  cacheManifest?: Maybe<Scalars['String']['output']>;
  /** The current status of the library cache generation process. */
  cacheStatus?: Maybe<LibraryCacheStatus>;
  /** Returns the download URL for the cached library bundle. Optionally filtered by software name. */
  caches?: Maybe<Scalars['String']['output']>;
  /** Retrieves the client organization that owns this library. */
  client?: Maybe<Client>;
  /** The ID of the client organization that owns this library. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Retrieves all content items accessible in this library, including both direct and registered inherited content. */
  contents?: Maybe<ContentsConnection>;
  /** Retrieves content items from a library using a client secret for service-to-service authentication. */
  contentsWithSecret?: Maybe<ContentsWithSecretConnection>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Returns a specific custom content configuration by its ID. */
  customContent?: Maybe<CustomContent>;
  /** Returns the custom content configurations for this library, filtered to valid entries. */
  customContents?: Maybe<Array<Maybe<CustomContent>>>;
  /** Deletes this library and all its content and versions. Requires system admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes users from the library admin list. Requires library admin access. */
  deleteAdmins?: Maybe<Scalars['Float']['output']>;
  /** Removes custom content configurations. Requires library admin access. */
  deleteCustomContents?: Maybe<Scalars['Float']['output']>;
  /** Permanently deletes content items and all their versions from this library. Requires library admin access. */
  deleteDirectContents?: Maybe<Scalars['Float']['output']>;
  /** Removes libraries from the inheritance chain. Requires library admin access. */
  deleteInheritLibraries?: Maybe<Scalars['Float']['output']>;
  /** Unregisters content items from this library. Requires library admin access. */
  deleteRegisedContents?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** A free-text description of the library. */
  description?: Maybe<Scalars['String']['output']>;
  /** Retrieves content items that belong directly to this library (not inherited). */
  directContents?: Maybe<DirectContentsConnection>;
  /** The unique identifier of the library. */
  id?: Maybe<Scalars['String']['output']>;
  /** Adds a library to the inheritance chain, making its content available for registration. Requires library admin access. */
  inheritLibrary?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the libraries whose content is inherited into this library. */
  inheritedLibraries?: Maybe<InheritedLibrariesConnection>;
  /** List of library IDs whose content is inherited into this library. */
  inheritedLibraryIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns whether the current authenticated user has admin access to this library. */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Library>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** Returns the server-side outcome of the most recent cache regeneration run for this library. Null when no summary is available (either the environment has not run since the summary feature was deployed, or the summary blob is unreadable). Exposes duration, per-blob byte counts (base64 vs gzip), manifest status, and any error message captured server-side, so admins can distinguish 'client download issue' from 'server never wrote the blob'. */
  lastCacheRunResult?: Maybe<LibraryCacheRunResult>;
  /** Returns the most recent library cache regeneration run summary written by the LibraryCache timer function. Null when no run has completed since the environment was deployed. Includes overall outcome (Success / Partial / Failure), total / success / failure counts, run duration, and per-library rows. */
  libraryCacheRunSummary?: Maybe<LibraryCacheRunSummary>;
  /** Moves this library to a different client organization. Also updates all content versions. Requires library admin access. */
  move?: Maybe<Scalars['Float']['output']>;
  /** Moves content items from this library to a target library. Requires admin access to both libraries. */
  moveContents?: Maybe<Scalars['Float']['output']>;
  /** The display name of the library. */
  name?: Maybe<Scalars['String']['output']>;
  /** Publishes an open new-content or edit-content request using uploaded Revit metadata, closes the request, and returns the resulting content upload target. */
  publishContent?: Maybe<Content>;
  /** Registers content items from inherited libraries to make them visible in this library. Requires library admin access. */
  registerContents?: Maybe<Scalars['Float']['output']>;
  /** List of content IDs from inherited libraries that are registered (visible) in this library. */
  registeredContentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves content items from inherited libraries that have been registered in this library. */
  registeredContents?: Maybe<RegisteredContentsConnection>;
  /** Resets usage counts to zero for every content item owned by this library. Requires system admin access. */
  resetContentUsageCounts?: Maybe<Scalars['Float']['output']>;
  /** Adds a user as an admin of this library. Requires library admin access. */
  setAdmin?: Maybe<Scalars['Float']['output']>;
  /** Sets the cache creation timestamp to the current UTC time. Requires library admin access. */
  setCacheCreatedTime?: Maybe<Scalars['Float']['output']>;
  /** Updates the cache generation status. Requires library admin access. */
  setCacheStatus?: Maybe<Scalars['Float']['output']>;
  /** Adds custom content configurations to override default settings. Requires library admin access. */
  setCustomContents?: Maybe<Scalars['Float']['output']>;
  /** Updates the description of this library. Requires library admin access. */
  setDescription?: Maybe<Scalars['Float']['output']>;
  /** Updates the display name of this library. Requires library admin access. */
  setName?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves content items from inherited libraries that have NOT been registered in this library. */
  unregisteredContents?: Maybe<UnregisteredContentsConnection>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** Creates or updates content with an associated version in this library. Supports overwriting existing content by name. Optionally links an existing approved request version instead of creating a new one, preserving its full history. Requires library admin access. */
  uploadContent?: Maybe<Content>;
  /** Resolves a batch of proposed uploads against current library content and open content requests. The result is advisory; mutations revalidate the selected action. */
  uploadTargets?: Maybe<Array<Maybe<UploadTargetResolution>>>;
  /** Returns a pre-signed upload URL for the library cache bundle. Optionally scoped by software name. Requires library admin access. */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryAssignContentClassificationsArgs = {
  classificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryAssignContentGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryAssignContentTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryCacheJsonArgs = {
  softwareName?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryCacheJsonManifestArgs = {
  softwareName?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryCacheManifestArgs = {
  softwareName?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryCachesArgs = {
  softwareName?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentFilterInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryContentsWithSecretArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  secret?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentFilterInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryCreateArgs = {
  item?: InputMaybe<LibraryInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryCustomContentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDeleteAdminsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDeleteCustomContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDeleteDirectContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDeleteInheritLibrariesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDeleteRegisedContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryDirectContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentFilterInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryInheritLibraryArgs = {
  inheritLibraryId?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryInheritedLibrariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LibrarySortInput>>;
  where?: InputMaybe<LibraryFilterInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LibrarySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<LibraryFilterInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryMoveArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryMoveContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetLibraryId?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryPublishContentArgs = {
  requestId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  version?: InputMaybe<ContentVersionInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryRegisterContentsArgs = {
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryRegisteredContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentFilterInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibrarySetAdminArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibrarySetCacheStatusArgs = {
  cacheStatus: Scalars['Int']['input'];
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibrarySetCustomContentsArgs = {
  customContents?: InputMaybe<Array<InputMaybe<CustomContentInput>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibrarySetDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibrarySetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibrarySetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryUnregisteredContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentFilterInput>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryUploadContentArgs = {
  overwrite: Scalars['Boolean']['input'];
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  version?: InputMaybe<ContentVersionInput>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryUploadTargetsArgs = {
  candidates?: InputMaybe<Array<InputMaybe<UploadCandidateInput>>>;
};


/** A content library belonging to a client, containing BIM content items and supporting inheritance from other libraries. */
export type LibraryUploadUrlArgs = {
  softwareName?: InputMaybe<Scalars['String']['input']>;
};

export type LibraryCacheBlobResult = {
  __typename?: 'LibraryCacheBlobResult';
  base64Bytes: Scalars['Long']['output'];
  blobName?: Maybe<Scalars['String']['output']>;
  gzipBytes: Scalars['Long']['output'];
  manifestOk: Scalars['Boolean']['output'];
  nodeCount: Scalars['Int']['output'];
  software?: Maybe<Scalars['String']['output']>;
};

export type LibraryCacheRunResult = {
  __typename?: 'LibraryCacheRunResult';
  blobs?: Maybe<Array<Maybe<LibraryCacheBlobResult>>>;
  completedAt: Scalars['DateTime']['output'];
  durationMs: Scalars['Long']['output'];
  error?: Maybe<Scalars['String']['output']>;
  libraryId?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

export type LibraryCacheRunSummary = {
  __typename?: 'LibraryCacheRunSummary';
  durationMs: Scalars['Long']['output'];
  failureCount: Scalars['Int']['output'];
  generatedBy?: Maybe<Scalars['String']['output']>;
  libraries?: Maybe<Array<Maybe<LibraryCacheRunResult>>>;
  orchestrationInstanceId?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  runCompletedAt: Scalars['DateTime']['output'];
  runStartedAt: Scalars['DateTime']['output'];
  schemaVersion: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalLibraries: Scalars['Int']['output'];
};

/** The status of a library cache generation process. */
export enum LibraryCacheStatus {
  /** Cache generation failed. Check logs for details. */
  Failed = 'FAILED',
  /** No cache generation has been initiated. */
  None = 'NONE',
  /** Cache generation has been requested and is queued. */
  Pending = 'PENDING',
  /** Cache generation is currently in progress. */
  Running = 'RUNNING',
  /** Cache generation completed successfully. */
  Succeeded = 'SUCCEEDED'
}

export type LibraryFilterInput = {
  adminIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<LibraryFilterInput>>;
  cacheCreatedTime?: InputMaybe<StringOperationFilterInput>;
  cacheStatus?: InputMaybe<NullableOfLibraryCacheStatusOperationFilterInput>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  customContents?: InputMaybe<ListFilterInputTypeOfCustomContentFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  inheritedLibraryIds?: InputMaybe<ListStringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LibraryFilterInput>>;
  registeredContentIds?: InputMaybe<ListStringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type LibraryInput = {
  adminIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cacheCreatedTime?: InputMaybe<Scalars['String']['input']>;
  cacheStatus?: InputMaybe<LibraryCacheStatus>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  customContents?: InputMaybe<Array<InputMaybe<CustomContentInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inheritedLibraryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  registeredContentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type LibraryListConnection = {
  __typename?: 'LibraryListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LibraryListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Library>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LibraryListEdge = {
  __typename?: 'LibraryListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Library>;
};

export type LibrarySortInput = {
  cacheCreatedTime?: InputMaybe<SortEnumType>;
  cacheStatus?: InputMaybe<SortEnumType>;
  clientId?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type ListFilterInputTypeOfContentTypeFilterInput = {
  all?: InputMaybe<ContentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContentTypeFilterInput>;
  some?: InputMaybe<ContentTypeFilterInput>;
};

export type ListFilterInputTypeOfCustomContentFilterInput = {
  all?: InputMaybe<CustomContentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomContentFilterInput>;
  some?: InputMaybe<CustomContentFilterInput>;
};

export type ListFilterInputTypeOfCustomContentTypeFilterInput = {
  all?: InputMaybe<CustomContentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomContentTypeFilterInput>;
  some?: InputMaybe<CustomContentTypeFilterInput>;
};

export type ListFilterInputTypeOfDynamicDataFilterInput = {
  all?: InputMaybe<DynamicDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DynamicDataFilterInput>;
  some?: InputMaybe<DynamicDataFilterInput>;
};

export type ListFilterInputTypeOfHistoryFilterInput = {
  all?: InputMaybe<HistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<HistoryFilterInput>;
  some?: InputMaybe<HistoryFilterInput>;
};

export type ListFilterInputTypeOfWorksetFilterInput = {
  all?: InputMaybe<WorksetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WorksetFilterInput>;
  some?: InputMaybe<WorksetFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

/** A parameter mapping definition that links content parameters to commands. */
export type Map = {
  __typename?: 'Map';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** List of command IDs associated with this map. */
  commandIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  commands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the map. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Map>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the map. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A parameter mapping definition that links content parameters to commands. */
export type MapAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A parameter mapping definition that links content parameters to commands. */
export type MapCreateArgs = {
  item?: InputMaybe<MapInput>;
};


/** A parameter mapping definition that links content parameters to commands. */
export type MapDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A parameter mapping definition that links content parameters to commands. */
export type MapDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A parameter mapping definition that links content parameters to commands. */
export type MapItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A parameter mapping definition that links content parameters to commands. */
export type MapItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MapSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<MapFilterInput>;
};


/** A parameter mapping definition that links content parameters to commands. */
export type MapSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MapFilterInput = {
  and?: InputMaybe<Array<MapFilterInput>>;
  commandIds?: InputMaybe<ListStringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MapFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type MapInput = {
  commandIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type MapListConnection = {
  __typename?: 'MapListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MapListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Map>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MapListEdge = {
  __typename?: 'MapListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Map>;
};

export type MapSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A BIM model file within a project, tracked for health checking and content management. */
export type Model = {
  __typename?: 'Model';
  /** The BIM application used to create the model (e.g., 'Revit'). */
  applicationName?: Maybe<Scalars['String']['output']>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the download URL for the cached model data. */
  caches?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** JSON string containing custom properties extracted from the model. */
  customProperties?: Maybe<Scalars['String']['output']>;
  /** Deletes models by their IDs. Requires system admin, client admin, or project admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** JSON string containing the health check results for this model. */
  healthResults?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the model. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Model>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** Finds or creates a BIM model by project ID and model name. */
  model?: Maybe<Model>;
  /** The display name of the model. */
  name?: Maybe<Scalars['String']['output']>;
  /** Retrieves the project this model belongs to. */
  project?: Maybe<Project>;
  /** The ID of the project this model belongs to. */
  projectId?: Maybe<Scalars['String']['output']>;
  /** Updates the BIM application name for this model. */
  setApplicationName?: Maybe<Scalars['Float']['output']>;
  /** Returns a pre-signed upload URL for the model cache data. */
  setCaches?: Maybe<Scalars['String']['output']>;
  /** Updates the custom properties JSON for this model. */
  setCustomProperties?: Maybe<Scalars['Float']['output']>;
  /** Updates the health check results JSON for this model. */
  setHealthResults?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelCreateArgs = {
  item?: InputMaybe<ModelInput>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ModelSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ModelFilterInput>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelModelArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelSetApplicationNameArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelSetCustomPropertiesArgs = {
  customProperties?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelSetHealthResultsArgs = {
  healthResults?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM model file within a project, tracked for health checking and content management. */
export type ModelSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModelFilterInput = {
  and?: InputMaybe<Array<ModelFilterInput>>;
  applicationName?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  customProperties?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  healthResults?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModelFilterInput>>;
  projectId?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type ModelInput = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  customProperties?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  healthResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type ModelListConnection = {
  __typename?: 'ModelListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ModelListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Model>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ModelListEdge = {
  __typename?: 'ModelListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Model>;
};

export type ModelSortInput = {
  applicationName?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  customProperties?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  healthResults?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type MutationType = {
  __typename?: 'MutationType';
  /** Archives tags without removing references from existing records. Requires system admin access. */
  ArchiveTagList?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Attachment items. Requires authorization. */
  AssignAttachmentListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Classification items. Requires authorization. */
  AssignClassificationListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple ClassificationType items. Requires authorization. */
  AssignClassificationTypeListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Client items. Requires authorization. */
  AssignClientListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns health checks to multiple client organizations. Supports overwriting existing assignments. Requires admin access. */
  AssignClientsHealthChecks?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Command items. Requires authorization. */
  AssignCommandListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Content items. Requires authorization. */
  AssignContentListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple ContentType items. Requires authorization. */
  AssignContentTypeListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple ContentVersion items. Requires authorization. */
  AssignContentVersionListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Default items. Requires authorization. */
  AssignDefaultListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Group items. Requires authorization. */
  AssignGroupListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple HealthCheck items. Requires authorization. */
  AssignHealthCheckListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple health checks. Supports overwriting existing tags. Requires admin access. */
  AssignHealthChecksTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple History items. Requires authorization. */
  AssignHistoryListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple IFCEntity items. Requires authorization. */
  AssignIFCEntityListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple IFC items. Requires authorization. */
  AssignIFCListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple IFCProp items. Requires authorization. */
  AssignIFCPropListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple IFCProperty items. Requires authorization. */
  AssignIFCPropertyListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple IFCPropertySet items. Requires authorization. */
  AssignIFCPropertySetListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple IFCPset items. Requires authorization. */
  AssignIFCPsetListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Library items. Requires authorization. */
  AssignLibraryListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Map items. Requires authorization. */
  AssignMapListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Model items. Requires authorization. */
  AssignModelListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Project items. Requires authorization. */
  AssignProjectListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns health checks to multiple projects. Supports overwriting existing assignments. Requires admin access. */
  AssignProjectsHealthChecks?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use ReassignRequest. */
  AssignResourceToRequest?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Tag items. Requires authorization. */
  AssignTagListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Uniclass items. Requires authorization. */
  AssignUniclassListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple User items. Requires authorization. */
  AssignUserListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple VBIS items. Requires authorization. */
  AssignVBISListTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple Workset items. Requires authorization. */
  AssignWorksetListTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves a single Attachment by ID. Requires authorization. */
  Attachment?: Maybe<Attachment>;
  /** Retrieves a single Classification by ID. Requires authorization. */
  Classification?: Maybe<Classification>;
  /** Retrieves a single ClassificationType by ID. Requires authorization. */
  ClassificationType?: Maybe<ClassificationType>;
  /** Retrieves a single Client by ID. Requires authorization. */
  Client?: Maybe<Client>;
  /** Closes an open request as published, declined, or cancelled. Requires library administration. */
  CloseRequest?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single Command by ID. Requires authorization. */
  Command?: Maybe<Command>;
  /** Retrieves a single Content by ID. Requires authorization. */
  Content?: Maybe<Content>;
  /** Retrieves a single ContentType by ID. Requires authorization. */
  ContentType?: Maybe<ContentType>;
  /** Retrieves a single ContentVersion by ID. Requires authorization. */
  ContentVersion?: Maybe<ContentVersion>;
  /** Creates a new Attachment. Requires authorization. */
  CreateAttachment?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Classification. Requires authorization. */
  CreateClassification?: Maybe<Scalars['Float']['output']>;
  /** Creates a new ClassificationType. Requires authorization. */
  CreateClassificationType?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Client. Requires authorization. */
  CreateClient?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Command. Requires authorization. */
  CreateCommand?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Content. Requires authorization. */
  CreateContent?: Maybe<Scalars['Float']['output']>;
  /** Creates a new ContentType. Requires authorization. */
  CreateContentType?: Maybe<Scalars['Float']['output']>;
  /** Creates a new ContentVersion. Requires authorization. */
  CreateContentVersion?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Default. Requires authorization. */
  CreateDefault?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Group. Requires authorization. */
  CreateGroup?: Maybe<Scalars['Float']['output']>;
  /** Creates a new HealthCheck. Requires authorization. */
  CreateHealthCheck?: Maybe<Scalars['Float']['output']>;
  /** Creates a new History. Requires authorization. */
  CreateHistory?: Maybe<Scalars['Float']['output']>;
  /** Creates a new IFC. Requires authorization. */
  CreateIFC?: Maybe<Scalars['Float']['output']>;
  /** Creates a new IFCEntity. Requires authorization. */
  CreateIFCEntity?: Maybe<Scalars['Float']['output']>;
  /** Creates a new IFCProp. Requires authorization. */
  CreateIFCProp?: Maybe<Scalars['Float']['output']>;
  /** Creates a new IFCProperty. Requires authorization. */
  CreateIFCProperty?: Maybe<Scalars['Float']['output']>;
  /** Creates a new IFCPropertySet. Requires authorization. */
  CreateIFCPropertySet?: Maybe<Scalars['Float']['output']>;
  /** Creates a new IFCPset. Requires authorization. */
  CreateIFCPset?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Library. Requires authorization. */
  CreateLibrary?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Map. Requires authorization. */
  CreateMap?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Model. Requires authorization. */
  CreateModel?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Project. Requires authorization. */
  CreateProject?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Tag. Requires authorization. */
  CreateTag?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Uniclass. Requires authorization. */
  CreateUniclass?: Maybe<Scalars['Float']['output']>;
  /** Creates a new User. Requires authorization. */
  CreateUser?: Maybe<Scalars['Float']['output']>;
  /** Creates a new VBIS. Requires authorization. */
  CreateVBIS?: Maybe<Scalars['Float']['output']>;
  /** Creates a new Workset. Requires authorization. */
  CreateWorkset?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the system-wide default settings. */
  Default?: Maybe<Default>;
  /** Deletes multiple Attachment items by their IDs. Requires authorization. */
  DeleteAttachmentList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Classification items by their IDs. Requires authorization. */
  DeleteClassificationList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple ClassificationType items by their IDs. Requires authorization. */
  DeleteClassificationTypeList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Client items by their IDs. Requires authorization. */
  DeleteClientList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Command items by their IDs. Requires authorization. */
  DeleteCommandList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Content items by their IDs. Requires authorization. */
  DeleteContentList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple ContentType items by their IDs. Requires authorization. */
  DeleteContentTypeList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple ContentVersion items by their IDs. Requires authorization. */
  DeleteContentVersionList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Default items by their IDs. Requires authorization. */
  DeleteDefaultList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Group items by their IDs. Requires authorization. */
  DeleteGroupList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple HealthCheck items by their IDs. Requires authorization. */
  DeleteHealthCheckList?: Maybe<Scalars['Float']['output']>;
  /** Deletes history entries from a ContentVersion by their IDs. Requires admin access. */
  DeleteHistories?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple History items by their IDs. Requires authorization. */
  DeleteHistoryList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple IFCEntity items by their IDs. Requires authorization. */
  DeleteIFCEntityList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple IFC items by their IDs. Requires authorization. */
  DeleteIFCList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple IFCProp items by their IDs. Requires authorization. */
  DeleteIFCPropList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple IFCProperty items by their IDs. Requires authorization. */
  DeleteIFCPropertyList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple IFCPropertySet items by their IDs. Requires authorization. */
  DeleteIFCPropertySetList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple IFCPset items by their IDs. Requires authorization. */
  DeleteIFCPsetList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Library items by their IDs. Requires authorization. */
  DeleteLibraryList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Map items by their IDs. Requires authorization. */
  DeleteMapList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Model items by their IDs. Requires authorization. */
  DeleteModelList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Project items by their IDs. Requires authorization. */
  DeleteProjectList?: Maybe<Scalars['Float']['output']>;
  /** Permanently deletes a content request and clears its edit-request pointer. Requires system admin access. */
  DeleteRequest: Scalars['Boolean']['output'];
  /** Deletes multiple Tag items by their IDs. Requires authorization. */
  DeleteTagList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Uniclass items by their IDs. Requires authorization. */
  DeleteUniclassList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple User items by their IDs. Requires authorization. */
  DeleteUserList?: Maybe<Scalars['Float']['output']>;
  /** Removes the role assignment from a user, resetting them to None. Requires system admin access. */
  DeleteUserRole?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple VBIS items by their IDs. Requires authorization. */
  DeleteVBISList?: Maybe<Scalars['Float']['output']>;
  /** Deletes multiple Workset items by their IDs. Requires authorization. */
  DeleteWorksetList?: Maybe<Scalars['Float']['output']>;
  /** Updates an open request. The assignee or a library administrator may update it. */
  EditRequest?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use CloseRequest. */
  FinalReviewRequest?: Maybe<Scalars['Float']['output']>;
  /** Retrieves a single Group by ID. Requires authorization. */
  Group?: Maybe<Group>;
  /** Retrieves a single HealthCheck by ID. Requires authorization. */
  HealthCheck?: Maybe<HealthCheck>;
  /** Retrieves a single History by ID. Requires authorization. */
  History?: Maybe<History>;
  /** Retrieves a single IFC by ID. Requires authorization. */
  IFC?: Maybe<Ifc>;
  /** Retrieves a single IFCEntity by ID. Requires authorization. */
  IFCEntity?: Maybe<IfcEntity>;
  /** Retrieves a single IFCProp by ID. Requires authorization. */
  IFCProp?: Maybe<IfcProp>;
  /** Retrieves a single IFCProperty by ID. Requires authorization. */
  IFCProperty?: Maybe<IfcProperty>;
  /** Retrieves a single IFCPropertySet by ID. Requires authorization. */
  IFCPropertySet?: Maybe<IfcPropertySet>;
  /** Retrieves a single IFCPset by ID. Requires authorization. */
  IFCPset?: Maybe<IfcPset>;
  /** Retrieves a single Library by ID. Requires authorization. */
  Library?: Maybe<Library>;
  /** Retrieves a single Map by ID. Requires authorization. */
  Map?: Maybe<Map>;
  /** @deprecated Use the Open/Closed request lifecycle. */
  MarkDeveloped?: Maybe<Scalars['Float']['output']>;
  /** Retrieves a single Model by ID. Requires authorization. */
  Model?: Maybe<Model>;
  /** Finds or creates a BIM model by project ID and model name. */
  ModelByName?: Maybe<Model>;
  /** Retrieves a single Project by ID. Requires authorization. */
  Project?: Maybe<Project>;
  /** Reassigns an open request. Requires library administration. */
  ReassignRequest?: Maybe<Scalars['String']['output']>;
  /** @deprecated Closed requests are immutable. */
  RecoverRequest?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use CloseRequest with a declined resolution. */
  RejectRequest?: Maybe<Scalars['Float']['output']>;
  /** Creates a content request. The server assigns the client's current default library. */
  Request?: Maybe<Scalars['String']['output']>;
  /** Restores archived tags so they can be selected again. Requires system admin access. */
  RestoreTagList?: Maybe<Scalars['Float']['output']>;
  /** Assigns an admin role and discipline to a user. Requires system admin access. */
  SetAdmin?: Maybe<Scalars['Float']['output']>;
  /** Adds the current user as a member of the specified project. */
  SetProjectAccess?: Maybe<Scalars['Float']['output']>;
  /** Sets the default light- and dark-mode colours for a tag type. Requires system admin access. */
  SetTagTypeColours?: Maybe<Scalars['String']['output']>;
  /** Sets whether a tag type is required for content requests. Requires system admin access. */
  SetTagTypeRequiredForContentRequests?: Maybe<Scalars['String']['output']>;
  /** Assigns a role and discipline to a user. Requires system admin access. */
  SetUserRole?: Maybe<Scalars['Float']['output']>;
  /** Adds a generated file to an open request without publishing or closing it. */
  SubmitDraft?: Maybe<SubmitDraftPayload>;
  /** Retrieves a single Tag by ID. Requires authorization. */
  Tag?: Maybe<Tag>;
  /** Assigns an open request to the current library administrator. */
  TakeOwnership?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single Uniclass by ID. Requires authorization. */
  Uniclass?: Maybe<Uniclass>;
  /** @deprecated Use EditRequest with a replacement file. */
  UploadAttachmentToRequest?: Maybe<Scalars['Float']['output']>;
  /** Retrieves a single User by ID. Requires authorization. */
  User?: Maybe<User>;
  /** Retrieves a single VBIS by ID. Requires authorization. */
  VBIS?: Maybe<Vbis>;
  /** @deprecated Use the Open/Closed request lifecycle. */
  VerifyRequest?: Maybe<Scalars['Float']['output']>;
  /** Retrieves a single Workset by ID. Requires authorization. */
  Workset?: Maybe<Workset>;
};


export type MutationTypeArchiveTagListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignAttachmentListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignClassificationListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignClassificationTypeListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignClientListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignClientsHealthChecksArgs = {
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTypeAssignCommandListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignContentListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignContentTypeListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignContentVersionListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignDefaultListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignGroupListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignHealthCheckListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignHealthChecksTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignHistoryListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignIfcEntityListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignIfcListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignIfcPropListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignIfcPropertyListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignIfcPropertySetListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignIfcPsetListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignLibraryListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignMapListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignModelListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignProjectListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignProjectsHealthChecksArgs = {
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTypeAssignResourceToRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modeller?: InputMaybe<UserInput>;
};


export type MutationTypeAssignTagListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignUniclassListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignUserListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignVbisListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAssignWorksetListTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeAttachmentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeClassificationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeClassificationTypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeClientArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeCloseRequestArgs = {
  id: Scalars['String']['input'];
  input: CloseContentRequestInput;
};


export type MutationTypeCommandArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeContentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeContentTypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeContentVersionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeCreateAttachmentArgs = {
  item?: InputMaybe<AttachmentInput>;
};


export type MutationTypeCreateClassificationArgs = {
  item?: InputMaybe<ClassificationInput>;
};


export type MutationTypeCreateClassificationTypeArgs = {
  item?: InputMaybe<ClassificationTypeInput>;
};


export type MutationTypeCreateClientArgs = {
  item?: InputMaybe<ClientInput>;
};


export type MutationTypeCreateCommandArgs = {
  item?: InputMaybe<CommandInput>;
};


export type MutationTypeCreateContentArgs = {
  item?: InputMaybe<ContentInput>;
};


export type MutationTypeCreateContentTypeArgs = {
  item?: InputMaybe<ContentTypeInput>;
};


export type MutationTypeCreateContentVersionArgs = {
  item?: InputMaybe<ContentVersionInput>;
};


export type MutationTypeCreateDefaultArgs = {
  item?: InputMaybe<DefaultInput>;
};


export type MutationTypeCreateGroupArgs = {
  item?: InputMaybe<GroupInput>;
};


export type MutationTypeCreateHealthCheckArgs = {
  item?: InputMaybe<HealthCheckInput>;
};


export type MutationTypeCreateHistoryArgs = {
  item?: InputMaybe<HistoryInput>;
};


export type MutationTypeCreateIfcArgs = {
  item?: InputMaybe<IfcInput>;
};


export type MutationTypeCreateIfcEntityArgs = {
  item?: InputMaybe<IfcEntityInput>;
};


export type MutationTypeCreateIfcPropArgs = {
  item?: InputMaybe<IfcPropInput>;
};


export type MutationTypeCreateIfcPropertyArgs = {
  item?: InputMaybe<IfcPropertyInput>;
};


export type MutationTypeCreateIfcPropertySetArgs = {
  item?: InputMaybe<IfcPropertySetInput>;
};


export type MutationTypeCreateIfcPsetArgs = {
  item?: InputMaybe<IfcPsetInput>;
};


export type MutationTypeCreateLibraryArgs = {
  item?: InputMaybe<LibraryInput>;
};


export type MutationTypeCreateMapArgs = {
  item?: InputMaybe<MapInput>;
};


export type MutationTypeCreateModelArgs = {
  item?: InputMaybe<ModelInput>;
};


export type MutationTypeCreateProjectArgs = {
  item?: InputMaybe<ProjectInput>;
};


export type MutationTypeCreateTagArgs = {
  item?: InputMaybe<TagInput>;
};


export type MutationTypeCreateUniclassArgs = {
  item?: InputMaybe<UniclassInput>;
};


export type MutationTypeCreateUserArgs = {
  item?: InputMaybe<UserInput>;
};


export type MutationTypeCreateVbisArgs = {
  item?: InputMaybe<VbisInput>;
};


export type MutationTypeCreateWorksetArgs = {
  item?: InputMaybe<WorksetInput>;
};


export type MutationTypeDefaultArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeDeleteAttachmentListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteClassificationListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteClassificationTypeListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteClientListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteCommandListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteContentListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteContentTypeListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteContentVersionListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteDefaultListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteGroupListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteHealthCheckListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteHistoriesArgs = {
  contentVersionId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteHistoryListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteIfcEntityListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteIfcListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteIfcPropListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteIfcPropertyListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteIfcPropertySetListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteIfcPsetListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteLibraryListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteMapListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteModelListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteProjectListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationTypeDeleteTagListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteUniclassListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteUserListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteUserRoleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeDeleteVbisListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeDeleteWorksetListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeEditRequestArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<EditContentRequestInput>;
};


export type MutationTypeFinalReviewRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeGroupArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeHealthCheckArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeHistoryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeIfcArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeIfcEntityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeIfcPropArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeIfcPropertyArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeIfcPropertySetArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeIfcPsetArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeLibraryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeMapArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeMarkDevelopedArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeModelArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeModelByNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeProjectArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeReassignRequestArgs = {
  assignedToId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeRecoverRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeRejectRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeRequestArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<CreateContentRequestInput>;
};


export type MutationTypeRestoreTagListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationTypeSetAdminArgs = {
  discipline?: InputMaybe<DisciplineEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeSetProjectAccessArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeSetTagTypeColoursArgs = {
  darkModeColour: Scalars['String']['input'];
  lightModeColour: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationTypeSetTagTypeRequiredForContentRequestsArgs = {
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};


export type MutationTypeSetUserRoleArgs = {
  discipline?: InputMaybe<DisciplineEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleEnum>;
};


export type MutationTypeSubmitDraftArgs = {
  fileName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeTagArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeTakeOwnershipArgs = {
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeUniclassArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeUploadAttachmentToRequestArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeVbisArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeVerifyRequestArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTypeWorksetArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type MyRequestsConnection = {
  __typename?: 'MyRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContentVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MyRequestsEdge = {
  __typename?: 'MyRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentVersion>;
};

/** A connection to a list of items. */
export type NeedActionRequestsConnection = {
  __typename?: 'NeedActionRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<NeedActionRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContentVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NeedActionRequestsEdge = {
  __typename?: 'NeedActionRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentVersion>;
};

export type NullableOfContentRequestTypeEnumOperationFilterInput = {
  eq?: InputMaybe<ContentRequestTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<ContentRequestTypeEnum>>>;
  neq?: InputMaybe<ContentRequestTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<ContentRequestTypeEnum>>>;
};

export type NullableOfDisciplineEnumOperationFilterInput = {
  eq?: InputMaybe<DisciplineEnum>;
  in?: InputMaybe<Array<InputMaybe<DisciplineEnum>>>;
  neq?: InputMaybe<DisciplineEnum>;
  nin?: InputMaybe<Array<InputMaybe<DisciplineEnum>>>;
};

export type NullableOfLibraryCacheStatusOperationFilterInput = {
  eq?: InputMaybe<LibraryCacheStatus>;
  in?: InputMaybe<Array<InputMaybe<LibraryCacheStatus>>>;
  neq?: InputMaybe<LibraryCacheStatus>;
  nin?: InputMaybe<Array<InputMaybe<LibraryCacheStatus>>>;
};

export type NullableOfRequestResolutionEnumOperationFilterInput = {
  eq?: InputMaybe<RequestResolutionEnum>;
  in?: InputMaybe<Array<InputMaybe<RequestResolutionEnum>>>;
  neq?: InputMaybe<RequestResolutionEnum>;
  nin?: InputMaybe<Array<InputMaybe<RequestResolutionEnum>>>;
};

export type NullableOfRequestStateEnumOperationFilterInput = {
  eq?: InputMaybe<RequestStateEnum>;
  in?: InputMaybe<Array<InputMaybe<RequestStateEnum>>>;
  neq?: InputMaybe<RequestStateEnum>;
  nin?: InputMaybe<Array<InputMaybe<RequestStateEnum>>>;
};

export type NullableOfRequestStatusEnumOperationFilterInput = {
  eq?: InputMaybe<RequestStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<RequestStatusEnum>>>;
  neq?: InputMaybe<RequestStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<RequestStatusEnum>>>;
};

export type NullableOfUserRoleEnumOperationFilterInput = {
  eq?: InputMaybe<UserRoleEnum>;
  in?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  neq?: InputMaybe<UserRoleEnum>;
  nin?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type PendingRequestsConnection = {
  __typename?: 'PendingRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PendingRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContentVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PendingRequestsEdge = {
  __typename?: 'PendingRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentVersion>;
};

/** A BIM project associated with a client, containing models, approved content, and team members. */
export type Project = {
  __typename?: 'Project';
  /** The Autodesk Platform Services (APS) project ID for BIM 360/ACC integration. */
  aPSProjectId?: Maybe<Scalars['String']['output']>;
  /** List of user IDs who are administrators of this project. */
  adminIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the users who are administrators of this project. */
  admins?: Maybe<Array<Maybe<User>>>;
  /** Retrieves all non-private projects in the system. */
  allProjects?: Maybe<AllProjectsConnection>;
  /** List of content IDs that have been approved for use in this project. */
  approvedContentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the content items approved for use in this project. */
  approvedContents?: Maybe<Array<Maybe<Content>>>;
  /** Assigns health checks to multiple projects. Supports overwriting existing assignments. Requires system admin access. */
  assignHealthChecks?: Maybe<Scalars['Float']['output']>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the client organization this project belongs to. */
  client?: Maybe<Client>;
  /** The ID of the client organization this project belongs to. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** The project code extracted from the cloud path. */
  code?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new project. Does not require admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes projects and all their models. Requires system admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes users from the project admin list. Requires project admin access. */
  deleteAdmins?: Maybe<Scalars['Float']['output']>;
  /** Removes content items from the approved list. */
  deleteApprovedContents?: Maybe<Scalars['Float']['output']>;
  /** Removes dynamic data entries from this project. */
  deleteDynamicData?: Maybe<Scalars['Float']['output']>;
  /** Removes health check assignments from this project. Requires project admin access. */
  deleteHealthChecks?: Maybe<Scalars['Float']['output']>;
  /** Removes users from the project member list. Requires project admin access. */
  deleteMembers?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this project. Requires project admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** Removes dynamic data entries from a user that are scoped to this project. Caller must be a project admin. */
  deleteUserDynamicData?: Maybe<Scalars['Float']['output']>;
  /** Removes workset configurations from this project. Requires project admin access. */
  deleteWorksets?: Maybe<Scalars['Float']['output']>;
  /** A free-text description of the project. */
  description?: Maybe<Scalars['String']['output']>;
  /** Custom dynamic data entries associated with this project. */
  dynamicData?: Maybe<Array<Maybe<DynamicData>>>;
  /** List of health check IDs assigned to this project. */
  healthCheckIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the health check entities assigned to this project. */
  healthChecks?: Maybe<Array<Maybe<HealthCheck>>>;
  /** The unique identifier of the project. */
  id?: Maybe<Scalars['String']['output']>;
  /** Returns whether the current authenticated user has admin access to this project. */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this project is private. Private projects are only visible to their members and admins. */
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** Retrieves a project by ID. Non-admin users only see projects they are members or admins of. */
  item?: Maybe<Project>;
  /** Retrieves all projects. Non-admin users only see projects they are members or admins of. */
  items?: Maybe<ItemsConnection>;
  /** Retrieves the content library assigned to this project. */
  library?: Maybe<Library>;
  /** The ID of the content library assigned to this project. */
  libraryId?: Maybe<Scalars['String']['output']>;
  /** List of user IDs who are members of this project. */
  memberIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the users who are members of this project. */
  members?: Maybe<Array<Maybe<User>>>;
  /** Retrieves the BIM models associated with this project. */
  models?: Maybe<Array<Maybe<Model>>>;
  /** The display name of the project. */
  name?: Maybe<Scalars['String']['output']>;
  /** The cloud document path (e.g., 'BIM360://...' or 'AutodeskDocs://...') used to identify the project. */
  path?: Maybe<Scalars['String']['output']>;
  /** Finds or creates a project by its Autodesk Platform Services (APS) project ID. */
  projectByAPSId?: Maybe<Project>;
  /** An optional sub-name for the project, used for additional identification. */
  projectSubName?: Maybe<Scalars['String']['output']>;
  /** Finds or creates a project by its cloud document path (BIM360 or Autodesk Docs). Auto-registers the current user as a member. */
  projet?: Maybe<Project>;
  /** Adds a user as a project admin. Requires project admin access. */
  setAdmin?: Maybe<Scalars['Float']['output']>;
  /** Adds content items to the approved list for this project. */
  setApprovedContents?: Maybe<Scalars['Float']['output']>;
  /** Changes the client organization for this project. Requires project admin access. */
  setClient?: Maybe<Scalars['Float']['output']>;
  /** Adds a dynamic data entry to this project. */
  setDynamicData?: Maybe<Scalars['Float']['output']>;
  /** Adds health check assignments to this project. Requires project admin access. */
  setHealthChecks?: Maybe<Scalars['Float']['output']>;
  /** Changes the content library for this project. Requires project admin access. */
  setLibrary?: Maybe<Scalars['Float']['output']>;
  /** Adds a user as a project member. Requires project admin access. */
  setMember?: Maybe<Scalars['Float']['output']>;
  /** Adds the current user as a member of the specified project. */
  setProjectAccess?: Maybe<Scalars['Float']['output']>;
  /** Updates the project sub-name. Requires project admin access. */
  setProjectSubName?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this project. Requires project admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns a dynamic data entry to a user on behalf of this project. Caller must be a project admin. OwnerId is automatically set to this project's ID. If an entry with the same Type and OwnerId already exists, it is replaced. Returns a SAS upload URL for the new entry's blob. */
  setUserDynamicData?: Maybe<Scalars['String']['output']>;
  /** Adds a workset configuration to this project. Requires project admin access. */
  setWorkset?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Toggles the private visibility of this project. Requires project admin access. */
  togglePrivate?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  /** Workset definitions configured for this project. */
  worksets?: Maybe<Array<Maybe<Workset>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectAllProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProjectSortInput>>;
  where?: InputMaybe<ProjectFilterInput>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectAssignHealthChecksArgs = {
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectCreateArgs = {
  item?: InputMaybe<ProjectInput>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteAdminsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteApprovedContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteDynamicDataArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteHealthChecksArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteMembersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteUserDynamicDataArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectDeleteWorksetsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProjectSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ProjectFilterInput>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectProjectByApsIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectProjetArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetAdminArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetApprovedContentsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetClientArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetDynamicDataArgs = {
  data?: InputMaybe<DynamicDataInput>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetHealthChecksArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetLibraryArgs = {
  libraryId?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetMemberArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetProjectAccessArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetProjectSubNameArgs = {
  projectSubName?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetUserDynamicDataArgs = {
  data?: InputMaybe<DynamicDataInput>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
};


/** A BIM project associated with a client, containing models, approved content, and team members. */
export type ProjectSetWorksetArgs = {
  workset?: InputMaybe<WorksetInput>;
};

export type ProjectFilterInput = {
  aPSProjectId?: InputMaybe<StringOperationFilterInput>;
  adminIds?: InputMaybe<ListStringOperationFilterInput>;
  and?: InputMaybe<Array<ProjectFilterInput>>;
  approvedContentIds?: InputMaybe<ListStringOperationFilterInput>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dynamicData?: InputMaybe<ListFilterInputTypeOfDynamicDataFilterInput>;
  healthCheckIds?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isPrivate?: InputMaybe<BooleanOperationFilterInput>;
  libraryId?: InputMaybe<StringOperationFilterInput>;
  memberIds?: InputMaybe<ListStringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  path?: InputMaybe<StringOperationFilterInput>;
  projectSubName?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
  worksets?: InputMaybe<ListFilterInputTypeOfWorksetFilterInput>;
};

export type ProjectInput = {
  aPSProjectId?: InputMaybe<Scalars['String']['input']>;
  adminIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedContentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicData?: InputMaybe<Array<InputMaybe<DynamicDataInput>>>;
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  projectSubName?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
  worksets?: InputMaybe<Array<InputMaybe<WorksetInput>>>;
};

/** A connection to a list of items. */
export type ProjectListConnection = {
  __typename?: 'ProjectListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProjectListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectListEdge = {
  __typename?: 'ProjectListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

export type ProjectSortInput = {
  aPSProjectId?: InputMaybe<SortEnumType>;
  clientId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPrivate?: InputMaybe<SortEnumType>;
  libraryId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  projectSubName?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type QueryType = {
  __typename?: 'QueryType';
  /** Retrieves all non-private projects in the system. */
  AllProjects?: Maybe<AllProjectsConnection>;
  /** Retrieves the distinct list of application names (e.g., 'Revit', 'ArchiCAD') across all current content versions. */
  ApplicationNameList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves archived tags so system administrators can restore them. */
  ArchivedTagList?: Maybe<ArchivedTagListConnection>;
  /** Retrieves requests assigned to the current user. */
  AssignedRequests?: Maybe<AssignedRequestsConnection>;
  /** Retrieves a single Attachment by its unique identifier. */
  Attachment?: Maybe<Attachment>;
  /** Returns the total count of all Attachment items. */
  AttachmentCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Attachment items. */
  AttachmentList?: Maybe<AttachmentListConnection>;
  /** Retrieves the distinct list of content categories across all current content versions. */
  CategoryList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves a single Classification by its unique identifier. */
  Classification?: Maybe<Classification>;
  /** Returns the total count of all Classification items. */
  ClassificationCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Classification items. */
  ClassificationList?: Maybe<ClassificationListConnection>;
  /** Retrieves a single ClassificationType by its unique identifier. */
  ClassificationType?: Maybe<ClassificationType>;
  /** Returns the total count of all ClassificationType items. */
  ClassificationTypeCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of ClassificationType items. */
  ClassificationTypeList?: Maybe<ClassificationTypeListConnection>;
  /** Retrieves a single Client by its unique identifier. */
  Client?: Maybe<Client>;
  /** Returns the total count of all Client items. */
  ClientCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Client items. */
  ClientList?: Maybe<ClientListConnection>;
  /** Retrieves a single Command by its unique identifier. */
  Command?: Maybe<Command>;
  /** Returns the total count of all Command items. */
  CommandCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Command items. */
  CommandList?: Maybe<CommandListConnection>;
  /** Retrieves a single Content by its unique identifier. */
  Content?: Maybe<Content>;
  /** Returns the total count of all Content items. */
  ContentCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Content items. */
  ContentList?: Maybe<ContentListConnection>;
  /** Retrieves a single ContentType by its unique identifier. */
  ContentType?: Maybe<ContentType>;
  /** Returns the total count of all ContentType items. */
  ContentTypeCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of ContentType items. */
  ContentTypeList?: Maybe<ContentTypeListConnection>;
  /** Retrieves a single ContentVersion by its unique identifier. */
  ContentVersion?: Maybe<ContentVersion>;
  /** Returns the total count of all ContentVersion items. */
  ContentVersionCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of ContentVersion items. */
  ContentVersionList?: Maybe<ContentVersionListConnection>;
  /** Retrieves content items from a library using a client secret for service-to-service authentication. Does not require user auth. */
  ContentsBySecret?: Maybe<ContentsBySecretConnection>;
  /** Retrieves the system-wide default settings (default client, library, and feature flags). */
  Default?: Maybe<Default>;
  /** Returns the total count of all Default items. */
  DefaultCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Default items. */
  DefaultList?: Maybe<DefaultListConnection>;
  /** Retrieves a single Group by its unique identifier. */
  Group?: Maybe<Group>;
  /** Returns the total count of all Group items. */
  GroupCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Group items. */
  GroupList?: Maybe<GroupListConnection>;
  /** Retrieves a single HealthCheck by its unique identifier. */
  HealthCheck?: Maybe<HealthCheck>;
  /** Returns the total count of all HealthCheck items. */
  HealthCheckCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of HealthCheck items. */
  HealthCheckList?: Maybe<HealthCheckListConnection>;
  /** Retrieves a single History by its unique identifier. */
  History?: Maybe<History>;
  /** Returns the total count of all History items. */
  HistoryCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of History items. */
  HistoryList?: Maybe<HistoryListConnection>;
  /** Retrieves a single IFC by its unique identifier. */
  IFC?: Maybe<Ifc>;
  /** Returns the total count of all IFC items. */
  IFCCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a single IFCEntity by its unique identifier. */
  IFCEntity?: Maybe<IfcEntity>;
  /** Returns the total count of all IFCEntity items. */
  IFCEntityCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of IFCEntity items. */
  IFCEntityList?: Maybe<IfcEntityListConnection>;
  /** Retrieves a paginated, filterable, and sortable list of IFC items. */
  IFCList?: Maybe<IfcListConnection>;
  /** Retrieves a single IFCProp by its unique identifier. */
  IFCProp?: Maybe<IfcProp>;
  /** Returns the total count of all IFCProp items. */
  IFCPropCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of IFCProp items. */
  IFCPropList?: Maybe<IfcPropListConnection>;
  /** Retrieves a single IFCProperty by its unique identifier. */
  IFCProperty?: Maybe<IfcProperty>;
  /** Returns the total count of all IFCProperty items. */
  IFCPropertyCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of IFCProperty items. */
  IFCPropertyList?: Maybe<IfcPropertyListConnection>;
  /** Retrieves a single IFCPropertySet by its unique identifier. */
  IFCPropertySet?: Maybe<IfcPropertySet>;
  /** Returns the total count of all IFCPropertySet items. */
  IFCPropertySetCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of IFCPropertySet items. */
  IFCPropertySetList?: Maybe<IfcPropertySetListConnection>;
  /** Retrieves a single IFCPset by its unique identifier. */
  IFCPset?: Maybe<IfcPset>;
  /** Returns the total count of all IFCPset items. */
  IFCPsetCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of IFCPset items. */
  IFCPsetList?: Maybe<IfcPsetListConnection>;
  /** Retrieves a single Library by its unique identifier. */
  Library?: Maybe<Library>;
  /** Retrieves the most recent library cache regeneration run summary written by the LibraryCache timer function. Null when no run has completed since the environment was deployed. */
  LibraryCacheRunSummary?: Maybe<LibraryCacheRunSummary>;
  /** Returns the total count of all Library items. */
  LibraryCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Library items. */
  LibraryList?: Maybe<LibraryListConnection>;
  /** Retrieves a single Map by its unique identifier. */
  Map?: Maybe<Map>;
  /** Returns the total count of all Map items. */
  MapCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Map items. */
  MapList?: Maybe<MapListConnection>;
  /** Retrieves the profile of the currently authenticated user. */
  Me?: Maybe<User>;
  /** Retrieves a single Model by its unique identifier. */
  Model?: Maybe<Model>;
  /** Finds or creates a BIM model by project ID and model name. */
  ModelByName?: Maybe<Model>;
  /** Returns the total count of all Model items. */
  ModelCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Model items. */
  ModelList?: Maybe<ModelListConnection>;
  /** Retrieves content requests submitted by the current user. Supports filtering by status and discipline, with sorting options. */
  MyRequests?: Maybe<MyRequestsConnection>;
  /** Retrieves content requests requiring action from the current user based on their role. */
  NeedActionRequests?: Maybe<NeedActionRequestsConnection>;
  /** Retrieves all open content requests. */
  PendingRequests?: Maybe<PendingRequestsConnection>;
  /** Returns the count of all pending content requests. */
  PendingRequestsCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a single Project by its unique identifier. */
  Project?: Maybe<Project>;
  /** Finds or creates a project by its Autodesk Platform Services (APS) project ID. */
  ProjectByAPSId?: Maybe<Project>;
  /** Finds or creates a project by its cloud document path (BIM360 or Autodesk Docs). Auto-registers the current user as a member. */
  ProjectByPath?: Maybe<Project>;
  /** Returns the total count of all Project items. */
  ProjectCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Project items. */
  ProjectList?: Maybe<ProjectListConnection>;
  /** Retrieves all content requests with optional filtering by status and discipline. */
  Requests?: Maybe<RequestsConnection>;
  /** Returns the total count of content requests, optionally filtered by status and discipline. */
  RequestsCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves the distinct list of content sub-categories across all current content versions. */
  SubCategoryList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves a single Tag by its unique identifier. */
  Tag?: Maybe<Tag>;
  /** Returns the total count of all Tag items. */
  TagCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Tag items. */
  TagList?: Maybe<TagListConnection>;
  /** Retrieves tag type configuration, including content request requirements. */
  TagTypeSettings?: Maybe<Array<Maybe<TagType>>>;
  /** Retrieves the distinct list of tag type values used across active tags. */
  TagTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves a single Uniclass by its unique identifier. */
  Uniclass?: Maybe<Uniclass>;
  /** Returns the total count of all Uniclass items. */
  UniclassCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Uniclass items. */
  UniclassList?: Maybe<UniclassListConnection>;
  /** Retrieves a single User by its unique identifier. */
  User?: Maybe<User>;
  /** Returns the total count of all User items. */
  UserCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of User items. */
  UserList?: Maybe<UserListConnection>;
  /** Retrieves a single VBIS by its unique identifier. */
  VBIS?: Maybe<Vbis>;
  /** Returns the total count of all VBIS items. */
  VBISCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of VBIS items. */
  VBISList?: Maybe<VbisListConnection>;
  /** Retrieves a single Workset by its unique identifier. */
  Workset?: Maybe<Workset>;
  /** Returns the total count of all Workset items. */
  WorksetCount?: Maybe<Scalars['Long']['output']>;
  /** Retrieves a paginated, filterable, and sortable list of Workset items. */
  WorksetList?: Maybe<WorksetListConnection>;
  _schemaDefinition?: Maybe<_SchemaDefinition>;
};


export type QueryTypeAllProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProjectSortInput>>;
  where?: InputMaybe<ProjectFilterInput>;
};


export type QueryTypeArchivedTagListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TagSortInput>>;
  where?: InputMaybe<TagFilterInput>;
};


export type QueryTypeAssignedRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


export type QueryTypeAttachmentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeAttachmentListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AttachmentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<AttachmentFilterInput>;
};


export type QueryTypeClassificationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeClassificationListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClassificationSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ClassificationFilterInput>;
};


export type QueryTypeClassificationTypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeClassificationTypeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClassificationTypeSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ClassificationTypeFilterInput>;
};


export type QueryTypeClientArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeClientListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ClientSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ClientFilterInput>;
};


export type QueryTypeCommandArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeCommandListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CommandSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<CommandFilterInput>;
};


export type QueryTypeContentArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeContentListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentFilterInput>;
};


export type QueryTypeContentTypeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeContentTypeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentTypeSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentTypeFilterInput>;
};


export type QueryTypeContentVersionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeContentVersionListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


export type QueryTypeContentsBySecretArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ContentSortInput>>;
  secret?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentFilterInput>;
};


export type QueryTypeDefaultArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeDefaultListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DefaultSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<DefaultFilterInput>;
};


export type QueryTypeGroupArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeGroupListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GroupSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<GroupFilterInput>;
};


export type QueryTypeHealthCheckArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeHealthCheckListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HealthCheckSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<HealthCheckFilterInput>;
};


export type QueryTypeHistoryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeHistoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HistorySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<HistoryFilterInput>;
};


export type QueryTypeIfcArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeIfcEntityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeIfcEntityListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcEntitySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcEntityFilterInput>;
};


export type QueryTypeIfcListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcFilterInput>;
};


export type QueryTypeIfcPropArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeIfcPropListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPropSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPropFilterInput>;
};


export type QueryTypeIfcPropertyArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeIfcPropertyListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPropertySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPropertyFilterInput>;
};


export type QueryTypeIfcPropertySetArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeIfcPropertySetListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPropertySetSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPropertySetFilterInput>;
};


export type QueryTypeIfcPsetArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeIfcPsetListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<IfcPsetSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<IfcPsetFilterInput>;
};


export type QueryTypeLibraryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeLibraryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LibrarySortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<LibraryFilterInput>;
};


export type QueryTypeMapArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeMapListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MapSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<MapFilterInput>;
};


export type QueryTypeModelArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeModelByNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeModelListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ModelSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ModelFilterInput>;
};


export type QueryTypeMyRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


export type QueryTypeNeedActionRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  status?: InputMaybe<RequestStatusEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


export type QueryTypePendingRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


export type QueryTypeProjectArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeProjectByApsIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeProjectByPathArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeProjectListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProjectSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<ProjectFilterInput>;
};


export type QueryTypeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput>>;
  state?: InputMaybe<RequestStateEnum>;
  where?: InputMaybe<ContentVersionFilterInput>;
};


export type QueryTypeRequestsCountArgs = {
  discipline?: InputMaybe<DisciplineEnum>;
  state?: InputMaybe<RequestStateEnum>;
};


export type QueryTypeTagArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeTagListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TagSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<TagFilterInput>;
};


export type QueryTypeUniclassArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeUniclassListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UniclassSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<UniclassFilterInput>;
};


export type QueryTypeUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeUserListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryTypeVbisArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeVbisListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VbisSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<VbisFilterInput>;
};


export type QueryTypeWorksetArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeWorksetListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WorksetSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<WorksetFilterInput>;
};


export type QueryType_SchemaDefinitionArgs = {
  configuration: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type RegisteredContentsConnection = {
  __typename?: 'RegisteredContentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RegisteredContentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegisteredContentsEdge = {
  __typename?: 'RegisteredContentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

export enum RequestResolutionEnum {
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Published = 'PUBLISHED'
}

export enum RequestStateEnum {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/** The workflow status of a content version request, tracking its progress through the approval pipeline. */
export enum RequestStatusEnum {
  /** Request has been approved and content is available in the library. */
  Approved = 'APPROVED',
  /** Content has been developed and uploaded, awaiting final review. */
  Developed = 'DEVELOPED',
  /** A modeller has been assigned and is developing the content. */
  InDevelopment = 'IN_DEVELOPMENT',
  /** No status set. */
  None = 'NONE',
  /** Request has been rejected and requires resubmission. */
  Rejected = 'REJECTED',
  /** Request has been submitted and is awaiting verification by an administrator of its assigned library. */
  Submitted = 'SUBMITTED',
  /** Request has been verified and is awaiting resource assignment by a resource manager. */
  Verified = 'VERIFIED'
}

/** A connection to a list of items. */
export type RequestsConnection = {
  __typename?: 'RequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContentVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RequestsEdge = {
  __typename?: 'RequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentVersion>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitDraftPayload = {
  __typename?: 'SubmitDraftPayload';
  historyId?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type Tag = {
  __typename?: 'Tag';
  /** Archives tags without removing references from existing records. Requires system admin access. */
  archive?: Maybe<Scalars['Float']['output']>;
  /** Retrieves archived tags so system administrators can restore them. */
  archivedItems?: Maybe<ArchivedItemsConnection>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Returns the full display name of the tag in the format 'Type: Name'. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the tag. */
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Tag>;
  /** Retrieves active tags. Archived tags remain available through ArchivedTagList and direct reference resolution. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the tag. */
  name?: Maybe<Scalars['String']['output']>;
  /** Restores archived tags so they can be selected again. Requires system admin access. */
  restore?: Maybe<Scalars['Float']['output']>;
  /** Updates the description of this tag. Requires system admin access. */
  setDescription?: Maybe<Scalars['Float']['output']>;
  /** Updates the name of this tag. Requires system admin access. */
  setName?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** Updates the type/category of this tag. Requires system admin access. */
  setType?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the distinct list of active tag type values. */
  tagTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The tag type/category, used to group related tags together. */
  type?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagArchiveArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagArchivedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TagSortInput>>;
  where?: InputMaybe<TagFilterInput>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagCreateArgs = {
  item?: InputMaybe<TagInput>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TagSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<TagFilterInput>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagRestoreArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagSetDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A tag used for categorizing and filtering content, libraries, clients, and other entities. */
export type TagSetTypeArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TagFilterInput = {
  and?: InputMaybe<Array<TagFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TagFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type TagInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type TagListConnection = {
  __typename?: 'TagListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TagListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TagListEdge = {
  __typename?: 'TagListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Tag>;
};

export type TagSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type TagType = {
  __typename?: 'TagType';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  darkModeColour?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<TagType>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  lightModeColour?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requiredForContentRequests?: Maybe<Scalars['Boolean']['output']>;
  /** Sets the default light- and dark-mode colours for a tag type. */
  setColours?: Maybe<Scalars['String']['output']>;
  /** Sets whether a tag type requires at least one active tag on content requests. */
  setRequiredForContentRequests?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** Returns all tag types, including types inferred from active tags and their request requirement settings. */
  settings?: Maybe<Array<Maybe<TagType>>>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


export type TagTypeAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TagTypeCreateArgs = {
  item?: InputMaybe<TagTypeInput>;
};


export type TagTypeDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TagTypeDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TagTypeItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type TagTypeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TagTypeSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<TagTypeFilterInput>;
};


export type TagTypeSetColoursArgs = {
  darkModeColour?: InputMaybe<Scalars['String']['input']>;
  lightModeColour?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type TagTypeSetRequiredForContentRequestsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};


export type TagTypeSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TagTypeFilterInput = {
  and?: InputMaybe<Array<TagTypeFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  darkModeColour?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lightModeColour?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TagTypeFilterInput>>;
  requiredForContentRequests?: InputMaybe<BooleanOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type TagTypeInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  darkModeColour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lightModeColour?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredForContentRequests?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

export type TagTypeSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  darkModeColour?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lightModeColour?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  requiredForContentRequests?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type Uniclass = {
  __typename?: 'Uniclass';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The numeric group code within the Uniclass hierarchy. */
  group: Scalars['Int']['output'];
  /** The unique identifier of the Uniclass entry. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Uniclass>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The NBS (National Building Specification) code associated with this entry. */
  nBSCode?: Maybe<Scalars['String']['output']>;
  /** The Uniclass code (e.g., 'Ss_25_10_30'). */
  name?: Maybe<Scalars['String']['output']>;
  /** The numeric object code within the Uniclass hierarchy. */
  object?: Maybe<Scalars['Int']['output']>;
  /** The numeric section code within the Uniclass hierarchy. */
  section?: Maybe<Scalars['Int']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** The numeric sub-group code within the Uniclass hierarchy. */
  subGroup?: Maybe<Scalars['Int']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The human-readable title of this Uniclass entry. */
  title?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type UniclassAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type UniclassCreateArgs = {
  item?: InputMaybe<UniclassInput>;
};


/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type UniclassDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type UniclassDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type UniclassItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type UniclassItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UniclassSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<UniclassFilterInput>;
};


/** A Uniclass 2015 classification entry, a UK-standard unified classification system for the construction industry. */
export type UniclassSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UniclassFilterInput = {
  and?: InputMaybe<Array<UniclassFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  nBSCode?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  object?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<UniclassFilterInput>>;
  section?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  subGroup?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type UniclassInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  nBSCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<Scalars['Int']['input']>;
  subGroup?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type UniclassListConnection = {
  __typename?: 'UniclassListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UniclassListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Uniclass>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UniclassListEdge = {
  __typename?: 'UniclassListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Uniclass>;
};

export type UniclassSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  nBSCode?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  object?: InputMaybe<SortEnumType>;
  section?: InputMaybe<SortEnumType>;
  subGroup?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UnregisteredContentsConnection = {
  __typename?: 'UnregisteredContentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UnregisteredContentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UnregisteredContentsEdge = {
  __typename?: 'UnregisteredContentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

export type UploadCandidateInput = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clientKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadRequestOption = {
  __typename?: 'UploadRequestOption';
  applicationName?: Maybe<Scalars['String']['output']>;
  assignedToId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requestType?: Maybe<ContentRequestTypeEnum>;
  state?: Maybe<RequestStateEnum>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadTargetResolution = {
  __typename?: 'UploadTargetResolution';
  availableRequests?: Maybe<Array<Maybe<UploadRequestOption>>>;
  clientKey?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentTagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currentVersionId?: Maybe<Scalars['String']['output']>;
  isAmbiguous: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  requestState?: Maybe<RequestStateEnum>;
  requestTagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requestType?: Maybe<ContentRequestTypeEnum>;
};

/** A system user with authentication, role, and discipline information. */
export type User = {
  __typename?: 'User';
  /** Retrieves the client organizations the current user is an admin of. */
  adminOfClients?: Maybe<Array<Maybe<Client>>>;
  /** Retrieves the libraries the current user is an admin of, optionally filtered by client ID. */
  adminOfLibraries?: Maybe<Array<Maybe<Library>>>;
  /** Retrieves the projects the current user is an admin of within a specific client. */
  adminOfProjects?: Maybe<Array<Maybe<Project>>>;
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** The Auth0 subject identifier used for authentication. */
  auth0Id?: Maybe<Scalars['String']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Retrieves the profile of the currently authenticated user. */
  currentUser?: Maybe<User>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes dynamic data entries from the current user. Only removes the blob from storage when the entry is owned by the current user (SharedById is null). */
  deleteDynamicData?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  /** Removes the role assignment from a user, resetting them to None. Requires system admin access. */
  deleteUserRole?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The engineering discipline the user is associated with. */
  discipline?: Maybe<DisciplineEnum>;
  /** Custom dynamic data entries associated with this user. */
  dynamicData?: Maybe<Array<Maybe<DynamicData>>>;
  /** The email address of the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the user. */
  id?: Maybe<Scalars['String']['output']>;
  /** Returns whether the current user is an admin of any libraries. */
  isAdminOfAnyLibraries?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether the current user is an admin of any projects. */
  isAdminOfAnyProjects?: Maybe<Scalars['Boolean']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<User>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the user. */
  name?: Maybe<Scalars['String']['output']>;
  /** Revokes a previously shared dynamic data entry from another user. The blob is not deleted. */
  revokeDynamicData?: Maybe<Scalars['Float']['output']>;
  /** The system role of the user, determining their permissions. */
  role?: Maybe<UserRoleEnum>;
  /** Assigns an admin role and discipline to a user. Requires system admin access. */
  setAdmin?: Maybe<Scalars['Float']['output']>;
  /** Adds a dynamic data entry to the current user. */
  setDynamicData?: Maybe<Scalars['Float']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** Assigns a role and discipline to a user. Requires system admin access. */
  setUserRole?: Maybe<Scalars['Float']['output']>;
  /** Shares an owned dynamic data entry with another user by copying the reference. The blob is not duplicated. */
  shareDynamicData?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A system user with authentication, role, and discipline information. */
export type UserAdminOfLibrariesArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


/** A system user with authentication, role, and discipline information. */
export type UserAdminOfProjectsArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


/** A system user with authentication, role, and discipline information. */
export type UserAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A system user with authentication, role, and discipline information. */
export type UserCreateArgs = {
  item?: InputMaybe<UserInput>;
};


/** A system user with authentication, role, and discipline information. */
export type UserDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A system user with authentication, role, and discipline information. */
export type UserDeleteDynamicDataArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A system user with authentication, role, and discipline information. */
export type UserDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A system user with authentication, role, and discipline information. */
export type UserDeleteUserRoleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A system user with authentication, role, and discipline information. */
export type UserItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A system user with authentication, role, and discipline information. */
export type UserItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<UserFilterInput>;
};


/** A system user with authentication, role, and discipline information. */
export type UserRevokeDynamicDataArgs = {
  dynamicDataId?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
};


/** A system user with authentication, role, and discipline information. */
export type UserSetAdminArgs = {
  discipline: DisciplineEnum;
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A system user with authentication, role, and discipline information. */
export type UserSetDynamicDataArgs = {
  data?: InputMaybe<DynamicDataInput>;
};


/** A system user with authentication, role, and discipline information. */
export type UserSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A system user with authentication, role, and discipline information. */
export type UserSetUserRoleArgs = {
  discipline: DisciplineEnum;
  id?: InputMaybe<Scalars['String']['input']>;
  role: UserRoleEnum;
};


/** A system user with authentication, role, and discipline information. */
export type UserShareDynamicDataArgs = {
  dynamicDataId?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  auth0Id?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discipline?: InputMaybe<NullableOfDisciplineEnumOperationFilterInput>;
  dynamicData?: InputMaybe<ListFilterInputTypeOfDynamicDataFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  role?: InputMaybe<NullableOfUserRoleEnumOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type UserInput = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<DisciplineEnum>;
  dynamicData?: InputMaybe<Array<InputMaybe<DynamicDataInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleEnum>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type UserListConnection = {
  __typename?: 'UserListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserListEdge = {
  __typename?: 'UserListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** The role assigned to a user, determining their access level and permissions in the system. */
export enum UserRoleEnum {
  /** System administrator with full access to all operations. */
  Admin = 'ADMIN',
  /** Can develop and upload content for assigned requests. */
  Modeller = 'MODELLER',
  /** No role assigned. User has basic read access only. */
  None = 'NONE',
  /** Can assign modellers to verified content requests. */
  ResourceManager = 'RESOURCE_MANAGER'
}

export type UserSortInput = {
  auth0Id?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  discipline?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type Vbis = {
  __typename?: 'VBIS';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The engineering discipline (e.g., 'Mechanical', 'Electrical'). */
  discipline?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the VBIS entry. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Vbis>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The VBIS code identifier. */
  name?: Maybe<Scalars['String']['output']>;
  /** The product category within the discipline. */
  product?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  /** The granular sub-sub-type classification. */
  subSubType?: Maybe<Scalars['String']['output']>;
  /** The sub-type classification within the product. */
  subType?: Maybe<Scalars['String']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The human-readable title of this VBIS entry. */
  title?: Maybe<Scalars['String']['output']>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type VbisAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type VbisCreateArgs = {
  item?: InputMaybe<VbisInput>;
};


/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type VbisDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type VbisDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type VbisItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type VbisItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VbisSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<VbisFilterInput>;
};


/** A VBIS (Virtual Building Information System) classification entry for standardized building component identification. */
export type VbisSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VbisFilterInput = {
  and?: InputMaybe<Array<VbisFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discipline?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VbisFilterInput>>;
  product?: InputMaybe<StringOperationFilterInput>;
  subSubType?: InputMaybe<StringOperationFilterInput>;
  subType?: InputMaybe<StringOperationFilterInput>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type VbisInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  subSubType?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type VbisListConnection = {
  __typename?: 'VBISListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VbisListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Vbis>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VbisListEdge = {
  __typename?: 'VBISListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Vbis>;
};

export type VbisSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  discipline?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  product?: InputMaybe<SortEnumType>;
  subSubType?: InputMaybe<SortEnumType>;
  subType?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

/** A workset definition used to organize elements in BIM models for collaboration. */
export type Workset = {
  __typename?: 'Workset';
  /** Assigns tags to multiple items at once. Requires admin access. */
  assignTags?: Maybe<Scalars['Float']['output']>;
  /** Returns the total count of all items of this type. */
  count?: Maybe<Scalars['Long']['output']>;
  /** Creates a new item. Requires admin access. */
  create?: Maybe<Scalars['Float']['output']>;
  /** Retrieves the user who created this item. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deletes multiple items by their IDs. Requires admin access. */
  delete?: Maybe<Scalars['Float']['output']>;
  /** Removes tags from this item. Requires admin access. */
  deleteTags?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The group this workset belongs to. */
  group?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the workset. */
  id?: Maybe<Scalars['String']['output']>;
  /** Retrieves a single item by its unique identifier. */
  item?: Maybe<Workset>;
  /** Retrieves a paginated, filterable, and sortable list of items. Optionally filters by tag IDs. */
  items?: Maybe<ItemsConnection>;
  /** The display name of the workset. */
  name?: Maybe<Scalars['String']['output']>;
  /** Adds tags to this item by their IDs. Requires admin access. */
  setTags?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Retrieves the tags associated with this item. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Retrieves the user who last updated this item. */
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};


/** A workset definition used to organize elements in BIM models for collaboration. */
export type WorksetAssignTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A workset definition used to organize elements in BIM models for collaboration. */
export type WorksetCreateArgs = {
  item?: InputMaybe<WorksetInput>;
};


/** A workset definition used to organize elements in BIM models for collaboration. */
export type WorksetDeleteArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A workset definition used to organize elements in BIM models for collaboration. */
export type WorksetDeleteTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A workset definition used to organize elements in BIM models for collaboration. */
export type WorksetItemArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** A workset definition used to organize elements in BIM models for collaboration. */
export type WorksetItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<WorksetSortInput>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<WorksetFilterInput>;
};


/** A workset definition used to organize elements in BIM models for collaboration. */
export type WorksetSetTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WorksetFilterInput = {
  and?: InputMaybe<Array<WorksetFilterInput>>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdTime?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorksetFilterInput>>;
  tagIds?: InputMaybe<ListStringOperationFilterInput>;
  updatedById?: InputMaybe<StringOperationFilterInput>;
  updatedTime?: InputMaybe<StringOperationFilterInput>;
};

export type WorksetInput = {
  createdById?: InputMaybe<Scalars['String']['input']>;
  createdTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedTime?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type WorksetListConnection = {
  __typename?: 'WorksetListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<WorksetListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Workset>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type WorksetListEdge = {
  __typename?: 'WorksetListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Workset>;
};

export type WorksetSortInput = {
  createdById?: InputMaybe<SortEnumType>;
  createdTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  updatedById?: InputMaybe<SortEnumType>;
  updatedTime?: InputMaybe<SortEnumType>;
};

export type _SchemaDefinition = {
  __typename?: '_SchemaDefinition';
  document: Scalars['String']['output'];
  extensionDocuments: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ClassificationPropsFragment = { __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateClassificationMutationVariables = Exact<{
  classification?: InputMaybe<ClassificationInput>;
}>;


export type CreateClassificationMutation = { __typename?: 'MutationType', CreateClassification?: number | null };

export type DeleteClassificationListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteClassificationListMutation = { __typename?: 'MutationType', DeleteClassificationList?: number | null };

export type GetClassificationListWithTypeQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ClassificationSortInput> | ClassificationSortInput>;
}>;


export type GetClassificationListWithTypeQuery = { __typename?: 'QueryType', ClassificationList?: { __typename?: 'ClassificationListConnection', nodes?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetClassificationListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ClassificationSortInput> | ClassificationSortInput>;
}>;


export type GetClassificationListQuery = { __typename?: 'QueryType', ClassificationList?: { __typename?: 'ClassificationListConnection', nodes?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetClassificationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClassificationQuery = { __typename?: 'QueryType', Classification?: { __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type ClassificationTypePropsFragment = { __typename?: 'ClassificationType', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateClassificationTypeMutationVariables = Exact<{
  classificationType?: InputMaybe<ClassificationTypeInput>;
}>;


export type CreateClassificationTypeMutation = { __typename?: 'MutationType', CreateClassificationType?: number | null };

export type DeleteClassificationTypeListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteClassificationTypeListMutation = { __typename?: 'MutationType', DeleteClassificationTypeList?: number | null };

export type GetClassificationTypeListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ClassificationTypeSortInput> | ClassificationTypeSortInput>;
}>;


export type GetClassificationTypeListQuery = { __typename?: 'QueryType', ClassificationTypeList?: { __typename?: 'ClassificationTypeListConnection', nodes?: Array<{ __typename?: 'ClassificationType', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetClassificationTypeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClassificationTypeQuery = { __typename?: 'QueryType', ClassificationType?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type ClientPropsFragment = { __typename?: 'Client', id?: string | null, name?: string | null, longName?: string | null, description?: string | null, createdTime?: string | null, isPrivate?: boolean | null, isAdmin?: boolean | null, defaultLibraryId?: string | null, adminIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdById?: string | null, defaultLibrary?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type ToggleClientPrivateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleClientPrivateMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', togglePrivate?: number | null } | null };

export type CreateClientMutationVariables = Exact<{
  client?: InputMaybe<ClientInput>;
}>;


export type CreateClientMutation = { __typename?: 'MutationType', CreateClient?: number | null };

export type DeleteClientsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteClientsMutation = { __typename?: 'MutationType', DeleteClientList?: number | null };

export type EditClientMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditClientMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', setDefaultLibrary?: number | null } | null };

export type AssignClientsTagsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AssignClientsTagsMutation = { __typename?: 'MutationType', AssignClientListTags?: number | null };

export type AssignClientsHealthChecksMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignClientsHealthChecksMutation = { __typename?: 'MutationType', AssignClientsHealthChecks?: number | null };

export type CreateClientWorksetMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  workset?: InputMaybe<WorksetInput>;
}>;


export type CreateClientWorksetMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', setWorkset?: number | null } | null };

export type SetClientAdminMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetClientAdminMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', setAdmin?: number | null } | null };

export type DeleteClientWorksetsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteClientWorksetsMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', deleteWorksets?: number | null } | null };

export type DeleteClientAdminsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteClientAdminsMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', deleteAdmins?: number | null } | null };

export type DeleteClientTagsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteClientTagsMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', deleteTags?: number | null } | null };

export type DeleteClientHealthChecksMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteClientHealthChecksMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', deleteHealthChecks?: number | null } | null };

export type CountClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountClientsQuery = { __typename?: 'QueryType', ClientCount?: any | null };

export type GetClientsQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetClientsQuery = { __typename?: 'QueryType', ClientList?: { __typename?: 'ClientListConnection', nodes?: Array<{ __typename?: 'Client', id?: string | null, name?: string | null, longName?: string | null, description?: string | null, createdTime?: string | null, isPrivate?: boolean | null, isAdmin?: boolean | null, defaultLibraryId?: string | null, adminIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdById?: string | null, defaultLibrary?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetClientsShortQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientsShortQuery = { __typename?: 'QueryType', ClientList?: { __typename?: 'ClientListConnection', nodes?: Array<{ __typename?: 'Client', id?: string | null, name?: string | null, createdTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecentClientCreationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentClientCreationsQuery = { __typename?: 'QueryType', ClientList?: { __typename?: 'ClientListConnection', nodes?: Array<{ __typename?: 'Client', id?: string | null, name?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetClientQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientQuery = { __typename?: 'QueryType', Client?: { __typename?: 'Client', id?: string | null, name?: string | null, longName?: string | null, description?: string | null, createdTime?: string | null, isPrivate?: boolean | null, isAdmin?: boolean | null, defaultLibraryId?: string | null, adminIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdById?: string | null, worksets?: Array<{ __typename?: 'Workset', id?: string | null, name?: string | null, group?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, defaultLibrary?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type CommandPropsFragment = { __typename?: 'Command', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, type?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateCommandMutationVariables = Exact<{
  command?: InputMaybe<CommandInput>;
}>;


export type CreateCommandMutation = { __typename?: 'MutationType', CreateCommand?: number | null };

export type DeleteCommandsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteCommandsMutation = { __typename?: 'MutationType', DeleteCommandList?: number | null };

export type GetCommandsQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCommandsQuery = { __typename?: 'QueryType', CommandList?: { __typename?: 'CommandListConnection', nodes?: Array<{ __typename?: 'Command', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, type?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetCommandQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCommandQuery = { __typename?: 'QueryType', Command?: { __typename?: 'Command', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, type?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type ContentPropsFragment = { __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateContentMutationVariables = Exact<{
  content?: InputMaybe<ContentInput>;
}>;


export type CreateContentMutation = { __typename?: 'MutationType', CreateContent?: number | null };

export type DeleteContentsMutationVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteContentsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', deleteDirectContents?: number | null } | null };

export type MoveContentsMutationVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  targetLibraryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type MoveContentsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', moveContents?: number | null } | null };

export type AssignContentsTagsMutationVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignContentsTagsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', assignContentTags?: number | null } | null };

export type AssignContentsGroupsMutationVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignContentsGroupsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', assignContentGroups?: number | null } | null };

export type AssignContentsClassificationsMutationVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  classificationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignContentsClassificationsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', assignContentClassifications?: number | null } | null };

export type SetContentTypeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContentTypeInput>;
}>;


export type SetContentTypeMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setType?: { __typename?: 'ContentType', id?: string | null, name?: string | null } | null } | null };

export type DeleteContentTypesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteContentTypesMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', deleteTypes?: number | null } | null };

export type DeleteContentTagsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteContentTagsMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', deleteTags?: number | null } | null };

export type EditContentSettingsMutationVariables = Exact<{
  versionId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditContentSettingsMutation = { __typename?: 'MutationType', ContentVersion?: { __typename?: 'ContentVersion', setSettings?: number | null } | null };

export type EditContentTypeSettingsMutationVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditContentTypeSettingsMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setTypeSettings?: number | null } | null };

export type RenameContentMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameContentMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setName?: number | null } | null };

export type EditContentCategoryMutationVariables = Exact<{
  versionId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditContentCategoryMutation = { __typename?: 'MutationType', ContentVersion?: { __typename?: 'ContentVersion', setCategory?: number | null } | null };

export type EditContentApplicationNameMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  applicationName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditContentApplicationNameMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setApplicationName?: number | null } | null };

export type RenameContentTypeMutationVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameContentTypeMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setTypeName?: number | null } | null };

export type EditContentDescriptionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditContentDescriptionMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setDescription?: number | null } | null };

export type EditContentTypeDescriptionMutationVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditContentTypeDescriptionMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setTypeDescription?: number | null } | null };

export type RequestContentFileDownloadMutationVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestContentFileDownloadMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', requestFileDownload?: string | null } | null };

export type SetRelatedContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SetRelatedContentsMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setRelatedContents?: number | null } | null };

export type DeleteRelatedContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteRelatedContentsMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', deleteRelatedContents?: number | null } | null };

export type GetRegisteredContentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ContentSortInput> | ContentSortInput>;
}>;


export type GetRegisteredContentsQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, registeredContents?: { __typename?: 'RegisteredContentsConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetUnregisteredContentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ContentSortInput> | ContentSortInput>;
}>;


export type GetUnregisteredContentsQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, unregisteredContents?: { __typename?: 'UnregisteredContentsConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetContentsWithCategoryQueryVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ContentSortInput> | ContentSortInput>;
}>;


export type GetContentsWithCategoryQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, contents?: { __typename?: 'ContentsConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetContentsQueryVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ContentSortInput> | ContentSortInput>;
}>;


export type GetContentsQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, contents?: { __typename?: 'ContentsConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetDirectContentsQueryVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  includeFileDownload: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<ContentSortInput> | ContentSortInput>;
}>;


export type GetDirectContentsQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, directContents?: { __typename?: 'DirectContentsConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, file?: { __typename?: 'Attachment', name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, types?: Array<{ __typename?: 'ContentType', settings?: string | null } | null> | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetContentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContentQuery = { __typename?: 'QueryType', Content?: { __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, file?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, relatedContents?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, library?: { __typename?: 'Library', name?: string | null, clientId?: string | null } | null } | null> | null, types?: Array<{ __typename?: 'ContentType', id?: string | null, name?: string | null, settings?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, uniclassId?: string | null, vBISId?: string | null, iFCEntityId?: string | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type CountContentQueryVariables = Exact<{ [key: string]: never; }>;


export type CountContentQuery = { __typename?: 'QueryType', ContentCount?: any | null };

export type GetContentShortQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentShortQuery = { __typename?: 'QueryType', ContentList?: { __typename?: 'ContentListConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, createdTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecentContentCreationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentContentCreationsQuery = { __typename?: 'QueryType', ContentList?: { __typename?: 'ContentListConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type SearchContentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  where?: InputMaybe<ContentFilterInput>;
}>;


export type SearchContentsQuery = { __typename?: 'QueryType', ContentList?: { __typename?: 'ContentListConnection', nodes?: Array<{ __typename?: 'Content', subCategory?: string | null, id?: string | null, name?: string | null, category?: string | null, settings?: string | null, description?: string | null, applicationName?: string | null, currentVersionId?: string | null, currentRequestId?: string | null, usageCount?: number | null, createdTime?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, groupIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, relatedContentIds?: Array<string | null> | null, createdById?: string | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, ifcEntity?: { __typename?: 'IFC', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null, title?: string | null } | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, groups?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetContentIdsByTagsQueryVariables = Exact<{
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetContentIdsByTagsQuery = { __typename?: 'QueryType', ContentList?: { __typename?: 'ContentListConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null } | null> | null } | null };

export type GetSavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedSearchesQuery = { __typename?: 'QueryType', ContentList?: { __typename?: 'ContentListConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, settings?: string | null, currentVersionId?: string | null, currentRequestId?: string | null } | null> | null } | null };

export type ContentVersionPropsFragment = { __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, description?: string | null, applicationName?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, baseVersionId?: string | null, closedTime?: string | null, updatedTime?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateContentVersionMutationVariables = Exact<{
  content?: InputMaybe<ContentVersionInput>;
}>;


export type CreateContentVersionMutation = { __typename?: 'MutationType', CreateContentVersion?: number | null };

export type DeleteContentVersionsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteContentVersionsMutation = { __typename?: 'MutationType', DeleteContentVersionList?: number | null };

export type GetContentVersionsQueryVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput> | ContentVersionSortInput>;
}>;


export type GetContentVersionsQuery = { __typename?: 'QueryType', ContentVersionList?: { __typename?: 'ContentVersionListConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, description?: string | null, applicationName?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, baseVersionId?: string | null, closedTime?: string | null, updatedTime?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecentActivityQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentActivityQuery = { __typename?: 'QueryType', ContentVersionList?: { __typename?: 'ContentVersionListConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, status?: RequestStatusEnum | null, updatedTime?: string | null, contentId?: string | null, libraryId?: string | null, clientId?: string | null, content?: { __typename?: 'Content', id?: string | null, name?: string | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null, clientId?: string | null, isAdmin?: boolean | null } | null } | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, histories?: Array<{ __typename?: 'History', id?: string | null, name?: string | null, message?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, tagIds?: Array<string | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GetLibraryRecentActivityQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLibraryRecentActivityQuery = { __typename?: 'QueryType', ContentVersionList?: { __typename?: 'ContentVersionListConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, status?: RequestStatusEnum | null, updatedTime?: string | null, contentId?: string | null, libraryId?: string | null, clientId?: string | null, content?: { __typename?: 'Content', id?: string | null, name?: string | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null, clientId?: string | null, isAdmin?: boolean | null } | null } | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, histories?: Array<{ __typename?: 'History', id?: string | null, name?: string | null, message?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, tagIds?: Array<string | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type GetContentHistoryBadgesQueryVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContentHistoryBadgesQuery = { __typename?: 'QueryType', ContentVersionList?: { __typename?: 'ContentVersionListConnection', nodes?: Array<{ __typename?: 'ContentVersion', contentId?: string | null, histories?: Array<{ __typename?: 'History', createdTime?: string | null, tagIds?: Array<string | null> | null, tags?: Array<{ __typename?: 'Tag', name?: string | null, type?: string | null } | null> | null } | null> | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type AddContentHistoryMutationVariables = Exact<{
  contentVersionId?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<HistoryInput>;
}>;


export type AddContentHistoryMutation = { __typename?: 'MutationType', ContentVersion?: { __typename?: 'ContentVersion', addHistory?: number | null } | null };

export type AddContentHistoryTagsMutationVariables = Exact<{
  contentVersionId?: InputMaybe<Scalars['String']['input']>;
  historyId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AddContentHistoryTagsMutation = { __typename?: 'MutationType', ContentVersion?: { __typename?: 'ContentVersion', addHistoryTags?: number | null } | null };

export type UploadHistoryAttachmentMutationVariables = Exact<{
  contentVersionId?: InputMaybe<Scalars['String']['input']>;
  historyId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UploadHistoryAttachmentMutation = { __typename?: 'MutationType', ContentVersion?: { __typename?: 'ContentVersion', uploadHistoryAttachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null } | null } | null };

export type SetHistoryAttachmentUrlMutationVariables = Exact<{
  contentVersionId?: InputMaybe<Scalars['String']['input']>;
  historyId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetHistoryAttachmentUrlMutation = { __typename?: 'MutationType', ContentVersion?: { __typename?: 'ContentVersion', setHistoryAttachmentUrl?: string | null } | null };

export type DeleteContentHistoryMutationVariables = Exact<{
  contentVersionId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteContentHistoryMutation = { __typename?: 'MutationType', DeleteHistories?: number | null };

export type SetAttachmentUrlMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetAttachmentUrlMutation = { __typename?: 'MutationType', ContentVersion?: { __typename?: 'ContentVersion', setAttachmentUrl?: string | null } | null };

export type GetContentCommentsQueryVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContentCommentsQuery = { __typename?: 'QueryType', ContentVersionList?: { __typename?: 'ContentVersionListConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, histories?: Array<{ __typename?: 'History', id?: string | null, name?: string | null, message?: string | null, createdTime?: string | null, createdById?: string | null, tagIds?: Array<string | null> | null, attachmentDownloadUrl?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null } | null> | null } | null> | null } | null };

export type SearchContentVersionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentVersionFilterInput>;
}>;


export type SearchContentVersionsQuery = { __typename?: 'QueryType', ContentVersionList?: { __typename?: 'ContentVersionListConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, subCategory?: string | null, description?: string | null, applicationName?: string | null, status?: RequestStatusEnum | null, createdTime?: string | null, updatedTime?: string | null, contentId?: string | null, libraryId?: string | null, clientId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, downloadUrl?: string | null } | null, thumbnail?: { __typename?: 'Attachment', id?: string | null, name?: string | null, downloadUrl?: string | null } | null, types?: Array<{ __typename?: 'ContentType', id?: string | null, name?: string | null, thumbnail?: { __typename?: 'Attachment', id?: string | null, name?: string | null, downloadUrl?: string | null } | null } | null> | null, content?: { __typename?: 'Content', id?: string | null, name?: string | null, currentVersionId?: string | null, usageCount?: number | null, tagIds?: Array<string | null> | null, classificationIds?: Array<string | null> | null, thumbnail?: { __typename?: 'Attachment', id?: string | null, name?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, classifications?: Array<{ __typename?: 'Classification', id?: string | null, name?: string | null, description?: string | null, type?: { __typename?: 'ClassificationType', id?: string | null, name?: string | null } | null } | null> | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null, clientId?: string | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type DefaultPropsFragment = { __typename?: 'Default', id?: string | null, name?: string | null, description?: string | null, clientId?: string | null, libraryId?: string | null, isProjSubNameEnabled: boolean, createdTime?: string | null, createdById?: string | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type EditDefaultMutationVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditDefaultMutation = { __typename?: 'MutationType', Default?: { __typename?: 'Default', setClient?: number | null, setLibrary?: number | null } | null };

export type GetDefaultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultQuery = { __typename?: 'QueryType', Default?: { __typename?: 'Default', id?: string | null, name?: string | null, description?: string | null, clientId?: string | null, libraryId?: string | null, isProjSubNameEnabled: boolean, createdTime?: string | null, createdById?: string | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type GroupPropsFragment = { __typename?: 'Group', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateGroupMutationVariables = Exact<{
  group?: InputMaybe<GroupInput>;
}>;


export type CreateGroupMutation = { __typename?: 'MutationType', CreateGroup?: number | null };

export type DeleteGroupListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteGroupListMutation = { __typename?: 'MutationType', DeleteGroupList?: number | null };

export type GetGroupListWithTypeQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<GroupSortInput> | GroupSortInput>;
}>;


export type GetGroupListWithTypeQuery = { __typename?: 'QueryType', GroupList?: { __typename?: 'GroupListConnection', nodes?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetGroupListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<GroupSortInput> | GroupSortInput>;
}>;


export type GetGroupListQuery = { __typename?: 'QueryType', GroupList?: { __typename?: 'GroupListConnection', nodes?: Array<{ __typename?: 'Group', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetGroupQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGroupQuery = { __typename?: 'QueryType', Group?: { __typename?: 'Group', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type HealthCheckPropsFragment = { __typename?: 'HealthCheck', id?: string | null, name?: string | null, description?: string | null, settings?: string | null, group?: string | null, display?: string | null, limit?: number | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateHealthCheckMutationVariables = Exact<{
  healthCheck?: InputMaybe<HealthCheckInput>;
}>;


export type CreateHealthCheckMutation = { __typename?: 'MutationType', CreateHealthCheck?: number | null };

export type DeleteHealthCheckListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteHealthCheckListMutation = { __typename?: 'MutationType', DeleteHealthCheckList?: number | null };

export type AssignHealthChecksTagsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignHealthChecksTagsMutation = { __typename?: 'MutationType', AssignHealthChecksTags?: number | null };

export type EditHealthCheckSettingsMutationVariables = Exact<{
  healthCheckId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditHealthCheckSettingsMutation = { __typename?: 'MutationType', HealthCheck?: { __typename?: 'HealthCheck', setSettings?: number | null } | null };

export type EditHealthCheckMutationVariables = Exact<{
  healthCheckId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditHealthCheckMutation = { __typename?: 'MutationType', HealthCheck?: { __typename?: 'HealthCheck', setName?: number | null, setGroup?: number | null, setDisplay?: number | null, setLimit?: number | null, setDescription?: number | null } | null };

export type GetHealthCheckListWithTypeQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<HealthCheckSortInput> | HealthCheckSortInput>;
}>;


export type GetHealthCheckListWithTypeQuery = { __typename?: 'QueryType', HealthCheckList?: { __typename?: 'HealthCheckListConnection', nodes?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null, description?: string | null, settings?: string | null, group?: string | null, display?: string | null, limit?: number | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetHealthCheckListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<HealthCheckSortInput> | HealthCheckSortInput>;
}>;


export type GetHealthCheckListQuery = { __typename?: 'QueryType', HealthCheckList?: { __typename?: 'HealthCheckListConnection', nodes?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null, description?: string | null, settings?: string | null, group?: string | null, display?: string | null, limit?: number | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetHealthCheckQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHealthCheckQuery = { __typename?: 'QueryType', HealthCheck?: { __typename?: 'HealthCheck', id?: string | null, name?: string | null, description?: string | null, settings?: string | null, group?: string | null, display?: string | null, limit?: number | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type IFcEntityPropsFragment = { __typename?: 'IFC', id?: string | null, name?: string | null };

export type CreateIfcEntityMutationVariables = Exact<{
  iFCEntity?: InputMaybe<IfcInput>;
}>;


export type CreateIfcEntityMutation = { __typename?: 'MutationType', CreateIFC?: number | null };

export type DeleteIfcEntitiesMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteIfcEntitiesMutation = { __typename?: 'MutationType', DeleteIFCList?: number | null };

export type GetIfcEntitiesQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIfcEntitiesQuery = { __typename?: 'QueryType', IFCList?: { __typename?: 'IFCListConnection', nodes?: Array<{ __typename?: 'IFC', id?: string | null, name?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetIfcEntityQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIfcEntityQuery = { __typename?: 'QueryType', IFC?: { __typename?: 'IFC', id?: string | null, name?: string | null } | null };

export type IFcPropertyPropsFragment = { __typename?: 'IFCProp', id?: string | null, name?: string | null };

export type CreateIfcPropertyMutationVariables = Exact<{
  iFCProperty?: InputMaybe<IfcPropInput>;
}>;


export type CreateIfcPropertyMutation = { __typename?: 'MutationType', CreateIFCProp?: number | null };

export type DeleteIfcPropertiesMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteIfcPropertiesMutation = { __typename?: 'MutationType', DeleteIFCPropList?: number | null };

export type GetIfcPropertiesQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIfcPropertiesQuery = { __typename?: 'QueryType', IFCPropList?: { __typename?: 'IFCPropListConnection', nodes?: Array<{ __typename?: 'IFCProp', id?: string | null, name?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetIfcPropertyQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIfcPropertyQuery = { __typename?: 'QueryType', IFCProp?: { __typename?: 'IFCProp', id?: string | null, name?: string | null } | null };

export type IFcPropertySetPropsFragment = { __typename?: 'IFCPset', id?: string | null, name?: string | null, propIds?: Array<string | null> | null, properties?: Array<{ __typename?: 'IFCProperty', id?: string | null, name?: string | null } | null> | null };

export type CreateIfcPropertySetMutationVariables = Exact<{
  iFCPropertySet?: InputMaybe<IfcPsetInput>;
}>;


export type CreateIfcPropertySetMutation = { __typename?: 'MutationType', CreateIFCPset?: number | null };

export type DeleteIfcPropertySetListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteIfcPropertySetListMutation = { __typename?: 'MutationType', DeleteIFCPsetList?: number | null };

export type GetIfcPropertySetListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIfcPropertySetListQuery = { __typename?: 'QueryType', IFCPsetList?: { __typename?: 'IFCPsetListConnection', nodes?: Array<{ __typename?: 'IFCPset', id?: string | null, name?: string | null, propIds?: Array<string | null> | null, properties?: Array<{ __typename?: 'IFCProperty', id?: string | null, name?: string | null } | null> | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetIfcPropertySetQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIfcPropertySetQuery = { __typename?: 'QueryType', IFCPset?: { __typename?: 'IFCPset', id?: string | null, name?: string | null, propIds?: Array<string | null> | null, properties?: Array<{ __typename?: 'IFCProperty', id?: string | null, name?: string | null } | null> | null } | null };

export type LibraryPropsFragment = { __typename?: 'Library', id?: string | null, name?: string | null, description?: string | null, cacheStatus?: LibraryCacheStatus | null, cacheCreatedTime?: string | null, isAdmin?: boolean | null, adminIds?: Array<string | null> | null, clientId?: string | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type MoveLibraryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveLibraryMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', move?: number | null } | null };

export type RenameLibraryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenameLibraryMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', setName?: number | null } | null };

export type EditLibraryDescriptionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditLibraryDescriptionMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', setDescription?: number | null } | null };

export type CreateLibraryMutationVariables = Exact<{
  library?: InputMaybe<LibraryInput>;
}>;


export type CreateLibraryMutation = { __typename?: 'MutationType', CreateLibrary?: number | null };

export type AssignLibrariesTagsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AssignLibrariesTagsMutation = { __typename?: 'MutationType', AssignLibraryListTags?: number | null };

export type DeleteLibraryTagsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteLibraryTagsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', deleteTags?: number | null } | null };

export type DeleteLibrariesMutationVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteLibrariesMutation = { __typename?: 'MutationType', Client?: { __typename?: 'Client', deleteLibraries?: number | null } | null };

export type SetLibraryAdminMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetLibraryAdminMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', setAdmin?: number | null } | null };

export type DeleteLibraryAdminsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteLibraryAdminsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', deleteAdmins?: number | null } | null };

export type InheritLibraryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
}>;


export type InheritLibraryMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', inheritLibrary?: number | null } | null };

export type UnInheritLibrariesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UnInheritLibrariesMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', deleteInheritLibraries?: number | null } | null };

export type RegisterContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  contentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type RegisterContentsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', registerContents?: number | null } | null };

export type UnregisterContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UnregisterContentsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', deleteRegisedContents?: number | null } | null };

export type SetCustomContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  customContents?: InputMaybe<Array<InputMaybe<CustomContentInput>> | InputMaybe<CustomContentInput>>;
}>;


export type SetCustomContentsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', setCustomContents?: number | null } | null };

export type DeleteCustomContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteCustomContentsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', deleteCustomContents?: number | null } | null };

export type SetCustomContentTypesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  customContentId?: InputMaybe<Scalars['String']['input']>;
  customContentTypes?: InputMaybe<Array<InputMaybe<CustomContentTypeInput>> | InputMaybe<CustomContentTypeInput>>;
}>;


export type SetCustomContentTypesMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', customContent?: { __typename?: 'CustomContent', setCustomContentTypes?: number | null } | null } | null };

export type EditCustomContentCustomSettingsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  customContentId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditCustomContentCustomSettingsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', customContent?: { __typename?: 'CustomContent', setCustomSettings?: number | null } | null } | null };

export type EditCustomContentTypeCustomSettingsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  customContentId?: InputMaybe<Scalars['String']['input']>;
  customContentTypeId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditCustomContentTypeCustomSettingsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', customContent?: { __typename?: 'CustomContent', customContentType?: { __typename?: 'CustomContentType', setCustomSettings?: number | null } | null } | null } | null };

export type DeleteCustomContentTypesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  customContentId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteCustomContentTypesMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', customContent?: { __typename?: 'CustomContent', deleteCustomContentTypes?: number | null } | null } | null };

export type GetLibrariesQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<LibrarySortInput> | LibrarySortInput>;
}>;


export type GetLibrariesQuery = { __typename?: 'QueryType', LibraryList?: { __typename?: 'LibraryListConnection', nodes?: Array<{ __typename?: 'Library', id?: string | null, name?: string | null, description?: string | null, cacheStatus?: LibraryCacheStatus | null, cacheCreatedTime?: string | null, isAdmin?: boolean | null, adminIds?: Array<string | null> | null, clientId?: string | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetInheritedLibrariesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInheritedLibrariesQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, inheritedLibraries?: { __typename?: 'InheritedLibrariesConnection', nodes?: Array<{ __typename?: 'Library', id?: string | null, name?: string | null, description?: string | null, cacheStatus?: LibraryCacheStatus | null, cacheCreatedTime?: string | null, isAdmin?: boolean | null, adminIds?: Array<string | null> | null, clientId?: string | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetLibraryCustomContentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLibraryCustomContentsQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, customContents?: Array<{ __typename?: 'CustomContent', id?: string | null, customSettings?: string | null, libraryId?: string | null, contentId?: string | null, content?: { __typename?: 'Content', id?: string | null, name?: string | null } | null, customContentTypes?: Array<{ __typename?: 'CustomContentType', id?: string | null, customSettings?: string | null, contentTypeId?: string | null, contentType?: { __typename?: 'ContentType', id?: string | null, name?: string | null } | null } | null> | null } | null> | null } | null };

export type GetLibraryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLibraryQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', id?: string | null, name?: string | null, description?: string | null, cacheStatus?: LibraryCacheStatus | null, cacheCreatedTime?: string | null, isAdmin?: boolean | null, adminIds?: Array<string | null> | null, clientId?: string | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type GetLibraryCacheQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLibraryCacheQuery = { __typename?: 'QueryType', Library?: { __typename?: 'Library', cacheJson?: string | null, cacheJsonManifest?: string | null, caches?: string | null, lastCacheRunResult?: { __typename?: 'LibraryCacheRunResult', libraryId?: string | null, startedAt: any, completedAt: any, durationMs: any, error?: string | null, blobs?: Array<{ __typename?: 'LibraryCacheBlobResult', software?: string | null, blobName?: string | null, nodeCount: number, base64Bytes: any, gzipBytes: any, manifestOk: boolean } | null> | null } | null } | null };

export type GetRecentLibraryCreationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentLibraryCreationsQuery = { __typename?: 'QueryType', LibraryList?: { __typename?: 'LibraryListConnection', nodes?: Array<{ __typename?: 'Library', id?: string | null, name?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type ResetLibraryContentUsageCountsMutationVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResetLibraryContentUsageCountsMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', resetContentUsageCounts?: number | null } | null };

export type MapPropsFragment = { __typename?: 'Map', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, commandIds?: Array<string | null> | null, commands?: Array<string | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateMapMutationVariables = Exact<{
  map?: InputMaybe<MapInput>;
}>;


export type CreateMapMutation = { __typename?: 'MutationType', CreateMap?: number | null };

export type DeleteMapsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteMapsMutation = { __typename?: 'MutationType', DeleteMapList?: number | null };

export type GetMapsQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMapsQuery = { __typename?: 'QueryType', MapList?: { __typename?: 'MapListConnection', nodes?: Array<{ __typename?: 'Map', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, commandIds?: Array<string | null> | null, commands?: Array<string | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMapQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMapQuery = { __typename?: 'QueryType', Map?: { __typename?: 'Map', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, commandIds?: Array<string | null> | null, commands?: Array<string | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type ModelPropsFragment = { __typename?: 'Model', id?: string | null, name?: string | null, description?: string | null, healthResults?: string | null, applicationName?: string | null, customProperties?: string | null, projectId?: string | null, createdTime?: string | null, updatedTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateModelMutationVariables = Exact<{
  model?: InputMaybe<ModelInput>;
}>;


export type CreateModelMutation = { __typename?: 'MutationType', CreateModel?: number | null };

export type DeleteModelsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteModelsMutation = { __typename?: 'MutationType', Model?: { __typename?: 'Model', delete?: number | null } | null };

export type CountModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountModelsQuery = { __typename?: 'QueryType', ModelCount?: any | null };

export type GetModelsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ModelSortInput> | ModelSortInput>;
}>;


export type GetModelsQuery = { __typename?: 'QueryType', ModelList?: { __typename?: 'ModelListConnection', nodes?: Array<{ __typename?: 'Model', id?: string | null, name?: string | null, description?: string | null, healthResults?: string | null, applicationName?: string | null, customProperties?: string | null, projectId?: string | null, createdTime?: string | null, updatedTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetModelsShortQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModelsShortQuery = { __typename?: 'QueryType', ModelList?: { __typename?: 'ModelListConnection', nodes?: Array<{ __typename?: 'Model', id?: string | null, name?: string | null, createdTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecentModelCreationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentModelCreationsQuery = { __typename?: 'QueryType', ModelList?: { __typename?: 'ModelListConnection', nodes?: Array<{ __typename?: 'Model', id?: string | null, name?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetModelApplicationReportQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetModelApplicationReportQuery = { __typename?: 'QueryType', ModelList?: { __typename?: 'ModelListConnection', nodes?: Array<{ __typename?: 'Model', id?: string | null, applicationName?: string | null, projectId?: string | null, updatedTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetModelQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetModelQuery = { __typename?: 'QueryType', Model?: { __typename?: 'Model', caches?: string | null, id?: string | null, name?: string | null, description?: string | null, healthResults?: string | null, applicationName?: string | null, customProperties?: string | null, projectId?: string | null, createdTime?: string | null, updatedTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type GetProfileStatsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfileStatsQuery = { __typename?: 'QueryType', MemberProjects?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null } | null> | null } | null, AdminProjects?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null } | null> | null } | null, AdminLibraries?: { __typename?: 'LibraryListConnection', nodes?: Array<{ __typename?: 'Library', id?: string | null } | null> | null } | null, AdminClients?: { __typename?: 'ClientListConnection', nodes?: Array<{ __typename?: 'Client', id?: string | null } | null> | null } | null, AllMyModels?: { __typename?: 'ModelListConnection', nodes?: Array<{ __typename?: 'Model', id?: string | null, createdTime?: string | null } | null> | null } | null, AllMyContents?: { __typename?: 'ContentListConnection', nodes?: Array<{ __typename?: 'Content', id?: string | null, createdTime?: string | null } | null> | null } | null };

export type GetMyAdminClientsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyAdminClientsQuery = { __typename?: 'QueryType', ClientList?: { __typename?: 'ClientListConnection', nodes?: Array<{ __typename?: 'Client', id?: string | null, name?: string | null, longName?: string | null, description?: string | null, createdTime?: string | null, isPrivate?: boolean | null, tagIds?: Array<string | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null } | null> | null } | null };

export type GetMyAdminProjectsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyAdminProjectsQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, updatedTime?: string | null, clientId?: string | null, libraryId?: string | null, tagIds?: Array<string | null> | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, models?: Array<{ __typename?: 'Model', id?: string | null, healthResults?: string | null } | null> | null } | null> | null } | null };

export type GetMyAdminLibrariesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyAdminLibrariesQuery = { __typename?: 'QueryType', LibraryList?: { __typename?: 'LibraryListConnection', nodes?: Array<{ __typename?: 'Library', id?: string | null, name?: string | null, description?: string | null, clientId?: string | null, createdTime?: string | null } | null> | null } | null };

export type ProjectPropsFragment = { __typename?: 'Project', id?: string | null, name?: string | null, description?: string | null, isAdmin?: boolean | null, isPrivate?: boolean | null, adminIds?: Array<string | null> | null, memberIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, members?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type ToggleProjectPrivateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleProjectPrivateMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', togglePrivate?: number | null } | null };

export type CreateProjectMutationVariables = Exact<{
  project?: InputMaybe<ProjectInput>;
}>;


export type CreateProjectMutation = { __typename?: 'MutationType', CreateProject?: number | null };

export type DeleteProjectsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteProjectsMutation = { __typename?: 'MutationType', DeleteProjectList?: number | null };

export type AssignProjectsTagsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AssignProjectsTagsMutation = { __typename?: 'MutationType', AssignProjectListTags?: number | null };

export type AssignProjectsHealthChecksMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  healthCheckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignProjectsHealthChecksMutation = { __typename?: 'MutationType', AssignProjectsHealthChecks?: number | null };

export type CreateProjectWorksetMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  workset?: InputMaybe<WorksetInput>;
}>;


export type CreateProjectWorksetMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', setWorkset?: number | null } | null };

export type EditProjectMutationVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  projectSubName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditProjectMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', setClient?: number | null, setLibrary?: number | null, setProjectSubName?: number | null } | null };

export type SetProjectAccessMutationVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetProjectAccessMutation = { __typename?: 'MutationType', SetProjectAccess?: number | null };

export type SetProjectSubNameMutationVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
  projectSubName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetProjectSubNameMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', id?: string | null, name?: string | null, setProjectSubName?: number | null } | null };

export type SetProjectAdminMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetProjectAdminMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', setAdmin?: number | null } | null };

export type SetProjectMemberMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetProjectMemberMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', setMember?: number | null } | null };

export type SetProjectApprovedContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type SetProjectApprovedContentsMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', setApprovedContents?: number | null } | null };

export type DeleteProjectWorksetsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteProjectWorksetsMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', deleteWorksets?: number | null } | null };

export type DeleteProjectApprovedContentsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteProjectApprovedContentsMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', deleteApprovedContents?: number | null } | null };

export type DeleteProjectAdminsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteProjectAdminsMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', deleteAdmins?: number | null } | null };

export type DeleteProjectMembersMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteProjectMembersMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', deleteMembers?: number | null } | null };

export type DeleteProjectTagsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteProjectTagsMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', deleteTags?: number | null } | null };

export type DeleteProjectHealthChecksMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteProjectHealthChecksMutation = { __typename?: 'MutationType', Project?: { __typename?: 'Project', deleteHealthChecks?: number | null } | null };

export type CountProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountProjectsQuery = { __typename?: 'QueryType', ProjectCount?: any | null };

export type GetAllProjectsWithoutPermissionQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllProjectsWithoutPermissionQuery = { __typename?: 'QueryType', AllProjects?: { __typename?: 'AllProjectsConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null, name?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProjectsQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
  libraryId?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ProjectSortInput> | ProjectSortInput>;
}>;


export type GetProjectsQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', projectSubName?: string | null, libraryId?: string | null, id?: string | null, name?: string | null, description?: string | null, isAdmin?: boolean | null, isPrivate?: boolean | null, adminIds?: Array<string | null> | null, memberIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, members?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetLibraryProjectsQueryVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ProjectSortInput> | ProjectSortInput>;
}>;


export type GetLibraryProjectsQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', clientId?: string | null, id?: string | null, name?: string | null, description?: string | null, isAdmin?: boolean | null, isPrivate?: boolean | null, adminIds?: Array<string | null> | null, memberIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null } | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, members?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProjectsShortQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsShortQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null, name?: string | null, createdTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecentProjectCreationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecentProjectCreationsQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null, name?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetProjectsSummaryQueryVariables = Exact<{
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetProjectsSummaryQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null, clientId?: string | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null, isPrivate?: boolean | null, isAdmin?: boolean | null } | null } | null> | null } | null };

export type GetClientProjectsSummaryQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetClientProjectsSummaryQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', id?: string | null, libraryId?: string | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetAllProjectsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ProjectSortInput> | ProjectSortInput>;
  where?: InputMaybe<ProjectFilterInput>;
}>;


export type GetAllProjectsQuery = { __typename?: 'QueryType', ProjectList?: { __typename?: 'ProjectListConnection', nodes?: Array<{ __typename?: 'Project', projectSubName?: string | null, clientId?: string | null, libraryId?: string | null, id?: string | null, name?: string | null, description?: string | null, isAdmin?: boolean | null, isPrivate?: boolean | null, adminIds?: Array<string | null> | null, memberIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, members?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProjectQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProjectQuery = { __typename?: 'QueryType', Project?: { __typename?: 'Project', clientId?: string | null, libraryId?: string | null, projectSubName?: string | null, approvedContentIds?: Array<string | null> | null, id?: string | null, name?: string | null, description?: string | null, isAdmin?: boolean | null, isPrivate?: boolean | null, adminIds?: Array<string | null> | null, memberIds?: Array<string | null> | null, healthCheckIds?: Array<string | null> | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, worksets?: Array<{ __typename?: 'Workset', id?: string | null, name?: string | null, group?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, client?: { __typename?: 'Client', id?: string | null, name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null, approvedContents?: Array<{ __typename?: 'Content', id?: string | null, name?: string | null, tagIds?: Array<string | null> | null, thumbnail?: { __typename?: 'Attachment', downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null } | null> | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, members?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, healthChecks?: Array<{ __typename?: 'HealthCheck', id?: string | null, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type GetProjectDynamicDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProjectDynamicDataQuery = { __typename?: 'QueryType', Project?: { __typename?: 'Project', dynamicData?: Array<{ __typename?: 'DynamicData', id?: string | null, name?: string | null, type?: string | null, data?: string | null } | null> | null } | null };

export type GetProjectReportDynamicDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProjectReportDynamicDataQuery = { __typename?: 'QueryType', Project?: { __typename?: 'Project', dynamicData?: Array<{ __typename?: 'DynamicData', id?: string | null, name?: string | null, type?: string | null, data?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type RequestPropsFragment = { __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, clientId?: string | null, libraryId?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, contentId?: string | null, baseVersionId?: string | null, assignedToId?: string | null, closedById?: string | null, closedTime?: string | null, discipline?: DisciplineEnum | null, tagIds?: Array<string | null> | null, createdById?: string | null, updatedById?: string | null, verifiedById?: string | null, developedById?: string | null, reviewedById?: string | null, createdTime?: string | null, updatedTime?: string | null, iFCEntityId?: string | null, uniclassId?: string | null, vBISId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null, isArchived?: boolean | null } | null> | null, ifcEntity?: { __typename?: 'IFCEntity', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null } | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, updatedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, submittedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, verifiedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, developedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, closedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null };

export type GetMyRequestsQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentVersionFilterInput>;
  order?: InputMaybe<Array<ContentVersionSortInput> | ContentVersionSortInput>;
}>;


export type GetMyRequestsQuery = { __typename?: 'QueryType', MyRequests?: { __typename?: 'MyRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, clientId?: string | null, libraryId?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, contentId?: string | null, baseVersionId?: string | null, assignedToId?: string | null, closedById?: string | null, closedTime?: string | null, discipline?: DisciplineEnum | null, tagIds?: Array<string | null> | null, createdById?: string | null, updatedById?: string | null, verifiedById?: string | null, developedById?: string | null, reviewedById?: string | null, createdTime?: string | null, updatedTime?: string | null, iFCEntityId?: string | null, uniclassId?: string | null, vBISId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null, isArchived?: boolean | null } | null> | null, ifcEntity?: { __typename?: 'IFCEntity', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null } | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, updatedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, submittedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, verifiedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, developedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, closedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetAssignedRequestsQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentVersionFilterInput>;
  order?: InputMaybe<Array<ContentVersionSortInput> | ContentVersionSortInput>;
}>;


export type GetAssignedRequestsQuery = { __typename?: 'QueryType', AssignedRequests?: { __typename?: 'AssignedRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, clientId?: string | null, libraryId?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, contentId?: string | null, baseVersionId?: string | null, assignedToId?: string | null, closedById?: string | null, closedTime?: string | null, discipline?: DisciplineEnum | null, tagIds?: Array<string | null> | null, createdById?: string | null, updatedById?: string | null, verifiedById?: string | null, developedById?: string | null, reviewedById?: string | null, createdTime?: string | null, updatedTime?: string | null, iFCEntityId?: string | null, uniclassId?: string | null, vBISId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null, isArchived?: boolean | null } | null> | null, ifcEntity?: { __typename?: 'IFCEntity', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null } | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, updatedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, submittedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, verifiedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, developedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, closedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetNeedActionRequestsQueryVariables = Exact<{
  status?: InputMaybe<RequestStatusEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ContentVersionSortInput> | ContentVersionSortInput>;
}>;


export type GetNeedActionRequestsQuery = { __typename?: 'QueryType', NeedActionRequests?: { __typename?: 'NeedActionRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, clientId?: string | null, libraryId?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, contentId?: string | null, baseVersionId?: string | null, assignedToId?: string | null, closedById?: string | null, closedTime?: string | null, discipline?: DisciplineEnum | null, tagIds?: Array<string | null> | null, createdById?: string | null, updatedById?: string | null, verifiedById?: string | null, developedById?: string | null, reviewedById?: string | null, createdTime?: string | null, updatedTime?: string | null, iFCEntityId?: string | null, uniclassId?: string | null, vBISId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null, isArchived?: boolean | null } | null> | null, ifcEntity?: { __typename?: 'IFCEntity', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null } | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, updatedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, submittedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, verifiedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, developedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, closedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPendingRequestsQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentVersionFilterInput>;
  order?: InputMaybe<Array<ContentVersionSortInput> | ContentVersionSortInput>;
}>;


export type GetPendingRequestsQuery = { __typename?: 'QueryType', PendingRequests?: { __typename?: 'PendingRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, clientId?: string | null, libraryId?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, contentId?: string | null, baseVersionId?: string | null, assignedToId?: string | null, closedById?: string | null, closedTime?: string | null, discipline?: DisciplineEnum | null, tagIds?: Array<string | null> | null, createdById?: string | null, updatedById?: string | null, verifiedById?: string | null, developedById?: string | null, reviewedById?: string | null, createdTime?: string | null, updatedTime?: string | null, iFCEntityId?: string | null, uniclassId?: string | null, vBISId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null, isArchived?: boolean | null } | null> | null, ifcEntity?: { __typename?: 'IFCEntity', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null } | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, updatedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, submittedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, verifiedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, developedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, closedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRequestsQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContentVersionFilterInput>;
  order?: InputMaybe<Array<ContentVersionSortInput> | ContentVersionSortInput>;
}>;


export type GetRequestsQuery = { __typename?: 'QueryType', Requests?: { __typename?: 'RequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, clientId?: string | null, libraryId?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, contentId?: string | null, baseVersionId?: string | null, assignedToId?: string | null, closedById?: string | null, closedTime?: string | null, discipline?: DisciplineEnum | null, tagIds?: Array<string | null> | null, createdById?: string | null, updatedById?: string | null, verifiedById?: string | null, developedById?: string | null, reviewedById?: string | null, createdTime?: string | null, updatedTime?: string | null, iFCEntityId?: string | null, uniclassId?: string | null, vBISId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null, isArchived?: boolean | null } | null> | null, ifcEntity?: { __typename?: 'IFCEntity', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null } | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, updatedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, submittedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, verifiedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, developedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, closedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPendingRequestsLibrarySummaryQueryVariables = Exact<{
  discipline?: InputMaybe<DisciplineEnum>;
}>;


export type GetPendingRequestsLibrarySummaryQuery = { __typename?: 'QueryType', PendingRequests?: { __typename?: 'PendingRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', clientId?: string | null, libraryId?: string | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetMyRequestsLibrarySummaryQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
}>;


export type GetMyRequestsLibrarySummaryQuery = { __typename?: 'QueryType', MyRequests?: { __typename?: 'MyRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', clientId?: string | null, libraryId?: string | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetAssignedRequestsLibrarySummaryQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
}>;


export type GetAssignedRequestsLibrarySummaryQuery = { __typename?: 'QueryType', AssignedRequests?: { __typename?: 'AssignedRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', clientId?: string | null, libraryId?: string | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetRequestsLibrarySummaryQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
}>;


export type GetRequestsLibrarySummaryQuery = { __typename?: 'QueryType', Requests?: { __typename?: 'RequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', clientId?: string | null, libraryId?: string | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetRequestsShortQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRequestsShortQuery = { __typename?: 'QueryType', Requests?: { __typename?: 'RequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', status?: RequestStatusEnum | null, updatedTime?: string | null, createdTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPendingRequestsShortQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
  isUpdatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  isAscending?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPendingRequestsShortQuery = { __typename?: 'QueryType', PendingRequests?: { __typename?: 'PendingRequestsConnection', nodes?: Array<{ __typename?: 'ContentVersion', status?: RequestStatusEnum | null, updatedTime?: string | null, createdTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRequestQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRequestQuery = { __typename?: 'QueryType', ContentVersion?: { __typename?: 'ContentVersion', id?: string | null, name?: string | null, category?: string | null, applicationName?: string | null, clientId?: string | null, libraryId?: string | null, status?: RequestStatusEnum | null, state?: RequestStateEnum | null, resolution?: RequestResolutionEnum | null, requestType?: ContentRequestTypeEnum | null, contentId?: string | null, baseVersionId?: string | null, assignedToId?: string | null, closedById?: string | null, closedTime?: string | null, discipline?: DisciplineEnum | null, tagIds?: Array<string | null> | null, createdById?: string | null, updatedById?: string | null, verifiedById?: string | null, developedById?: string | null, reviewedById?: string | null, createdTime?: string | null, updatedTime?: string | null, iFCEntityId?: string | null, uniclassId?: string | null, vBISId?: string | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null, isArchived?: boolean | null } | null> | null, ifcEntity?: { __typename?: 'IFCEntity', name?: string | null } | null, uniclass?: { __typename?: 'Uniclass', name?: string | null } | null, vBIS?: { __typename?: 'VBIS', name?: string | null } | null, client?: { __typename?: 'Client', name?: string | null } | null, library?: { __typename?: 'Library', name?: string | null, isAdmin?: boolean | null } | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, updatedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, submittedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, verifiedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, developedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, reviewedBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, assignedTo?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null, closedBy?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null } | null } | null };

export type RequestsCountQueryVariables = Exact<{
  state?: InputMaybe<RequestStateEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
}>;


export type RequestsCountQuery = { __typename?: 'QueryType', RequestsCount?: any | null };

export type PendingRequestsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingRequestsCountQuery = { __typename?: 'QueryType', PendingRequestsCount?: any | null };

export type GetRequestHistoriesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRequestHistoriesQuery = { __typename?: 'QueryType', ContentVersion?: { __typename?: 'ContentVersion', histories?: Array<{ __typename?: 'History', id?: string | null, name?: string | null, message?: string | null, createdTime?: string | null, attachmentDownloadUrl?: string | null, createdBy?: { __typename?: 'User', name?: string | null, email?: string | null } | null, attachment?: { __typename?: 'Attachment', id?: string | null, name?: string | null, extension?: string | null, downloadUrl?: string | null } | null } | null> | null } | null };

export type SetRequestMutationVariables = Exact<{
  request?: InputMaybe<CreateContentRequestInput>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetRequestMutation = { __typename?: 'MutationType', Request?: string | null };

export type EditContentRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  request?: InputMaybe<EditContentRequestInput>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditContentRequestMutation = { __typename?: 'MutationType', EditRequest?: string | null };

export type ReassignRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  assignedToId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReassignRequestMutation = { __typename?: 'MutationType', ReassignRequest?: string | null };

export type TakeOwnershipMutationVariables = Exact<{
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type TakeOwnershipMutation = { __typename?: 'MutationType', TakeOwnership?: string | null };

export type CloseRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CloseContentRequestInput;
}>;


export type CloseRequestMutation = { __typename?: 'MutationType', CloseRequest?: string | null };

export type VerifyRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyRequestMutation = { __typename?: 'MutationType', VerifyRequest?: number | null };

export type AssignResourceToRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  modeller?: InputMaybe<UserInput>;
}>;


export type AssignResourceToRequestMutation = { __typename?: 'MutationType', AssignResourceToRequest?: number | null };

export type UploadAttachmentToRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UploadAttachmentToRequestMutation = { __typename?: 'MutationType', UploadAttachmentToRequest?: number | null };

export type FinalReviewRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinalReviewRequestMutation = { __typename?: 'MutationType', FinalReviewRequest?: number | null };

export type MarkDevelopedMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkDevelopedMutation = { __typename?: 'MutationType', MarkDeveloped?: number | null };

export type RejectRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectRequestMutation = { __typename?: 'MutationType', RejectRequest?: number | null };

export type RecoverRequestMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecoverRequestMutation = { __typename?: 'MutationType', RecoverRequest?: number | null };

export type TagPropsFragment = { __typename?: 'Tag', id?: string | null, name?: string | null, fullName?: string | null, description?: string | null, type?: string | null, isArchived?: boolean | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateTagMutationVariables = Exact<{
  tag?: InputMaybe<TagInput>;
}>;


export type CreateTagMutation = { __typename?: 'MutationType', CreateTag?: number | null };

export type ArchiveTagListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ArchiveTagListMutation = { __typename?: 'MutationType', ArchiveTagList?: number | null };

export type RestoreTagListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type RestoreTagListMutation = { __typename?: 'MutationType', RestoreTagList?: number | null };

export type GetTagTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagTypesQuery = { __typename?: 'QueryType', TagTypes?: Array<string | null> | null };

export type GetTagListWithTypeQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTagListWithTypeQuery = { __typename?: 'QueryType', TagList?: { __typename?: 'TagListConnection', nodes?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, fullName?: string | null, description?: string | null, type?: string | null, isArchived?: boolean | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTagListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTagListQuery = { __typename?: 'QueryType', TagList?: { __typename?: 'TagListConnection', nodes?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, fullName?: string | null, description?: string | null, type?: string | null, isArchived?: boolean | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetArchivedTagListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArchivedTagListQuery = { __typename?: 'QueryType', ArchivedTagList?: { __typename?: 'ArchivedTagListConnection', nodes?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, fullName?: string | null, description?: string | null, type?: string | null, isArchived?: boolean | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTagQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTagQuery = { __typename?: 'QueryType', Tag?: { __typename?: 'Tag', id?: string | null, name?: string | null, fullName?: string | null, description?: string | null, type?: string | null, isArchived?: boolean | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type UniclassPropsFragment = { __typename?: 'Uniclass', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, group: number, title?: string | null, nBSCode?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateUniclassMutationVariables = Exact<{
  uniclass?: InputMaybe<UniclassInput>;
}>;


export type CreateUniclassMutation = { __typename?: 'MutationType', CreateUniclass?: number | null };

export type DeleteUniclassesMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteUniclassesMutation = { __typename?: 'MutationType', DeleteUniclassList?: number | null };

export type GetUniclassesQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniclassesQuery = { __typename?: 'QueryType', UniclassList?: { __typename?: 'UniclassListConnection', nodes?: Array<{ __typename?: 'Uniclass', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, group: number, title?: string | null, nBSCode?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetUniclassQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniclassQuery = { __typename?: 'QueryType', Uniclass?: { __typename?: 'Uniclass', id?: string | null, name?: string | null, description?: string | null, createdTime?: string | null, createdById?: string | null, group: number, title?: string | null, nBSCode?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export type UploadContentMutationVariables = Exact<{
  libraryId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<ContentVersionInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  thumbnailName?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overwrite: Scalars['Boolean']['input'];
}>;


export type UploadContentMutation = { __typename?: 'MutationType', Library?: { __typename?: 'Library', uploadContent?: { __typename?: 'Content', id?: string | null, setFile?: string | null, setThumbnail?: string | null } | null } | null };

export type SetContentTypeThumbnailMutationVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetContentTypeThumbnailMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setTypeThumbnail?: string | null } | null };

export type SetContentThumbnailMutationVariables = Exact<{
  contentId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetContentThumbnailMutation = { __typename?: 'MutationType', Content?: { __typename?: 'Content', setThumbnail?: string | null } | null };

export type GetApplicationNameListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationNameListQuery = { __typename?: 'QueryType', ApplicationNameList?: Array<string | null> | null };

export type GetCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoryListQuery = { __typename?: 'QueryType', CategoryList?: Array<string | null> | null };

export type GetSubCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubCategoryListQuery = { __typename?: 'QueryType', SubCategoryList?: Array<string | null> | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'QueryType', Me?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: UserRoleEnum | null, discipline?: DisciplineEnum | null, createdTime?: string | null, updatedTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null, dynamicData?: Array<{ __typename?: 'DynamicData', id?: string | null, name?: string | null, type?: string | null, ownerId?: string | null, sharedById?: string | null } | null> | null } | null };

export type GetUsersQueryVariables = Exact<{
  role?: InputMaybe<UserRoleEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type GetUsersQuery = { __typename?: 'QueryType', UserList?: { __typename?: 'UserListConnection', nodes?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: UserRoleEnum | null, discipline?: DisciplineEnum | null, updatedTime?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetUsersWithoutRoleQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type GetUsersWithoutRoleQuery = { __typename?: 'QueryType', UserList?: { __typename?: 'UserListConnection', nodes?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: UserRoleEnum | null, discipline?: DisciplineEnum | null, updatedTime?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMembersQueryVariables = Exact<{
  role?: InputMaybe<UserRoleEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
}>;


export type GetMembersQuery = { __typename?: 'QueryType', UserList?: { __typename?: 'UserListConnection', nodes?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: UserRoleEnum | null, discipline?: DisciplineEnum | null, updatedTime?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type CountUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type CountUsersQuery = { __typename?: 'QueryType', UserCount?: any | null };

export type GetUsersShortQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersShortQuery = { __typename?: 'QueryType', UserList?: { __typename?: 'UserListConnection', nodes?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, createdTime?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type AdminOfLibrariesQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminOfLibrariesQuery = { __typename?: 'QueryType', Me?: { __typename?: 'User', adminOfLibraries?: Array<{ __typename?: 'Library', id?: string | null, name?: string | null, description?: string | null, cacheStatus?: LibraryCacheStatus | null, cacheCreatedTime?: string | null, isAdmin?: boolean | null, adminIds?: Array<string | null> | null, clientId?: string | null, tagIds?: Array<string | null> | null, createdTime?: string | null, createdById?: string | null, admins?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, updatedTime?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, name?: string | null, type?: string | null } | null> | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type SetGlobalAdminMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  discipline: DisciplineEnum;
}>;


export type SetGlobalAdminMutation = { __typename?: 'MutationType', SetAdmin?: number | null };

export type SetUserRoleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoleEnum>;
  discipline?: InputMaybe<DisciplineEnum>;
}>;


export type SetUserRoleMutation = { __typename?: 'MutationType', SetUserRole?: number | null };

export type DeleteGlobalUserRoleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteGlobalUserRoleMutation = { __typename?: 'MutationType', DeleteUserRole?: number | null };

export type GetMyDynamicDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyDynamicDataQuery = { __typename?: 'QueryType', Me?: { __typename?: 'User', dynamicData?: Array<{ __typename?: 'DynamicData', id?: string | null, name?: string | null, description?: string | null, type?: string | null, ownerId?: string | null, sharedById?: string | null, data?: string | null, setData?: string | null, createdTime?: string | null, updatedTime?: string | null } | null> | null } | null };

export type SetMyDynamicDataMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<DynamicDataInput>;
}>;


export type SetMyDynamicDataMutation = { __typename?: 'MutationType', User?: { __typename?: 'User', setDynamicData?: number | null } | null };

export type DeleteMyDynamicDataMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteMyDynamicDataMutation = { __typename?: 'MutationType', User?: { __typename?: 'User', deleteDynamicData?: number | null } | null };

export type GetPreviewFeatureUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreviewFeatureUsersQuery = { __typename?: 'QueryType', UserList?: { __typename?: 'UserListConnection', nodes?: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: UserRoleEnum | null, dynamicData?: Array<{ __typename?: 'DynamicData', id?: string | null, type?: string | null, ownerId?: string | null, sharedById?: string | null } | null> | null } | null> | null } | null };

export type SharePreviewFeatureMutationVariables = Exact<{
  ownerId?: InputMaybe<Scalars['String']['input']>;
  dynamicDataId?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SharePreviewFeatureMutation = { __typename?: 'MutationType', User?: { __typename?: 'User', shareDynamicData?: number | null } | null };

export type RevokePreviewFeatureMutationVariables = Exact<{
  ownerId?: InputMaybe<Scalars['String']['input']>;
  dynamicDataId?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevokePreviewFeatureMutation = { __typename?: 'MutationType', User?: { __typename?: 'User', revokeDynamicData?: number | null } | null };

export type VbisPropsFragment = { __typename?: 'VBIS', id?: string | null, name?: string | null, description?: string | null, discipline?: string | null, product?: string | null, subType?: string | null, subSubType?: string | null, title?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null };

export type CreateVbisMutationVariables = Exact<{
  vbis?: InputMaybe<VbisInput>;
}>;


export type CreateVbisMutation = { __typename?: 'MutationType', CreateVBIS?: number | null };

export type DeleteVbisListMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteVbisListMutation = { __typename?: 'MutationType', DeleteVBISList?: number | null };

export type GetVbisListQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVbisListQuery = { __typename?: 'QueryType', VBISList?: { __typename?: 'VBISListConnection', nodes?: Array<{ __typename?: 'VBIS', id?: string | null, name?: string | null, description?: string | null, discipline?: string | null, product?: string | null, subType?: string | null, subSubType?: string | null, title?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVbisQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVbisQuery = { __typename?: 'QueryType', VBIS?: { __typename?: 'VBIS', id?: string | null, name?: string | null, description?: string | null, discipline?: string | null, product?: string | null, subType?: string | null, subSubType?: string | null, title?: string | null, createdTime?: string | null, createdById?: string | null, createdBy?: { __typename?: 'User', id?: string | null, name?: string | null } | null } | null };

export const ClassificationPropsFragmentDoc = gql`
    fragment classificationProps on Classification {
  id
  name
  description
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const ClassificationTypePropsFragmentDoc = gql`
    fragment classificationTypeProps on ClassificationType {
  id
  name
  description
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const ClientPropsFragmentDoc = gql`
    fragment clientProps on Client {
  id
  name
  longName
  description
  createdTime
  isPrivate
  isAdmin
  defaultLibraryId
  defaultLibrary {
    id
    name
  }
  adminIds
  admins {
    id
    name
    email
    updatedTime
  }
  healthCheckIds
  healthChecks {
    id
    name
  }
  tagIds
  tags {
    id
    name
    type
  }
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const CommandPropsFragmentDoc = gql`
    fragment commandProps on Command {
  id
  name
  description
  createdTime
  createdById
  createdBy {
    id
    name
  }
  type
}
    `;
export const ContentPropsFragmentDoc = gql`
    fragment contentProps on Content {
  id
  name
  category
  settings
  description
  applicationName
  currentVersionId
  currentRequestId
  usageCount
  vBIS {
    name
  }
  ifcEntity {
    name
  }
  uniclass {
    name
    title
  }
  thumbnail {
    downloadUrl
  }
  createdTime
  libraryId
  library {
    name
    isAdmin
  }
  tagIds
  tags {
    id
    name
    type
  }
  groupIds
  groups {
    id
    name
  }
  classificationIds
  classifications {
    id
    name
    description
    type {
      id
      name
    }
  }
  relatedContentIds
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const ContentVersionPropsFragmentDoc = gql`
    fragment contentVersionProps on ContentVersion {
  id
  name
  category
  description
  applicationName
  status
  state
  resolution
  requestType
  baseVersionId
  closedTime
  updatedTime
  createdTime
  createdById
  createdBy {
    id
    name
  }
  category
}
    `;
export const DefaultPropsFragmentDoc = gql`
    fragment defaultProps on Default {
  id
  name
  description
  clientId
  client {
    id
    name
  }
  libraryId
  library {
    id
    name
  }
  isProjSubNameEnabled
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const GroupPropsFragmentDoc = gql`
    fragment groupProps on Group {
  id
  name
  description
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const HealthCheckPropsFragmentDoc = gql`
    fragment healthCheckProps on HealthCheck {
  id
  name
  description
  settings
  group
  display
  limit
  tagIds
  tags {
    id
    name
    type
  }
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const IFcEntityPropsFragmentDoc = gql`
    fragment iFCEntityProps on IFC {
  id
  name
}
    `;
export const IFcPropertyPropsFragmentDoc = gql`
    fragment iFCPropertyProps on IFCProp {
  id
  name
}
    `;
export const IFcPropertySetPropsFragmentDoc = gql`
    fragment iFCPropertySetProps on IFCPset {
  id
  name
  propIds
  properties {
    id
    name
  }
}
    `;
export const LibraryPropsFragmentDoc = gql`
    fragment libraryProps on Library {
  id
  name
  description
  cacheStatus
  cacheCreatedTime
  isAdmin
  adminIds
  admins {
    id
    name
    email
    updatedTime
  }
  clientId
  tagIds
  tags {
    id
    name
    type
  }
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const MapPropsFragmentDoc = gql`
    fragment mapProps on Map {
  id
  name
  description
  createdTime
  createdById
  createdBy {
    id
    name
  }
  commandIds
  commands
}
    `;
export const ModelPropsFragmentDoc = gql`
    fragment modelProps on Model {
  id
  name
  description
  healthResults
  applicationName
  customProperties
  projectId
  createdTime
  updatedTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const ProjectPropsFragmentDoc = gql`
    fragment projectProps on Project {
  id
  name
  description
  isAdmin
  isPrivate
  adminIds
  admins {
    id
    name
    email
    updatedTime
  }
  memberIds
  members {
    id
    name
    email
    updatedTime
  }
  healthCheckIds
  healthChecks {
    id
    name
  }
  tagIds
  tags {
    id
    name
    type
  }
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const RequestPropsFragmentDoc = gql`
    fragment RequestProps on ContentVersion {
  id
  name
  category
  applicationName
  attachment {
    id
    name
    extension
    downloadUrl
  }
  clientId
  libraryId
  status
  state
  resolution
  requestType
  contentId
  baseVersionId
  assignedToId
  closedById
  closedTime
  discipline
  tagIds
  tags {
    id
    name
    type
    isArchived
  }
  createdById
  updatedById
  verifiedById
  developedById
  reviewedById
  createdTime
  updatedTime
  iFCEntityId
  uniclassId
  vBISId
  ifcEntity {
    name
  }
  uniclass {
    name
  }
  vBIS {
    name
  }
  client {
    name
  }
  library {
    name
    isAdmin
  }
  createdBy {
    name
    email
  }
  updatedBy {
    name
    email
  }
  submittedBy {
    name
    email
  }
  verifiedBy {
    name
    email
  }
  developedBy {
    name
    email
  }
  reviewedBy {
    name
    email
  }
  assignedTo {
    id
    name
    email
  }
  closedBy {
    id
    name
    email
  }
}
    `;
export const TagPropsFragmentDoc = gql`
    fragment tagProps on Tag {
  id
  name
  fullName
  description
  type
  isArchived
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const UniclassPropsFragmentDoc = gql`
    fragment uniclassProps on Uniclass {
  id
  name
  description
  createdTime
  createdById
  createdBy {
    id
    name
  }
  group
  title
  nBSCode
}
    `;
export const VbisPropsFragmentDoc = gql`
    fragment vbisProps on VBIS {
  id
  name
  description
  discipline
  product
  subType
  subSubType
  title
  createdTime
  createdById
  createdBy {
    id
    name
  }
}
    `;
export const CreateClassificationDocument = gql`
    mutation createClassification($classification: ClassificationInput) {
  CreateClassification(item: $classification)
}
    `;
export type CreateClassificationMutationFn = Apollo.MutationFunction<CreateClassificationMutation, CreateClassificationMutationVariables>;

/**
 * __useCreateClassificationMutation__
 *
 * To run a mutation, you first call `useCreateClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassificationMutation, { data, loading, error }] = useCreateClassificationMutation({
 *   variables: {
 *      classification: // value for 'classification'
 *   },
 * });
 */
export function useCreateClassificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateClassificationMutation, CreateClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClassificationMutation, CreateClassificationMutationVariables>(CreateClassificationDocument, options);
      }
export type CreateClassificationMutationHookResult = ReturnType<typeof useCreateClassificationMutation>;
export type CreateClassificationMutationResult = Apollo.MutationResult<CreateClassificationMutation>;
export type CreateClassificationMutationOptions = Apollo.BaseMutationOptions<CreateClassificationMutation, CreateClassificationMutationVariables>;
export const DeleteClassificationListDocument = gql`
    mutation deleteClassificationList($ids: [String]) {
  DeleteClassificationList(ids: $ids)
}
    `;
export type DeleteClassificationListMutationFn = Apollo.MutationFunction<DeleteClassificationListMutation, DeleteClassificationListMutationVariables>;

/**
 * __useDeleteClassificationListMutation__
 *
 * To run a mutation, you first call `useDeleteClassificationListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassificationListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassificationListMutation, { data, loading, error }] = useDeleteClassificationListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClassificationListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassificationListMutation, DeleteClassificationListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClassificationListMutation, DeleteClassificationListMutationVariables>(DeleteClassificationListDocument, options);
      }
export type DeleteClassificationListMutationHookResult = ReturnType<typeof useDeleteClassificationListMutation>;
export type DeleteClassificationListMutationResult = Apollo.MutationResult<DeleteClassificationListMutation>;
export type DeleteClassificationListMutationOptions = Apollo.BaseMutationOptions<DeleteClassificationListMutation, DeleteClassificationListMutationVariables>;
export const GetClassificationListWithTypeDocument = gql`
    query getClassificationListWithType($contains: String, $typeId: String, $after: String, $order: [ClassificationSortInput!]) {
  ClassificationList(
    after: $after
    order: $order
    where: {and: [{typeId: {eq: $typeId}}, {or: [{name: {contains: $contains}}, {description: {contains: $contains}}]}]}
  ) {
    nodes {
      ...classificationProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ClassificationPropsFragmentDoc}`;

/**
 * __useGetClassificationListWithTypeQuery__
 *
 * To run a query within a React component, call `useGetClassificationListWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationListWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationListWithTypeQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      typeId: // value for 'typeId'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetClassificationListWithTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>(GetClassificationListWithTypeDocument, options);
      }
export function useGetClassificationListWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>(GetClassificationListWithTypeDocument, options);
        }
// @ts-ignore
export function useGetClassificationListWithTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>;
export function useGetClassificationListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationListWithTypeQuery | undefined, GetClassificationListWithTypeQueryVariables>;
export function useGetClassificationListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>(GetClassificationListWithTypeDocument, options);
        }
export type GetClassificationListWithTypeQueryHookResult = ReturnType<typeof useGetClassificationListWithTypeQuery>;
export type GetClassificationListWithTypeLazyQueryHookResult = ReturnType<typeof useGetClassificationListWithTypeLazyQuery>;
export type GetClassificationListWithTypeSuspenseQueryHookResult = ReturnType<typeof useGetClassificationListWithTypeSuspenseQuery>;
export type GetClassificationListWithTypeQueryResult = Apollo.QueryResult<GetClassificationListWithTypeQuery, GetClassificationListWithTypeQueryVariables>;
export const GetClassificationListDocument = gql`
    query getClassificationList($contains: String, $after: String, $order: [ClassificationSortInput!]) {
  ClassificationList(
    after: $after
    order: $order
    where: {or: [{name: {contains: $contains}}, {description: {contains: $contains}}]}
  ) {
    nodes {
      ...classificationProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ClassificationPropsFragmentDoc}`;

/**
 * __useGetClassificationListQuery__
 *
 * To run a query within a React component, call `useGetClassificationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetClassificationListQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationListQuery, GetClassificationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationListQuery, GetClassificationListQueryVariables>(GetClassificationListDocument, options);
      }
export function useGetClassificationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationListQuery, GetClassificationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationListQuery, GetClassificationListQueryVariables>(GetClassificationListDocument, options);
        }
// @ts-ignore
export function useGetClassificationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClassificationListQuery, GetClassificationListQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationListQuery, GetClassificationListQueryVariables>;
export function useGetClassificationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationListQuery, GetClassificationListQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationListQuery | undefined, GetClassificationListQueryVariables>;
export function useGetClassificationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationListQuery, GetClassificationListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassificationListQuery, GetClassificationListQueryVariables>(GetClassificationListDocument, options);
        }
export type GetClassificationListQueryHookResult = ReturnType<typeof useGetClassificationListQuery>;
export type GetClassificationListLazyQueryHookResult = ReturnType<typeof useGetClassificationListLazyQuery>;
export type GetClassificationListSuspenseQueryHookResult = ReturnType<typeof useGetClassificationListSuspenseQuery>;
export type GetClassificationListQueryResult = Apollo.QueryResult<GetClassificationListQuery, GetClassificationListQueryVariables>;
export const GetClassificationDocument = gql`
    query getClassification($id: String) {
  Classification(id: $id) {
    ...classificationProps
  }
}
    ${ClassificationPropsFragmentDoc}`;

/**
 * __useGetClassificationQuery__
 *
 * To run a query within a React component, call `useGetClassificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassificationQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationQuery, GetClassificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationQuery, GetClassificationQueryVariables>(GetClassificationDocument, options);
      }
export function useGetClassificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationQuery, GetClassificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationQuery, GetClassificationQueryVariables>(GetClassificationDocument, options);
        }
// @ts-ignore
export function useGetClassificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClassificationQuery, GetClassificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationQuery, GetClassificationQueryVariables>;
export function useGetClassificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationQuery, GetClassificationQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationQuery | undefined, GetClassificationQueryVariables>;
export function useGetClassificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationQuery, GetClassificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassificationQuery, GetClassificationQueryVariables>(GetClassificationDocument, options);
        }
export type GetClassificationQueryHookResult = ReturnType<typeof useGetClassificationQuery>;
export type GetClassificationLazyQueryHookResult = ReturnType<typeof useGetClassificationLazyQuery>;
export type GetClassificationSuspenseQueryHookResult = ReturnType<typeof useGetClassificationSuspenseQuery>;
export type GetClassificationQueryResult = Apollo.QueryResult<GetClassificationQuery, GetClassificationQueryVariables>;
export const CreateClassificationTypeDocument = gql`
    mutation createClassificationType($classificationType: ClassificationTypeInput) {
  CreateClassificationType(item: $classificationType)
}
    `;
export type CreateClassificationTypeMutationFn = Apollo.MutationFunction<CreateClassificationTypeMutation, CreateClassificationTypeMutationVariables>;

/**
 * __useCreateClassificationTypeMutation__
 *
 * To run a mutation, you first call `useCreateClassificationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassificationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassificationTypeMutation, { data, loading, error }] = useCreateClassificationTypeMutation({
 *   variables: {
 *      classificationType: // value for 'classificationType'
 *   },
 * });
 */
export function useCreateClassificationTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateClassificationTypeMutation, CreateClassificationTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClassificationTypeMutation, CreateClassificationTypeMutationVariables>(CreateClassificationTypeDocument, options);
      }
export type CreateClassificationTypeMutationHookResult = ReturnType<typeof useCreateClassificationTypeMutation>;
export type CreateClassificationTypeMutationResult = Apollo.MutationResult<CreateClassificationTypeMutation>;
export type CreateClassificationTypeMutationOptions = Apollo.BaseMutationOptions<CreateClassificationTypeMutation, CreateClassificationTypeMutationVariables>;
export const DeleteClassificationTypeListDocument = gql`
    mutation deleteClassificationTypeList($ids: [String]) {
  DeleteClassificationTypeList(ids: $ids)
}
    `;
export type DeleteClassificationTypeListMutationFn = Apollo.MutationFunction<DeleteClassificationTypeListMutation, DeleteClassificationTypeListMutationVariables>;

/**
 * __useDeleteClassificationTypeListMutation__
 *
 * To run a mutation, you first call `useDeleteClassificationTypeListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassificationTypeListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassificationTypeListMutation, { data, loading, error }] = useDeleteClassificationTypeListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClassificationTypeListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClassificationTypeListMutation, DeleteClassificationTypeListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClassificationTypeListMutation, DeleteClassificationTypeListMutationVariables>(DeleteClassificationTypeListDocument, options);
      }
export type DeleteClassificationTypeListMutationHookResult = ReturnType<typeof useDeleteClassificationTypeListMutation>;
export type DeleteClassificationTypeListMutationResult = Apollo.MutationResult<DeleteClassificationTypeListMutation>;
export type DeleteClassificationTypeListMutationOptions = Apollo.BaseMutationOptions<DeleteClassificationTypeListMutation, DeleteClassificationTypeListMutationVariables>;
export const GetClassificationTypeListDocument = gql`
    query getClassificationTypeList($contains: String, $after: String, $tagIds: [String], $order: [ClassificationTypeSortInput!]) {
  ClassificationTypeList(
    after: $after
    tagIds: $tagIds
    where: {name: {contains: $contains}}
    order: $order
  ) {
    nodes {
      ...classificationTypeProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ClassificationTypePropsFragmentDoc}`;

/**
 * __useGetClassificationTypeListQuery__
 *
 * To run a query within a React component, call `useGetClassificationTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationTypeListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetClassificationTypeListQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>(GetClassificationTypeListDocument, options);
      }
export function useGetClassificationTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>(GetClassificationTypeListDocument, options);
        }
// @ts-ignore
export function useGetClassificationTypeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>;
export function useGetClassificationTypeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationTypeListQuery | undefined, GetClassificationTypeListQueryVariables>;
export function useGetClassificationTypeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>(GetClassificationTypeListDocument, options);
        }
export type GetClassificationTypeListQueryHookResult = ReturnType<typeof useGetClassificationTypeListQuery>;
export type GetClassificationTypeListLazyQueryHookResult = ReturnType<typeof useGetClassificationTypeListLazyQuery>;
export type GetClassificationTypeListSuspenseQueryHookResult = ReturnType<typeof useGetClassificationTypeListSuspenseQuery>;
export type GetClassificationTypeListQueryResult = Apollo.QueryResult<GetClassificationTypeListQuery, GetClassificationTypeListQueryVariables>;
export const GetClassificationTypeDocument = gql`
    query getClassificationType($id: String) {
  ClassificationType(id: $id) {
    ...classificationTypeProps
  }
}
    ${ClassificationTypePropsFragmentDoc}`;

/**
 * __useGetClassificationTypeQuery__
 *
 * To run a query within a React component, call `useGetClassificationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassificationTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>(GetClassificationTypeDocument, options);
      }
export function useGetClassificationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>(GetClassificationTypeDocument, options);
        }
// @ts-ignore
export function useGetClassificationTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>;
export function useGetClassificationTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetClassificationTypeQuery | undefined, GetClassificationTypeQueryVariables>;
export function useGetClassificationTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>(GetClassificationTypeDocument, options);
        }
export type GetClassificationTypeQueryHookResult = ReturnType<typeof useGetClassificationTypeQuery>;
export type GetClassificationTypeLazyQueryHookResult = ReturnType<typeof useGetClassificationTypeLazyQuery>;
export type GetClassificationTypeSuspenseQueryHookResult = ReturnType<typeof useGetClassificationTypeSuspenseQuery>;
export type GetClassificationTypeQueryResult = Apollo.QueryResult<GetClassificationTypeQuery, GetClassificationTypeQueryVariables>;
export const ToggleClientPrivateDocument = gql`
    mutation toggleClientPrivate($id: String) {
  Client(id: $id) {
    togglePrivate
  }
}
    `;
export type ToggleClientPrivateMutationFn = Apollo.MutationFunction<ToggleClientPrivateMutation, ToggleClientPrivateMutationVariables>;

/**
 * __useToggleClientPrivateMutation__
 *
 * To run a mutation, you first call `useToggleClientPrivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleClientPrivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleClientPrivateMutation, { data, loading, error }] = useToggleClientPrivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleClientPrivateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleClientPrivateMutation, ToggleClientPrivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleClientPrivateMutation, ToggleClientPrivateMutationVariables>(ToggleClientPrivateDocument, options);
      }
export type ToggleClientPrivateMutationHookResult = ReturnType<typeof useToggleClientPrivateMutation>;
export type ToggleClientPrivateMutationResult = Apollo.MutationResult<ToggleClientPrivateMutation>;
export type ToggleClientPrivateMutationOptions = Apollo.BaseMutationOptions<ToggleClientPrivateMutation, ToggleClientPrivateMutationVariables>;
export const CreateClientDocument = gql`
    mutation createClient($client: ClientInput) {
  CreateClient(item: $client)
}
    `;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      client: // value for 'client'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const DeleteClientsDocument = gql`
    mutation deleteClients($ids: [String]) {
  DeleteClientList(ids: $ids)
}
    `;
export type DeleteClientsMutationFn = Apollo.MutationFunction<DeleteClientsMutation, DeleteClientsMutationVariables>;

/**
 * __useDeleteClientsMutation__
 *
 * To run a mutation, you first call `useDeleteClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientsMutation, { data, loading, error }] = useDeleteClientsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClientsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientsMutation, DeleteClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientsMutation, DeleteClientsMutationVariables>(DeleteClientsDocument, options);
      }
export type DeleteClientsMutationHookResult = ReturnType<typeof useDeleteClientsMutation>;
export type DeleteClientsMutationResult = Apollo.MutationResult<DeleteClientsMutation>;
export type DeleteClientsMutationOptions = Apollo.BaseMutationOptions<DeleteClientsMutation, DeleteClientsMutationVariables>;
export const EditClientDocument = gql`
    mutation editClient($id: String, $libraryId: String) {
  Client(id: $id) {
    setDefaultLibrary(id: $libraryId)
  }
}
    `;
export type EditClientMutationFn = Apollo.MutationFunction<EditClientMutation, EditClientMutationVariables>;

/**
 * __useEditClientMutation__
 *
 * To run a mutation, you first call `useEditClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClientMutation, { data, loading, error }] = useEditClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      libraryId: // value for 'libraryId'
 *   },
 * });
 */
export function useEditClientMutation(baseOptions?: Apollo.MutationHookOptions<EditClientMutation, EditClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClientMutation, EditClientMutationVariables>(EditClientDocument, options);
      }
export type EditClientMutationHookResult = ReturnType<typeof useEditClientMutation>;
export type EditClientMutationResult = Apollo.MutationResult<EditClientMutation>;
export type EditClientMutationOptions = Apollo.BaseMutationOptions<EditClientMutation, EditClientMutationVariables>;
export const AssignClientsTagsDocument = gql`
    mutation assignClientsTags($ids: [String], $tagIds: [String]) {
  AssignClientListTags(ids: $ids, tagIds: $tagIds)
}
    `;
export type AssignClientsTagsMutationFn = Apollo.MutationFunction<AssignClientsTagsMutation, AssignClientsTagsMutationVariables>;

/**
 * __useAssignClientsTagsMutation__
 *
 * To run a mutation, you first call `useAssignClientsTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientsTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientsTagsMutation, { data, loading, error }] = useAssignClientsTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAssignClientsTagsMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientsTagsMutation, AssignClientsTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientsTagsMutation, AssignClientsTagsMutationVariables>(AssignClientsTagsDocument, options);
      }
export type AssignClientsTagsMutationHookResult = ReturnType<typeof useAssignClientsTagsMutation>;
export type AssignClientsTagsMutationResult = Apollo.MutationResult<AssignClientsTagsMutation>;
export type AssignClientsTagsMutationOptions = Apollo.BaseMutationOptions<AssignClientsTagsMutation, AssignClientsTagsMutationVariables>;
export const AssignClientsHealthChecksDocument = gql`
    mutation assignClientsHealthChecks($ids: [String], $healthCheckIds: [String], $overwrite: Boolean) {
  AssignClientsHealthChecks(
    ids: $ids
    healthCheckIds: $healthCheckIds
    overwrite: $overwrite
  )
}
    `;
export type AssignClientsHealthChecksMutationFn = Apollo.MutationFunction<AssignClientsHealthChecksMutation, AssignClientsHealthChecksMutationVariables>;

/**
 * __useAssignClientsHealthChecksMutation__
 *
 * To run a mutation, you first call `useAssignClientsHealthChecksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientsHealthChecksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientsHealthChecksMutation, { data, loading, error }] = useAssignClientsHealthChecksMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      healthCheckIds: // value for 'healthCheckIds'
 *      overwrite: // value for 'overwrite'
 *   },
 * });
 */
export function useAssignClientsHealthChecksMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientsHealthChecksMutation, AssignClientsHealthChecksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientsHealthChecksMutation, AssignClientsHealthChecksMutationVariables>(AssignClientsHealthChecksDocument, options);
      }
export type AssignClientsHealthChecksMutationHookResult = ReturnType<typeof useAssignClientsHealthChecksMutation>;
export type AssignClientsHealthChecksMutationResult = Apollo.MutationResult<AssignClientsHealthChecksMutation>;
export type AssignClientsHealthChecksMutationOptions = Apollo.BaseMutationOptions<AssignClientsHealthChecksMutation, AssignClientsHealthChecksMutationVariables>;
export const CreateClientWorksetDocument = gql`
    mutation createClientWorkset($id: String, $workset: WorksetInput) {
  Client(id: $id) {
    setWorkset(workset: $workset)
  }
}
    `;
export type CreateClientWorksetMutationFn = Apollo.MutationFunction<CreateClientWorksetMutation, CreateClientWorksetMutationVariables>;

/**
 * __useCreateClientWorksetMutation__
 *
 * To run a mutation, you first call `useCreateClientWorksetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientWorksetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientWorksetMutation, { data, loading, error }] = useCreateClientWorksetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      workset: // value for 'workset'
 *   },
 * });
 */
export function useCreateClientWorksetMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientWorksetMutation, CreateClientWorksetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientWorksetMutation, CreateClientWorksetMutationVariables>(CreateClientWorksetDocument, options);
      }
export type CreateClientWorksetMutationHookResult = ReturnType<typeof useCreateClientWorksetMutation>;
export type CreateClientWorksetMutationResult = Apollo.MutationResult<CreateClientWorksetMutation>;
export type CreateClientWorksetMutationOptions = Apollo.BaseMutationOptions<CreateClientWorksetMutation, CreateClientWorksetMutationVariables>;
export const SetClientAdminDocument = gql`
    mutation setClientAdmin($id: String, $userId: String) {
  Client(id: $id) {
    setAdmin(id: $userId)
  }
}
    `;
export type SetClientAdminMutationFn = Apollo.MutationFunction<SetClientAdminMutation, SetClientAdminMutationVariables>;

/**
 * __useSetClientAdminMutation__
 *
 * To run a mutation, you first call `useSetClientAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClientAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClientAdminMutation, { data, loading, error }] = useSetClientAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetClientAdminMutation(baseOptions?: Apollo.MutationHookOptions<SetClientAdminMutation, SetClientAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClientAdminMutation, SetClientAdminMutationVariables>(SetClientAdminDocument, options);
      }
export type SetClientAdminMutationHookResult = ReturnType<typeof useSetClientAdminMutation>;
export type SetClientAdminMutationResult = Apollo.MutationResult<SetClientAdminMutation>;
export type SetClientAdminMutationOptions = Apollo.BaseMutationOptions<SetClientAdminMutation, SetClientAdminMutationVariables>;
export const DeleteClientWorksetsDocument = gql`
    mutation deleteClientWorksets($id: String, $ids: [String]) {
  Client(id: $id) {
    deleteWorksets(ids: $ids)
  }
}
    `;
export type DeleteClientWorksetsMutationFn = Apollo.MutationFunction<DeleteClientWorksetsMutation, DeleteClientWorksetsMutationVariables>;

/**
 * __useDeleteClientWorksetsMutation__
 *
 * To run a mutation, you first call `useDeleteClientWorksetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientWorksetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientWorksetsMutation, { data, loading, error }] = useDeleteClientWorksetsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClientWorksetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientWorksetsMutation, DeleteClientWorksetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientWorksetsMutation, DeleteClientWorksetsMutationVariables>(DeleteClientWorksetsDocument, options);
      }
export type DeleteClientWorksetsMutationHookResult = ReturnType<typeof useDeleteClientWorksetsMutation>;
export type DeleteClientWorksetsMutationResult = Apollo.MutationResult<DeleteClientWorksetsMutation>;
export type DeleteClientWorksetsMutationOptions = Apollo.BaseMutationOptions<DeleteClientWorksetsMutation, DeleteClientWorksetsMutationVariables>;
export const DeleteClientAdminsDocument = gql`
    mutation deleteClientAdmins($id: String, $ids: [String]) {
  Client(id: $id) {
    deleteAdmins(ids: $ids)
  }
}
    `;
export type DeleteClientAdminsMutationFn = Apollo.MutationFunction<DeleteClientAdminsMutation, DeleteClientAdminsMutationVariables>;

/**
 * __useDeleteClientAdminsMutation__
 *
 * To run a mutation, you first call `useDeleteClientAdminsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientAdminsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientAdminsMutation, { data, loading, error }] = useDeleteClientAdminsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClientAdminsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientAdminsMutation, DeleteClientAdminsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientAdminsMutation, DeleteClientAdminsMutationVariables>(DeleteClientAdminsDocument, options);
      }
export type DeleteClientAdminsMutationHookResult = ReturnType<typeof useDeleteClientAdminsMutation>;
export type DeleteClientAdminsMutationResult = Apollo.MutationResult<DeleteClientAdminsMutation>;
export type DeleteClientAdminsMutationOptions = Apollo.BaseMutationOptions<DeleteClientAdminsMutation, DeleteClientAdminsMutationVariables>;
export const DeleteClientTagsDocument = gql`
    mutation deleteClientTags($id: String, $ids: [String]) {
  Client(id: $id) {
    deleteTags(ids: $ids)
  }
}
    `;
export type DeleteClientTagsMutationFn = Apollo.MutationFunction<DeleteClientTagsMutation, DeleteClientTagsMutationVariables>;

/**
 * __useDeleteClientTagsMutation__
 *
 * To run a mutation, you first call `useDeleteClientTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientTagsMutation, { data, loading, error }] = useDeleteClientTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClientTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientTagsMutation, DeleteClientTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientTagsMutation, DeleteClientTagsMutationVariables>(DeleteClientTagsDocument, options);
      }
export type DeleteClientTagsMutationHookResult = ReturnType<typeof useDeleteClientTagsMutation>;
export type DeleteClientTagsMutationResult = Apollo.MutationResult<DeleteClientTagsMutation>;
export type DeleteClientTagsMutationOptions = Apollo.BaseMutationOptions<DeleteClientTagsMutation, DeleteClientTagsMutationVariables>;
export const DeleteClientHealthChecksDocument = gql`
    mutation deleteClientHealthChecks($id: String, $ids: [String]) {
  Client(id: $id) {
    deleteHealthChecks(ids: $ids)
  }
}
    `;
export type DeleteClientHealthChecksMutationFn = Apollo.MutationFunction<DeleteClientHealthChecksMutation, DeleteClientHealthChecksMutationVariables>;

/**
 * __useDeleteClientHealthChecksMutation__
 *
 * To run a mutation, you first call `useDeleteClientHealthChecksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientHealthChecksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientHealthChecksMutation, { data, loading, error }] = useDeleteClientHealthChecksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteClientHealthChecksMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientHealthChecksMutation, DeleteClientHealthChecksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientHealthChecksMutation, DeleteClientHealthChecksMutationVariables>(DeleteClientHealthChecksDocument, options);
      }
export type DeleteClientHealthChecksMutationHookResult = ReturnType<typeof useDeleteClientHealthChecksMutation>;
export type DeleteClientHealthChecksMutationResult = Apollo.MutationResult<DeleteClientHealthChecksMutation>;
export type DeleteClientHealthChecksMutationOptions = Apollo.BaseMutationOptions<DeleteClientHealthChecksMutation, DeleteClientHealthChecksMutationVariables>;
export const CountClientsDocument = gql`
    query countClients {
  ClientCount
}
    `;

/**
 * __useCountClientsQuery__
 *
 * To run a query within a React component, call `useCountClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountClientsQuery(baseOptions?: Apollo.QueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
      }
export function useCountClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
        }
// @ts-ignore
export function useCountClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountClientsQuery, CountClientsQueryVariables>): Apollo.UseSuspenseQueryResult<CountClientsQuery, CountClientsQueryVariables>;
export function useCountClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountClientsQuery, CountClientsQueryVariables>): Apollo.UseSuspenseQueryResult<CountClientsQuery | undefined, CountClientsQueryVariables>;
export function useCountClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
        }
export type CountClientsQueryHookResult = ReturnType<typeof useCountClientsQuery>;
export type CountClientsLazyQueryHookResult = ReturnType<typeof useCountClientsLazyQuery>;
export type CountClientsSuspenseQueryHookResult = ReturnType<typeof useCountClientsSuspenseQuery>;
export type CountClientsQueryResult = Apollo.QueryResult<CountClientsQuery, CountClientsQueryVariables>;
export const GetClientsDocument = gql`
    query getClients($contains: String, $tags: [String]) {
  ClientList(tagIds: $tags, where: {name: {contains: $contains}}) {
    nodes {
      ...clientProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ClientPropsFragmentDoc}`;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
// @ts-ignore
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsQuery, GetClientsQueryVariables>;
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsQuery | undefined, GetClientsQueryVariables>;
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsSuspenseQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const GetClientsShortDocument = gql`
    query getClientsShort {
  ClientList(first: 10000) {
    nodes {
      id
      name
      createdTime
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetClientsShortQuery__
 *
 * To run a query within a React component, call `useGetClientsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientsShortQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsShortQuery, GetClientsShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsShortQuery, GetClientsShortQueryVariables>(GetClientsShortDocument, options);
      }
export function useGetClientsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsShortQuery, GetClientsShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsShortQuery, GetClientsShortQueryVariables>(GetClientsShortDocument, options);
        }
// @ts-ignore
export function useGetClientsShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsShortQuery, GetClientsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsShortQuery, GetClientsShortQueryVariables>;
export function useGetClientsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsShortQuery, GetClientsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsShortQuery | undefined, GetClientsShortQueryVariables>;
export function useGetClientsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsShortQuery, GetClientsShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsShortQuery, GetClientsShortQueryVariables>(GetClientsShortDocument, options);
        }
export type GetClientsShortQueryHookResult = ReturnType<typeof useGetClientsShortQuery>;
export type GetClientsShortLazyQueryHookResult = ReturnType<typeof useGetClientsShortLazyQuery>;
export type GetClientsShortSuspenseQueryHookResult = ReturnType<typeof useGetClientsShortSuspenseQuery>;
export type GetClientsShortQueryResult = Apollo.QueryResult<GetClientsShortQuery, GetClientsShortQueryVariables>;
export const GetRecentClientCreationsDocument = gql`
    query getRecentClientCreations($first: Int) {
  ClientList(first: $first, order: {createdTime: DESC}) {
    nodes {
      id
      name
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRecentClientCreationsQuery__
 *
 * To run a query within a React component, call `useGetRecentClientCreationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentClientCreationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentClientCreationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRecentClientCreationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>(GetRecentClientCreationsDocument, options);
      }
export function useGetRecentClientCreationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>(GetRecentClientCreationsDocument, options);
        }
// @ts-ignore
export function useGetRecentClientCreationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>;
export function useGetRecentClientCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentClientCreationsQuery | undefined, GetRecentClientCreationsQueryVariables>;
export function useGetRecentClientCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>(GetRecentClientCreationsDocument, options);
        }
export type GetRecentClientCreationsQueryHookResult = ReturnType<typeof useGetRecentClientCreationsQuery>;
export type GetRecentClientCreationsLazyQueryHookResult = ReturnType<typeof useGetRecentClientCreationsLazyQuery>;
export type GetRecentClientCreationsSuspenseQueryHookResult = ReturnType<typeof useGetRecentClientCreationsSuspenseQuery>;
export type GetRecentClientCreationsQueryResult = Apollo.QueryResult<GetRecentClientCreationsQuery, GetRecentClientCreationsQueryVariables>;
export const GetClientDocument = gql`
    query getClient($id: String) {
  Client(id: $id) {
    ...clientProps
    worksets {
      id
      name
      group
      description
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
  }
}
    ${ClientPropsFragmentDoc}`;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions?: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
// @ts-ignore
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery | undefined, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const CreateCommandDocument = gql`
    mutation createCommand($command: CommandInput) {
  CreateCommand(item: $command)
}
    `;
export type CreateCommandMutationFn = Apollo.MutationFunction<CreateCommandMutation, CreateCommandMutationVariables>;

/**
 * __useCreateCommandMutation__
 *
 * To run a mutation, you first call `useCreateCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommandMutation, { data, loading, error }] = useCreateCommandMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useCreateCommandMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommandMutation, CreateCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommandMutation, CreateCommandMutationVariables>(CreateCommandDocument, options);
      }
export type CreateCommandMutationHookResult = ReturnType<typeof useCreateCommandMutation>;
export type CreateCommandMutationResult = Apollo.MutationResult<CreateCommandMutation>;
export type CreateCommandMutationOptions = Apollo.BaseMutationOptions<CreateCommandMutation, CreateCommandMutationVariables>;
export const DeleteCommandsDocument = gql`
    mutation deleteCommands($ids: [String]) {
  DeleteCommandList(ids: $ids)
}
    `;
export type DeleteCommandsMutationFn = Apollo.MutationFunction<DeleteCommandsMutation, DeleteCommandsMutationVariables>;

/**
 * __useDeleteCommandsMutation__
 *
 * To run a mutation, you first call `useDeleteCommandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommandsMutation, { data, loading, error }] = useDeleteCommandsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCommandsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommandsMutation, DeleteCommandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommandsMutation, DeleteCommandsMutationVariables>(DeleteCommandsDocument, options);
      }
export type DeleteCommandsMutationHookResult = ReturnType<typeof useDeleteCommandsMutation>;
export type DeleteCommandsMutationResult = Apollo.MutationResult<DeleteCommandsMutation>;
export type DeleteCommandsMutationOptions = Apollo.BaseMutationOptions<DeleteCommandsMutation, DeleteCommandsMutationVariables>;
export const GetCommandsDocument = gql`
    query getCommands($contains: String) {
  CommandList(where: {name: {contains: $contains}}) {
    nodes {
      ...commandProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${CommandPropsFragmentDoc}`;

/**
 * __useGetCommandsQuery__
 *
 * To run a query within a React component, call `useGetCommandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommandsQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *   },
 * });
 */
export function useGetCommandsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommandsQuery, GetCommandsQueryVariables>(GetCommandsDocument, options);
      }
export function useGetCommandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommandsQuery, GetCommandsQueryVariables>(GetCommandsDocument, options);
        }
// @ts-ignore
export function useGetCommandsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandsQuery, GetCommandsQueryVariables>;
export function useGetCommandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandsQuery | undefined, GetCommandsQueryVariables>;
export function useGetCommandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommandsQuery, GetCommandsQueryVariables>(GetCommandsDocument, options);
        }
export type GetCommandsQueryHookResult = ReturnType<typeof useGetCommandsQuery>;
export type GetCommandsLazyQueryHookResult = ReturnType<typeof useGetCommandsLazyQuery>;
export type GetCommandsSuspenseQueryHookResult = ReturnType<typeof useGetCommandsSuspenseQuery>;
export type GetCommandsQueryResult = Apollo.QueryResult<GetCommandsQuery, GetCommandsQueryVariables>;
export const GetCommandDocument = gql`
    query getCommand($id: String) {
  Command(id: $id) {
    ...commandProps
  }
}
    ${CommandPropsFragmentDoc}`;

/**
 * __useGetCommandQuery__
 *
 * To run a query within a React component, call `useGetCommandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommandQuery(baseOptions?: Apollo.QueryHookOptions<GetCommandQuery, GetCommandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommandQuery, GetCommandQueryVariables>(GetCommandDocument, options);
      }
export function useGetCommandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommandQuery, GetCommandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommandQuery, GetCommandQueryVariables>(GetCommandDocument, options);
        }
// @ts-ignore
export function useGetCommandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommandQuery, GetCommandQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandQuery, GetCommandQueryVariables>;
export function useGetCommandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandQuery, GetCommandQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandQuery | undefined, GetCommandQueryVariables>;
export function useGetCommandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandQuery, GetCommandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommandQuery, GetCommandQueryVariables>(GetCommandDocument, options);
        }
export type GetCommandQueryHookResult = ReturnType<typeof useGetCommandQuery>;
export type GetCommandLazyQueryHookResult = ReturnType<typeof useGetCommandLazyQuery>;
export type GetCommandSuspenseQueryHookResult = ReturnType<typeof useGetCommandSuspenseQuery>;
export type GetCommandQueryResult = Apollo.QueryResult<GetCommandQuery, GetCommandQueryVariables>;
export const CreateContentDocument = gql`
    mutation createContent($content: ContentInput) {
  CreateContent(item: $content)
}
    `;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const DeleteContentsDocument = gql`
    mutation deleteContents($libraryId: String, $ids: [String]) {
  Library(id: $libraryId) {
    deleteDirectContents(ids: $ids)
  }
}
    `;
export type DeleteContentsMutationFn = Apollo.MutationFunction<DeleteContentsMutation, DeleteContentsMutationVariables>;

/**
 * __useDeleteContentsMutation__
 *
 * To run a mutation, you first call `useDeleteContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentsMutation, { data, loading, error }] = useDeleteContentsMutation({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentsMutation, DeleteContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentsMutation, DeleteContentsMutationVariables>(DeleteContentsDocument, options);
      }
export type DeleteContentsMutationHookResult = ReturnType<typeof useDeleteContentsMutation>;
export type DeleteContentsMutationResult = Apollo.MutationResult<DeleteContentsMutation>;
export type DeleteContentsMutationOptions = Apollo.BaseMutationOptions<DeleteContentsMutation, DeleteContentsMutationVariables>;
export const MoveContentsDocument = gql`
    mutation moveContents($libraryId: String, $targetLibraryId: String, $ids: [String]) {
  Library(id: $libraryId) {
    moveContents(targetLibraryId: $targetLibraryId, ids: $ids)
  }
}
    `;
export type MoveContentsMutationFn = Apollo.MutationFunction<MoveContentsMutation, MoveContentsMutationVariables>;

/**
 * __useMoveContentsMutation__
 *
 * To run a mutation, you first call `useMoveContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveContentsMutation, { data, loading, error }] = useMoveContentsMutation({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      targetLibraryId: // value for 'targetLibraryId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMoveContentsMutation(baseOptions?: Apollo.MutationHookOptions<MoveContentsMutation, MoveContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveContentsMutation, MoveContentsMutationVariables>(MoveContentsDocument, options);
      }
export type MoveContentsMutationHookResult = ReturnType<typeof useMoveContentsMutation>;
export type MoveContentsMutationResult = Apollo.MutationResult<MoveContentsMutation>;
export type MoveContentsMutationOptions = Apollo.BaseMutationOptions<MoveContentsMutation, MoveContentsMutationVariables>;
export const AssignContentsTagsDocument = gql`
    mutation assignContentsTags($libraryId: String, $ids: [String], $tagIds: [String], $overwrite: Boolean) {
  Library(id: $libraryId) {
    assignContentTags(ids: $ids, tagIds: $tagIds, overwrite: $overwrite)
  }
}
    `;
export type AssignContentsTagsMutationFn = Apollo.MutationFunction<AssignContentsTagsMutation, AssignContentsTagsMutationVariables>;

/**
 * __useAssignContentsTagsMutation__
 *
 * To run a mutation, you first call `useAssignContentsTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignContentsTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignContentsTagsMutation, { data, loading, error }] = useAssignContentsTagsMutation({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      ids: // value for 'ids'
 *      tagIds: // value for 'tagIds'
 *      overwrite: // value for 'overwrite'
 *   },
 * });
 */
export function useAssignContentsTagsMutation(baseOptions?: Apollo.MutationHookOptions<AssignContentsTagsMutation, AssignContentsTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignContentsTagsMutation, AssignContentsTagsMutationVariables>(AssignContentsTagsDocument, options);
      }
export type AssignContentsTagsMutationHookResult = ReturnType<typeof useAssignContentsTagsMutation>;
export type AssignContentsTagsMutationResult = Apollo.MutationResult<AssignContentsTagsMutation>;
export type AssignContentsTagsMutationOptions = Apollo.BaseMutationOptions<AssignContentsTagsMutation, AssignContentsTagsMutationVariables>;
export const AssignContentsGroupsDocument = gql`
    mutation assignContentsGroups($libraryId: String, $ids: [String], $groupIds: [String], $overwrite: Boolean) {
  Library(id: $libraryId) {
    assignContentGroups(ids: $ids, groupIds: $groupIds, overwrite: $overwrite)
  }
}
    `;
export type AssignContentsGroupsMutationFn = Apollo.MutationFunction<AssignContentsGroupsMutation, AssignContentsGroupsMutationVariables>;

/**
 * __useAssignContentsGroupsMutation__
 *
 * To run a mutation, you first call `useAssignContentsGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignContentsGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignContentsGroupsMutation, { data, loading, error }] = useAssignContentsGroupsMutation({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      ids: // value for 'ids'
 *      groupIds: // value for 'groupIds'
 *      overwrite: // value for 'overwrite'
 *   },
 * });
 */
export function useAssignContentsGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AssignContentsGroupsMutation, AssignContentsGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignContentsGroupsMutation, AssignContentsGroupsMutationVariables>(AssignContentsGroupsDocument, options);
      }
export type AssignContentsGroupsMutationHookResult = ReturnType<typeof useAssignContentsGroupsMutation>;
export type AssignContentsGroupsMutationResult = Apollo.MutationResult<AssignContentsGroupsMutation>;
export type AssignContentsGroupsMutationOptions = Apollo.BaseMutationOptions<AssignContentsGroupsMutation, AssignContentsGroupsMutationVariables>;
export const AssignContentsClassificationsDocument = gql`
    mutation assignContentsClassifications($libraryId: String, $ids: [String], $classificationIds: [String], $overwrite: Boolean) {
  Library(id: $libraryId) {
    assignContentClassifications(
      ids: $ids
      classificationIds: $classificationIds
      overwrite: $overwrite
    )
  }
}
    `;
export type AssignContentsClassificationsMutationFn = Apollo.MutationFunction<AssignContentsClassificationsMutation, AssignContentsClassificationsMutationVariables>;

/**
 * __useAssignContentsClassificationsMutation__
 *
 * To run a mutation, you first call `useAssignContentsClassificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignContentsClassificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignContentsClassificationsMutation, { data, loading, error }] = useAssignContentsClassificationsMutation({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      ids: // value for 'ids'
 *      classificationIds: // value for 'classificationIds'
 *      overwrite: // value for 'overwrite'
 *   },
 * });
 */
export function useAssignContentsClassificationsMutation(baseOptions?: Apollo.MutationHookOptions<AssignContentsClassificationsMutation, AssignContentsClassificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignContentsClassificationsMutation, AssignContentsClassificationsMutationVariables>(AssignContentsClassificationsDocument, options);
      }
export type AssignContentsClassificationsMutationHookResult = ReturnType<typeof useAssignContentsClassificationsMutation>;
export type AssignContentsClassificationsMutationResult = Apollo.MutationResult<AssignContentsClassificationsMutation>;
export type AssignContentsClassificationsMutationOptions = Apollo.BaseMutationOptions<AssignContentsClassificationsMutation, AssignContentsClassificationsMutationVariables>;
export const SetContentTypeDocument = gql`
    mutation setContentType($id: String, $type: ContentTypeInput) {
  Content(id: $id) {
    setType(type: $type) {
      id
      name
    }
  }
}
    `;
export type SetContentTypeMutationFn = Apollo.MutationFunction<SetContentTypeMutation, SetContentTypeMutationVariables>;

/**
 * __useSetContentTypeMutation__
 *
 * To run a mutation, you first call `useSetContentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContentTypeMutation, { data, loading, error }] = useSetContentTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSetContentTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetContentTypeMutation, SetContentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContentTypeMutation, SetContentTypeMutationVariables>(SetContentTypeDocument, options);
      }
export type SetContentTypeMutationHookResult = ReturnType<typeof useSetContentTypeMutation>;
export type SetContentTypeMutationResult = Apollo.MutationResult<SetContentTypeMutation>;
export type SetContentTypeMutationOptions = Apollo.BaseMutationOptions<SetContentTypeMutation, SetContentTypeMutationVariables>;
export const DeleteContentTypesDocument = gql`
    mutation deleteContentTypes($id: String, $ids: [String]) {
  Content(id: $id) {
    deleteTypes(ids: $ids)
  }
}
    `;
export type DeleteContentTypesMutationFn = Apollo.MutationFunction<DeleteContentTypesMutation, DeleteContentTypesMutationVariables>;

/**
 * __useDeleteContentTypesMutation__
 *
 * To run a mutation, you first call `useDeleteContentTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentTypesMutation, { data, loading, error }] = useDeleteContentTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContentTypesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentTypesMutation, DeleteContentTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentTypesMutation, DeleteContentTypesMutationVariables>(DeleteContentTypesDocument, options);
      }
export type DeleteContentTypesMutationHookResult = ReturnType<typeof useDeleteContentTypesMutation>;
export type DeleteContentTypesMutationResult = Apollo.MutationResult<DeleteContentTypesMutation>;
export type DeleteContentTypesMutationOptions = Apollo.BaseMutationOptions<DeleteContentTypesMutation, DeleteContentTypesMutationVariables>;
export const DeleteContentTagsDocument = gql`
    mutation deleteContentTags($id: String, $ids: [String]) {
  Content(id: $id) {
    deleteTags(ids: $ids)
  }
}
    `;
export type DeleteContentTagsMutationFn = Apollo.MutationFunction<DeleteContentTagsMutation, DeleteContentTagsMutationVariables>;

/**
 * __useDeleteContentTagsMutation__
 *
 * To run a mutation, you first call `useDeleteContentTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentTagsMutation, { data, loading, error }] = useDeleteContentTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContentTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentTagsMutation, DeleteContentTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentTagsMutation, DeleteContentTagsMutationVariables>(DeleteContentTagsDocument, options);
      }
export type DeleteContentTagsMutationHookResult = ReturnType<typeof useDeleteContentTagsMutation>;
export type DeleteContentTagsMutationResult = Apollo.MutationResult<DeleteContentTagsMutation>;
export type DeleteContentTagsMutationOptions = Apollo.BaseMutationOptions<DeleteContentTagsMutation, DeleteContentTagsMutationVariables>;
export const EditContentSettingsDocument = gql`
    mutation editContentSettings($versionId: String, $settings: String) {
  ContentVersion(id: $versionId) {
    setSettings(settings: $settings)
  }
}
    `;
export type EditContentSettingsMutationFn = Apollo.MutationFunction<EditContentSettingsMutation, EditContentSettingsMutationVariables>;

/**
 * __useEditContentSettingsMutation__
 *
 * To run a mutation, you first call `useEditContentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentSettingsMutation, { data, loading, error }] = useEditContentSettingsMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useEditContentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditContentSettingsMutation, EditContentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentSettingsMutation, EditContentSettingsMutationVariables>(EditContentSettingsDocument, options);
      }
export type EditContentSettingsMutationHookResult = ReturnType<typeof useEditContentSettingsMutation>;
export type EditContentSettingsMutationResult = Apollo.MutationResult<EditContentSettingsMutation>;
export type EditContentSettingsMutationOptions = Apollo.BaseMutationOptions<EditContentSettingsMutation, EditContentSettingsMutationVariables>;
export const EditContentTypeSettingsDocument = gql`
    mutation editContentTypeSettings($contentId: String, $typeId: String, $settings: String) {
  Content(id: $contentId) {
    setTypeSettings(typeId: $typeId, settings: $settings)
  }
}
    `;
export type EditContentTypeSettingsMutationFn = Apollo.MutationFunction<EditContentTypeSettingsMutation, EditContentTypeSettingsMutationVariables>;

/**
 * __useEditContentTypeSettingsMutation__
 *
 * To run a mutation, you first call `useEditContentTypeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentTypeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentTypeSettingsMutation, { data, loading, error }] = useEditContentTypeSettingsMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      typeId: // value for 'typeId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useEditContentTypeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditContentTypeSettingsMutation, EditContentTypeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentTypeSettingsMutation, EditContentTypeSettingsMutationVariables>(EditContentTypeSettingsDocument, options);
      }
export type EditContentTypeSettingsMutationHookResult = ReturnType<typeof useEditContentTypeSettingsMutation>;
export type EditContentTypeSettingsMutationResult = Apollo.MutationResult<EditContentTypeSettingsMutation>;
export type EditContentTypeSettingsMutationOptions = Apollo.BaseMutationOptions<EditContentTypeSettingsMutation, EditContentTypeSettingsMutationVariables>;
export const RenameContentDocument = gql`
    mutation renameContent($id: String, $name: String) {
  Content(id: $id) {
    setName(name: $name)
  }
}
    `;
export type RenameContentMutationFn = Apollo.MutationFunction<RenameContentMutation, RenameContentMutationVariables>;

/**
 * __useRenameContentMutation__
 *
 * To run a mutation, you first call `useRenameContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameContentMutation, { data, loading, error }] = useRenameContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameContentMutation(baseOptions?: Apollo.MutationHookOptions<RenameContentMutation, RenameContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameContentMutation, RenameContentMutationVariables>(RenameContentDocument, options);
      }
export type RenameContentMutationHookResult = ReturnType<typeof useRenameContentMutation>;
export type RenameContentMutationResult = Apollo.MutationResult<RenameContentMutation>;
export type RenameContentMutationOptions = Apollo.BaseMutationOptions<RenameContentMutation, RenameContentMutationVariables>;
export const EditContentCategoryDocument = gql`
    mutation editContentCategory($versionId: String, $category: String) {
  ContentVersion(id: $versionId) {
    setCategory(category: $category)
  }
}
    `;
export type EditContentCategoryMutationFn = Apollo.MutationFunction<EditContentCategoryMutation, EditContentCategoryMutationVariables>;

/**
 * __useEditContentCategoryMutation__
 *
 * To run a mutation, you first call `useEditContentCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentCategoryMutation, { data, loading, error }] = useEditContentCategoryMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useEditContentCategoryMutation(baseOptions?: Apollo.MutationHookOptions<EditContentCategoryMutation, EditContentCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentCategoryMutation, EditContentCategoryMutationVariables>(EditContentCategoryDocument, options);
      }
export type EditContentCategoryMutationHookResult = ReturnType<typeof useEditContentCategoryMutation>;
export type EditContentCategoryMutationResult = Apollo.MutationResult<EditContentCategoryMutation>;
export type EditContentCategoryMutationOptions = Apollo.BaseMutationOptions<EditContentCategoryMutation, EditContentCategoryMutationVariables>;
export const EditContentApplicationNameDocument = gql`
    mutation editContentApplicationName($id: String, $applicationName: String) {
  Content(id: $id) {
    setApplicationName(applicationName: $applicationName)
  }
}
    `;
export type EditContentApplicationNameMutationFn = Apollo.MutationFunction<EditContentApplicationNameMutation, EditContentApplicationNameMutationVariables>;

/**
 * __useEditContentApplicationNameMutation__
 *
 * To run a mutation, you first call `useEditContentApplicationNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentApplicationNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentApplicationNameMutation, { data, loading, error }] = useEditContentApplicationNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      applicationName: // value for 'applicationName'
 *   },
 * });
 */
export function useEditContentApplicationNameMutation(baseOptions?: Apollo.MutationHookOptions<EditContentApplicationNameMutation, EditContentApplicationNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentApplicationNameMutation, EditContentApplicationNameMutationVariables>(EditContentApplicationNameDocument, options);
      }
export type EditContentApplicationNameMutationHookResult = ReturnType<typeof useEditContentApplicationNameMutation>;
export type EditContentApplicationNameMutationResult = Apollo.MutationResult<EditContentApplicationNameMutation>;
export type EditContentApplicationNameMutationOptions = Apollo.BaseMutationOptions<EditContentApplicationNameMutation, EditContentApplicationNameMutationVariables>;
export const RenameContentTypeDocument = gql`
    mutation renameContentType($contentId: String, $typeId: String, $name: String) {
  Content(id: $contentId) {
    setTypeName(typeId: $typeId, name: $name)
  }
}
    `;
export type RenameContentTypeMutationFn = Apollo.MutationFunction<RenameContentTypeMutation, RenameContentTypeMutationVariables>;

/**
 * __useRenameContentTypeMutation__
 *
 * To run a mutation, you first call `useRenameContentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameContentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameContentTypeMutation, { data, loading, error }] = useRenameContentTypeMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      typeId: // value for 'typeId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameContentTypeMutation(baseOptions?: Apollo.MutationHookOptions<RenameContentTypeMutation, RenameContentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameContentTypeMutation, RenameContentTypeMutationVariables>(RenameContentTypeDocument, options);
      }
export type RenameContentTypeMutationHookResult = ReturnType<typeof useRenameContentTypeMutation>;
export type RenameContentTypeMutationResult = Apollo.MutationResult<RenameContentTypeMutation>;
export type RenameContentTypeMutationOptions = Apollo.BaseMutationOptions<RenameContentTypeMutation, RenameContentTypeMutationVariables>;
export const EditContentDescriptionDocument = gql`
    mutation editContentDescription($id: String, $description: String) {
  Content(id: $id) {
    setDescription(description: $description)
  }
}
    `;
export type EditContentDescriptionMutationFn = Apollo.MutationFunction<EditContentDescriptionMutation, EditContentDescriptionMutationVariables>;

/**
 * __useEditContentDescriptionMutation__
 *
 * To run a mutation, you first call `useEditContentDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentDescriptionMutation, { data, loading, error }] = useEditContentDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditContentDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<EditContentDescriptionMutation, EditContentDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentDescriptionMutation, EditContentDescriptionMutationVariables>(EditContentDescriptionDocument, options);
      }
export type EditContentDescriptionMutationHookResult = ReturnType<typeof useEditContentDescriptionMutation>;
export type EditContentDescriptionMutationResult = Apollo.MutationResult<EditContentDescriptionMutation>;
export type EditContentDescriptionMutationOptions = Apollo.BaseMutationOptions<EditContentDescriptionMutation, EditContentDescriptionMutationVariables>;
export const EditContentTypeDescriptionDocument = gql`
    mutation editContentTypeDescription($contentId: String, $typeId: String, $description: String) {
  Content(id: $contentId) {
    setTypeDescription(typeId: $typeId, description: $description)
  }
}
    `;
export type EditContentTypeDescriptionMutationFn = Apollo.MutationFunction<EditContentTypeDescriptionMutation, EditContentTypeDescriptionMutationVariables>;

/**
 * __useEditContentTypeDescriptionMutation__
 *
 * To run a mutation, you first call `useEditContentTypeDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentTypeDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentTypeDescriptionMutation, { data, loading, error }] = useEditContentTypeDescriptionMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      typeId: // value for 'typeId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditContentTypeDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<EditContentTypeDescriptionMutation, EditContentTypeDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentTypeDescriptionMutation, EditContentTypeDescriptionMutationVariables>(EditContentTypeDescriptionDocument, options);
      }
export type EditContentTypeDescriptionMutationHookResult = ReturnType<typeof useEditContentTypeDescriptionMutation>;
export type EditContentTypeDescriptionMutationResult = Apollo.MutationResult<EditContentTypeDescriptionMutation>;
export type EditContentTypeDescriptionMutationOptions = Apollo.BaseMutationOptions<EditContentTypeDescriptionMutation, EditContentTypeDescriptionMutationVariables>;
export const RequestContentFileDownloadDocument = gql`
    mutation requestContentFileDownload($contentId: String) {
  Content(id: $contentId) {
    requestFileDownload
  }
}
    `;
export type RequestContentFileDownloadMutationFn = Apollo.MutationFunction<RequestContentFileDownloadMutation, RequestContentFileDownloadMutationVariables>;

/**
 * __useRequestContentFileDownloadMutation__
 *
 * To run a mutation, you first call `useRequestContentFileDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestContentFileDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestContentFileDownloadMutation, { data, loading, error }] = useRequestContentFileDownloadMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useRequestContentFileDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RequestContentFileDownloadMutation, RequestContentFileDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestContentFileDownloadMutation, RequestContentFileDownloadMutationVariables>(RequestContentFileDownloadDocument, options);
      }
export type RequestContentFileDownloadMutationHookResult = ReturnType<typeof useRequestContentFileDownloadMutation>;
export type RequestContentFileDownloadMutationResult = Apollo.MutationResult<RequestContentFileDownloadMutation>;
export type RequestContentFileDownloadMutationOptions = Apollo.BaseMutationOptions<RequestContentFileDownloadMutation, RequestContentFileDownloadMutationVariables>;
export const SetRelatedContentsDocument = gql`
    mutation setRelatedContents($id: String, $ids: [String]) {
  Content(id: $id) {
    setRelatedContents(ids: $ids)
  }
}
    `;
export type SetRelatedContentsMutationFn = Apollo.MutationFunction<SetRelatedContentsMutation, SetRelatedContentsMutationVariables>;

/**
 * __useSetRelatedContentsMutation__
 *
 * To run a mutation, you first call `useSetRelatedContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRelatedContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRelatedContentsMutation, { data, loading, error }] = useSetRelatedContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSetRelatedContentsMutation(baseOptions?: Apollo.MutationHookOptions<SetRelatedContentsMutation, SetRelatedContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRelatedContentsMutation, SetRelatedContentsMutationVariables>(SetRelatedContentsDocument, options);
      }
export type SetRelatedContentsMutationHookResult = ReturnType<typeof useSetRelatedContentsMutation>;
export type SetRelatedContentsMutationResult = Apollo.MutationResult<SetRelatedContentsMutation>;
export type SetRelatedContentsMutationOptions = Apollo.BaseMutationOptions<SetRelatedContentsMutation, SetRelatedContentsMutationVariables>;
export const DeleteRelatedContentsDocument = gql`
    mutation deleteRelatedContents($id: String, $ids: [String]) {
  Content(id: $id) {
    deleteRelatedContents(ids: $ids)
  }
}
    `;
export type DeleteRelatedContentsMutationFn = Apollo.MutationFunction<DeleteRelatedContentsMutation, DeleteRelatedContentsMutationVariables>;

/**
 * __useDeleteRelatedContentsMutation__
 *
 * To run a mutation, you first call `useDeleteRelatedContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRelatedContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRelatedContentsMutation, { data, loading, error }] = useDeleteRelatedContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteRelatedContentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRelatedContentsMutation, DeleteRelatedContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRelatedContentsMutation, DeleteRelatedContentsMutationVariables>(DeleteRelatedContentsDocument, options);
      }
export type DeleteRelatedContentsMutationHookResult = ReturnType<typeof useDeleteRelatedContentsMutation>;
export type DeleteRelatedContentsMutationResult = Apollo.MutationResult<DeleteRelatedContentsMutation>;
export type DeleteRelatedContentsMutationOptions = Apollo.BaseMutationOptions<DeleteRelatedContentsMutation, DeleteRelatedContentsMutationVariables>;
export const GetRegisteredContentsDocument = gql`
    query getRegisteredContents($id: String, $contains: String, $category: String, $after: String, $tagIds: [String], $order: [ContentSortInput!]) {
  Library(id: $id) {
    id
    registeredContents(
      first: 10000
      tagIds: $tagIds
      after: $after
      where: {or: [{name: {contains: $contains}}, {category: {contains: $category}}]}
      order: $order
    ) {
      nodes {
        ...contentProps
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${ContentPropsFragmentDoc}`;

/**
 * __useGetRegisteredContentsQuery__
 *
 * To run a query within a React component, call `useGetRegisteredContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegisteredContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegisteredContentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contains: // value for 'contains'
 *      category: // value for 'category'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetRegisteredContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>(GetRegisteredContentsDocument, options);
      }
export function useGetRegisteredContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>(GetRegisteredContentsDocument, options);
        }
// @ts-ignore
export function useGetRegisteredContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>;
export function useGetRegisteredContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegisteredContentsQuery | undefined, GetRegisteredContentsQueryVariables>;
export function useGetRegisteredContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>(GetRegisteredContentsDocument, options);
        }
export type GetRegisteredContentsQueryHookResult = ReturnType<typeof useGetRegisteredContentsQuery>;
export type GetRegisteredContentsLazyQueryHookResult = ReturnType<typeof useGetRegisteredContentsLazyQuery>;
export type GetRegisteredContentsSuspenseQueryHookResult = ReturnType<typeof useGetRegisteredContentsSuspenseQuery>;
export type GetRegisteredContentsQueryResult = Apollo.QueryResult<GetRegisteredContentsQuery, GetRegisteredContentsQueryVariables>;
export const GetUnregisteredContentsDocument = gql`
    query getUnregisteredContents($id: String, $contains: String, $category: String, $after: String, $tagIds: [String], $order: [ContentSortInput!]) {
  Library(id: $id) {
    id
    unregisteredContents(
      first: 10000
      tagIds: $tagIds
      after: $after
      where: {or: [{name: {contains: $contains}}, {category: {contains: $category}}]}
      order: $order
    ) {
      nodes {
        ...contentProps
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${ContentPropsFragmentDoc}`;

/**
 * __useGetUnregisteredContentsQuery__
 *
 * To run a query within a React component, call `useGetUnregisteredContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnregisteredContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnregisteredContentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contains: // value for 'contains'
 *      category: // value for 'category'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetUnregisteredContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>(GetUnregisteredContentsDocument, options);
      }
export function useGetUnregisteredContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>(GetUnregisteredContentsDocument, options);
        }
// @ts-ignore
export function useGetUnregisteredContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>;
export function useGetUnregisteredContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnregisteredContentsQuery | undefined, GetUnregisteredContentsQueryVariables>;
export function useGetUnregisteredContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>(GetUnregisteredContentsDocument, options);
        }
export type GetUnregisteredContentsQueryHookResult = ReturnType<typeof useGetUnregisteredContentsQuery>;
export type GetUnregisteredContentsLazyQueryHookResult = ReturnType<typeof useGetUnregisteredContentsLazyQuery>;
export type GetUnregisteredContentsSuspenseQueryHookResult = ReturnType<typeof useGetUnregisteredContentsSuspenseQuery>;
export type GetUnregisteredContentsQueryResult = Apollo.QueryResult<GetUnregisteredContentsQuery, GetUnregisteredContentsQueryVariables>;
export const GetContentsWithCategoryDocument = gql`
    query getContentsWithCategory($libraryId: String, $contains: String, $category: String, $after: String, $tagIds: [String], $order: [ContentSortInput!]) {
  Library(id: $libraryId) {
    id
    contents(
      tagIds: $tagIds
      after: $after
      where: {and: [{name: {contains: $contains}}, {category: {contains: $category}}]}
      order: $order
    ) {
      nodes {
        ...contentProps
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${ContentPropsFragmentDoc}`;

/**
 * __useGetContentsWithCategoryQuery__
 *
 * To run a query within a React component, call `useGetContentsWithCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsWithCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsWithCategoryQuery({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      contains: // value for 'contains'
 *      category: // value for 'category'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetContentsWithCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>(GetContentsWithCategoryDocument, options);
      }
export function useGetContentsWithCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>(GetContentsWithCategoryDocument, options);
        }
// @ts-ignore
export function useGetContentsWithCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>;
export function useGetContentsWithCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentsWithCategoryQuery | undefined, GetContentsWithCategoryQueryVariables>;
export function useGetContentsWithCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>(GetContentsWithCategoryDocument, options);
        }
export type GetContentsWithCategoryQueryHookResult = ReturnType<typeof useGetContentsWithCategoryQuery>;
export type GetContentsWithCategoryLazyQueryHookResult = ReturnType<typeof useGetContentsWithCategoryLazyQuery>;
export type GetContentsWithCategorySuspenseQueryHookResult = ReturnType<typeof useGetContentsWithCategorySuspenseQuery>;
export type GetContentsWithCategoryQueryResult = Apollo.QueryResult<GetContentsWithCategoryQuery, GetContentsWithCategoryQueryVariables>;
export const GetContentsDocument = gql`
    query getContents($libraryId: String, $contains: String, $category: String, $after: String, $tagIds: [String], $order: [ContentSortInput!]) {
  Library(id: $libraryId) {
    id
    contents(
      tagIds: $tagIds
      after: $after
      where: {or: [{name: {contains: $contains}}, {category: {contains: $category}}]}
      order: $order
    ) {
      nodes {
        ...contentProps
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${ContentPropsFragmentDoc}`;

/**
 * __useGetContentsQuery__
 *
 * To run a query within a React component, call `useGetContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsQuery({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      contains: // value for 'contains'
 *      category: // value for 'category'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
      }
export function useGetContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
// @ts-ignore
export function useGetContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentsQuery, GetContentsQueryVariables>;
export function useGetContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentsQuery | undefined, GetContentsQueryVariables>;
export function useGetContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
export type GetContentsQueryHookResult = ReturnType<typeof useGetContentsQuery>;
export type GetContentsLazyQueryHookResult = ReturnType<typeof useGetContentsLazyQuery>;
export type GetContentsSuspenseQueryHookResult = ReturnType<typeof useGetContentsSuspenseQuery>;
export type GetContentsQueryResult = Apollo.QueryResult<GetContentsQuery, GetContentsQueryVariables>;
export const GetDirectContentsDocument = gql`
    query getDirectContents($libraryId: String, $where: ContentFilterInput, $after: String, $tagIds: [String], $includeFileDownload: Boolean!, $order: [ContentSortInput!]) {
  Library(id: $libraryId) {
    id
    directContents(tagIds: $tagIds, after: $after, where: $where, order: $order) {
      nodes {
        ...contentProps
        file {
          name
          extension
          downloadUrl @include(if: $includeFileDownload)
        }
        types {
          settings
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${ContentPropsFragmentDoc}`;

/**
 * __useGetDirectContentsQuery__
 *
 * To run a query within a React component, call `useGetDirectContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectContentsQuery({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      where: // value for 'where'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      includeFileDownload: // value for 'includeFileDownload'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetDirectContentsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectContentsQuery, GetDirectContentsQueryVariables> & ({ variables: GetDirectContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectContentsQuery, GetDirectContentsQueryVariables>(GetDirectContentsDocument, options);
      }
export function useGetDirectContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectContentsQuery, GetDirectContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectContentsQuery, GetDirectContentsQueryVariables>(GetDirectContentsDocument, options);
        }
// @ts-ignore
export function useGetDirectContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectContentsQuery, GetDirectContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectContentsQuery, GetDirectContentsQueryVariables>;
export function useGetDirectContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectContentsQuery, GetDirectContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectContentsQuery | undefined, GetDirectContentsQueryVariables>;
export function useGetDirectContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectContentsQuery, GetDirectContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectContentsQuery, GetDirectContentsQueryVariables>(GetDirectContentsDocument, options);
        }
export type GetDirectContentsQueryHookResult = ReturnType<typeof useGetDirectContentsQuery>;
export type GetDirectContentsLazyQueryHookResult = ReturnType<typeof useGetDirectContentsLazyQuery>;
export type GetDirectContentsSuspenseQueryHookResult = ReturnType<typeof useGetDirectContentsSuspenseQuery>;
export type GetDirectContentsQueryResult = Apollo.QueryResult<GetDirectContentsQuery, GetDirectContentsQueryVariables>;
export const GetContentDocument = gql`
    query getContent($id: String) {
  Content(id: $id) {
    ...contentProps
    file {
      downloadUrl
    }
    relatedContents {
      id
      name
      category
      applicationName
      thumbnail {
        downloadUrl
      }
      tags {
        id
        name
        type
      }
      library {
        name
        clientId
      }
    }
    types {
      id
      name
      settings
      description
      thumbnail {
        downloadUrl
      }
      createdTime
      createdById
      createdBy {
        id
        name
      }
      uniclassId
      vBISId
      iFCEntityId
    }
  }
}
    ${ContentPropsFragmentDoc}`;

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentQuery(baseOptions?: Apollo.QueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
      }
export function useGetContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
// @ts-ignore
export function useGetContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentQuery, GetContentQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentQuery, GetContentQueryVariables>;
export function useGetContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentQuery, GetContentQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentQuery | undefined, GetContentQueryVariables>;
export function useGetContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<typeof useGetContentLazyQuery>;
export type GetContentSuspenseQueryHookResult = ReturnType<typeof useGetContentSuspenseQuery>;
export type GetContentQueryResult = Apollo.QueryResult<GetContentQuery, GetContentQueryVariables>;
export const CountContentDocument = gql`
    query countContent {
  ContentCount
}
    `;

/**
 * __useCountContentQuery__
 *
 * To run a query within a React component, call `useCountContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountContentQuery(baseOptions?: Apollo.QueryHookOptions<CountContentQuery, CountContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountContentQuery, CountContentQueryVariables>(CountContentDocument, options);
      }
export function useCountContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountContentQuery, CountContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountContentQuery, CountContentQueryVariables>(CountContentDocument, options);
        }
// @ts-ignore
export function useCountContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountContentQuery, CountContentQueryVariables>): Apollo.UseSuspenseQueryResult<CountContentQuery, CountContentQueryVariables>;
export function useCountContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountContentQuery, CountContentQueryVariables>): Apollo.UseSuspenseQueryResult<CountContentQuery | undefined, CountContentQueryVariables>;
export function useCountContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountContentQuery, CountContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountContentQuery, CountContentQueryVariables>(CountContentDocument, options);
        }
export type CountContentQueryHookResult = ReturnType<typeof useCountContentQuery>;
export type CountContentLazyQueryHookResult = ReturnType<typeof useCountContentLazyQuery>;
export type CountContentSuspenseQueryHookResult = ReturnType<typeof useCountContentSuspenseQuery>;
export type CountContentQueryResult = Apollo.QueryResult<CountContentQuery, CountContentQueryVariables>;
export const GetContentShortDocument = gql`
    query getContentShort {
  ContentList(first: 10000) {
    nodes {
      id
      name
      createdTime
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetContentShortQuery__
 *
 * To run a query within a React component, call `useGetContentShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentShortQuery(baseOptions?: Apollo.QueryHookOptions<GetContentShortQuery, GetContentShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentShortQuery, GetContentShortQueryVariables>(GetContentShortDocument, options);
      }
export function useGetContentShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentShortQuery, GetContentShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentShortQuery, GetContentShortQueryVariables>(GetContentShortDocument, options);
        }
// @ts-ignore
export function useGetContentShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentShortQuery, GetContentShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentShortQuery, GetContentShortQueryVariables>;
export function useGetContentShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentShortQuery, GetContentShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentShortQuery | undefined, GetContentShortQueryVariables>;
export function useGetContentShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentShortQuery, GetContentShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentShortQuery, GetContentShortQueryVariables>(GetContentShortDocument, options);
        }
export type GetContentShortQueryHookResult = ReturnType<typeof useGetContentShortQuery>;
export type GetContentShortLazyQueryHookResult = ReturnType<typeof useGetContentShortLazyQuery>;
export type GetContentShortSuspenseQueryHookResult = ReturnType<typeof useGetContentShortSuspenseQuery>;
export type GetContentShortQueryResult = Apollo.QueryResult<GetContentShortQuery, GetContentShortQueryVariables>;
export const GetRecentContentCreationsDocument = gql`
    query getRecentContentCreations($first: Int) {
  ContentList(first: $first, order: {createdTime: DESC}) {
    nodes {
      id
      name
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRecentContentCreationsQuery__
 *
 * To run a query within a React component, call `useGetRecentContentCreationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentContentCreationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentContentCreationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRecentContentCreationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>(GetRecentContentCreationsDocument, options);
      }
export function useGetRecentContentCreationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>(GetRecentContentCreationsDocument, options);
        }
// @ts-ignore
export function useGetRecentContentCreationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>;
export function useGetRecentContentCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentContentCreationsQuery | undefined, GetRecentContentCreationsQueryVariables>;
export function useGetRecentContentCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>(GetRecentContentCreationsDocument, options);
        }
export type GetRecentContentCreationsQueryHookResult = ReturnType<typeof useGetRecentContentCreationsQuery>;
export type GetRecentContentCreationsLazyQueryHookResult = ReturnType<typeof useGetRecentContentCreationsLazyQuery>;
export type GetRecentContentCreationsSuspenseQueryHookResult = ReturnType<typeof useGetRecentContentCreationsSuspenseQuery>;
export type GetRecentContentCreationsQueryResult = Apollo.QueryResult<GetRecentContentCreationsQuery, GetRecentContentCreationsQueryVariables>;
export const SearchContentsDocument = gql`
    query searchContents($first: Int, $after: String, $tagIds: [String], $where: ContentFilterInput) {
  ContentList(
    first: $first
    after: $after
    tagIds: $tagIds
    where: $where
    order: {createdTime: DESC}
  ) {
    nodes {
      ...contentProps
      subCategory
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ContentPropsFragmentDoc}`;

/**
 * __useSearchContentsQuery__
 *
 * To run a query within a React component, call `useSearchContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchContentsQuery(baseOptions?: Apollo.QueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, options);
      }
export function useSearchContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, options);
        }
// @ts-ignore
export function useSearchContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchContentsQuery, SearchContentsQueryVariables>;
export function useSearchContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchContentsQuery | undefined, SearchContentsQueryVariables>;
export function useSearchContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContentsQuery, SearchContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContentsQuery, SearchContentsQueryVariables>(SearchContentsDocument, options);
        }
export type SearchContentsQueryHookResult = ReturnType<typeof useSearchContentsQuery>;
export type SearchContentsLazyQueryHookResult = ReturnType<typeof useSearchContentsLazyQuery>;
export type SearchContentsSuspenseQueryHookResult = ReturnType<typeof useSearchContentsSuspenseQuery>;
export type SearchContentsQueryResult = Apollo.QueryResult<SearchContentsQuery, SearchContentsQueryVariables>;
export const GetContentIdsByTagsDocument = gql`
    query getContentIdsByTags($tagIds: [String]) {
  ContentList(first: 10000, tagIds: $tagIds) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useGetContentIdsByTagsQuery__
 *
 * To run a query within a React component, call `useGetContentIdsByTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentIdsByTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentIdsByTagsQuery({
 *   variables: {
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useGetContentIdsByTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>(GetContentIdsByTagsDocument, options);
      }
export function useGetContentIdsByTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>(GetContentIdsByTagsDocument, options);
        }
// @ts-ignore
export function useGetContentIdsByTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>;
export function useGetContentIdsByTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentIdsByTagsQuery | undefined, GetContentIdsByTagsQueryVariables>;
export function useGetContentIdsByTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>(GetContentIdsByTagsDocument, options);
        }
export type GetContentIdsByTagsQueryHookResult = ReturnType<typeof useGetContentIdsByTagsQuery>;
export type GetContentIdsByTagsLazyQueryHookResult = ReturnType<typeof useGetContentIdsByTagsLazyQuery>;
export type GetContentIdsByTagsSuspenseQueryHookResult = ReturnType<typeof useGetContentIdsByTagsSuspenseQuery>;
export type GetContentIdsByTagsQueryResult = Apollo.QueryResult<GetContentIdsByTagsQuery, GetContentIdsByTagsQueryVariables>;
export const GetSavedSearchesDocument = gql`
    query getSavedSearches {
  ContentList(
    first: 500
    where: {libraryId: {eq: "5ea65b5c-3f37-4429-9b6e-a77d5b8a963f"}}
    order: {name: ASC}
  ) {
    nodes {
      id
      name
      settings
      currentVersionId
      currentRequestId
    }
  }
}
    `;

/**
 * __useGetSavedSearchesQuery__
 *
 * To run a query within a React component, call `useGetSavedSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedSearchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedSearchesQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
      }
export function useGetSavedSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
        }
// @ts-ignore
export function useGetSavedSearchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>;
export function useGetSavedSearchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedSearchesQuery | undefined, GetSavedSearchesQueryVariables>;
export function useGetSavedSearchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
        }
export type GetSavedSearchesQueryHookResult = ReturnType<typeof useGetSavedSearchesQuery>;
export type GetSavedSearchesLazyQueryHookResult = ReturnType<typeof useGetSavedSearchesLazyQuery>;
export type GetSavedSearchesSuspenseQueryHookResult = ReturnType<typeof useGetSavedSearchesSuspenseQuery>;
export type GetSavedSearchesQueryResult = Apollo.QueryResult<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>;
export const CreateContentVersionDocument = gql`
    mutation createContentVersion($content: ContentVersionInput) {
  CreateContentVersion(item: $content)
}
    `;
export type CreateContentVersionMutationFn = Apollo.MutationFunction<CreateContentVersionMutation, CreateContentVersionMutationVariables>;

/**
 * __useCreateContentVersionMutation__
 *
 * To run a mutation, you first call `useCreateContentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentVersionMutation, { data, loading, error }] = useCreateContentVersionMutation({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreateContentVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentVersionMutation, CreateContentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentVersionMutation, CreateContentVersionMutationVariables>(CreateContentVersionDocument, options);
      }
export type CreateContentVersionMutationHookResult = ReturnType<typeof useCreateContentVersionMutation>;
export type CreateContentVersionMutationResult = Apollo.MutationResult<CreateContentVersionMutation>;
export type CreateContentVersionMutationOptions = Apollo.BaseMutationOptions<CreateContentVersionMutation, CreateContentVersionMutationVariables>;
export const DeleteContentVersionsDocument = gql`
    mutation deleteContentVersions($ids: [String]) {
  DeleteContentVersionList(ids: $ids)
}
    `;
export type DeleteContentVersionsMutationFn = Apollo.MutationFunction<DeleteContentVersionsMutation, DeleteContentVersionsMutationVariables>;

/**
 * __useDeleteContentVersionsMutation__
 *
 * To run a mutation, you first call `useDeleteContentVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentVersionsMutation, { data, loading, error }] = useDeleteContentVersionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContentVersionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentVersionsMutation, DeleteContentVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentVersionsMutation, DeleteContentVersionsMutationVariables>(DeleteContentVersionsDocument, options);
      }
export type DeleteContentVersionsMutationHookResult = ReturnType<typeof useDeleteContentVersionsMutation>;
export type DeleteContentVersionsMutationResult = Apollo.MutationResult<DeleteContentVersionsMutation>;
export type DeleteContentVersionsMutationOptions = Apollo.BaseMutationOptions<DeleteContentVersionsMutation, DeleteContentVersionsMutationVariables>;
export const GetContentVersionsDocument = gql`
    query getContentVersions($contentId: String, $contains: String, $after: String, $order: [ContentVersionSortInput!]) {
  ContentVersionList(
    after: $after
    order: $order
    where: {and: [{contentId: {eq: $contentId}}, {name: {contains: $contains}}]}
  ) {
    nodes {
      ...contentVersionProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ContentVersionPropsFragmentDoc}`;

/**
 * __useGetContentVersionsQuery__
 *
 * To run a query within a React component, call `useGetContentVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentVersionsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetContentVersionsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentVersionsQuery, GetContentVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentVersionsQuery, GetContentVersionsQueryVariables>(GetContentVersionsDocument, options);
      }
export function useGetContentVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentVersionsQuery, GetContentVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentVersionsQuery, GetContentVersionsQueryVariables>(GetContentVersionsDocument, options);
        }
// @ts-ignore
export function useGetContentVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentVersionsQuery, GetContentVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentVersionsQuery, GetContentVersionsQueryVariables>;
export function useGetContentVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentVersionsQuery, GetContentVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentVersionsQuery | undefined, GetContentVersionsQueryVariables>;
export function useGetContentVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentVersionsQuery, GetContentVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentVersionsQuery, GetContentVersionsQueryVariables>(GetContentVersionsDocument, options);
        }
export type GetContentVersionsQueryHookResult = ReturnType<typeof useGetContentVersionsQuery>;
export type GetContentVersionsLazyQueryHookResult = ReturnType<typeof useGetContentVersionsLazyQuery>;
export type GetContentVersionsSuspenseQueryHookResult = ReturnType<typeof useGetContentVersionsSuspenseQuery>;
export type GetContentVersionsQueryResult = Apollo.QueryResult<GetContentVersionsQuery, GetContentVersionsQueryVariables>;
export const GetRecentActivityDocument = gql`
    query getRecentActivity($first: Int) {
  ContentVersionList(
    first: $first
    order: {updatedTime: DESC}
    where: {histories: {any: true}}
  ) {
    nodes {
      id
      name
      status
      updatedTime
      contentId
      libraryId
      clientId
      content {
        id
        name
        library {
          id
          name
          clientId
          isAdmin
        }
      }
      createdBy {
        id
        name
      }
      histories {
        id
        name
        message
        description
        createdTime
        createdById
        createdBy {
          id
          name
        }
        tagIds
        tags {
          id
          name
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecentActivityQuery__
 *
 * To run a query within a React component, call `useGetRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentActivityQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRecentActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentActivityQuery, GetRecentActivityQueryVariables>(GetRecentActivityDocument, options);
      }
export function useGetRecentActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentActivityQuery, GetRecentActivityQueryVariables>(GetRecentActivityDocument, options);
        }
// @ts-ignore
export function useGetRecentActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentActivityQuery, GetRecentActivityQueryVariables>;
export function useGetRecentActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentActivityQuery | undefined, GetRecentActivityQueryVariables>;
export function useGetRecentActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentActivityQuery, GetRecentActivityQueryVariables>(GetRecentActivityDocument, options);
        }
export type GetRecentActivityQueryHookResult = ReturnType<typeof useGetRecentActivityQuery>;
export type GetRecentActivityLazyQueryHookResult = ReturnType<typeof useGetRecentActivityLazyQuery>;
export type GetRecentActivitySuspenseQueryHookResult = ReturnType<typeof useGetRecentActivitySuspenseQuery>;
export type GetRecentActivityQueryResult = Apollo.QueryResult<GetRecentActivityQuery, GetRecentActivityQueryVariables>;
export const GetLibraryRecentActivityDocument = gql`
    query getLibraryRecentActivity($first: Int, $libraryId: String) {
  ContentVersionList(
    first: $first
    order: {updatedTime: DESC}
    where: {and: [{libraryId: {eq: $libraryId}}, {histories: {any: true}}]}
  ) {
    nodes {
      id
      name
      status
      updatedTime
      contentId
      libraryId
      clientId
      content {
        id
        name
        library {
          id
          name
          clientId
          isAdmin
        }
      }
      createdBy {
        id
        name
      }
      histories {
        id
        name
        message
        description
        createdTime
        createdById
        createdBy {
          id
          name
        }
        tagIds
        tags {
          id
          name
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetLibraryRecentActivityQuery__
 *
 * To run a query within a React component, call `useGetLibraryRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryRecentActivityQuery({
 *   variables: {
 *      first: // value for 'first'
 *      libraryId: // value for 'libraryId'
 *   },
 * });
 */
export function useGetLibraryRecentActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>(GetLibraryRecentActivityDocument, options);
      }
export function useGetLibraryRecentActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>(GetLibraryRecentActivityDocument, options);
        }
// @ts-ignore
export function useGetLibraryRecentActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>;
export function useGetLibraryRecentActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryRecentActivityQuery | undefined, GetLibraryRecentActivityQueryVariables>;
export function useGetLibraryRecentActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>(GetLibraryRecentActivityDocument, options);
        }
export type GetLibraryRecentActivityQueryHookResult = ReturnType<typeof useGetLibraryRecentActivityQuery>;
export type GetLibraryRecentActivityLazyQueryHookResult = ReturnType<typeof useGetLibraryRecentActivityLazyQuery>;
export type GetLibraryRecentActivitySuspenseQueryHookResult = ReturnType<typeof useGetLibraryRecentActivitySuspenseQuery>;
export type GetLibraryRecentActivityQueryResult = Apollo.QueryResult<GetLibraryRecentActivityQuery, GetLibraryRecentActivityQueryVariables>;
export const GetContentHistoryBadgesDocument = gql`
    query getContentHistoryBadges($libraryId: String, $after: String) {
  ContentVersionList(
    first: 1000
    after: $after
    where: {and: [{libraryId: {eq: $libraryId}}, {histories: {any: true}}]}
  ) {
    nodes {
      contentId
      histories {
        createdTime
        tagIds
        tags {
          name
          type
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetContentHistoryBadgesQuery__
 *
 * To run a query within a React component, call `useGetContentHistoryBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentHistoryBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentHistoryBadgesQuery({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetContentHistoryBadgesQuery(baseOptions?: Apollo.QueryHookOptions<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>(GetContentHistoryBadgesDocument, options);
      }
export function useGetContentHistoryBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>(GetContentHistoryBadgesDocument, options);
        }
// @ts-ignore
export function useGetContentHistoryBadgesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>;
export function useGetContentHistoryBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentHistoryBadgesQuery | undefined, GetContentHistoryBadgesQueryVariables>;
export function useGetContentHistoryBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>(GetContentHistoryBadgesDocument, options);
        }
export type GetContentHistoryBadgesQueryHookResult = ReturnType<typeof useGetContentHistoryBadgesQuery>;
export type GetContentHistoryBadgesLazyQueryHookResult = ReturnType<typeof useGetContentHistoryBadgesLazyQuery>;
export type GetContentHistoryBadgesSuspenseQueryHookResult = ReturnType<typeof useGetContentHistoryBadgesSuspenseQuery>;
export type GetContentHistoryBadgesQueryResult = Apollo.QueryResult<GetContentHistoryBadgesQuery, GetContentHistoryBadgesQueryVariables>;
export const AddContentHistoryDocument = gql`
    mutation addContentHistory($contentVersionId: String, $history: HistoryInput) {
  ContentVersion(id: $contentVersionId) {
    addHistory(history: $history)
  }
}
    `;
export type AddContentHistoryMutationFn = Apollo.MutationFunction<AddContentHistoryMutation, AddContentHistoryMutationVariables>;

/**
 * __useAddContentHistoryMutation__
 *
 * To run a mutation, you first call `useAddContentHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContentHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContentHistoryMutation, { data, loading, error }] = useAddContentHistoryMutation({
 *   variables: {
 *      contentVersionId: // value for 'contentVersionId'
 *      history: // value for 'history'
 *   },
 * });
 */
export function useAddContentHistoryMutation(baseOptions?: Apollo.MutationHookOptions<AddContentHistoryMutation, AddContentHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContentHistoryMutation, AddContentHistoryMutationVariables>(AddContentHistoryDocument, options);
      }
export type AddContentHistoryMutationHookResult = ReturnType<typeof useAddContentHistoryMutation>;
export type AddContentHistoryMutationResult = Apollo.MutationResult<AddContentHistoryMutation>;
export type AddContentHistoryMutationOptions = Apollo.BaseMutationOptions<AddContentHistoryMutation, AddContentHistoryMutationVariables>;
export const AddContentHistoryTagsDocument = gql`
    mutation addContentHistoryTags($contentVersionId: String, $historyId: String, $tagIds: [String]) {
  ContentVersion(id: $contentVersionId) {
    addHistoryTags(historyId: $historyId, tagIds: $tagIds)
  }
}
    `;
export type AddContentHistoryTagsMutationFn = Apollo.MutationFunction<AddContentHistoryTagsMutation, AddContentHistoryTagsMutationVariables>;

/**
 * __useAddContentHistoryTagsMutation__
 *
 * To run a mutation, you first call `useAddContentHistoryTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContentHistoryTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContentHistoryTagsMutation, { data, loading, error }] = useAddContentHistoryTagsMutation({
 *   variables: {
 *      contentVersionId: // value for 'contentVersionId'
 *      historyId: // value for 'historyId'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAddContentHistoryTagsMutation(baseOptions?: Apollo.MutationHookOptions<AddContentHistoryTagsMutation, AddContentHistoryTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContentHistoryTagsMutation, AddContentHistoryTagsMutationVariables>(AddContentHistoryTagsDocument, options);
      }
export type AddContentHistoryTagsMutationHookResult = ReturnType<typeof useAddContentHistoryTagsMutation>;
export type AddContentHistoryTagsMutationResult = Apollo.MutationResult<AddContentHistoryTagsMutation>;
export type AddContentHistoryTagsMutationOptions = Apollo.BaseMutationOptions<AddContentHistoryTagsMutation, AddContentHistoryTagsMutationVariables>;
export const UploadHistoryAttachmentDocument = gql`
    mutation uploadHistoryAttachment($contentVersionId: String, $historyId: String, $file: Upload) {
  ContentVersion(id: $contentVersionId) {
    uploadHistoryAttachment(historyId: $historyId, file: $file) {
      id
      name
      extension
    }
  }
}
    `;
export type UploadHistoryAttachmentMutationFn = Apollo.MutationFunction<UploadHistoryAttachmentMutation, UploadHistoryAttachmentMutationVariables>;

/**
 * __useUploadHistoryAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadHistoryAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadHistoryAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadHistoryAttachmentMutation, { data, loading, error }] = useUploadHistoryAttachmentMutation({
 *   variables: {
 *      contentVersionId: // value for 'contentVersionId'
 *      historyId: // value for 'historyId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadHistoryAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UploadHistoryAttachmentMutation, UploadHistoryAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadHistoryAttachmentMutation, UploadHistoryAttachmentMutationVariables>(UploadHistoryAttachmentDocument, options);
      }
export type UploadHistoryAttachmentMutationHookResult = ReturnType<typeof useUploadHistoryAttachmentMutation>;
export type UploadHistoryAttachmentMutationResult = Apollo.MutationResult<UploadHistoryAttachmentMutation>;
export type UploadHistoryAttachmentMutationOptions = Apollo.BaseMutationOptions<UploadHistoryAttachmentMutation, UploadHistoryAttachmentMutationVariables>;
export const SetHistoryAttachmentUrlDocument = gql`
    mutation setHistoryAttachmentUrl($contentVersionId: String, $historyId: String, $name: String) {
  ContentVersion(id: $contentVersionId) {
    setHistoryAttachmentUrl(historyId: $historyId, name: $name)
  }
}
    `;
export type SetHistoryAttachmentUrlMutationFn = Apollo.MutationFunction<SetHistoryAttachmentUrlMutation, SetHistoryAttachmentUrlMutationVariables>;

/**
 * __useSetHistoryAttachmentUrlMutation__
 *
 * To run a mutation, you first call `useSetHistoryAttachmentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHistoryAttachmentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHistoryAttachmentUrlMutation, { data, loading, error }] = useSetHistoryAttachmentUrlMutation({
 *   variables: {
 *      contentVersionId: // value for 'contentVersionId'
 *      historyId: // value for 'historyId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetHistoryAttachmentUrlMutation(baseOptions?: Apollo.MutationHookOptions<SetHistoryAttachmentUrlMutation, SetHistoryAttachmentUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHistoryAttachmentUrlMutation, SetHistoryAttachmentUrlMutationVariables>(SetHistoryAttachmentUrlDocument, options);
      }
export type SetHistoryAttachmentUrlMutationHookResult = ReturnType<typeof useSetHistoryAttachmentUrlMutation>;
export type SetHistoryAttachmentUrlMutationResult = Apollo.MutationResult<SetHistoryAttachmentUrlMutation>;
export type SetHistoryAttachmentUrlMutationOptions = Apollo.BaseMutationOptions<SetHistoryAttachmentUrlMutation, SetHistoryAttachmentUrlMutationVariables>;
export const DeleteContentHistoryDocument = gql`
    mutation deleteContentHistory($contentVersionId: String, $ids: [String]) {
  DeleteHistories(contentVersionId: $contentVersionId, ids: $ids)
}
    `;
export type DeleteContentHistoryMutationFn = Apollo.MutationFunction<DeleteContentHistoryMutation, DeleteContentHistoryMutationVariables>;

/**
 * __useDeleteContentHistoryMutation__
 *
 * To run a mutation, you first call `useDeleteContentHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentHistoryMutation, { data, loading, error }] = useDeleteContentHistoryMutation({
 *   variables: {
 *      contentVersionId: // value for 'contentVersionId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContentHistoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentHistoryMutation, DeleteContentHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentHistoryMutation, DeleteContentHistoryMutationVariables>(DeleteContentHistoryDocument, options);
      }
export type DeleteContentHistoryMutationHookResult = ReturnType<typeof useDeleteContentHistoryMutation>;
export type DeleteContentHistoryMutationResult = Apollo.MutationResult<DeleteContentHistoryMutation>;
export type DeleteContentHistoryMutationOptions = Apollo.BaseMutationOptions<DeleteContentHistoryMutation, DeleteContentHistoryMutationVariables>;
export const SetAttachmentUrlDocument = gql`
    mutation setAttachmentUrl($id: String, $name: String) {
  ContentVersion(id: $id) {
    setAttachmentUrl(name: $name)
  }
}
    `;
export type SetAttachmentUrlMutationFn = Apollo.MutationFunction<SetAttachmentUrlMutation, SetAttachmentUrlMutationVariables>;

/**
 * __useSetAttachmentUrlMutation__
 *
 * To run a mutation, you first call `useSetAttachmentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAttachmentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAttachmentUrlMutation, { data, loading, error }] = useSetAttachmentUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetAttachmentUrlMutation(baseOptions?: Apollo.MutationHookOptions<SetAttachmentUrlMutation, SetAttachmentUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAttachmentUrlMutation, SetAttachmentUrlMutationVariables>(SetAttachmentUrlDocument, options);
      }
export type SetAttachmentUrlMutationHookResult = ReturnType<typeof useSetAttachmentUrlMutation>;
export type SetAttachmentUrlMutationResult = Apollo.MutationResult<SetAttachmentUrlMutation>;
export type SetAttachmentUrlMutationOptions = Apollo.BaseMutationOptions<SetAttachmentUrlMutation, SetAttachmentUrlMutationVariables>;
export const GetContentCommentsDocument = gql`
    query getContentComments($contentId: String) {
  ContentVersionList(
    first: 100
    order: {updatedTime: DESC}
    where: {contentId: {eq: $contentId}}
  ) {
    nodes {
      id
      name
      histories {
        id
        name
        message
        createdTime
        createdById
        createdBy {
          id
          name
        }
        tagIds
        tags {
          id
          name
          type
        }
        attachmentDownloadUrl
        attachment {
          id
          name
          extension
          downloadUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetContentCommentsQuery__
 *
 * To run a query within a React component, call `useGetContentCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentCommentsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetContentCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentCommentsQuery, GetContentCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentCommentsQuery, GetContentCommentsQueryVariables>(GetContentCommentsDocument, options);
      }
export function useGetContentCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentCommentsQuery, GetContentCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentCommentsQuery, GetContentCommentsQueryVariables>(GetContentCommentsDocument, options);
        }
// @ts-ignore
export function useGetContentCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentCommentsQuery, GetContentCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentCommentsQuery, GetContentCommentsQueryVariables>;
export function useGetContentCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentCommentsQuery, GetContentCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentCommentsQuery | undefined, GetContentCommentsQueryVariables>;
export function useGetContentCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentCommentsQuery, GetContentCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentCommentsQuery, GetContentCommentsQueryVariables>(GetContentCommentsDocument, options);
        }
export type GetContentCommentsQueryHookResult = ReturnType<typeof useGetContentCommentsQuery>;
export type GetContentCommentsLazyQueryHookResult = ReturnType<typeof useGetContentCommentsLazyQuery>;
export type GetContentCommentsSuspenseQueryHookResult = ReturnType<typeof useGetContentCommentsSuspenseQuery>;
export type GetContentCommentsQueryResult = Apollo.QueryResult<GetContentCommentsQuery, GetContentCommentsQueryVariables>;
export const SearchContentVersionsDocument = gql`
    query searchContentVersions($first: Int, $after: String, $where: ContentVersionFilterInput) {
  ContentVersionList(
    first: $first
    after: $after
    where: $where
    order: {updatedTime: DESC}
  ) {
    nodes {
      id
      name
      category
      subCategory
      description
      applicationName
      status
      createdTime
      updatedTime
      contentId
      libraryId
      clientId
      attachment {
        id
        downloadUrl
      }
      thumbnail {
        id
        name
        downloadUrl
      }
      types {
        id
        name
        thumbnail {
          id
          name
          downloadUrl
        }
      }
      content {
        id
        name
        currentVersionId
        usageCount
        thumbnail {
          id
          name
          downloadUrl
        }
        tagIds
        tags {
          id
          name
          type
        }
        classificationIds
        classifications {
          id
          name
          description
          type {
            id
            name
          }
        }
      }
      library {
        id
        name
        clientId
        client {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSearchContentVersionsQuery__
 *
 * To run a query within a React component, call `useSearchContentVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentVersionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchContentVersionsQuery(baseOptions?: Apollo.QueryHookOptions<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>(SearchContentVersionsDocument, options);
      }
export function useSearchContentVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>(SearchContentVersionsDocument, options);
        }
// @ts-ignore
export function useSearchContentVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>;
export function useSearchContentVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchContentVersionsQuery | undefined, SearchContentVersionsQueryVariables>;
export function useSearchContentVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>(SearchContentVersionsDocument, options);
        }
export type SearchContentVersionsQueryHookResult = ReturnType<typeof useSearchContentVersionsQuery>;
export type SearchContentVersionsLazyQueryHookResult = ReturnType<typeof useSearchContentVersionsLazyQuery>;
export type SearchContentVersionsSuspenseQueryHookResult = ReturnType<typeof useSearchContentVersionsSuspenseQuery>;
export type SearchContentVersionsQueryResult = Apollo.QueryResult<SearchContentVersionsQuery, SearchContentVersionsQueryVariables>;
export const EditDefaultDocument = gql`
    mutation editDefault($clientId: String, $libraryId: String) {
  Default {
    setClient(clientId: $clientId)
    setLibrary(libraryId: $libraryId)
  }
}
    `;
export type EditDefaultMutationFn = Apollo.MutationFunction<EditDefaultMutation, EditDefaultMutationVariables>;

/**
 * __useEditDefaultMutation__
 *
 * To run a mutation, you first call `useEditDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDefaultMutation, { data, loading, error }] = useEditDefaultMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      libraryId: // value for 'libraryId'
 *   },
 * });
 */
export function useEditDefaultMutation(baseOptions?: Apollo.MutationHookOptions<EditDefaultMutation, EditDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDefaultMutation, EditDefaultMutationVariables>(EditDefaultDocument, options);
      }
export type EditDefaultMutationHookResult = ReturnType<typeof useEditDefaultMutation>;
export type EditDefaultMutationResult = Apollo.MutationResult<EditDefaultMutation>;
export type EditDefaultMutationOptions = Apollo.BaseMutationOptions<EditDefaultMutation, EditDefaultMutationVariables>;
export const GetDefaultDocument = gql`
    query getDefault {
  Default {
    ...defaultProps
  }
}
    ${DefaultPropsFragmentDoc}`;

/**
 * __useGetDefaultQuery__
 *
 * To run a query within a React component, call `useGetDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultQuery, GetDefaultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultQuery, GetDefaultQueryVariables>(GetDefaultDocument, options);
      }
export function useGetDefaultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultQuery, GetDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultQuery, GetDefaultQueryVariables>(GetDefaultDocument, options);
        }
// @ts-ignore
export function useGetDefaultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefaultQuery, GetDefaultQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefaultQuery, GetDefaultQueryVariables>;
export function useGetDefaultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultQuery, GetDefaultQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefaultQuery | undefined, GetDefaultQueryVariables>;
export function useGetDefaultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultQuery, GetDefaultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultQuery, GetDefaultQueryVariables>(GetDefaultDocument, options);
        }
export type GetDefaultQueryHookResult = ReturnType<typeof useGetDefaultQuery>;
export type GetDefaultLazyQueryHookResult = ReturnType<typeof useGetDefaultLazyQuery>;
export type GetDefaultSuspenseQueryHookResult = ReturnType<typeof useGetDefaultSuspenseQuery>;
export type GetDefaultQueryResult = Apollo.QueryResult<GetDefaultQuery, GetDefaultQueryVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($group: GroupInput) {
  CreateGroup(item: $group)
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const DeleteGroupListDocument = gql`
    mutation deleteGroupList($ids: [String]) {
  DeleteGroupList(ids: $ids)
}
    `;
export type DeleteGroupListMutationFn = Apollo.MutationFunction<DeleteGroupListMutation, DeleteGroupListMutationVariables>;

/**
 * __useDeleteGroupListMutation__
 *
 * To run a mutation, you first call `useDeleteGroupListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupListMutation, { data, loading, error }] = useDeleteGroupListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteGroupListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupListMutation, DeleteGroupListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupListMutation, DeleteGroupListMutationVariables>(DeleteGroupListDocument, options);
      }
export type DeleteGroupListMutationHookResult = ReturnType<typeof useDeleteGroupListMutation>;
export type DeleteGroupListMutationResult = Apollo.MutationResult<DeleteGroupListMutation>;
export type DeleteGroupListMutationOptions = Apollo.BaseMutationOptions<DeleteGroupListMutation, DeleteGroupListMutationVariables>;
export const GetGroupListWithTypeDocument = gql`
    query getGroupListWithType($contains: String, $type: String, $after: String, $order: [GroupSortInput!]) {
  GroupList(after: $after, where: {name: {contains: $contains}}, order: $order) {
    nodes {
      ...groupProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${GroupPropsFragmentDoc}`;

/**
 * __useGetGroupListWithTypeQuery__
 *
 * To run a query within a React component, call `useGetGroupListWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupListWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupListWithTypeQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      type: // value for 'type'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetGroupListWithTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>(GetGroupListWithTypeDocument, options);
      }
export function useGetGroupListWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>(GetGroupListWithTypeDocument, options);
        }
// @ts-ignore
export function useGetGroupListWithTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>;
export function useGetGroupListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupListWithTypeQuery | undefined, GetGroupListWithTypeQueryVariables>;
export function useGetGroupListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>(GetGroupListWithTypeDocument, options);
        }
export type GetGroupListWithTypeQueryHookResult = ReturnType<typeof useGetGroupListWithTypeQuery>;
export type GetGroupListWithTypeLazyQueryHookResult = ReturnType<typeof useGetGroupListWithTypeLazyQuery>;
export type GetGroupListWithTypeSuspenseQueryHookResult = ReturnType<typeof useGetGroupListWithTypeSuspenseQuery>;
export type GetGroupListWithTypeQueryResult = Apollo.QueryResult<GetGroupListWithTypeQuery, GetGroupListWithTypeQueryVariables>;
export const GetGroupListDocument = gql`
    query getGroupList($contains: String, $after: String, $order: [GroupSortInput!]) {
  GroupList(after: $after, where: {name: {contains: $contains}}, order: $order) {
    nodes {
      ...groupProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${GroupPropsFragmentDoc}`;

/**
 * __useGetGroupListQuery__
 *
 * To run a query within a React component, call `useGetGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetGroupListQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupListQuery, GetGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupListQuery, GetGroupListQueryVariables>(GetGroupListDocument, options);
      }
export function useGetGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupListQuery, GetGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupListQuery, GetGroupListQueryVariables>(GetGroupListDocument, options);
        }
// @ts-ignore
export function useGetGroupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupListQuery, GetGroupListQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupListQuery, GetGroupListQueryVariables>;
export function useGetGroupListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupListQuery, GetGroupListQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupListQuery | undefined, GetGroupListQueryVariables>;
export function useGetGroupListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupListQuery, GetGroupListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupListQuery, GetGroupListQueryVariables>(GetGroupListDocument, options);
        }
export type GetGroupListQueryHookResult = ReturnType<typeof useGetGroupListQuery>;
export type GetGroupListLazyQueryHookResult = ReturnType<typeof useGetGroupListLazyQuery>;
export type GetGroupListSuspenseQueryHookResult = ReturnType<typeof useGetGroupListSuspenseQuery>;
export type GetGroupListQueryResult = Apollo.QueryResult<GetGroupListQuery, GetGroupListQueryVariables>;
export const GetGroupDocument = gql`
    query getGroup($id: String) {
  Group(id: $id) {
    ...groupProps
  }
}
    ${GroupPropsFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
// @ts-ignore
export function useGetGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupQuery, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupQuery | undefined, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupSuspenseQueryHookResult = ReturnType<typeof useGetGroupSuspenseQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const CreateHealthCheckDocument = gql`
    mutation createHealthCheck($healthCheck: HealthCheckInput) {
  CreateHealthCheck(item: $healthCheck)
}
    `;
export type CreateHealthCheckMutationFn = Apollo.MutationFunction<CreateHealthCheckMutation, CreateHealthCheckMutationVariables>;

/**
 * __useCreateHealthCheckMutation__
 *
 * To run a mutation, you first call `useCreateHealthCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthCheckMutation, { data, loading, error }] = useCreateHealthCheckMutation({
 *   variables: {
 *      healthCheck: // value for 'healthCheck'
 *   },
 * });
 */
export function useCreateHealthCheckMutation(baseOptions?: Apollo.MutationHookOptions<CreateHealthCheckMutation, CreateHealthCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHealthCheckMutation, CreateHealthCheckMutationVariables>(CreateHealthCheckDocument, options);
      }
export type CreateHealthCheckMutationHookResult = ReturnType<typeof useCreateHealthCheckMutation>;
export type CreateHealthCheckMutationResult = Apollo.MutationResult<CreateHealthCheckMutation>;
export type CreateHealthCheckMutationOptions = Apollo.BaseMutationOptions<CreateHealthCheckMutation, CreateHealthCheckMutationVariables>;
export const DeleteHealthCheckListDocument = gql`
    mutation deleteHealthCheckList($ids: [String]) {
  DeleteHealthCheckList(ids: $ids)
}
    `;
export type DeleteHealthCheckListMutationFn = Apollo.MutationFunction<DeleteHealthCheckListMutation, DeleteHealthCheckListMutationVariables>;

/**
 * __useDeleteHealthCheckListMutation__
 *
 * To run a mutation, you first call `useDeleteHealthCheckListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHealthCheckListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHealthCheckListMutation, { data, loading, error }] = useDeleteHealthCheckListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteHealthCheckListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHealthCheckListMutation, DeleteHealthCheckListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHealthCheckListMutation, DeleteHealthCheckListMutationVariables>(DeleteHealthCheckListDocument, options);
      }
export type DeleteHealthCheckListMutationHookResult = ReturnType<typeof useDeleteHealthCheckListMutation>;
export type DeleteHealthCheckListMutationResult = Apollo.MutationResult<DeleteHealthCheckListMutation>;
export type DeleteHealthCheckListMutationOptions = Apollo.BaseMutationOptions<DeleteHealthCheckListMutation, DeleteHealthCheckListMutationVariables>;
export const AssignHealthChecksTagsDocument = gql`
    mutation assignHealthChecksTags($ids: [String], $tagIds: [String], $overwrite: Boolean) {
  AssignHealthChecksTags(ids: $ids, tagIds: $tagIds, overwrite: $overwrite)
}
    `;
export type AssignHealthChecksTagsMutationFn = Apollo.MutationFunction<AssignHealthChecksTagsMutation, AssignHealthChecksTagsMutationVariables>;

/**
 * __useAssignHealthChecksTagsMutation__
 *
 * To run a mutation, you first call `useAssignHealthChecksTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignHealthChecksTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignHealthChecksTagsMutation, { data, loading, error }] = useAssignHealthChecksTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      tagIds: // value for 'tagIds'
 *      overwrite: // value for 'overwrite'
 *   },
 * });
 */
export function useAssignHealthChecksTagsMutation(baseOptions?: Apollo.MutationHookOptions<AssignHealthChecksTagsMutation, AssignHealthChecksTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignHealthChecksTagsMutation, AssignHealthChecksTagsMutationVariables>(AssignHealthChecksTagsDocument, options);
      }
export type AssignHealthChecksTagsMutationHookResult = ReturnType<typeof useAssignHealthChecksTagsMutation>;
export type AssignHealthChecksTagsMutationResult = Apollo.MutationResult<AssignHealthChecksTagsMutation>;
export type AssignHealthChecksTagsMutationOptions = Apollo.BaseMutationOptions<AssignHealthChecksTagsMutation, AssignHealthChecksTagsMutationVariables>;
export const EditHealthCheckSettingsDocument = gql`
    mutation editHealthCheckSettings($healthCheckId: String, $settings: String) {
  HealthCheck(id: $healthCheckId) {
    setSettings(settings: $settings)
  }
}
    `;
export type EditHealthCheckSettingsMutationFn = Apollo.MutationFunction<EditHealthCheckSettingsMutation, EditHealthCheckSettingsMutationVariables>;

/**
 * __useEditHealthCheckSettingsMutation__
 *
 * To run a mutation, you first call `useEditHealthCheckSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditHealthCheckSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editHealthCheckSettingsMutation, { data, loading, error }] = useEditHealthCheckSettingsMutation({
 *   variables: {
 *      healthCheckId: // value for 'healthCheckId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useEditHealthCheckSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditHealthCheckSettingsMutation, EditHealthCheckSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditHealthCheckSettingsMutation, EditHealthCheckSettingsMutationVariables>(EditHealthCheckSettingsDocument, options);
      }
export type EditHealthCheckSettingsMutationHookResult = ReturnType<typeof useEditHealthCheckSettingsMutation>;
export type EditHealthCheckSettingsMutationResult = Apollo.MutationResult<EditHealthCheckSettingsMutation>;
export type EditHealthCheckSettingsMutationOptions = Apollo.BaseMutationOptions<EditHealthCheckSettingsMutation, EditHealthCheckSettingsMutationVariables>;
export const EditHealthCheckDocument = gql`
    mutation editHealthCheck($healthCheckId: String, $name: String, $group: String, $display: String, $limit: Int!, $description: String) {
  HealthCheck(id: $healthCheckId) {
    setName(name: $name)
    setGroup(group: $group)
    setDisplay(display: $display)
    setLimit(limit: $limit)
    setDescription(description: $description)
  }
}
    `;
export type EditHealthCheckMutationFn = Apollo.MutationFunction<EditHealthCheckMutation, EditHealthCheckMutationVariables>;

/**
 * __useEditHealthCheckMutation__
 *
 * To run a mutation, you first call `useEditHealthCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditHealthCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editHealthCheckMutation, { data, loading, error }] = useEditHealthCheckMutation({
 *   variables: {
 *      healthCheckId: // value for 'healthCheckId'
 *      name: // value for 'name'
 *      group: // value for 'group'
 *      display: // value for 'display'
 *      limit: // value for 'limit'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditHealthCheckMutation(baseOptions?: Apollo.MutationHookOptions<EditHealthCheckMutation, EditHealthCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditHealthCheckMutation, EditHealthCheckMutationVariables>(EditHealthCheckDocument, options);
      }
export type EditHealthCheckMutationHookResult = ReturnType<typeof useEditHealthCheckMutation>;
export type EditHealthCheckMutationResult = Apollo.MutationResult<EditHealthCheckMutation>;
export type EditHealthCheckMutationOptions = Apollo.BaseMutationOptions<EditHealthCheckMutation, EditHealthCheckMutationVariables>;
export const GetHealthCheckListWithTypeDocument = gql`
    query getHealthCheckListWithType($contains: String, $type: String, $after: String, $order: [HealthCheckSortInput!]) {
  HealthCheckList(
    after: $after
    where: {name: {contains: $contains}}
    order: $order
  ) {
    nodes {
      ...healthCheckProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${HealthCheckPropsFragmentDoc}`;

/**
 * __useGetHealthCheckListWithTypeQuery__
 *
 * To run a query within a React component, call `useGetHealthCheckListWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthCheckListWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthCheckListWithTypeQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      type: // value for 'type'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetHealthCheckListWithTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>(GetHealthCheckListWithTypeDocument, options);
      }
export function useGetHealthCheckListWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>(GetHealthCheckListWithTypeDocument, options);
        }
// @ts-ignore
export function useGetHealthCheckListWithTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>;
export function useGetHealthCheckListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckListWithTypeQuery | undefined, GetHealthCheckListWithTypeQueryVariables>;
export function useGetHealthCheckListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>(GetHealthCheckListWithTypeDocument, options);
        }
export type GetHealthCheckListWithTypeQueryHookResult = ReturnType<typeof useGetHealthCheckListWithTypeQuery>;
export type GetHealthCheckListWithTypeLazyQueryHookResult = ReturnType<typeof useGetHealthCheckListWithTypeLazyQuery>;
export type GetHealthCheckListWithTypeSuspenseQueryHookResult = ReturnType<typeof useGetHealthCheckListWithTypeSuspenseQuery>;
export type GetHealthCheckListWithTypeQueryResult = Apollo.QueryResult<GetHealthCheckListWithTypeQuery, GetHealthCheckListWithTypeQueryVariables>;
export const GetHealthCheckListDocument = gql`
    query getHealthCheckList($contains: String, $after: String, $order: [HealthCheckSortInput!]) {
  HealthCheckList(
    after: $after
    where: {name: {contains: $contains}}
    order: $order
  ) {
    nodes {
      ...healthCheckProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${HealthCheckPropsFragmentDoc}`;

/**
 * __useGetHealthCheckListQuery__
 *
 * To run a query within a React component, call `useGetHealthCheckListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthCheckListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthCheckListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetHealthCheckListQuery(baseOptions?: Apollo.QueryHookOptions<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>(GetHealthCheckListDocument, options);
      }
export function useGetHealthCheckListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>(GetHealthCheckListDocument, options);
        }
// @ts-ignore
export function useGetHealthCheckListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>;
export function useGetHealthCheckListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckListQuery | undefined, GetHealthCheckListQueryVariables>;
export function useGetHealthCheckListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>(GetHealthCheckListDocument, options);
        }
export type GetHealthCheckListQueryHookResult = ReturnType<typeof useGetHealthCheckListQuery>;
export type GetHealthCheckListLazyQueryHookResult = ReturnType<typeof useGetHealthCheckListLazyQuery>;
export type GetHealthCheckListSuspenseQueryHookResult = ReturnType<typeof useGetHealthCheckListSuspenseQuery>;
export type GetHealthCheckListQueryResult = Apollo.QueryResult<GetHealthCheckListQuery, GetHealthCheckListQueryVariables>;
export const GetHealthCheckDocument = gql`
    query getHealthCheck($id: String) {
  HealthCheck(id: $id) {
    ...healthCheckProps
  }
}
    ${HealthCheckPropsFragmentDoc}`;

/**
 * __useGetHealthCheckQuery__
 *
 * To run a query within a React component, call `useGetHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthCheckQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
      }
export function useGetHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
        }
// @ts-ignore
export function useGetHealthCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckQuery, GetHealthCheckQueryVariables>;
export function useGetHealthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckQuery | undefined, GetHealthCheckQueryVariables>;
export function useGetHealthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
        }
export type GetHealthCheckQueryHookResult = ReturnType<typeof useGetHealthCheckQuery>;
export type GetHealthCheckLazyQueryHookResult = ReturnType<typeof useGetHealthCheckLazyQuery>;
export type GetHealthCheckSuspenseQueryHookResult = ReturnType<typeof useGetHealthCheckSuspenseQuery>;
export type GetHealthCheckQueryResult = Apollo.QueryResult<GetHealthCheckQuery, GetHealthCheckQueryVariables>;
export const CreateIfcEntityDocument = gql`
    mutation createIFCEntity($iFCEntity: IFCInput) {
  CreateIFC(item: $iFCEntity)
}
    `;
export type CreateIfcEntityMutationFn = Apollo.MutationFunction<CreateIfcEntityMutation, CreateIfcEntityMutationVariables>;

/**
 * __useCreateIfcEntityMutation__
 *
 * To run a mutation, you first call `useCreateIfcEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIfcEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIfcEntityMutation, { data, loading, error }] = useCreateIfcEntityMutation({
 *   variables: {
 *      iFCEntity: // value for 'iFCEntity'
 *   },
 * });
 */
export function useCreateIfcEntityMutation(baseOptions?: Apollo.MutationHookOptions<CreateIfcEntityMutation, CreateIfcEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIfcEntityMutation, CreateIfcEntityMutationVariables>(CreateIfcEntityDocument, options);
      }
export type CreateIfcEntityMutationHookResult = ReturnType<typeof useCreateIfcEntityMutation>;
export type CreateIfcEntityMutationResult = Apollo.MutationResult<CreateIfcEntityMutation>;
export type CreateIfcEntityMutationOptions = Apollo.BaseMutationOptions<CreateIfcEntityMutation, CreateIfcEntityMutationVariables>;
export const DeleteIfcEntitiesDocument = gql`
    mutation deleteIFCEntities($ids: [String]) {
  DeleteIFCList(ids: $ids)
}
    `;
export type DeleteIfcEntitiesMutationFn = Apollo.MutationFunction<DeleteIfcEntitiesMutation, DeleteIfcEntitiesMutationVariables>;

/**
 * __useDeleteIfcEntitiesMutation__
 *
 * To run a mutation, you first call `useDeleteIfcEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIfcEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIfcEntitiesMutation, { data, loading, error }] = useDeleteIfcEntitiesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteIfcEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIfcEntitiesMutation, DeleteIfcEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIfcEntitiesMutation, DeleteIfcEntitiesMutationVariables>(DeleteIfcEntitiesDocument, options);
      }
export type DeleteIfcEntitiesMutationHookResult = ReturnType<typeof useDeleteIfcEntitiesMutation>;
export type DeleteIfcEntitiesMutationResult = Apollo.MutationResult<DeleteIfcEntitiesMutation>;
export type DeleteIfcEntitiesMutationOptions = Apollo.BaseMutationOptions<DeleteIfcEntitiesMutation, DeleteIfcEntitiesMutationVariables>;
export const GetIfcEntitiesDocument = gql`
    query getIFCEntities($contains: String, $after: String) {
  IFCList(after: $after, where: {name: {contains: $contains}}) {
    nodes {
      ...iFCEntityProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${IFcEntityPropsFragmentDoc}`;

/**
 * __useGetIfcEntitiesQuery__
 *
 * To run a query within a React component, call `useGetIfcEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIfcEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIfcEntitiesQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetIfcEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>(GetIfcEntitiesDocument, options);
      }
export function useGetIfcEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>(GetIfcEntitiesDocument, options);
        }
// @ts-ignore
export function useGetIfcEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>;
export function useGetIfcEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcEntitiesQuery | undefined, GetIfcEntitiesQueryVariables>;
export function useGetIfcEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>(GetIfcEntitiesDocument, options);
        }
export type GetIfcEntitiesQueryHookResult = ReturnType<typeof useGetIfcEntitiesQuery>;
export type GetIfcEntitiesLazyQueryHookResult = ReturnType<typeof useGetIfcEntitiesLazyQuery>;
export type GetIfcEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetIfcEntitiesSuspenseQuery>;
export type GetIfcEntitiesQueryResult = Apollo.QueryResult<GetIfcEntitiesQuery, GetIfcEntitiesQueryVariables>;
export const GetIfcEntityDocument = gql`
    query getIFCEntity($id: String) {
  IFC(id: $id) {
    ...iFCEntityProps
  }
}
    ${IFcEntityPropsFragmentDoc}`;

/**
 * __useGetIfcEntityQuery__
 *
 * To run a query within a React component, call `useGetIfcEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIfcEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIfcEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIfcEntityQuery(baseOptions?: Apollo.QueryHookOptions<GetIfcEntityQuery, GetIfcEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIfcEntityQuery, GetIfcEntityQueryVariables>(GetIfcEntityDocument, options);
      }
export function useGetIfcEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIfcEntityQuery, GetIfcEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIfcEntityQuery, GetIfcEntityQueryVariables>(GetIfcEntityDocument, options);
        }
// @ts-ignore
export function useGetIfcEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIfcEntityQuery, GetIfcEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcEntityQuery, GetIfcEntityQueryVariables>;
export function useGetIfcEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcEntityQuery, GetIfcEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcEntityQuery | undefined, GetIfcEntityQueryVariables>;
export function useGetIfcEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcEntityQuery, GetIfcEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIfcEntityQuery, GetIfcEntityQueryVariables>(GetIfcEntityDocument, options);
        }
export type GetIfcEntityQueryHookResult = ReturnType<typeof useGetIfcEntityQuery>;
export type GetIfcEntityLazyQueryHookResult = ReturnType<typeof useGetIfcEntityLazyQuery>;
export type GetIfcEntitySuspenseQueryHookResult = ReturnType<typeof useGetIfcEntitySuspenseQuery>;
export type GetIfcEntityQueryResult = Apollo.QueryResult<GetIfcEntityQuery, GetIfcEntityQueryVariables>;
export const CreateIfcPropertyDocument = gql`
    mutation createIFCProperty($iFCProperty: IFCPropInput) {
  CreateIFCProp(item: $iFCProperty)
}
    `;
export type CreateIfcPropertyMutationFn = Apollo.MutationFunction<CreateIfcPropertyMutation, CreateIfcPropertyMutationVariables>;

/**
 * __useCreateIfcPropertyMutation__
 *
 * To run a mutation, you first call `useCreateIfcPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIfcPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIfcPropertyMutation, { data, loading, error }] = useCreateIfcPropertyMutation({
 *   variables: {
 *      iFCProperty: // value for 'iFCProperty'
 *   },
 * });
 */
export function useCreateIfcPropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreateIfcPropertyMutation, CreateIfcPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIfcPropertyMutation, CreateIfcPropertyMutationVariables>(CreateIfcPropertyDocument, options);
      }
export type CreateIfcPropertyMutationHookResult = ReturnType<typeof useCreateIfcPropertyMutation>;
export type CreateIfcPropertyMutationResult = Apollo.MutationResult<CreateIfcPropertyMutation>;
export type CreateIfcPropertyMutationOptions = Apollo.BaseMutationOptions<CreateIfcPropertyMutation, CreateIfcPropertyMutationVariables>;
export const DeleteIfcPropertiesDocument = gql`
    mutation deleteIFCProperties($ids: [String]) {
  DeleteIFCPropList(ids: $ids)
}
    `;
export type DeleteIfcPropertiesMutationFn = Apollo.MutationFunction<DeleteIfcPropertiesMutation, DeleteIfcPropertiesMutationVariables>;

/**
 * __useDeleteIfcPropertiesMutation__
 *
 * To run a mutation, you first call `useDeleteIfcPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIfcPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIfcPropertiesMutation, { data, loading, error }] = useDeleteIfcPropertiesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteIfcPropertiesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIfcPropertiesMutation, DeleteIfcPropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIfcPropertiesMutation, DeleteIfcPropertiesMutationVariables>(DeleteIfcPropertiesDocument, options);
      }
export type DeleteIfcPropertiesMutationHookResult = ReturnType<typeof useDeleteIfcPropertiesMutation>;
export type DeleteIfcPropertiesMutationResult = Apollo.MutationResult<DeleteIfcPropertiesMutation>;
export type DeleteIfcPropertiesMutationOptions = Apollo.BaseMutationOptions<DeleteIfcPropertiesMutation, DeleteIfcPropertiesMutationVariables>;
export const GetIfcPropertiesDocument = gql`
    query getIFCProperties($contains: String) {
  IFCPropList(where: {name: {contains: $contains}}) {
    nodes {
      ...iFCPropertyProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${IFcPropertyPropsFragmentDoc}`;

/**
 * __useGetIfcPropertiesQuery__
 *
 * To run a query within a React component, call `useGetIfcPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIfcPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIfcPropertiesQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *   },
 * });
 */
export function useGetIfcPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>(GetIfcPropertiesDocument, options);
      }
export function useGetIfcPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>(GetIfcPropertiesDocument, options);
        }
// @ts-ignore
export function useGetIfcPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>;
export function useGetIfcPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertiesQuery | undefined, GetIfcPropertiesQueryVariables>;
export function useGetIfcPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>(GetIfcPropertiesDocument, options);
        }
export type GetIfcPropertiesQueryHookResult = ReturnType<typeof useGetIfcPropertiesQuery>;
export type GetIfcPropertiesLazyQueryHookResult = ReturnType<typeof useGetIfcPropertiesLazyQuery>;
export type GetIfcPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetIfcPropertiesSuspenseQuery>;
export type GetIfcPropertiesQueryResult = Apollo.QueryResult<GetIfcPropertiesQuery, GetIfcPropertiesQueryVariables>;
export const GetIfcPropertyDocument = gql`
    query getIFCProperty($id: String) {
  IFCProp(id: $id) {
    ...iFCPropertyProps
  }
}
    ${IFcPropertyPropsFragmentDoc}`;

/**
 * __useGetIfcPropertyQuery__
 *
 * To run a query within a React component, call `useGetIfcPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIfcPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIfcPropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIfcPropertyQuery(baseOptions?: Apollo.QueryHookOptions<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>(GetIfcPropertyDocument, options);
      }
export function useGetIfcPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>(GetIfcPropertyDocument, options);
        }
// @ts-ignore
export function useGetIfcPropertySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>;
export function useGetIfcPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertyQuery | undefined, GetIfcPropertyQueryVariables>;
export function useGetIfcPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>(GetIfcPropertyDocument, options);
        }
export type GetIfcPropertyQueryHookResult = ReturnType<typeof useGetIfcPropertyQuery>;
export type GetIfcPropertyLazyQueryHookResult = ReturnType<typeof useGetIfcPropertyLazyQuery>;
export type GetIfcPropertySuspenseQueryHookResult = ReturnType<typeof useGetIfcPropertySuspenseQuery>;
export type GetIfcPropertyQueryResult = Apollo.QueryResult<GetIfcPropertyQuery, GetIfcPropertyQueryVariables>;
export const CreateIfcPropertySetDocument = gql`
    mutation createIFCPropertySet($iFCPropertySet: IFCPsetInput) {
  CreateIFCPset(item: $iFCPropertySet)
}
    `;
export type CreateIfcPropertySetMutationFn = Apollo.MutationFunction<CreateIfcPropertySetMutation, CreateIfcPropertySetMutationVariables>;

/**
 * __useCreateIfcPropertySetMutation__
 *
 * To run a mutation, you first call `useCreateIfcPropertySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIfcPropertySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIfcPropertySetMutation, { data, loading, error }] = useCreateIfcPropertySetMutation({
 *   variables: {
 *      iFCPropertySet: // value for 'iFCPropertySet'
 *   },
 * });
 */
export function useCreateIfcPropertySetMutation(baseOptions?: Apollo.MutationHookOptions<CreateIfcPropertySetMutation, CreateIfcPropertySetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIfcPropertySetMutation, CreateIfcPropertySetMutationVariables>(CreateIfcPropertySetDocument, options);
      }
export type CreateIfcPropertySetMutationHookResult = ReturnType<typeof useCreateIfcPropertySetMutation>;
export type CreateIfcPropertySetMutationResult = Apollo.MutationResult<CreateIfcPropertySetMutation>;
export type CreateIfcPropertySetMutationOptions = Apollo.BaseMutationOptions<CreateIfcPropertySetMutation, CreateIfcPropertySetMutationVariables>;
export const DeleteIfcPropertySetListDocument = gql`
    mutation deleteIFCPropertySetList($ids: [String]) {
  DeleteIFCPsetList(ids: $ids)
}
    `;
export type DeleteIfcPropertySetListMutationFn = Apollo.MutationFunction<DeleteIfcPropertySetListMutation, DeleteIfcPropertySetListMutationVariables>;

/**
 * __useDeleteIfcPropertySetListMutation__
 *
 * To run a mutation, you first call `useDeleteIfcPropertySetListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIfcPropertySetListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIfcPropertySetListMutation, { data, loading, error }] = useDeleteIfcPropertySetListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteIfcPropertySetListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIfcPropertySetListMutation, DeleteIfcPropertySetListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIfcPropertySetListMutation, DeleteIfcPropertySetListMutationVariables>(DeleteIfcPropertySetListDocument, options);
      }
export type DeleteIfcPropertySetListMutationHookResult = ReturnType<typeof useDeleteIfcPropertySetListMutation>;
export type DeleteIfcPropertySetListMutationResult = Apollo.MutationResult<DeleteIfcPropertySetListMutation>;
export type DeleteIfcPropertySetListMutationOptions = Apollo.BaseMutationOptions<DeleteIfcPropertySetListMutation, DeleteIfcPropertySetListMutationVariables>;
export const GetIfcPropertySetListDocument = gql`
    query getIFCPropertySetList($contains: String) {
  IFCPsetList(where: {name: {contains: $contains}}) {
    nodes {
      ...iFCPropertySetProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${IFcPropertySetPropsFragmentDoc}`;

/**
 * __useGetIfcPropertySetListQuery__
 *
 * To run a query within a React component, call `useGetIfcPropertySetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIfcPropertySetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIfcPropertySetListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *   },
 * });
 */
export function useGetIfcPropertySetListQuery(baseOptions?: Apollo.QueryHookOptions<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>(GetIfcPropertySetListDocument, options);
      }
export function useGetIfcPropertySetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>(GetIfcPropertySetListDocument, options);
        }
// @ts-ignore
export function useGetIfcPropertySetListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>;
export function useGetIfcPropertySetListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertySetListQuery | undefined, GetIfcPropertySetListQueryVariables>;
export function useGetIfcPropertySetListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>(GetIfcPropertySetListDocument, options);
        }
export type GetIfcPropertySetListQueryHookResult = ReturnType<typeof useGetIfcPropertySetListQuery>;
export type GetIfcPropertySetListLazyQueryHookResult = ReturnType<typeof useGetIfcPropertySetListLazyQuery>;
export type GetIfcPropertySetListSuspenseQueryHookResult = ReturnType<typeof useGetIfcPropertySetListSuspenseQuery>;
export type GetIfcPropertySetListQueryResult = Apollo.QueryResult<GetIfcPropertySetListQuery, GetIfcPropertySetListQueryVariables>;
export const GetIfcPropertySetDocument = gql`
    query getIFCPropertySet($id: String) {
  IFCPset(id: $id) {
    ...iFCPropertySetProps
  }
}
    ${IFcPropertySetPropsFragmentDoc}`;

/**
 * __useGetIfcPropertySetQuery__
 *
 * To run a query within a React component, call `useGetIfcPropertySetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIfcPropertySetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIfcPropertySetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIfcPropertySetQuery(baseOptions?: Apollo.QueryHookOptions<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>(GetIfcPropertySetDocument, options);
      }
export function useGetIfcPropertySetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>(GetIfcPropertySetDocument, options);
        }
// @ts-ignore
export function useGetIfcPropertySetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>;
export function useGetIfcPropertySetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>): Apollo.UseSuspenseQueryResult<GetIfcPropertySetQuery | undefined, GetIfcPropertySetQueryVariables>;
export function useGetIfcPropertySetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>(GetIfcPropertySetDocument, options);
        }
export type GetIfcPropertySetQueryHookResult = ReturnType<typeof useGetIfcPropertySetQuery>;
export type GetIfcPropertySetLazyQueryHookResult = ReturnType<typeof useGetIfcPropertySetLazyQuery>;
export type GetIfcPropertySetSuspenseQueryHookResult = ReturnType<typeof useGetIfcPropertySetSuspenseQuery>;
export type GetIfcPropertySetQueryResult = Apollo.QueryResult<GetIfcPropertySetQuery, GetIfcPropertySetQueryVariables>;
export const MoveLibraryDocument = gql`
    mutation moveLibrary($id: String, $clientId: String) {
  Library(id: $id) {
    move(clientId: $clientId)
  }
}
    `;
export type MoveLibraryMutationFn = Apollo.MutationFunction<MoveLibraryMutation, MoveLibraryMutationVariables>;

/**
 * __useMoveLibraryMutation__
 *
 * To run a mutation, you first call `useMoveLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLibraryMutation, { data, loading, error }] = useMoveLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useMoveLibraryMutation(baseOptions?: Apollo.MutationHookOptions<MoveLibraryMutation, MoveLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLibraryMutation, MoveLibraryMutationVariables>(MoveLibraryDocument, options);
      }
export type MoveLibraryMutationHookResult = ReturnType<typeof useMoveLibraryMutation>;
export type MoveLibraryMutationResult = Apollo.MutationResult<MoveLibraryMutation>;
export type MoveLibraryMutationOptions = Apollo.BaseMutationOptions<MoveLibraryMutation, MoveLibraryMutationVariables>;
export const RenameLibraryDocument = gql`
    mutation renameLibrary($id: String, $name: String) {
  Library(id: $id) {
    setName(name: $name)
  }
}
    `;
export type RenameLibraryMutationFn = Apollo.MutationFunction<RenameLibraryMutation, RenameLibraryMutationVariables>;

/**
 * __useRenameLibraryMutation__
 *
 * To run a mutation, you first call `useRenameLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameLibraryMutation, { data, loading, error }] = useRenameLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameLibraryMutation(baseOptions?: Apollo.MutationHookOptions<RenameLibraryMutation, RenameLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameLibraryMutation, RenameLibraryMutationVariables>(RenameLibraryDocument, options);
      }
export type RenameLibraryMutationHookResult = ReturnType<typeof useRenameLibraryMutation>;
export type RenameLibraryMutationResult = Apollo.MutationResult<RenameLibraryMutation>;
export type RenameLibraryMutationOptions = Apollo.BaseMutationOptions<RenameLibraryMutation, RenameLibraryMutationVariables>;
export const EditLibraryDescriptionDocument = gql`
    mutation editLibraryDescription($id: String, $description: String) {
  Library(id: $id) {
    setDescription(description: $description)
  }
}
    `;
export type EditLibraryDescriptionMutationFn = Apollo.MutationFunction<EditLibraryDescriptionMutation, EditLibraryDescriptionMutationVariables>;

/**
 * __useEditLibraryDescriptionMutation__
 *
 * To run a mutation, you first call `useEditLibraryDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLibraryDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLibraryDescriptionMutation, { data, loading, error }] = useEditLibraryDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useEditLibraryDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<EditLibraryDescriptionMutation, EditLibraryDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLibraryDescriptionMutation, EditLibraryDescriptionMutationVariables>(EditLibraryDescriptionDocument, options);
      }
export type EditLibraryDescriptionMutationHookResult = ReturnType<typeof useEditLibraryDescriptionMutation>;
export type EditLibraryDescriptionMutationResult = Apollo.MutationResult<EditLibraryDescriptionMutation>;
export type EditLibraryDescriptionMutationOptions = Apollo.BaseMutationOptions<EditLibraryDescriptionMutation, EditLibraryDescriptionMutationVariables>;
export const CreateLibraryDocument = gql`
    mutation createLibrary($library: LibraryInput) {
  CreateLibrary(item: $library)
}
    `;
export type CreateLibraryMutationFn = Apollo.MutationFunction<CreateLibraryMutation, CreateLibraryMutationVariables>;

/**
 * __useCreateLibraryMutation__
 *
 * To run a mutation, you first call `useCreateLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryMutation, { data, loading, error }] = useCreateLibraryMutation({
 *   variables: {
 *      library: // value for 'library'
 *   },
 * });
 */
export function useCreateLibraryMutation(baseOptions?: Apollo.MutationHookOptions<CreateLibraryMutation, CreateLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLibraryMutation, CreateLibraryMutationVariables>(CreateLibraryDocument, options);
      }
export type CreateLibraryMutationHookResult = ReturnType<typeof useCreateLibraryMutation>;
export type CreateLibraryMutationResult = Apollo.MutationResult<CreateLibraryMutation>;
export type CreateLibraryMutationOptions = Apollo.BaseMutationOptions<CreateLibraryMutation, CreateLibraryMutationVariables>;
export const AssignLibrariesTagsDocument = gql`
    mutation assignLibrariesTags($ids: [String], $tagIds: [String]) {
  AssignLibraryListTags(ids: $ids, tagIds: $tagIds)
}
    `;
export type AssignLibrariesTagsMutationFn = Apollo.MutationFunction<AssignLibrariesTagsMutation, AssignLibrariesTagsMutationVariables>;

/**
 * __useAssignLibrariesTagsMutation__
 *
 * To run a mutation, you first call `useAssignLibrariesTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignLibrariesTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignLibrariesTagsMutation, { data, loading, error }] = useAssignLibrariesTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAssignLibrariesTagsMutation(baseOptions?: Apollo.MutationHookOptions<AssignLibrariesTagsMutation, AssignLibrariesTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignLibrariesTagsMutation, AssignLibrariesTagsMutationVariables>(AssignLibrariesTagsDocument, options);
      }
export type AssignLibrariesTagsMutationHookResult = ReturnType<typeof useAssignLibrariesTagsMutation>;
export type AssignLibrariesTagsMutationResult = Apollo.MutationResult<AssignLibrariesTagsMutation>;
export type AssignLibrariesTagsMutationOptions = Apollo.BaseMutationOptions<AssignLibrariesTagsMutation, AssignLibrariesTagsMutationVariables>;
export const DeleteLibraryTagsDocument = gql`
    mutation deleteLibraryTags($id: String, $ids: [String]) {
  Library(id: $id) {
    deleteTags(ids: $ids)
  }
}
    `;
export type DeleteLibraryTagsMutationFn = Apollo.MutationFunction<DeleteLibraryTagsMutation, DeleteLibraryTagsMutationVariables>;

/**
 * __useDeleteLibraryTagsMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryTagsMutation, { data, loading, error }] = useDeleteLibraryTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteLibraryTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryTagsMutation, DeleteLibraryTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryTagsMutation, DeleteLibraryTagsMutationVariables>(DeleteLibraryTagsDocument, options);
      }
export type DeleteLibraryTagsMutationHookResult = ReturnType<typeof useDeleteLibraryTagsMutation>;
export type DeleteLibraryTagsMutationResult = Apollo.MutationResult<DeleteLibraryTagsMutation>;
export type DeleteLibraryTagsMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryTagsMutation, DeleteLibraryTagsMutationVariables>;
export const DeleteLibrariesDocument = gql`
    mutation deleteLibraries($clientId: String, $ids: [String]) {
  Client(id: $clientId) {
    deleteLibraries(ids: $ids)
  }
}
    `;
export type DeleteLibrariesMutationFn = Apollo.MutationFunction<DeleteLibrariesMutation, DeleteLibrariesMutationVariables>;

/**
 * __useDeleteLibrariesMutation__
 *
 * To run a mutation, you first call `useDeleteLibrariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibrariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibrariesMutation, { data, loading, error }] = useDeleteLibrariesMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteLibrariesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibrariesMutation, DeleteLibrariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibrariesMutation, DeleteLibrariesMutationVariables>(DeleteLibrariesDocument, options);
      }
export type DeleteLibrariesMutationHookResult = ReturnType<typeof useDeleteLibrariesMutation>;
export type DeleteLibrariesMutationResult = Apollo.MutationResult<DeleteLibrariesMutation>;
export type DeleteLibrariesMutationOptions = Apollo.BaseMutationOptions<DeleteLibrariesMutation, DeleteLibrariesMutationVariables>;
export const SetLibraryAdminDocument = gql`
    mutation setLibraryAdmin($id: String, $userId: String) {
  Library(id: $id) {
    setAdmin(id: $userId)
  }
}
    `;
export type SetLibraryAdminMutationFn = Apollo.MutationFunction<SetLibraryAdminMutation, SetLibraryAdminMutationVariables>;

/**
 * __useSetLibraryAdminMutation__
 *
 * To run a mutation, you first call `useSetLibraryAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLibraryAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLibraryAdminMutation, { data, loading, error }] = useSetLibraryAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetLibraryAdminMutation(baseOptions?: Apollo.MutationHookOptions<SetLibraryAdminMutation, SetLibraryAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLibraryAdminMutation, SetLibraryAdminMutationVariables>(SetLibraryAdminDocument, options);
      }
export type SetLibraryAdminMutationHookResult = ReturnType<typeof useSetLibraryAdminMutation>;
export type SetLibraryAdminMutationResult = Apollo.MutationResult<SetLibraryAdminMutation>;
export type SetLibraryAdminMutationOptions = Apollo.BaseMutationOptions<SetLibraryAdminMutation, SetLibraryAdminMutationVariables>;
export const DeleteLibraryAdminsDocument = gql`
    mutation deleteLibraryAdmins($id: String, $ids: [String]) {
  Library(id: $id) {
    deleteAdmins(ids: $ids)
  }
}
    `;
export type DeleteLibraryAdminsMutationFn = Apollo.MutationFunction<DeleteLibraryAdminsMutation, DeleteLibraryAdminsMutationVariables>;

/**
 * __useDeleteLibraryAdminsMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryAdminsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryAdminsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryAdminsMutation, { data, loading, error }] = useDeleteLibraryAdminsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteLibraryAdminsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryAdminsMutation, DeleteLibraryAdminsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryAdminsMutation, DeleteLibraryAdminsMutationVariables>(DeleteLibraryAdminsDocument, options);
      }
export type DeleteLibraryAdminsMutationHookResult = ReturnType<typeof useDeleteLibraryAdminsMutation>;
export type DeleteLibraryAdminsMutationResult = Apollo.MutationResult<DeleteLibraryAdminsMutation>;
export type DeleteLibraryAdminsMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryAdminsMutation, DeleteLibraryAdminsMutationVariables>;
export const InheritLibraryDocument = gql`
    mutation inheritLibrary($id: String, $to: String) {
  Library(id: $id) {
    inheritLibrary(inheritLibraryId: $to)
  }
}
    `;
export type InheritLibraryMutationFn = Apollo.MutationFunction<InheritLibraryMutation, InheritLibraryMutationVariables>;

/**
 * __useInheritLibraryMutation__
 *
 * To run a mutation, you first call `useInheritLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInheritLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inheritLibraryMutation, { data, loading, error }] = useInheritLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useInheritLibraryMutation(baseOptions?: Apollo.MutationHookOptions<InheritLibraryMutation, InheritLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InheritLibraryMutation, InheritLibraryMutationVariables>(InheritLibraryDocument, options);
      }
export type InheritLibraryMutationHookResult = ReturnType<typeof useInheritLibraryMutation>;
export type InheritLibraryMutationResult = Apollo.MutationResult<InheritLibraryMutation>;
export type InheritLibraryMutationOptions = Apollo.BaseMutationOptions<InheritLibraryMutation, InheritLibraryMutationVariables>;
export const UnInheritLibrariesDocument = gql`
    mutation unInheritLibraries($id: String, $ids: [String]) {
  Library(id: $id) {
    deleteInheritLibraries(ids: $ids)
  }
}
    `;
export type UnInheritLibrariesMutationFn = Apollo.MutationFunction<UnInheritLibrariesMutation, UnInheritLibrariesMutationVariables>;

/**
 * __useUnInheritLibrariesMutation__
 *
 * To run a mutation, you first call `useUnInheritLibrariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnInheritLibrariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unInheritLibrariesMutation, { data, loading, error }] = useUnInheritLibrariesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnInheritLibrariesMutation(baseOptions?: Apollo.MutationHookOptions<UnInheritLibrariesMutation, UnInheritLibrariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnInheritLibrariesMutation, UnInheritLibrariesMutationVariables>(UnInheritLibrariesDocument, options);
      }
export type UnInheritLibrariesMutationHookResult = ReturnType<typeof useUnInheritLibrariesMutation>;
export type UnInheritLibrariesMutationResult = Apollo.MutationResult<UnInheritLibrariesMutation>;
export type UnInheritLibrariesMutationOptions = Apollo.BaseMutationOptions<UnInheritLibrariesMutation, UnInheritLibrariesMutationVariables>;
export const RegisterContentsDocument = gql`
    mutation registerContents($id: String, $contentIds: [String]) {
  Library(id: $id) {
    registerContents(contentIds: $contentIds)
  }
}
    `;
export type RegisterContentsMutationFn = Apollo.MutationFunction<RegisterContentsMutation, RegisterContentsMutationVariables>;

/**
 * __useRegisterContentsMutation__
 *
 * To run a mutation, you first call `useRegisterContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerContentsMutation, { data, loading, error }] = useRegisterContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useRegisterContentsMutation(baseOptions?: Apollo.MutationHookOptions<RegisterContentsMutation, RegisterContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterContentsMutation, RegisterContentsMutationVariables>(RegisterContentsDocument, options);
      }
export type RegisterContentsMutationHookResult = ReturnType<typeof useRegisterContentsMutation>;
export type RegisterContentsMutationResult = Apollo.MutationResult<RegisterContentsMutation>;
export type RegisterContentsMutationOptions = Apollo.BaseMutationOptions<RegisterContentsMutation, RegisterContentsMutationVariables>;
export const UnregisterContentsDocument = gql`
    mutation unregisterContents($id: String, $ids: [String]) {
  Library(id: $id) {
    deleteRegisedContents(ids: $ids)
  }
}
    `;
export type UnregisterContentsMutationFn = Apollo.MutationFunction<UnregisterContentsMutation, UnregisterContentsMutationVariables>;

/**
 * __useUnregisterContentsMutation__
 *
 * To run a mutation, you first call `useUnregisterContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterContentsMutation, { data, loading, error }] = useUnregisterContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnregisterContentsMutation(baseOptions?: Apollo.MutationHookOptions<UnregisterContentsMutation, UnregisterContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnregisterContentsMutation, UnregisterContentsMutationVariables>(UnregisterContentsDocument, options);
      }
export type UnregisterContentsMutationHookResult = ReturnType<typeof useUnregisterContentsMutation>;
export type UnregisterContentsMutationResult = Apollo.MutationResult<UnregisterContentsMutation>;
export type UnregisterContentsMutationOptions = Apollo.BaseMutationOptions<UnregisterContentsMutation, UnregisterContentsMutationVariables>;
export const SetCustomContentsDocument = gql`
    mutation setCustomContents($id: String, $customContents: [CustomContentInput]) {
  Library(id: $id) {
    setCustomContents(customContents: $customContents)
  }
}
    `;
export type SetCustomContentsMutationFn = Apollo.MutationFunction<SetCustomContentsMutation, SetCustomContentsMutationVariables>;

/**
 * __useSetCustomContentsMutation__
 *
 * To run a mutation, you first call `useSetCustomContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomContentsMutation, { data, loading, error }] = useSetCustomContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customContents: // value for 'customContents'
 *   },
 * });
 */
export function useSetCustomContentsMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomContentsMutation, SetCustomContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomContentsMutation, SetCustomContentsMutationVariables>(SetCustomContentsDocument, options);
      }
export type SetCustomContentsMutationHookResult = ReturnType<typeof useSetCustomContentsMutation>;
export type SetCustomContentsMutationResult = Apollo.MutationResult<SetCustomContentsMutation>;
export type SetCustomContentsMutationOptions = Apollo.BaseMutationOptions<SetCustomContentsMutation, SetCustomContentsMutationVariables>;
export const DeleteCustomContentsDocument = gql`
    mutation deleteCustomContents($id: String, $ids: [String]) {
  Library(id: $id) {
    deleteCustomContents(ids: $ids)
  }
}
    `;
export type DeleteCustomContentsMutationFn = Apollo.MutationFunction<DeleteCustomContentsMutation, DeleteCustomContentsMutationVariables>;

/**
 * __useDeleteCustomContentsMutation__
 *
 * To run a mutation, you first call `useDeleteCustomContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomContentsMutation, { data, loading, error }] = useDeleteCustomContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCustomContentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomContentsMutation, DeleteCustomContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomContentsMutation, DeleteCustomContentsMutationVariables>(DeleteCustomContentsDocument, options);
      }
export type DeleteCustomContentsMutationHookResult = ReturnType<typeof useDeleteCustomContentsMutation>;
export type DeleteCustomContentsMutationResult = Apollo.MutationResult<DeleteCustomContentsMutation>;
export type DeleteCustomContentsMutationOptions = Apollo.BaseMutationOptions<DeleteCustomContentsMutation, DeleteCustomContentsMutationVariables>;
export const SetCustomContentTypesDocument = gql`
    mutation setCustomContentTypes($id: String, $customContentId: String, $customContentTypes: [CustomContentTypeInput]) {
  Library(id: $id) {
    customContent(id: $customContentId) {
      setCustomContentTypes(customContentTypes: $customContentTypes)
    }
  }
}
    `;
export type SetCustomContentTypesMutationFn = Apollo.MutationFunction<SetCustomContentTypesMutation, SetCustomContentTypesMutationVariables>;

/**
 * __useSetCustomContentTypesMutation__
 *
 * To run a mutation, you first call `useSetCustomContentTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomContentTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomContentTypesMutation, { data, loading, error }] = useSetCustomContentTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customContentId: // value for 'customContentId'
 *      customContentTypes: // value for 'customContentTypes'
 *   },
 * });
 */
export function useSetCustomContentTypesMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomContentTypesMutation, SetCustomContentTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomContentTypesMutation, SetCustomContentTypesMutationVariables>(SetCustomContentTypesDocument, options);
      }
export type SetCustomContentTypesMutationHookResult = ReturnType<typeof useSetCustomContentTypesMutation>;
export type SetCustomContentTypesMutationResult = Apollo.MutationResult<SetCustomContentTypesMutation>;
export type SetCustomContentTypesMutationOptions = Apollo.BaseMutationOptions<SetCustomContentTypesMutation, SetCustomContentTypesMutationVariables>;
export const EditCustomContentCustomSettingsDocument = gql`
    mutation editCustomContentCustomSettings($id: String, $customContentId: String, $settings: String) {
  Library(id: $id) {
    customContent(id: $customContentId) {
      setCustomSettings(settings: $settings)
    }
  }
}
    `;
export type EditCustomContentCustomSettingsMutationFn = Apollo.MutationFunction<EditCustomContentCustomSettingsMutation, EditCustomContentCustomSettingsMutationVariables>;

/**
 * __useEditCustomContentCustomSettingsMutation__
 *
 * To run a mutation, you first call `useEditCustomContentCustomSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomContentCustomSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomContentCustomSettingsMutation, { data, loading, error }] = useEditCustomContentCustomSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customContentId: // value for 'customContentId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useEditCustomContentCustomSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditCustomContentCustomSettingsMutation, EditCustomContentCustomSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCustomContentCustomSettingsMutation, EditCustomContentCustomSettingsMutationVariables>(EditCustomContentCustomSettingsDocument, options);
      }
export type EditCustomContentCustomSettingsMutationHookResult = ReturnType<typeof useEditCustomContentCustomSettingsMutation>;
export type EditCustomContentCustomSettingsMutationResult = Apollo.MutationResult<EditCustomContentCustomSettingsMutation>;
export type EditCustomContentCustomSettingsMutationOptions = Apollo.BaseMutationOptions<EditCustomContentCustomSettingsMutation, EditCustomContentCustomSettingsMutationVariables>;
export const EditCustomContentTypeCustomSettingsDocument = gql`
    mutation editCustomContentTypeCustomSettings($id: String, $customContentId: String, $customContentTypeId: String, $settings: String) {
  Library(id: $id) {
    customContent(id: $customContentId) {
      customContentType(id: $customContentTypeId) {
        setCustomSettings(settings: $settings)
      }
    }
  }
}
    `;
export type EditCustomContentTypeCustomSettingsMutationFn = Apollo.MutationFunction<EditCustomContentTypeCustomSettingsMutation, EditCustomContentTypeCustomSettingsMutationVariables>;

/**
 * __useEditCustomContentTypeCustomSettingsMutation__
 *
 * To run a mutation, you first call `useEditCustomContentTypeCustomSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomContentTypeCustomSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomContentTypeCustomSettingsMutation, { data, loading, error }] = useEditCustomContentTypeCustomSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customContentId: // value for 'customContentId'
 *      customContentTypeId: // value for 'customContentTypeId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useEditCustomContentTypeCustomSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditCustomContentTypeCustomSettingsMutation, EditCustomContentTypeCustomSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCustomContentTypeCustomSettingsMutation, EditCustomContentTypeCustomSettingsMutationVariables>(EditCustomContentTypeCustomSettingsDocument, options);
      }
export type EditCustomContentTypeCustomSettingsMutationHookResult = ReturnType<typeof useEditCustomContentTypeCustomSettingsMutation>;
export type EditCustomContentTypeCustomSettingsMutationResult = Apollo.MutationResult<EditCustomContentTypeCustomSettingsMutation>;
export type EditCustomContentTypeCustomSettingsMutationOptions = Apollo.BaseMutationOptions<EditCustomContentTypeCustomSettingsMutation, EditCustomContentTypeCustomSettingsMutationVariables>;
export const DeleteCustomContentTypesDocument = gql`
    mutation deleteCustomContentTypes($id: String, $customContentId: String, $ids: [String]) {
  Library(id: $id) {
    customContent(id: $customContentId) {
      deleteCustomContentTypes(ids: $ids)
    }
  }
}
    `;
export type DeleteCustomContentTypesMutationFn = Apollo.MutationFunction<DeleteCustomContentTypesMutation, DeleteCustomContentTypesMutationVariables>;

/**
 * __useDeleteCustomContentTypesMutation__
 *
 * To run a mutation, you first call `useDeleteCustomContentTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomContentTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomContentTypesMutation, { data, loading, error }] = useDeleteCustomContentTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customContentId: // value for 'customContentId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCustomContentTypesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomContentTypesMutation, DeleteCustomContentTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomContentTypesMutation, DeleteCustomContentTypesMutationVariables>(DeleteCustomContentTypesDocument, options);
      }
export type DeleteCustomContentTypesMutationHookResult = ReturnType<typeof useDeleteCustomContentTypesMutation>;
export type DeleteCustomContentTypesMutationResult = Apollo.MutationResult<DeleteCustomContentTypesMutation>;
export type DeleteCustomContentTypesMutationOptions = Apollo.BaseMutationOptions<DeleteCustomContentTypesMutation, DeleteCustomContentTypesMutationVariables>;
export const GetLibrariesDocument = gql`
    query getLibraries($clientId: String, $id: String, $contains: String, $after: String, $order: [LibrarySortInput!]) {
  LibraryList(
    after: $after
    order: $order
    where: {and: [{clientId: {eq: $clientId}}, {id: {neq: $id}}, {name: {contains: $contains}}]}
  ) {
    nodes {
      ...libraryProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${LibraryPropsFragmentDoc}`;

/**
 * __useGetLibrariesQuery__
 *
 * To run a query within a React component, call `useGetLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibrariesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      id: // value for 'id'
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetLibrariesQuery(baseOptions?: Apollo.QueryHookOptions<GetLibrariesQuery, GetLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLibrariesQuery, GetLibrariesQueryVariables>(GetLibrariesDocument, options);
      }
export function useGetLibrariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLibrariesQuery, GetLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLibrariesQuery, GetLibrariesQueryVariables>(GetLibrariesDocument, options);
        }
// @ts-ignore
export function useGetLibrariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLibrariesQuery, GetLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibrariesQuery, GetLibrariesQueryVariables>;
export function useGetLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibrariesQuery, GetLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibrariesQuery | undefined, GetLibrariesQueryVariables>;
export function useGetLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibrariesQuery, GetLibrariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLibrariesQuery, GetLibrariesQueryVariables>(GetLibrariesDocument, options);
        }
export type GetLibrariesQueryHookResult = ReturnType<typeof useGetLibrariesQuery>;
export type GetLibrariesLazyQueryHookResult = ReturnType<typeof useGetLibrariesLazyQuery>;
export type GetLibrariesSuspenseQueryHookResult = ReturnType<typeof useGetLibrariesSuspenseQuery>;
export type GetLibrariesQueryResult = Apollo.QueryResult<GetLibrariesQuery, GetLibrariesQueryVariables>;
export const GetInheritedLibrariesDocument = gql`
    query getInheritedLibraries($id: String, $contains: String, $after: String) {
  Library(id: $id) {
    id
    inheritedLibraries(after: $after, where: {name: {contains: $contains}}) {
      nodes {
        ...libraryProps
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${LibraryPropsFragmentDoc}`;

/**
 * __useGetInheritedLibrariesQuery__
 *
 * To run a query within a React component, call `useGetInheritedLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInheritedLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInheritedLibrariesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInheritedLibrariesQuery(baseOptions?: Apollo.QueryHookOptions<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>(GetInheritedLibrariesDocument, options);
      }
export function useGetInheritedLibrariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>(GetInheritedLibrariesDocument, options);
        }
// @ts-ignore
export function useGetInheritedLibrariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>;
export function useGetInheritedLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInheritedLibrariesQuery | undefined, GetInheritedLibrariesQueryVariables>;
export function useGetInheritedLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>(GetInheritedLibrariesDocument, options);
        }
export type GetInheritedLibrariesQueryHookResult = ReturnType<typeof useGetInheritedLibrariesQuery>;
export type GetInheritedLibrariesLazyQueryHookResult = ReturnType<typeof useGetInheritedLibrariesLazyQuery>;
export type GetInheritedLibrariesSuspenseQueryHookResult = ReturnType<typeof useGetInheritedLibrariesSuspenseQuery>;
export type GetInheritedLibrariesQueryResult = Apollo.QueryResult<GetInheritedLibrariesQuery, GetInheritedLibrariesQueryVariables>;
export const GetLibraryCustomContentsDocument = gql`
    query getLibraryCustomContents($id: String) {
  Library(id: $id) {
    id
    customContents {
      id
      customSettings
      libraryId
      contentId
      content {
        id
        name
      }
      customContentTypes {
        id
        customSettings
        contentTypeId
        contentType {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetLibraryCustomContentsQuery__
 *
 * To run a query within a React component, call `useGetLibraryCustomContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryCustomContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryCustomContentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLibraryCustomContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>(GetLibraryCustomContentsDocument, options);
      }
export function useGetLibraryCustomContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>(GetLibraryCustomContentsDocument, options);
        }
// @ts-ignore
export function useGetLibraryCustomContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>;
export function useGetLibraryCustomContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryCustomContentsQuery | undefined, GetLibraryCustomContentsQueryVariables>;
export function useGetLibraryCustomContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>(GetLibraryCustomContentsDocument, options);
        }
export type GetLibraryCustomContentsQueryHookResult = ReturnType<typeof useGetLibraryCustomContentsQuery>;
export type GetLibraryCustomContentsLazyQueryHookResult = ReturnType<typeof useGetLibraryCustomContentsLazyQuery>;
export type GetLibraryCustomContentsSuspenseQueryHookResult = ReturnType<typeof useGetLibraryCustomContentsSuspenseQuery>;
export type GetLibraryCustomContentsQueryResult = Apollo.QueryResult<GetLibraryCustomContentsQuery, GetLibraryCustomContentsQueryVariables>;
export const GetLibraryDocument = gql`
    query getLibrary($id: String) {
  Library(id: $id) {
    ...libraryProps
  }
}
    ${LibraryPropsFragmentDoc}`;

/**
 * __useGetLibraryQuery__
 *
 * To run a query within a React component, call `useGetLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLibraryQuery(baseOptions?: Apollo.QueryHookOptions<GetLibraryQuery, GetLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLibraryQuery, GetLibraryQueryVariables>(GetLibraryDocument, options);
      }
export function useGetLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLibraryQuery, GetLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLibraryQuery, GetLibraryQueryVariables>(GetLibraryDocument, options);
        }
// @ts-ignore
export function useGetLibrarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLibraryQuery, GetLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryQuery, GetLibraryQueryVariables>;
export function useGetLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryQuery, GetLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryQuery | undefined, GetLibraryQueryVariables>;
export function useGetLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryQuery, GetLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLibraryQuery, GetLibraryQueryVariables>(GetLibraryDocument, options);
        }
export type GetLibraryQueryHookResult = ReturnType<typeof useGetLibraryQuery>;
export type GetLibraryLazyQueryHookResult = ReturnType<typeof useGetLibraryLazyQuery>;
export type GetLibrarySuspenseQueryHookResult = ReturnType<typeof useGetLibrarySuspenseQuery>;
export type GetLibraryQueryResult = Apollo.QueryResult<GetLibraryQuery, GetLibraryQueryVariables>;
export const GetLibraryCacheDocument = gql`
    query getLibraryCache($id: String) {
  Library(id: $id) {
    cacheJson
    cacheJsonManifest
    caches
    lastCacheRunResult {
      libraryId
      startedAt
      completedAt
      durationMs
      error
      blobs {
        software
        blobName
        nodeCount
        base64Bytes
        gzipBytes
        manifestOk
      }
    }
  }
}
    `;

/**
 * __useGetLibraryCacheQuery__
 *
 * To run a query within a React component, call `useGetLibraryCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryCacheQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLibraryCacheQuery(baseOptions?: Apollo.QueryHookOptions<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>(GetLibraryCacheDocument, options);
      }
export function useGetLibraryCacheLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>(GetLibraryCacheDocument, options);
        }
// @ts-ignore
export function useGetLibraryCacheSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>;
export function useGetLibraryCacheSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryCacheQuery | undefined, GetLibraryCacheQueryVariables>;
export function useGetLibraryCacheSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>(GetLibraryCacheDocument, options);
        }
export type GetLibraryCacheQueryHookResult = ReturnType<typeof useGetLibraryCacheQuery>;
export type GetLibraryCacheLazyQueryHookResult = ReturnType<typeof useGetLibraryCacheLazyQuery>;
export type GetLibraryCacheSuspenseQueryHookResult = ReturnType<typeof useGetLibraryCacheSuspenseQuery>;
export type GetLibraryCacheQueryResult = Apollo.QueryResult<GetLibraryCacheQuery, GetLibraryCacheQueryVariables>;
export const GetRecentLibraryCreationsDocument = gql`
    query getRecentLibraryCreations($first: Int) {
  LibraryList(first: $first, order: {createdTime: DESC}) {
    nodes {
      id
      name
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRecentLibraryCreationsQuery__
 *
 * To run a query within a React component, call `useGetRecentLibraryCreationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentLibraryCreationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentLibraryCreationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRecentLibraryCreationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>(GetRecentLibraryCreationsDocument, options);
      }
export function useGetRecentLibraryCreationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>(GetRecentLibraryCreationsDocument, options);
        }
// @ts-ignore
export function useGetRecentLibraryCreationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>;
export function useGetRecentLibraryCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentLibraryCreationsQuery | undefined, GetRecentLibraryCreationsQueryVariables>;
export function useGetRecentLibraryCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>(GetRecentLibraryCreationsDocument, options);
        }
export type GetRecentLibraryCreationsQueryHookResult = ReturnType<typeof useGetRecentLibraryCreationsQuery>;
export type GetRecentLibraryCreationsLazyQueryHookResult = ReturnType<typeof useGetRecentLibraryCreationsLazyQuery>;
export type GetRecentLibraryCreationsSuspenseQueryHookResult = ReturnType<typeof useGetRecentLibraryCreationsSuspenseQuery>;
export type GetRecentLibraryCreationsQueryResult = Apollo.QueryResult<GetRecentLibraryCreationsQuery, GetRecentLibraryCreationsQueryVariables>;
export const ResetLibraryContentUsageCountsDocument = gql`
    mutation resetLibraryContentUsageCounts($libraryId: String) {
  Library(id: $libraryId) {
    resetContentUsageCounts
  }
}
    `;
export type ResetLibraryContentUsageCountsMutationFn = Apollo.MutationFunction<ResetLibraryContentUsageCountsMutation, ResetLibraryContentUsageCountsMutationVariables>;

/**
 * __useResetLibraryContentUsageCountsMutation__
 *
 * To run a mutation, you first call `useResetLibraryContentUsageCountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetLibraryContentUsageCountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetLibraryContentUsageCountsMutation, { data, loading, error }] = useResetLibraryContentUsageCountsMutation({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *   },
 * });
 */
export function useResetLibraryContentUsageCountsMutation(baseOptions?: Apollo.MutationHookOptions<ResetLibraryContentUsageCountsMutation, ResetLibraryContentUsageCountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetLibraryContentUsageCountsMutation, ResetLibraryContentUsageCountsMutationVariables>(ResetLibraryContentUsageCountsDocument, options);
      }
export type ResetLibraryContentUsageCountsMutationHookResult = ReturnType<typeof useResetLibraryContentUsageCountsMutation>;
export type ResetLibraryContentUsageCountsMutationResult = Apollo.MutationResult<ResetLibraryContentUsageCountsMutation>;
export type ResetLibraryContentUsageCountsMutationOptions = Apollo.BaseMutationOptions<ResetLibraryContentUsageCountsMutation, ResetLibraryContentUsageCountsMutationVariables>;
export const CreateMapDocument = gql`
    mutation createMap($map: MapInput) {
  CreateMap(item: $map)
}
    `;
export type CreateMapMutationFn = Apollo.MutationFunction<CreateMapMutation, CreateMapMutationVariables>;

/**
 * __useCreateMapMutation__
 *
 * To run a mutation, you first call `useCreateMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMapMutation, { data, loading, error }] = useCreateMapMutation({
 *   variables: {
 *      map: // value for 'map'
 *   },
 * });
 */
export function useCreateMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateMapMutation, CreateMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMapMutation, CreateMapMutationVariables>(CreateMapDocument, options);
      }
export type CreateMapMutationHookResult = ReturnType<typeof useCreateMapMutation>;
export type CreateMapMutationResult = Apollo.MutationResult<CreateMapMutation>;
export type CreateMapMutationOptions = Apollo.BaseMutationOptions<CreateMapMutation, CreateMapMutationVariables>;
export const DeleteMapsDocument = gql`
    mutation deleteMaps($ids: [String]) {
  DeleteMapList(ids: $ids)
}
    `;
export type DeleteMapsMutationFn = Apollo.MutationFunction<DeleteMapsMutation, DeleteMapsMutationVariables>;

/**
 * __useDeleteMapsMutation__
 *
 * To run a mutation, you first call `useDeleteMapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMapsMutation, { data, loading, error }] = useDeleteMapsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMapsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMapsMutation, DeleteMapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMapsMutation, DeleteMapsMutationVariables>(DeleteMapsDocument, options);
      }
export type DeleteMapsMutationHookResult = ReturnType<typeof useDeleteMapsMutation>;
export type DeleteMapsMutationResult = Apollo.MutationResult<DeleteMapsMutation>;
export type DeleteMapsMutationOptions = Apollo.BaseMutationOptions<DeleteMapsMutation, DeleteMapsMutationVariables>;
export const GetMapsDocument = gql`
    query getMaps($contains: String) {
  MapList(where: {name: {contains: $contains}}) {
    nodes {
      ...mapProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${MapPropsFragmentDoc}`;

/**
 * __useGetMapsQuery__
 *
 * To run a query within a React component, call `useGetMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapsQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *   },
 * });
 */
export function useGetMapsQuery(baseOptions?: Apollo.QueryHookOptions<GetMapsQuery, GetMapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapsQuery, GetMapsQueryVariables>(GetMapsDocument, options);
      }
export function useGetMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapsQuery, GetMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapsQuery, GetMapsQueryVariables>(GetMapsDocument, options);
        }
// @ts-ignore
export function useGetMapsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMapsQuery, GetMapsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMapsQuery, GetMapsQueryVariables>;
export function useGetMapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMapsQuery, GetMapsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMapsQuery | undefined, GetMapsQueryVariables>;
export function useGetMapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMapsQuery, GetMapsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMapsQuery, GetMapsQueryVariables>(GetMapsDocument, options);
        }
export type GetMapsQueryHookResult = ReturnType<typeof useGetMapsQuery>;
export type GetMapsLazyQueryHookResult = ReturnType<typeof useGetMapsLazyQuery>;
export type GetMapsSuspenseQueryHookResult = ReturnType<typeof useGetMapsSuspenseQuery>;
export type GetMapsQueryResult = Apollo.QueryResult<GetMapsQuery, GetMapsQueryVariables>;
export const GetMapDocument = gql`
    query getMap($id: String) {
  Map(id: $id) {
    ...mapProps
  }
}
    ${MapPropsFragmentDoc}`;

/**
 * __useGetMapQuery__
 *
 * To run a query within a React component, call `useGetMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMapQuery(baseOptions?: Apollo.QueryHookOptions<GetMapQuery, GetMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapQuery, GetMapQueryVariables>(GetMapDocument, options);
      }
export function useGetMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapQuery, GetMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapQuery, GetMapQueryVariables>(GetMapDocument, options);
        }
// @ts-ignore
export function useGetMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMapQuery, GetMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetMapQuery, GetMapQueryVariables>;
export function useGetMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMapQuery, GetMapQueryVariables>): Apollo.UseSuspenseQueryResult<GetMapQuery | undefined, GetMapQueryVariables>;
export function useGetMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMapQuery, GetMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMapQuery, GetMapQueryVariables>(GetMapDocument, options);
        }
export type GetMapQueryHookResult = ReturnType<typeof useGetMapQuery>;
export type GetMapLazyQueryHookResult = ReturnType<typeof useGetMapLazyQuery>;
export type GetMapSuspenseQueryHookResult = ReturnType<typeof useGetMapSuspenseQuery>;
export type GetMapQueryResult = Apollo.QueryResult<GetMapQuery, GetMapQueryVariables>;
export const CreateModelDocument = gql`
    mutation createModel($model: ModelInput) {
  CreateModel(item: $model)
}
    `;
export type CreateModelMutationFn = Apollo.MutationFunction<CreateModelMutation, CreateModelMutationVariables>;

/**
 * __useCreateModelMutation__
 *
 * To run a mutation, you first call `useCreateModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelMutation, { data, loading, error }] = useCreateModelMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useCreateModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelMutation, CreateModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelMutation, CreateModelMutationVariables>(CreateModelDocument, options);
      }
export type CreateModelMutationHookResult = ReturnType<typeof useCreateModelMutation>;
export type CreateModelMutationResult = Apollo.MutationResult<CreateModelMutation>;
export type CreateModelMutationOptions = Apollo.BaseMutationOptions<CreateModelMutation, CreateModelMutationVariables>;
export const DeleteModelsDocument = gql`
    mutation deleteModels($id: String, $ids: [String]) {
  Model(id: $id) {
    delete(ids: $ids)
  }
}
    `;
export type DeleteModelsMutationFn = Apollo.MutationFunction<DeleteModelsMutation, DeleteModelsMutationVariables>;

/**
 * __useDeleteModelsMutation__
 *
 * To run a mutation, you first call `useDeleteModelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModelsMutation, { data, loading, error }] = useDeleteModelsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteModelsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModelsMutation, DeleteModelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModelsMutation, DeleteModelsMutationVariables>(DeleteModelsDocument, options);
      }
export type DeleteModelsMutationHookResult = ReturnType<typeof useDeleteModelsMutation>;
export type DeleteModelsMutationResult = Apollo.MutationResult<DeleteModelsMutation>;
export type DeleteModelsMutationOptions = Apollo.BaseMutationOptions<DeleteModelsMutation, DeleteModelsMutationVariables>;
export const CountModelsDocument = gql`
    query countModels {
  ModelCount
}
    `;

/**
 * __useCountModelsQuery__
 *
 * To run a query within a React component, call `useCountModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountModelsQuery(baseOptions?: Apollo.QueryHookOptions<CountModelsQuery, CountModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountModelsQuery, CountModelsQueryVariables>(CountModelsDocument, options);
      }
export function useCountModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountModelsQuery, CountModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountModelsQuery, CountModelsQueryVariables>(CountModelsDocument, options);
        }
// @ts-ignore
export function useCountModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountModelsQuery, CountModelsQueryVariables>): Apollo.UseSuspenseQueryResult<CountModelsQuery, CountModelsQueryVariables>;
export function useCountModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountModelsQuery, CountModelsQueryVariables>): Apollo.UseSuspenseQueryResult<CountModelsQuery | undefined, CountModelsQueryVariables>;
export function useCountModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountModelsQuery, CountModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountModelsQuery, CountModelsQueryVariables>(CountModelsDocument, options);
        }
export type CountModelsQueryHookResult = ReturnType<typeof useCountModelsQuery>;
export type CountModelsLazyQueryHookResult = ReturnType<typeof useCountModelsLazyQuery>;
export type CountModelsSuspenseQueryHookResult = ReturnType<typeof useCountModelsSuspenseQuery>;
export type CountModelsQueryResult = Apollo.QueryResult<CountModelsQuery, CountModelsQueryVariables>;
export const GetModelsDocument = gql`
    query getModels($projectId: String, $contains: String, $after: String, $order: [ModelSortInput!]) {
  ModelList(
    after: $after
    order: $order
    where: {and: [{projectId: {eq: $projectId}}, {name: {contains: $contains}}]}
  ) {
    nodes {
      ...modelProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ModelPropsFragmentDoc}`;

/**
 * __useGetModelsQuery__
 *
 * To run a query within a React component, call `useGetModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetModelsQuery, GetModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, options);
      }
export function useGetModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, options);
        }
// @ts-ignore
export function useGetModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelsQuery, GetModelsQueryVariables>;
export function useGetModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelsQuery | undefined, GetModelsQueryVariables>;
export function useGetModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelsQuery, GetModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModelsQuery, GetModelsQueryVariables>(GetModelsDocument, options);
        }
export type GetModelsQueryHookResult = ReturnType<typeof useGetModelsQuery>;
export type GetModelsLazyQueryHookResult = ReturnType<typeof useGetModelsLazyQuery>;
export type GetModelsSuspenseQueryHookResult = ReturnType<typeof useGetModelsSuspenseQuery>;
export type GetModelsQueryResult = Apollo.QueryResult<GetModelsQuery, GetModelsQueryVariables>;
export const GetModelsShortDocument = gql`
    query getModelsShort {
  ModelList(first: 10000) {
    nodes {
      id
      name
      createdTime
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetModelsShortQuery__
 *
 * To run a query within a React component, call `useGetModelsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelsShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModelsShortQuery(baseOptions?: Apollo.QueryHookOptions<GetModelsShortQuery, GetModelsShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelsShortQuery, GetModelsShortQueryVariables>(GetModelsShortDocument, options);
      }
export function useGetModelsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelsShortQuery, GetModelsShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelsShortQuery, GetModelsShortQueryVariables>(GetModelsShortDocument, options);
        }
// @ts-ignore
export function useGetModelsShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModelsShortQuery, GetModelsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelsShortQuery, GetModelsShortQueryVariables>;
export function useGetModelsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelsShortQuery, GetModelsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelsShortQuery | undefined, GetModelsShortQueryVariables>;
export function useGetModelsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelsShortQuery, GetModelsShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModelsShortQuery, GetModelsShortQueryVariables>(GetModelsShortDocument, options);
        }
export type GetModelsShortQueryHookResult = ReturnType<typeof useGetModelsShortQuery>;
export type GetModelsShortLazyQueryHookResult = ReturnType<typeof useGetModelsShortLazyQuery>;
export type GetModelsShortSuspenseQueryHookResult = ReturnType<typeof useGetModelsShortSuspenseQuery>;
export type GetModelsShortQueryResult = Apollo.QueryResult<GetModelsShortQuery, GetModelsShortQueryVariables>;
export const GetRecentModelCreationsDocument = gql`
    query getRecentModelCreations($first: Int) {
  ModelList(first: $first, order: {createdTime: DESC}) {
    nodes {
      id
      name
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRecentModelCreationsQuery__
 *
 * To run a query within a React component, call `useGetRecentModelCreationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentModelCreationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentModelCreationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRecentModelCreationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>(GetRecentModelCreationsDocument, options);
      }
export function useGetRecentModelCreationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>(GetRecentModelCreationsDocument, options);
        }
// @ts-ignore
export function useGetRecentModelCreationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>;
export function useGetRecentModelCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentModelCreationsQuery | undefined, GetRecentModelCreationsQueryVariables>;
export function useGetRecentModelCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>(GetRecentModelCreationsDocument, options);
        }
export type GetRecentModelCreationsQueryHookResult = ReturnType<typeof useGetRecentModelCreationsQuery>;
export type GetRecentModelCreationsLazyQueryHookResult = ReturnType<typeof useGetRecentModelCreationsLazyQuery>;
export type GetRecentModelCreationsSuspenseQueryHookResult = ReturnType<typeof useGetRecentModelCreationsSuspenseQuery>;
export type GetRecentModelCreationsQueryResult = Apollo.QueryResult<GetRecentModelCreationsQuery, GetRecentModelCreationsQueryVariables>;
export const GetModelApplicationReportDocument = gql`
    query getModelApplicationReport($after: String) {
  ModelList(first: 5000, after: $after) {
    nodes {
      id
      applicationName
      projectId
      updatedTime
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetModelApplicationReportQuery__
 *
 * To run a query within a React component, call `useGetModelApplicationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelApplicationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelApplicationReportQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetModelApplicationReportQuery(baseOptions?: Apollo.QueryHookOptions<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>(GetModelApplicationReportDocument, options);
      }
export function useGetModelApplicationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>(GetModelApplicationReportDocument, options);
        }
// @ts-ignore
export function useGetModelApplicationReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>;
export function useGetModelApplicationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelApplicationReportQuery | undefined, GetModelApplicationReportQueryVariables>;
export function useGetModelApplicationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>(GetModelApplicationReportDocument, options);
        }
export type GetModelApplicationReportQueryHookResult = ReturnType<typeof useGetModelApplicationReportQuery>;
export type GetModelApplicationReportLazyQueryHookResult = ReturnType<typeof useGetModelApplicationReportLazyQuery>;
export type GetModelApplicationReportSuspenseQueryHookResult = ReturnType<typeof useGetModelApplicationReportSuspenseQuery>;
export type GetModelApplicationReportQueryResult = Apollo.QueryResult<GetModelApplicationReportQuery, GetModelApplicationReportQueryVariables>;
export const GetModelDocument = gql`
    query getModel($id: String) {
  Model(id: $id) {
    ...modelProps
    caches
  }
}
    ${ModelPropsFragmentDoc}`;

/**
 * __useGetModelQuery__
 *
 * To run a query within a React component, call `useGetModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetModelQuery(baseOptions?: Apollo.QueryHookOptions<GetModelQuery, GetModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelQuery, GetModelQueryVariables>(GetModelDocument, options);
      }
export function useGetModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelQuery, GetModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelQuery, GetModelQueryVariables>(GetModelDocument, options);
        }
// @ts-ignore
export function useGetModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModelQuery, GetModelQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelQuery, GetModelQueryVariables>;
export function useGetModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelQuery, GetModelQueryVariables>): Apollo.UseSuspenseQueryResult<GetModelQuery | undefined, GetModelQueryVariables>;
export function useGetModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModelQuery, GetModelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModelQuery, GetModelQueryVariables>(GetModelDocument, options);
        }
export type GetModelQueryHookResult = ReturnType<typeof useGetModelQuery>;
export type GetModelLazyQueryHookResult = ReturnType<typeof useGetModelLazyQuery>;
export type GetModelSuspenseQueryHookResult = ReturnType<typeof useGetModelSuspenseQuery>;
export type GetModelQueryResult = Apollo.QueryResult<GetModelQuery, GetModelQueryVariables>;
export const GetProfileStatsDocument = gql`
    query GetProfileStats($userId: String) {
  MemberProjects: ProjectList(
    first: 10000
    where: {memberIds: {some: {eq: $userId}}}
  ) {
    nodes {
      id
    }
  }
  AdminProjects: ProjectList(
    first: 10000
    where: {adminIds: {some: {eq: $userId}}}
  ) {
    nodes {
      id
    }
  }
  AdminLibraries: LibraryList(
    first: 10000
    where: {adminIds: {some: {eq: $userId}}}
  ) {
    nodes {
      id
    }
  }
  AdminClients: ClientList(first: 10000, where: {adminIds: {some: {eq: $userId}}}) {
    nodes {
      id
    }
  }
  AllMyModels: ModelList(first: 10000, where: {createdById: {eq: $userId}}) {
    nodes {
      id
      createdTime
    }
  }
  AllMyContents: ContentList(first: 10000, where: {createdById: {eq: $userId}}) {
    nodes {
      id
      createdTime
    }
  }
}
    `;

/**
 * __useGetProfileStatsQuery__
 *
 * To run a query within a React component, call `useGetProfileStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileStatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetProfileStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileStatsQuery, GetProfileStatsQueryVariables>(GetProfileStatsDocument, options);
      }
export function useGetProfileStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileStatsQuery, GetProfileStatsQueryVariables>(GetProfileStatsDocument, options);
        }
// @ts-ignore
export function useGetProfileStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProfileStatsQuery, GetProfileStatsQueryVariables>;
export function useGetProfileStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProfileStatsQuery | undefined, GetProfileStatsQueryVariables>;
export function useGetProfileStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProfileStatsQuery, GetProfileStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfileStatsQuery, GetProfileStatsQueryVariables>(GetProfileStatsDocument, options);
        }
export type GetProfileStatsQueryHookResult = ReturnType<typeof useGetProfileStatsQuery>;
export type GetProfileStatsLazyQueryHookResult = ReturnType<typeof useGetProfileStatsLazyQuery>;
export type GetProfileStatsSuspenseQueryHookResult = ReturnType<typeof useGetProfileStatsSuspenseQuery>;
export type GetProfileStatsQueryResult = Apollo.QueryResult<GetProfileStatsQuery, GetProfileStatsQueryVariables>;
export const GetMyAdminClientsDocument = gql`
    query GetMyAdminClients($userId: String) {
  ClientList(first: 10000, where: {adminIds: {some: {eq: $userId}}}) {
    nodes {
      id
      name
      longName
      description
      createdTime
      isPrivate
      tagIds
      tags {
        id
        name
        type
      }
    }
  }
}
    `;

/**
 * __useGetMyAdminClientsQuery__
 *
 * To run a query within a React component, call `useGetMyAdminClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAdminClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAdminClientsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyAdminClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>(GetMyAdminClientsDocument, options);
      }
export function useGetMyAdminClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>(GetMyAdminClientsDocument, options);
        }
// @ts-ignore
export function useGetMyAdminClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>;
export function useGetMyAdminClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAdminClientsQuery | undefined, GetMyAdminClientsQueryVariables>;
export function useGetMyAdminClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>(GetMyAdminClientsDocument, options);
        }
export type GetMyAdminClientsQueryHookResult = ReturnType<typeof useGetMyAdminClientsQuery>;
export type GetMyAdminClientsLazyQueryHookResult = ReturnType<typeof useGetMyAdminClientsLazyQuery>;
export type GetMyAdminClientsSuspenseQueryHookResult = ReturnType<typeof useGetMyAdminClientsSuspenseQuery>;
export type GetMyAdminClientsQueryResult = Apollo.QueryResult<GetMyAdminClientsQuery, GetMyAdminClientsQueryVariables>;
export const GetMyAdminProjectsDocument = gql`
    query GetMyAdminProjects($userId: String) {
  ProjectList(first: 10000, where: {adminIds: {some: {eq: $userId}}}) {
    nodes {
      id
      name
      description
      createdTime
      updatedTime
      clientId
      client {
        id
        name
      }
      libraryId
      library {
        id
        name
      }
      tagIds
      tags {
        id
        name
        type
      }
      models {
        id
        healthResults
      }
    }
  }
}
    `;

/**
 * __useGetMyAdminProjectsQuery__
 *
 * To run a query within a React component, call `useGetMyAdminProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAdminProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAdminProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyAdminProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>(GetMyAdminProjectsDocument, options);
      }
export function useGetMyAdminProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>(GetMyAdminProjectsDocument, options);
        }
// @ts-ignore
export function useGetMyAdminProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>;
export function useGetMyAdminProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAdminProjectsQuery | undefined, GetMyAdminProjectsQueryVariables>;
export function useGetMyAdminProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>(GetMyAdminProjectsDocument, options);
        }
export type GetMyAdminProjectsQueryHookResult = ReturnType<typeof useGetMyAdminProjectsQuery>;
export type GetMyAdminProjectsLazyQueryHookResult = ReturnType<typeof useGetMyAdminProjectsLazyQuery>;
export type GetMyAdminProjectsSuspenseQueryHookResult = ReturnType<typeof useGetMyAdminProjectsSuspenseQuery>;
export type GetMyAdminProjectsQueryResult = Apollo.QueryResult<GetMyAdminProjectsQuery, GetMyAdminProjectsQueryVariables>;
export const GetMyAdminLibrariesDocument = gql`
    query GetMyAdminLibraries($userId: String) {
  LibraryList(first: 10000, where: {adminIds: {some: {eq: $userId}}}) {
    nodes {
      id
      name
      description
      clientId
      createdTime
    }
  }
}
    `;

/**
 * __useGetMyAdminLibrariesQuery__
 *
 * To run a query within a React component, call `useGetMyAdminLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAdminLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAdminLibrariesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyAdminLibrariesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>(GetMyAdminLibrariesDocument, options);
      }
export function useGetMyAdminLibrariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>(GetMyAdminLibrariesDocument, options);
        }
// @ts-ignore
export function useGetMyAdminLibrariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>;
export function useGetMyAdminLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyAdminLibrariesQuery | undefined, GetMyAdminLibrariesQueryVariables>;
export function useGetMyAdminLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>(GetMyAdminLibrariesDocument, options);
        }
export type GetMyAdminLibrariesQueryHookResult = ReturnType<typeof useGetMyAdminLibrariesQuery>;
export type GetMyAdminLibrariesLazyQueryHookResult = ReturnType<typeof useGetMyAdminLibrariesLazyQuery>;
export type GetMyAdminLibrariesSuspenseQueryHookResult = ReturnType<typeof useGetMyAdminLibrariesSuspenseQuery>;
export type GetMyAdminLibrariesQueryResult = Apollo.QueryResult<GetMyAdminLibrariesQuery, GetMyAdminLibrariesQueryVariables>;
export const ToggleProjectPrivateDocument = gql`
    mutation toggleProjectPrivate($id: String) {
  Project(id: $id) {
    togglePrivate
  }
}
    `;
export type ToggleProjectPrivateMutationFn = Apollo.MutationFunction<ToggleProjectPrivateMutation, ToggleProjectPrivateMutationVariables>;

/**
 * __useToggleProjectPrivateMutation__
 *
 * To run a mutation, you first call `useToggleProjectPrivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProjectPrivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProjectPrivateMutation, { data, loading, error }] = useToggleProjectPrivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleProjectPrivateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProjectPrivateMutation, ToggleProjectPrivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProjectPrivateMutation, ToggleProjectPrivateMutationVariables>(ToggleProjectPrivateDocument, options);
      }
export type ToggleProjectPrivateMutationHookResult = ReturnType<typeof useToggleProjectPrivateMutation>;
export type ToggleProjectPrivateMutationResult = Apollo.MutationResult<ToggleProjectPrivateMutation>;
export type ToggleProjectPrivateMutationOptions = Apollo.BaseMutationOptions<ToggleProjectPrivateMutation, ToggleProjectPrivateMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($project: ProjectInput) {
  CreateProject(item: $project)
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const DeleteProjectsDocument = gql`
    mutation deleteProjects($ids: [String]) {
  DeleteProjectList(ids: $ids)
}
    `;
export type DeleteProjectsMutationFn = Apollo.MutationFunction<DeleteProjectsMutation, DeleteProjectsMutationVariables>;

/**
 * __useDeleteProjectsMutation__
 *
 * To run a mutation, you first call `useDeleteProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectsMutation, { data, loading, error }] = useDeleteProjectsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectsMutation, DeleteProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectsMutation, DeleteProjectsMutationVariables>(DeleteProjectsDocument, options);
      }
export type DeleteProjectsMutationHookResult = ReturnType<typeof useDeleteProjectsMutation>;
export type DeleteProjectsMutationResult = Apollo.MutationResult<DeleteProjectsMutation>;
export type DeleteProjectsMutationOptions = Apollo.BaseMutationOptions<DeleteProjectsMutation, DeleteProjectsMutationVariables>;
export const AssignProjectsTagsDocument = gql`
    mutation assignProjectsTags($ids: [String], $tagIds: [String]) {
  AssignProjectListTags(ids: $ids, tagIds: $tagIds)
}
    `;
export type AssignProjectsTagsMutationFn = Apollo.MutationFunction<AssignProjectsTagsMutation, AssignProjectsTagsMutationVariables>;

/**
 * __useAssignProjectsTagsMutation__
 *
 * To run a mutation, you first call `useAssignProjectsTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProjectsTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProjectsTagsMutation, { data, loading, error }] = useAssignProjectsTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAssignProjectsTagsMutation(baseOptions?: Apollo.MutationHookOptions<AssignProjectsTagsMutation, AssignProjectsTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignProjectsTagsMutation, AssignProjectsTagsMutationVariables>(AssignProjectsTagsDocument, options);
      }
export type AssignProjectsTagsMutationHookResult = ReturnType<typeof useAssignProjectsTagsMutation>;
export type AssignProjectsTagsMutationResult = Apollo.MutationResult<AssignProjectsTagsMutation>;
export type AssignProjectsTagsMutationOptions = Apollo.BaseMutationOptions<AssignProjectsTagsMutation, AssignProjectsTagsMutationVariables>;
export const AssignProjectsHealthChecksDocument = gql`
    mutation assignProjectsHealthChecks($ids: [String], $healthCheckIds: [String], $overwrite: Boolean) {
  AssignProjectsHealthChecks(
    ids: $ids
    healthCheckIds: $healthCheckIds
    overwrite: $overwrite
  )
}
    `;
export type AssignProjectsHealthChecksMutationFn = Apollo.MutationFunction<AssignProjectsHealthChecksMutation, AssignProjectsHealthChecksMutationVariables>;

/**
 * __useAssignProjectsHealthChecksMutation__
 *
 * To run a mutation, you first call `useAssignProjectsHealthChecksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProjectsHealthChecksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProjectsHealthChecksMutation, { data, loading, error }] = useAssignProjectsHealthChecksMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      healthCheckIds: // value for 'healthCheckIds'
 *      overwrite: // value for 'overwrite'
 *   },
 * });
 */
export function useAssignProjectsHealthChecksMutation(baseOptions?: Apollo.MutationHookOptions<AssignProjectsHealthChecksMutation, AssignProjectsHealthChecksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignProjectsHealthChecksMutation, AssignProjectsHealthChecksMutationVariables>(AssignProjectsHealthChecksDocument, options);
      }
export type AssignProjectsHealthChecksMutationHookResult = ReturnType<typeof useAssignProjectsHealthChecksMutation>;
export type AssignProjectsHealthChecksMutationResult = Apollo.MutationResult<AssignProjectsHealthChecksMutation>;
export type AssignProjectsHealthChecksMutationOptions = Apollo.BaseMutationOptions<AssignProjectsHealthChecksMutation, AssignProjectsHealthChecksMutationVariables>;
export const CreateProjectWorksetDocument = gql`
    mutation createProjectWorkset($id: String, $workset: WorksetInput) {
  Project(id: $id) {
    setWorkset(workset: $workset)
  }
}
    `;
export type CreateProjectWorksetMutationFn = Apollo.MutationFunction<CreateProjectWorksetMutation, CreateProjectWorksetMutationVariables>;

/**
 * __useCreateProjectWorksetMutation__
 *
 * To run a mutation, you first call `useCreateProjectWorksetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectWorksetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectWorksetMutation, { data, loading, error }] = useCreateProjectWorksetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      workset: // value for 'workset'
 *   },
 * });
 */
export function useCreateProjectWorksetMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectWorksetMutation, CreateProjectWorksetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectWorksetMutation, CreateProjectWorksetMutationVariables>(CreateProjectWorksetDocument, options);
      }
export type CreateProjectWorksetMutationHookResult = ReturnType<typeof useCreateProjectWorksetMutation>;
export type CreateProjectWorksetMutationResult = Apollo.MutationResult<CreateProjectWorksetMutation>;
export type CreateProjectWorksetMutationOptions = Apollo.BaseMutationOptions<CreateProjectWorksetMutation, CreateProjectWorksetMutationVariables>;
export const EditProjectDocument = gql`
    mutation editProject($projectId: String, $clientId: String, $libraryId: String, $projectSubName: String) {
  Project(id: $projectId) {
    setClient(clientId: $clientId)
    setLibrary(libraryId: $libraryId)
    setProjectSubName(projectSubName: $projectSubName)
  }
}
    `;
export type EditProjectMutationFn = Apollo.MutationFunction<EditProjectMutation, EditProjectMutationVariables>;

/**
 * __useEditProjectMutation__
 *
 * To run a mutation, you first call `useEditProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectMutation, { data, loading, error }] = useEditProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      clientId: // value for 'clientId'
 *      libraryId: // value for 'libraryId'
 *      projectSubName: // value for 'projectSubName'
 *   },
 * });
 */
export function useEditProjectMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectMutation, EditProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectMutation, EditProjectMutationVariables>(EditProjectDocument, options);
      }
export type EditProjectMutationHookResult = ReturnType<typeof useEditProjectMutation>;
export type EditProjectMutationResult = Apollo.MutationResult<EditProjectMutation>;
export type EditProjectMutationOptions = Apollo.BaseMutationOptions<EditProjectMutation, EditProjectMutationVariables>;
export const SetProjectAccessDocument = gql`
    mutation setProjectAccess($projectId: String) {
  SetProjectAccess(projectId: $projectId)
}
    `;
export type SetProjectAccessMutationFn = Apollo.MutationFunction<SetProjectAccessMutation, SetProjectAccessMutationVariables>;

/**
 * __useSetProjectAccessMutation__
 *
 * To run a mutation, you first call `useSetProjectAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectAccessMutation, { data, loading, error }] = useSetProjectAccessMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSetProjectAccessMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectAccessMutation, SetProjectAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectAccessMutation, SetProjectAccessMutationVariables>(SetProjectAccessDocument, options);
      }
export type SetProjectAccessMutationHookResult = ReturnType<typeof useSetProjectAccessMutation>;
export type SetProjectAccessMutationResult = Apollo.MutationResult<SetProjectAccessMutation>;
export type SetProjectAccessMutationOptions = Apollo.BaseMutationOptions<SetProjectAccessMutation, SetProjectAccessMutationVariables>;
export const SetProjectSubNameDocument = gql`
    mutation setProjectSubName($projectId: String, $projectSubName: String) {
  Project(id: $projectId) {
    id
    name
    setProjectSubName(projectSubName: $projectSubName)
  }
}
    `;
export type SetProjectSubNameMutationFn = Apollo.MutationFunction<SetProjectSubNameMutation, SetProjectSubNameMutationVariables>;

/**
 * __useSetProjectSubNameMutation__
 *
 * To run a mutation, you first call `useSetProjectSubNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectSubNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectSubNameMutation, { data, loading, error }] = useSetProjectSubNameMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      projectSubName: // value for 'projectSubName'
 *   },
 * });
 */
export function useSetProjectSubNameMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectSubNameMutation, SetProjectSubNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectSubNameMutation, SetProjectSubNameMutationVariables>(SetProjectSubNameDocument, options);
      }
export type SetProjectSubNameMutationHookResult = ReturnType<typeof useSetProjectSubNameMutation>;
export type SetProjectSubNameMutationResult = Apollo.MutationResult<SetProjectSubNameMutation>;
export type SetProjectSubNameMutationOptions = Apollo.BaseMutationOptions<SetProjectSubNameMutation, SetProjectSubNameMutationVariables>;
export const SetProjectAdminDocument = gql`
    mutation setProjectAdmin($id: String, $userId: String) {
  Project(id: $id) {
    setAdmin(id: $userId)
  }
}
    `;
export type SetProjectAdminMutationFn = Apollo.MutationFunction<SetProjectAdminMutation, SetProjectAdminMutationVariables>;

/**
 * __useSetProjectAdminMutation__
 *
 * To run a mutation, you first call `useSetProjectAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectAdminMutation, { data, loading, error }] = useSetProjectAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetProjectAdminMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectAdminMutation, SetProjectAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectAdminMutation, SetProjectAdminMutationVariables>(SetProjectAdminDocument, options);
      }
export type SetProjectAdminMutationHookResult = ReturnType<typeof useSetProjectAdminMutation>;
export type SetProjectAdminMutationResult = Apollo.MutationResult<SetProjectAdminMutation>;
export type SetProjectAdminMutationOptions = Apollo.BaseMutationOptions<SetProjectAdminMutation, SetProjectAdminMutationVariables>;
export const SetProjectMemberDocument = gql`
    mutation setProjectMember($id: String, $userId: String) {
  Project(id: $id) {
    setMember(id: $userId)
  }
}
    `;
export type SetProjectMemberMutationFn = Apollo.MutationFunction<SetProjectMemberMutation, SetProjectMemberMutationVariables>;

/**
 * __useSetProjectMemberMutation__
 *
 * To run a mutation, you first call `useSetProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectMemberMutation, { data, loading, error }] = useSetProjectMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetProjectMemberMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectMemberMutation, SetProjectMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectMemberMutation, SetProjectMemberMutationVariables>(SetProjectMemberDocument, options);
      }
export type SetProjectMemberMutationHookResult = ReturnType<typeof useSetProjectMemberMutation>;
export type SetProjectMemberMutationResult = Apollo.MutationResult<SetProjectMemberMutation>;
export type SetProjectMemberMutationOptions = Apollo.BaseMutationOptions<SetProjectMemberMutation, SetProjectMemberMutationVariables>;
export const SetProjectApprovedContentsDocument = gql`
    mutation setProjectApprovedContents($id: String, $ids: [String]) {
  Project(id: $id) {
    setApprovedContents(ids: $ids)
  }
}
    `;
export type SetProjectApprovedContentsMutationFn = Apollo.MutationFunction<SetProjectApprovedContentsMutation, SetProjectApprovedContentsMutationVariables>;

/**
 * __useSetProjectApprovedContentsMutation__
 *
 * To run a mutation, you first call `useSetProjectApprovedContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectApprovedContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectApprovedContentsMutation, { data, loading, error }] = useSetProjectApprovedContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSetProjectApprovedContentsMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectApprovedContentsMutation, SetProjectApprovedContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectApprovedContentsMutation, SetProjectApprovedContentsMutationVariables>(SetProjectApprovedContentsDocument, options);
      }
export type SetProjectApprovedContentsMutationHookResult = ReturnType<typeof useSetProjectApprovedContentsMutation>;
export type SetProjectApprovedContentsMutationResult = Apollo.MutationResult<SetProjectApprovedContentsMutation>;
export type SetProjectApprovedContentsMutationOptions = Apollo.BaseMutationOptions<SetProjectApprovedContentsMutation, SetProjectApprovedContentsMutationVariables>;
export const DeleteProjectWorksetsDocument = gql`
    mutation deleteProjectWorksets($id: String, $ids: [String]) {
  Project(id: $id) {
    deleteWorksets(ids: $ids)
  }
}
    `;
export type DeleteProjectWorksetsMutationFn = Apollo.MutationFunction<DeleteProjectWorksetsMutation, DeleteProjectWorksetsMutationVariables>;

/**
 * __useDeleteProjectWorksetsMutation__
 *
 * To run a mutation, you first call `useDeleteProjectWorksetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectWorksetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectWorksetsMutation, { data, loading, error }] = useDeleteProjectWorksetsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectWorksetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectWorksetsMutation, DeleteProjectWorksetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectWorksetsMutation, DeleteProjectWorksetsMutationVariables>(DeleteProjectWorksetsDocument, options);
      }
export type DeleteProjectWorksetsMutationHookResult = ReturnType<typeof useDeleteProjectWorksetsMutation>;
export type DeleteProjectWorksetsMutationResult = Apollo.MutationResult<DeleteProjectWorksetsMutation>;
export type DeleteProjectWorksetsMutationOptions = Apollo.BaseMutationOptions<DeleteProjectWorksetsMutation, DeleteProjectWorksetsMutationVariables>;
export const DeleteProjectApprovedContentsDocument = gql`
    mutation deleteProjectApprovedContents($id: String, $ids: [String]) {
  Project(id: $id) {
    deleteApprovedContents(ids: $ids)
  }
}
    `;
export type DeleteProjectApprovedContentsMutationFn = Apollo.MutationFunction<DeleteProjectApprovedContentsMutation, DeleteProjectApprovedContentsMutationVariables>;

/**
 * __useDeleteProjectApprovedContentsMutation__
 *
 * To run a mutation, you first call `useDeleteProjectApprovedContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectApprovedContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectApprovedContentsMutation, { data, loading, error }] = useDeleteProjectApprovedContentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectApprovedContentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectApprovedContentsMutation, DeleteProjectApprovedContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectApprovedContentsMutation, DeleteProjectApprovedContentsMutationVariables>(DeleteProjectApprovedContentsDocument, options);
      }
export type DeleteProjectApprovedContentsMutationHookResult = ReturnType<typeof useDeleteProjectApprovedContentsMutation>;
export type DeleteProjectApprovedContentsMutationResult = Apollo.MutationResult<DeleteProjectApprovedContentsMutation>;
export type DeleteProjectApprovedContentsMutationOptions = Apollo.BaseMutationOptions<DeleteProjectApprovedContentsMutation, DeleteProjectApprovedContentsMutationVariables>;
export const DeleteProjectAdminsDocument = gql`
    mutation deleteProjectAdmins($id: String, $ids: [String]) {
  Project(id: $id) {
    deleteAdmins(ids: $ids)
  }
}
    `;
export type DeleteProjectAdminsMutationFn = Apollo.MutationFunction<DeleteProjectAdminsMutation, DeleteProjectAdminsMutationVariables>;

/**
 * __useDeleteProjectAdminsMutation__
 *
 * To run a mutation, you first call `useDeleteProjectAdminsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectAdminsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectAdminsMutation, { data, loading, error }] = useDeleteProjectAdminsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectAdminsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectAdminsMutation, DeleteProjectAdminsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectAdminsMutation, DeleteProjectAdminsMutationVariables>(DeleteProjectAdminsDocument, options);
      }
export type DeleteProjectAdminsMutationHookResult = ReturnType<typeof useDeleteProjectAdminsMutation>;
export type DeleteProjectAdminsMutationResult = Apollo.MutationResult<DeleteProjectAdminsMutation>;
export type DeleteProjectAdminsMutationOptions = Apollo.BaseMutationOptions<DeleteProjectAdminsMutation, DeleteProjectAdminsMutationVariables>;
export const DeleteProjectMembersDocument = gql`
    mutation deleteProjectMembers($id: String, $ids: [String]) {
  Project(id: $id) {
    deleteMembers(ids: $ids)
  }
}
    `;
export type DeleteProjectMembersMutationFn = Apollo.MutationFunction<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>;

/**
 * __useDeleteProjectMembersMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMembersMutation, { data, loading, error }] = useDeleteProjectMembersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectMembersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>(DeleteProjectMembersDocument, options);
      }
export type DeleteProjectMembersMutationHookResult = ReturnType<typeof useDeleteProjectMembersMutation>;
export type DeleteProjectMembersMutationResult = Apollo.MutationResult<DeleteProjectMembersMutation>;
export type DeleteProjectMembersMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>;
export const DeleteProjectTagsDocument = gql`
    mutation deleteProjectTags($id: String, $ids: [String]) {
  Project(id: $id) {
    deleteTags(ids: $ids)
  }
}
    `;
export type DeleteProjectTagsMutationFn = Apollo.MutationFunction<DeleteProjectTagsMutation, DeleteProjectTagsMutationVariables>;

/**
 * __useDeleteProjectTagsMutation__
 *
 * To run a mutation, you first call `useDeleteProjectTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectTagsMutation, { data, loading, error }] = useDeleteProjectTagsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectTagsMutation, DeleteProjectTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectTagsMutation, DeleteProjectTagsMutationVariables>(DeleteProjectTagsDocument, options);
      }
export type DeleteProjectTagsMutationHookResult = ReturnType<typeof useDeleteProjectTagsMutation>;
export type DeleteProjectTagsMutationResult = Apollo.MutationResult<DeleteProjectTagsMutation>;
export type DeleteProjectTagsMutationOptions = Apollo.BaseMutationOptions<DeleteProjectTagsMutation, DeleteProjectTagsMutationVariables>;
export const DeleteProjectHealthChecksDocument = gql`
    mutation deleteProjectHealthChecks($id: String, $ids: [String]) {
  Project(id: $id) {
    deleteHealthChecks(ids: $ids)
  }
}
    `;
export type DeleteProjectHealthChecksMutationFn = Apollo.MutationFunction<DeleteProjectHealthChecksMutation, DeleteProjectHealthChecksMutationVariables>;

/**
 * __useDeleteProjectHealthChecksMutation__
 *
 * To run a mutation, you first call `useDeleteProjectHealthChecksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectHealthChecksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectHealthChecksMutation, { data, loading, error }] = useDeleteProjectHealthChecksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProjectHealthChecksMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectHealthChecksMutation, DeleteProjectHealthChecksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectHealthChecksMutation, DeleteProjectHealthChecksMutationVariables>(DeleteProjectHealthChecksDocument, options);
      }
export type DeleteProjectHealthChecksMutationHookResult = ReturnType<typeof useDeleteProjectHealthChecksMutation>;
export type DeleteProjectHealthChecksMutationResult = Apollo.MutationResult<DeleteProjectHealthChecksMutation>;
export type DeleteProjectHealthChecksMutationOptions = Apollo.BaseMutationOptions<DeleteProjectHealthChecksMutation, DeleteProjectHealthChecksMutationVariables>;
export const CountProjectsDocument = gql`
    query countProjects {
  ProjectCount
}
    `;

/**
 * __useCountProjectsQuery__
 *
 * To run a query within a React component, call `useCountProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountProjectsQuery(baseOptions?: Apollo.QueryHookOptions<CountProjectsQuery, CountProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountProjectsQuery, CountProjectsQueryVariables>(CountProjectsDocument, options);
      }
export function useCountProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountProjectsQuery, CountProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountProjectsQuery, CountProjectsQueryVariables>(CountProjectsDocument, options);
        }
// @ts-ignore
export function useCountProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountProjectsQuery, CountProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<CountProjectsQuery, CountProjectsQueryVariables>;
export function useCountProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountProjectsQuery, CountProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<CountProjectsQuery | undefined, CountProjectsQueryVariables>;
export function useCountProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountProjectsQuery, CountProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountProjectsQuery, CountProjectsQueryVariables>(CountProjectsDocument, options);
        }
export type CountProjectsQueryHookResult = ReturnType<typeof useCountProjectsQuery>;
export type CountProjectsLazyQueryHookResult = ReturnType<typeof useCountProjectsLazyQuery>;
export type CountProjectsSuspenseQueryHookResult = ReturnType<typeof useCountProjectsSuspenseQuery>;
export type CountProjectsQueryResult = Apollo.QueryResult<CountProjectsQuery, CountProjectsQueryVariables>;
export const GetAllProjectsWithoutPermissionDocument = gql`
    query getAllProjectsWithoutPermission($contains: String, $after: String) {
  AllProjects(after: $after, where: {name: {contains: $contains}}) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetAllProjectsWithoutPermissionQuery__
 *
 * To run a query within a React component, call `useGetAllProjectsWithoutPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectsWithoutPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectsWithoutPermissionQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAllProjectsWithoutPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>(GetAllProjectsWithoutPermissionDocument, options);
      }
export function useGetAllProjectsWithoutPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>(GetAllProjectsWithoutPermissionDocument, options);
        }
// @ts-ignore
export function useGetAllProjectsWithoutPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>;
export function useGetAllProjectsWithoutPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProjectsWithoutPermissionQuery | undefined, GetAllProjectsWithoutPermissionQueryVariables>;
export function useGetAllProjectsWithoutPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>(GetAllProjectsWithoutPermissionDocument, options);
        }
export type GetAllProjectsWithoutPermissionQueryHookResult = ReturnType<typeof useGetAllProjectsWithoutPermissionQuery>;
export type GetAllProjectsWithoutPermissionLazyQueryHookResult = ReturnType<typeof useGetAllProjectsWithoutPermissionLazyQuery>;
export type GetAllProjectsWithoutPermissionSuspenseQueryHookResult = ReturnType<typeof useGetAllProjectsWithoutPermissionSuspenseQuery>;
export type GetAllProjectsWithoutPermissionQueryResult = Apollo.QueryResult<GetAllProjectsWithoutPermissionQuery, GetAllProjectsWithoutPermissionQueryVariables>;
export const GetProjectsDocument = gql`
    query getProjects($clientId: String, $libraryId: String, $contains: String, $after: String, $tagIds: [String], $order: [ProjectSortInput!]) {
  ProjectList(
    tagIds: $tagIds
    after: $after
    order: $order
    where: {and: [{clientId: {eq: $clientId}}, {libraryId: {eq: $libraryId}}, {name: {contains: $contains}}]}
  ) {
    nodes {
      ...projectProps
      projectSubName
      libraryId
      library {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ProjectPropsFragmentDoc}`;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      libraryId: // value for 'libraryId'
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
// @ts-ignore
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsQuery | undefined, GetProjectsQueryVariables>;
export function useGetProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectsSuspenseQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetLibraryProjectsDocument = gql`
    query getLibraryProjects($libraryId: String, $contains: String, $after: String, $tagIds: [String], $order: [ProjectSortInput!]) {
  ProjectList(
    tagIds: $tagIds
    after: $after
    order: $order
    where: {and: [{libraryId: {eq: $libraryId}}, {name: {contains: $contains}}]}
  ) {
    nodes {
      ...projectProps
      clientId
      client {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ProjectPropsFragmentDoc}`;

/**
 * __useGetLibraryProjectsQuery__
 *
 * To run a query within a React component, call `useGetLibraryProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryProjectsQuery({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetLibraryProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>(GetLibraryProjectsDocument, options);
      }
export function useGetLibraryProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>(GetLibraryProjectsDocument, options);
        }
// @ts-ignore
export function useGetLibraryProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>;
export function useGetLibraryProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLibraryProjectsQuery | undefined, GetLibraryProjectsQueryVariables>;
export function useGetLibraryProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>(GetLibraryProjectsDocument, options);
        }
export type GetLibraryProjectsQueryHookResult = ReturnType<typeof useGetLibraryProjectsQuery>;
export type GetLibraryProjectsLazyQueryHookResult = ReturnType<typeof useGetLibraryProjectsLazyQuery>;
export type GetLibraryProjectsSuspenseQueryHookResult = ReturnType<typeof useGetLibraryProjectsSuspenseQuery>;
export type GetLibraryProjectsQueryResult = Apollo.QueryResult<GetLibraryProjectsQuery, GetLibraryProjectsQueryVariables>;
export const GetProjectsShortDocument = gql`
    query getProjectsShort {
  ProjectList(first: 10000) {
    nodes {
      id
      name
      createdTime
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetProjectsShortQuery__
 *
 * To run a query within a React component, call `useGetProjectsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsShortQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsShortQuery, GetProjectsShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsShortQuery, GetProjectsShortQueryVariables>(GetProjectsShortDocument, options);
      }
export function useGetProjectsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsShortQuery, GetProjectsShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsShortQuery, GetProjectsShortQueryVariables>(GetProjectsShortDocument, options);
        }
// @ts-ignore
export function useGetProjectsShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsShortQuery, GetProjectsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsShortQuery, GetProjectsShortQueryVariables>;
export function useGetProjectsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsShortQuery, GetProjectsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsShortQuery | undefined, GetProjectsShortQueryVariables>;
export function useGetProjectsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsShortQuery, GetProjectsShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsShortQuery, GetProjectsShortQueryVariables>(GetProjectsShortDocument, options);
        }
export type GetProjectsShortQueryHookResult = ReturnType<typeof useGetProjectsShortQuery>;
export type GetProjectsShortLazyQueryHookResult = ReturnType<typeof useGetProjectsShortLazyQuery>;
export type GetProjectsShortSuspenseQueryHookResult = ReturnType<typeof useGetProjectsShortSuspenseQuery>;
export type GetProjectsShortQueryResult = Apollo.QueryResult<GetProjectsShortQuery, GetProjectsShortQueryVariables>;
export const GetRecentProjectCreationsDocument = gql`
    query getRecentProjectCreations($first: Int) {
  ProjectList(first: $first, order: {createdTime: DESC}) {
    nodes {
      id
      name
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRecentProjectCreationsQuery__
 *
 * To run a query within a React component, call `useGetRecentProjectCreationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentProjectCreationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentProjectCreationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRecentProjectCreationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>(GetRecentProjectCreationsDocument, options);
      }
export function useGetRecentProjectCreationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>(GetRecentProjectCreationsDocument, options);
        }
// @ts-ignore
export function useGetRecentProjectCreationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>;
export function useGetRecentProjectCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentProjectCreationsQuery | undefined, GetRecentProjectCreationsQueryVariables>;
export function useGetRecentProjectCreationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>(GetRecentProjectCreationsDocument, options);
        }
export type GetRecentProjectCreationsQueryHookResult = ReturnType<typeof useGetRecentProjectCreationsQuery>;
export type GetRecentProjectCreationsLazyQueryHookResult = ReturnType<typeof useGetRecentProjectCreationsLazyQuery>;
export type GetRecentProjectCreationsSuspenseQueryHookResult = ReturnType<typeof useGetRecentProjectCreationsSuspenseQuery>;
export type GetRecentProjectCreationsQueryResult = Apollo.QueryResult<GetRecentProjectCreationsQuery, GetRecentProjectCreationsQueryVariables>;
export const GetProjectsSummaryDocument = gql`
    query getProjectsSummary($tagIds: [String]) {
  ProjectList(first: 10000, tagIds: $tagIds) {
    nodes {
      id
      clientId
      client {
        id
        name
        isPrivate
        isAdmin
      }
    }
  }
}
    `;

/**
 * __useGetProjectsSummaryQuery__
 *
 * To run a query within a React component, call `useGetProjectsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsSummaryQuery({
 *   variables: {
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useGetProjectsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>(GetProjectsSummaryDocument, options);
      }
export function useGetProjectsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>(GetProjectsSummaryDocument, options);
        }
// @ts-ignore
export function useGetProjectsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>;
export function useGetProjectsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsSummaryQuery | undefined, GetProjectsSummaryQueryVariables>;
export function useGetProjectsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>(GetProjectsSummaryDocument, options);
        }
export type GetProjectsSummaryQueryHookResult = ReturnType<typeof useGetProjectsSummaryQuery>;
export type GetProjectsSummaryLazyQueryHookResult = ReturnType<typeof useGetProjectsSummaryLazyQuery>;
export type GetProjectsSummarySuspenseQueryHookResult = ReturnType<typeof useGetProjectsSummarySuspenseQuery>;
export type GetProjectsSummaryQueryResult = Apollo.QueryResult<GetProjectsSummaryQuery, GetProjectsSummaryQueryVariables>;
export const GetClientProjectsSummaryDocument = gql`
    query getClientProjectsSummary($clientId: String, $tagIds: [String]) {
  ProjectList(first: 10000, tagIds: $tagIds, where: {clientId: {eq: $clientId}}) {
    nodes {
      id
      libraryId
      library {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetClientProjectsSummaryQuery__
 *
 * To run a query within a React component, call `useGetClientProjectsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientProjectsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientProjectsSummaryQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useGetClientProjectsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>(GetClientProjectsSummaryDocument, options);
      }
export function useGetClientProjectsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>(GetClientProjectsSummaryDocument, options);
        }
// @ts-ignore
export function useGetClientProjectsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>;
export function useGetClientProjectsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientProjectsSummaryQuery | undefined, GetClientProjectsSummaryQueryVariables>;
export function useGetClientProjectsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>(GetClientProjectsSummaryDocument, options);
        }
export type GetClientProjectsSummaryQueryHookResult = ReturnType<typeof useGetClientProjectsSummaryQuery>;
export type GetClientProjectsSummaryLazyQueryHookResult = ReturnType<typeof useGetClientProjectsSummaryLazyQuery>;
export type GetClientProjectsSummarySuspenseQueryHookResult = ReturnType<typeof useGetClientProjectsSummarySuspenseQuery>;
export type GetClientProjectsSummaryQueryResult = Apollo.QueryResult<GetClientProjectsSummaryQuery, GetClientProjectsSummaryQueryVariables>;
export const GetAllProjectsDocument = gql`
    query getAllProjects($after: String, $tagIds: [String], $order: [ProjectSortInput!], $where: ProjectFilterInput) {
  ProjectList(tagIds: $tagIds, after: $after, order: $order, where: $where) {
    nodes {
      ...projectProps
      projectSubName
      clientId
      client {
        id
        name
      }
      libraryId
      library {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ProjectPropsFragmentDoc}`;

/**
 * __useGetAllProjectsQuery__
 *
 * To run a query within a React component, call `useGetAllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProjectsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      tagIds: // value for 'tagIds'
 *      order: // value for 'order'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
      }
export function useGetAllProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
        }
// @ts-ignore
export function useGetAllProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProjectsQuery, GetAllProjectsQueryVariables>;
export function useGetAllProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProjectsQuery | undefined, GetAllProjectsQueryVariables>;
export function useGetAllProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument, options);
        }
export type GetAllProjectsQueryHookResult = ReturnType<typeof useGetAllProjectsQuery>;
export type GetAllProjectsLazyQueryHookResult = ReturnType<typeof useGetAllProjectsLazyQuery>;
export type GetAllProjectsSuspenseQueryHookResult = ReturnType<typeof useGetAllProjectsSuspenseQuery>;
export type GetAllProjectsQueryResult = Apollo.QueryResult<GetAllProjectsQuery, GetAllProjectsQueryVariables>;
export const GetProjectDocument = gql`
    query getProject($id: String) {
  Project(id: $id) {
    ...projectProps
    worksets {
      id
      name
      group
      description
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
    clientId
    client {
      id
      name
    }
    libraryId
    library {
      id
      name
    }
    projectSubName
    approvedContentIds
    approvedContents {
      id
      name
      thumbnail {
        downloadUrl
      }
      tagIds
      tags {
        id
        name
        type
      }
    }
  }
}
    ${ProjectPropsFragmentDoc}`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
// @ts-ignore
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery | undefined, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectDynamicDataDocument = gql`
    query getProjectDynamicData($id: String) {
  Project(id: $id) {
    dynamicData {
      id
      name
      type
      data
    }
  }
}
    `;

/**
 * __useGetProjectDynamicDataQuery__
 *
 * To run a query within a React component, call `useGetProjectDynamicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDynamicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDynamicDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectDynamicDataQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>(GetProjectDynamicDataDocument, options);
      }
export function useGetProjectDynamicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>(GetProjectDynamicDataDocument, options);
        }
// @ts-ignore
export function useGetProjectDynamicDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>;
export function useGetProjectDynamicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDynamicDataQuery | undefined, GetProjectDynamicDataQueryVariables>;
export function useGetProjectDynamicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>(GetProjectDynamicDataDocument, options);
        }
export type GetProjectDynamicDataQueryHookResult = ReturnType<typeof useGetProjectDynamicDataQuery>;
export type GetProjectDynamicDataLazyQueryHookResult = ReturnType<typeof useGetProjectDynamicDataLazyQuery>;
export type GetProjectDynamicDataSuspenseQueryHookResult = ReturnType<typeof useGetProjectDynamicDataSuspenseQuery>;
export type GetProjectDynamicDataQueryResult = Apollo.QueryResult<GetProjectDynamicDataQuery, GetProjectDynamicDataQueryVariables>;
export const GetProjectReportDynamicDataDocument = gql`
    query getProjectReportDynamicData($id: String) {
  Project(id: $id) {
    dynamicData {
      id
      name
      type
      data
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetProjectReportDynamicDataQuery__
 *
 * To run a query within a React component, call `useGetProjectReportDynamicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectReportDynamicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectReportDynamicDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectReportDynamicDataQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>(GetProjectReportDynamicDataDocument, options);
      }
export function useGetProjectReportDynamicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>(GetProjectReportDynamicDataDocument, options);
        }
// @ts-ignore
export function useGetProjectReportDynamicDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>;
export function useGetProjectReportDynamicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectReportDynamicDataQuery | undefined, GetProjectReportDynamicDataQueryVariables>;
export function useGetProjectReportDynamicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>(GetProjectReportDynamicDataDocument, options);
        }
export type GetProjectReportDynamicDataQueryHookResult = ReturnType<typeof useGetProjectReportDynamicDataQuery>;
export type GetProjectReportDynamicDataLazyQueryHookResult = ReturnType<typeof useGetProjectReportDynamicDataLazyQuery>;
export type GetProjectReportDynamicDataSuspenseQueryHookResult = ReturnType<typeof useGetProjectReportDynamicDataSuspenseQuery>;
export type GetProjectReportDynamicDataQueryResult = Apollo.QueryResult<GetProjectReportDynamicDataQuery, GetProjectReportDynamicDataQueryVariables>;
export const GetMyRequestsDocument = gql`
    query GetMyRequests($state: RequestStateEnum, $discipline: DisciplineEnum, $after: String, $where: ContentVersionFilterInput, $order: [ContentVersionSortInput!]) {
  MyRequests(
    state: $state
    discipline: $discipline
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...RequestProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${RequestPropsFragmentDoc}`;

/**
 * __useGetMyRequestsQuery__
 *
 * To run a query within a React component, call `useGetMyRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRequestsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetMyRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRequestsQuery, GetMyRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRequestsQuery, GetMyRequestsQueryVariables>(GetMyRequestsDocument, options);
      }
export function useGetMyRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRequestsQuery, GetMyRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRequestsQuery, GetMyRequestsQueryVariables>(GetMyRequestsDocument, options);
        }
// @ts-ignore
export function useGetMyRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyRequestsQuery, GetMyRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyRequestsQuery, GetMyRequestsQueryVariables>;
export function useGetMyRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRequestsQuery, GetMyRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyRequestsQuery | undefined, GetMyRequestsQueryVariables>;
export function useGetMyRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRequestsQuery, GetMyRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRequestsQuery, GetMyRequestsQueryVariables>(GetMyRequestsDocument, options);
        }
export type GetMyRequestsQueryHookResult = ReturnType<typeof useGetMyRequestsQuery>;
export type GetMyRequestsLazyQueryHookResult = ReturnType<typeof useGetMyRequestsLazyQuery>;
export type GetMyRequestsSuspenseQueryHookResult = ReturnType<typeof useGetMyRequestsSuspenseQuery>;
export type GetMyRequestsQueryResult = Apollo.QueryResult<GetMyRequestsQuery, GetMyRequestsQueryVariables>;
export const GetAssignedRequestsDocument = gql`
    query GetAssignedRequests($state: RequestStateEnum, $discipline: DisciplineEnum, $after: String, $where: ContentVersionFilterInput, $order: [ContentVersionSortInput!]) {
  AssignedRequests(
    state: $state
    discipline: $discipline
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...RequestProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${RequestPropsFragmentDoc}`;

/**
 * __useGetAssignedRequestsQuery__
 *
 * To run a query within a React component, call `useGetAssignedRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedRequestsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetAssignedRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>(GetAssignedRequestsDocument, options);
      }
export function useGetAssignedRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>(GetAssignedRequestsDocument, options);
        }
// @ts-ignore
export function useGetAssignedRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>;
export function useGetAssignedRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignedRequestsQuery | undefined, GetAssignedRequestsQueryVariables>;
export function useGetAssignedRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>(GetAssignedRequestsDocument, options);
        }
export type GetAssignedRequestsQueryHookResult = ReturnType<typeof useGetAssignedRequestsQuery>;
export type GetAssignedRequestsLazyQueryHookResult = ReturnType<typeof useGetAssignedRequestsLazyQuery>;
export type GetAssignedRequestsSuspenseQueryHookResult = ReturnType<typeof useGetAssignedRequestsSuspenseQuery>;
export type GetAssignedRequestsQueryResult = Apollo.QueryResult<GetAssignedRequestsQuery, GetAssignedRequestsQueryVariables>;
export const GetNeedActionRequestsDocument = gql`
    query GetNeedActionRequests($status: RequestStatusEnum, $discipline: DisciplineEnum, $after: String, $order: [ContentVersionSortInput!]) {
  NeedActionRequests(
    status: $status
    discipline: $discipline
    after: $after
    order: $order
  ) {
    nodes {
      ...RequestProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${RequestPropsFragmentDoc}`;

/**
 * __useGetNeedActionRequestsQuery__
 *
 * To run a query within a React component, call `useGetNeedActionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNeedActionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNeedActionRequestsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      discipline: // value for 'discipline'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetNeedActionRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>(GetNeedActionRequestsDocument, options);
      }
export function useGetNeedActionRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>(GetNeedActionRequestsDocument, options);
        }
// @ts-ignore
export function useGetNeedActionRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>;
export function useGetNeedActionRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNeedActionRequestsQuery | undefined, GetNeedActionRequestsQueryVariables>;
export function useGetNeedActionRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>(GetNeedActionRequestsDocument, options);
        }
export type GetNeedActionRequestsQueryHookResult = ReturnType<typeof useGetNeedActionRequestsQuery>;
export type GetNeedActionRequestsLazyQueryHookResult = ReturnType<typeof useGetNeedActionRequestsLazyQuery>;
export type GetNeedActionRequestsSuspenseQueryHookResult = ReturnType<typeof useGetNeedActionRequestsSuspenseQuery>;
export type GetNeedActionRequestsQueryResult = Apollo.QueryResult<GetNeedActionRequestsQuery, GetNeedActionRequestsQueryVariables>;
export const GetPendingRequestsDocument = gql`
    query GetPendingRequests($state: RequestStateEnum, $discipline: DisciplineEnum, $after: String, $where: ContentVersionFilterInput, $order: [ContentVersionSortInput!]) {
  PendingRequests(
    state: $state
    discipline: $discipline
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...RequestProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${RequestPropsFragmentDoc}`;

/**
 * __useGetPendingRequestsQuery__
 *
 * To run a query within a React component, call `useGetPendingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingRequestsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetPendingRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>(GetPendingRequestsDocument, options);
      }
export function useGetPendingRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>(GetPendingRequestsDocument, options);
        }
// @ts-ignore
export function useGetPendingRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>;
export function useGetPendingRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingRequestsQuery | undefined, GetPendingRequestsQueryVariables>;
export function useGetPendingRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>(GetPendingRequestsDocument, options);
        }
export type GetPendingRequestsQueryHookResult = ReturnType<typeof useGetPendingRequestsQuery>;
export type GetPendingRequestsLazyQueryHookResult = ReturnType<typeof useGetPendingRequestsLazyQuery>;
export type GetPendingRequestsSuspenseQueryHookResult = ReturnType<typeof useGetPendingRequestsSuspenseQuery>;
export type GetPendingRequestsQueryResult = Apollo.QueryResult<GetPendingRequestsQuery, GetPendingRequestsQueryVariables>;
export const GetRequestsDocument = gql`
    query GetRequests($state: RequestStateEnum, $discipline: DisciplineEnum, $after: String, $where: ContentVersionFilterInput, $order: [ContentVersionSortInput!]) {
  Requests(
    state: $state
    discipline: $discipline
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...RequestProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${RequestPropsFragmentDoc}`;

/**
 * __useGetRequestsQuery__
 *
 * To run a query within a React component, call `useGetRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestsQuery, GetRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestsQuery, GetRequestsQueryVariables>(GetRequestsDocument, options);
      }
export function useGetRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestsQuery, GetRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestsQuery, GetRequestsQueryVariables>(GetRequestsDocument, options);
        }
// @ts-ignore
export function useGetRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestsQuery, GetRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestsQuery, GetRequestsQueryVariables>;
export function useGetRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestsQuery, GetRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestsQuery | undefined, GetRequestsQueryVariables>;
export function useGetRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestsQuery, GetRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestsQuery, GetRequestsQueryVariables>(GetRequestsDocument, options);
        }
export type GetRequestsQueryHookResult = ReturnType<typeof useGetRequestsQuery>;
export type GetRequestsLazyQueryHookResult = ReturnType<typeof useGetRequestsLazyQuery>;
export type GetRequestsSuspenseQueryHookResult = ReturnType<typeof useGetRequestsSuspenseQuery>;
export type GetRequestsQueryResult = Apollo.QueryResult<GetRequestsQuery, GetRequestsQueryVariables>;
export const GetPendingRequestsLibrarySummaryDocument = gql`
    query GetPendingRequestsLibrarySummary($discipline: DisciplineEnum) {
  PendingRequests(first: 10000, discipline: $discipline) {
    nodes {
      clientId
      libraryId
      client {
        name
      }
      library {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPendingRequestsLibrarySummaryQuery__
 *
 * To run a query within a React component, call `useGetPendingRequestsLibrarySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingRequestsLibrarySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingRequestsLibrarySummaryQuery({
 *   variables: {
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useGetPendingRequestsLibrarySummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>(GetPendingRequestsLibrarySummaryDocument, options);
      }
export function useGetPendingRequestsLibrarySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>(GetPendingRequestsLibrarySummaryDocument, options);
        }
// @ts-ignore
export function useGetPendingRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>;
export function useGetPendingRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingRequestsLibrarySummaryQuery | undefined, GetPendingRequestsLibrarySummaryQueryVariables>;
export function useGetPendingRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>(GetPendingRequestsLibrarySummaryDocument, options);
        }
export type GetPendingRequestsLibrarySummaryQueryHookResult = ReturnType<typeof useGetPendingRequestsLibrarySummaryQuery>;
export type GetPendingRequestsLibrarySummaryLazyQueryHookResult = ReturnType<typeof useGetPendingRequestsLibrarySummaryLazyQuery>;
export type GetPendingRequestsLibrarySummarySuspenseQueryHookResult = ReturnType<typeof useGetPendingRequestsLibrarySummarySuspenseQuery>;
export type GetPendingRequestsLibrarySummaryQueryResult = Apollo.QueryResult<GetPendingRequestsLibrarySummaryQuery, GetPendingRequestsLibrarySummaryQueryVariables>;
export const GetMyRequestsLibrarySummaryDocument = gql`
    query GetMyRequestsLibrarySummary($state: RequestStateEnum, $discipline: DisciplineEnum) {
  MyRequests(first: 10000, state: $state, discipline: $discipline) {
    nodes {
      clientId
      libraryId
      client {
        name
      }
      library {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetMyRequestsLibrarySummaryQuery__
 *
 * To run a query within a React component, call `useGetMyRequestsLibrarySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRequestsLibrarySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRequestsLibrarySummaryQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useGetMyRequestsLibrarySummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>(GetMyRequestsLibrarySummaryDocument, options);
      }
export function useGetMyRequestsLibrarySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>(GetMyRequestsLibrarySummaryDocument, options);
        }
// @ts-ignore
export function useGetMyRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>;
export function useGetMyRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyRequestsLibrarySummaryQuery | undefined, GetMyRequestsLibrarySummaryQueryVariables>;
export function useGetMyRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>(GetMyRequestsLibrarySummaryDocument, options);
        }
export type GetMyRequestsLibrarySummaryQueryHookResult = ReturnType<typeof useGetMyRequestsLibrarySummaryQuery>;
export type GetMyRequestsLibrarySummaryLazyQueryHookResult = ReturnType<typeof useGetMyRequestsLibrarySummaryLazyQuery>;
export type GetMyRequestsLibrarySummarySuspenseQueryHookResult = ReturnType<typeof useGetMyRequestsLibrarySummarySuspenseQuery>;
export type GetMyRequestsLibrarySummaryQueryResult = Apollo.QueryResult<GetMyRequestsLibrarySummaryQuery, GetMyRequestsLibrarySummaryQueryVariables>;
export const GetAssignedRequestsLibrarySummaryDocument = gql`
    query GetAssignedRequestsLibrarySummary($state: RequestStateEnum, $discipline: DisciplineEnum) {
  AssignedRequests(first: 10000, state: $state, discipline: $discipline) {
    nodes {
      clientId
      libraryId
      client {
        name
      }
      library {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAssignedRequestsLibrarySummaryQuery__
 *
 * To run a query within a React component, call `useGetAssignedRequestsLibrarySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedRequestsLibrarySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedRequestsLibrarySummaryQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useGetAssignedRequestsLibrarySummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>(GetAssignedRequestsLibrarySummaryDocument, options);
      }
export function useGetAssignedRequestsLibrarySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>(GetAssignedRequestsLibrarySummaryDocument, options);
        }
// @ts-ignore
export function useGetAssignedRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>;
export function useGetAssignedRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignedRequestsLibrarySummaryQuery | undefined, GetAssignedRequestsLibrarySummaryQueryVariables>;
export function useGetAssignedRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>(GetAssignedRequestsLibrarySummaryDocument, options);
        }
export type GetAssignedRequestsLibrarySummaryQueryHookResult = ReturnType<typeof useGetAssignedRequestsLibrarySummaryQuery>;
export type GetAssignedRequestsLibrarySummaryLazyQueryHookResult = ReturnType<typeof useGetAssignedRequestsLibrarySummaryLazyQuery>;
export type GetAssignedRequestsLibrarySummarySuspenseQueryHookResult = ReturnType<typeof useGetAssignedRequestsLibrarySummarySuspenseQuery>;
export type GetAssignedRequestsLibrarySummaryQueryResult = Apollo.QueryResult<GetAssignedRequestsLibrarySummaryQuery, GetAssignedRequestsLibrarySummaryQueryVariables>;
export const GetRequestsLibrarySummaryDocument = gql`
    query GetRequestsLibrarySummary($state: RequestStateEnum, $discipline: DisciplineEnum) {
  Requests(first: 10000, state: $state, discipline: $discipline) {
    nodes {
      clientId
      libraryId
      client {
        name
      }
      library {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRequestsLibrarySummaryQuery__
 *
 * To run a query within a React component, call `useGetRequestsLibrarySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsLibrarySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsLibrarySummaryQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useGetRequestsLibrarySummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>(GetRequestsLibrarySummaryDocument, options);
      }
export function useGetRequestsLibrarySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>(GetRequestsLibrarySummaryDocument, options);
        }
// @ts-ignore
export function useGetRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>;
export function useGetRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestsLibrarySummaryQuery | undefined, GetRequestsLibrarySummaryQueryVariables>;
export function useGetRequestsLibrarySummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>(GetRequestsLibrarySummaryDocument, options);
        }
export type GetRequestsLibrarySummaryQueryHookResult = ReturnType<typeof useGetRequestsLibrarySummaryQuery>;
export type GetRequestsLibrarySummaryLazyQueryHookResult = ReturnType<typeof useGetRequestsLibrarySummaryLazyQuery>;
export type GetRequestsLibrarySummarySuspenseQueryHookResult = ReturnType<typeof useGetRequestsLibrarySummarySuspenseQuery>;
export type GetRequestsLibrarySummaryQueryResult = Apollo.QueryResult<GetRequestsLibrarySummaryQuery, GetRequestsLibrarySummaryQueryVariables>;
export const GetRequestsShortDocument = gql`
    query GetRequestsShort($state: RequestStateEnum, $discipline: DisciplineEnum, $isUpdatedTime: Boolean, $isAscending: Boolean) {
  Requests(
    first: 100
    state: $state
    discipline: $discipline
    isUpdatedTime: $isUpdatedTime
    isAscending: $isAscending
  ) {
    nodes {
      status
      updatedTime
      createdTime
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetRequestsShortQuery__
 *
 * To run a query within a React component, call `useGetRequestsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsShortQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *      isUpdatedTime: // value for 'isUpdatedTime'
 *      isAscending: // value for 'isAscending'
 *   },
 * });
 */
export function useGetRequestsShortQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestsShortQuery, GetRequestsShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestsShortQuery, GetRequestsShortQueryVariables>(GetRequestsShortDocument, options);
      }
export function useGetRequestsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestsShortQuery, GetRequestsShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestsShortQuery, GetRequestsShortQueryVariables>(GetRequestsShortDocument, options);
        }
// @ts-ignore
export function useGetRequestsShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestsShortQuery, GetRequestsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestsShortQuery, GetRequestsShortQueryVariables>;
export function useGetRequestsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestsShortQuery, GetRequestsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestsShortQuery | undefined, GetRequestsShortQueryVariables>;
export function useGetRequestsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestsShortQuery, GetRequestsShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestsShortQuery, GetRequestsShortQueryVariables>(GetRequestsShortDocument, options);
        }
export type GetRequestsShortQueryHookResult = ReturnType<typeof useGetRequestsShortQuery>;
export type GetRequestsShortLazyQueryHookResult = ReturnType<typeof useGetRequestsShortLazyQuery>;
export type GetRequestsShortSuspenseQueryHookResult = ReturnType<typeof useGetRequestsShortSuspenseQuery>;
export type GetRequestsShortQueryResult = Apollo.QueryResult<GetRequestsShortQuery, GetRequestsShortQueryVariables>;
export const GetPendingRequestsShortDocument = gql`
    query GetPendingRequestsShort($state: RequestStateEnum, $discipline: DisciplineEnum, $isUpdatedTime: Boolean, $isAscending: Boolean) {
  PendingRequests(
    first: 100
    state: $state
    discipline: $discipline
    isUpdatedTime: $isUpdatedTime
    isAscending: $isAscending
  ) {
    nodes {
      status
      updatedTime
      createdTime
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetPendingRequestsShortQuery__
 *
 * To run a query within a React component, call `useGetPendingRequestsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingRequestsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingRequestsShortQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *      isUpdatedTime: // value for 'isUpdatedTime'
 *      isAscending: // value for 'isAscending'
 *   },
 * });
 */
export function useGetPendingRequestsShortQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>(GetPendingRequestsShortDocument, options);
      }
export function useGetPendingRequestsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>(GetPendingRequestsShortDocument, options);
        }
// @ts-ignore
export function useGetPendingRequestsShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>;
export function useGetPendingRequestsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingRequestsShortQuery | undefined, GetPendingRequestsShortQueryVariables>;
export function useGetPendingRequestsShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>(GetPendingRequestsShortDocument, options);
        }
export type GetPendingRequestsShortQueryHookResult = ReturnType<typeof useGetPendingRequestsShortQuery>;
export type GetPendingRequestsShortLazyQueryHookResult = ReturnType<typeof useGetPendingRequestsShortLazyQuery>;
export type GetPendingRequestsShortSuspenseQueryHookResult = ReturnType<typeof useGetPendingRequestsShortSuspenseQuery>;
export type GetPendingRequestsShortQueryResult = Apollo.QueryResult<GetPendingRequestsShortQuery, GetPendingRequestsShortQueryVariables>;
export const GetRequestDocument = gql`
    query GetRequest($id: String) {
  ContentVersion(id: $id) {
    ...RequestProps
  }
}
    ${RequestPropsFragmentDoc}`;

/**
 * __useGetRequestQuery__
 *
 * To run a query within a React component, call `useGetRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequestQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestQuery, GetRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
      }
export function useGetRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestQuery, GetRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
        }
// @ts-ignore
export function useGetRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestQuery, GetRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestQuery, GetRequestQueryVariables>;
export function useGetRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestQuery, GetRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestQuery | undefined, GetRequestQueryVariables>;
export function useGetRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestQuery, GetRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestQuery, GetRequestQueryVariables>(GetRequestDocument, options);
        }
export type GetRequestQueryHookResult = ReturnType<typeof useGetRequestQuery>;
export type GetRequestLazyQueryHookResult = ReturnType<typeof useGetRequestLazyQuery>;
export type GetRequestSuspenseQueryHookResult = ReturnType<typeof useGetRequestSuspenseQuery>;
export type GetRequestQueryResult = Apollo.QueryResult<GetRequestQuery, GetRequestQueryVariables>;
export const RequestsCountDocument = gql`
    query RequestsCount($state: RequestStateEnum, $discipline: DisciplineEnum) {
  RequestsCount(state: $state, discipline: $discipline)
}
    `;

/**
 * __useRequestsCountQuery__
 *
 * To run a query within a React component, call `useRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsCountQuery({
 *   variables: {
 *      state: // value for 'state'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useRequestsCountQuery(baseOptions?: Apollo.QueryHookOptions<RequestsCountQuery, RequestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestsCountQuery, RequestsCountQueryVariables>(RequestsCountDocument, options);
      }
export function useRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestsCountQuery, RequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestsCountQuery, RequestsCountQueryVariables>(RequestsCountDocument, options);
        }
// @ts-ignore
export function useRequestsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestsCountQuery, RequestsCountQueryVariables>): Apollo.UseSuspenseQueryResult<RequestsCountQuery, RequestsCountQueryVariables>;
export function useRequestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestsCountQuery, RequestsCountQueryVariables>): Apollo.UseSuspenseQueryResult<RequestsCountQuery | undefined, RequestsCountQueryVariables>;
export function useRequestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestsCountQuery, RequestsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestsCountQuery, RequestsCountQueryVariables>(RequestsCountDocument, options);
        }
export type RequestsCountQueryHookResult = ReturnType<typeof useRequestsCountQuery>;
export type RequestsCountLazyQueryHookResult = ReturnType<typeof useRequestsCountLazyQuery>;
export type RequestsCountSuspenseQueryHookResult = ReturnType<typeof useRequestsCountSuspenseQuery>;
export type RequestsCountQueryResult = Apollo.QueryResult<RequestsCountQuery, RequestsCountQueryVariables>;
export const PendingRequestsCountDocument = gql`
    query PendingRequestsCount {
  PendingRequestsCount
}
    `;

/**
 * __usePendingRequestsCountQuery__
 *
 * To run a query within a React component, call `usePendingRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingRequestsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingRequestsCountQuery(baseOptions?: Apollo.QueryHookOptions<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>(PendingRequestsCountDocument, options);
      }
export function usePendingRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>(PendingRequestsCountDocument, options);
        }
// @ts-ignore
export function usePendingRequestsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>): Apollo.UseSuspenseQueryResult<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>;
export function usePendingRequestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>): Apollo.UseSuspenseQueryResult<PendingRequestsCountQuery | undefined, PendingRequestsCountQueryVariables>;
export function usePendingRequestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>(PendingRequestsCountDocument, options);
        }
export type PendingRequestsCountQueryHookResult = ReturnType<typeof usePendingRequestsCountQuery>;
export type PendingRequestsCountLazyQueryHookResult = ReturnType<typeof usePendingRequestsCountLazyQuery>;
export type PendingRequestsCountSuspenseQueryHookResult = ReturnType<typeof usePendingRequestsCountSuspenseQuery>;
export type PendingRequestsCountQueryResult = Apollo.QueryResult<PendingRequestsCountQuery, PendingRequestsCountQueryVariables>;
export const GetRequestHistoriesDocument = gql`
    query GetRequestHistories($id: String) {
  ContentVersion(id: $id) {
    histories {
      id
      name
      message
      createdTime
      createdBy {
        name
        email
      }
      attachmentDownloadUrl
      attachment {
        id
        name
        extension
        downloadUrl
      }
    }
  }
}
    `;

/**
 * __useGetRequestHistoriesQuery__
 *
 * To run a query within a React component, call `useGetRequestHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestHistoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequestHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>(GetRequestHistoriesDocument, options);
      }
export function useGetRequestHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>(GetRequestHistoriesDocument, options);
        }
// @ts-ignore
export function useGetRequestHistoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>;
export function useGetRequestHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestHistoriesQuery | undefined, GetRequestHistoriesQueryVariables>;
export function useGetRequestHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>(GetRequestHistoriesDocument, options);
        }
export type GetRequestHistoriesQueryHookResult = ReturnType<typeof useGetRequestHistoriesQuery>;
export type GetRequestHistoriesLazyQueryHookResult = ReturnType<typeof useGetRequestHistoriesLazyQuery>;
export type GetRequestHistoriesSuspenseQueryHookResult = ReturnType<typeof useGetRequestHistoriesSuspenseQuery>;
export type GetRequestHistoriesQueryResult = Apollo.QueryResult<GetRequestHistoriesQuery, GetRequestHistoriesQueryVariables>;
export const SetRequestDocument = gql`
    mutation SetRequest($request: CreateContentRequestInput, $file: Upload, $message: String) {
  Request(request: $request, file: $file, message: $message)
}
    `;
export type SetRequestMutationFn = Apollo.MutationFunction<SetRequestMutation, SetRequestMutationVariables>;

/**
 * __useSetRequestMutation__
 *
 * To run a mutation, you first call `useSetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRequestMutation, { data, loading, error }] = useSetRequestMutation({
 *   variables: {
 *      request: // value for 'request'
 *      file: // value for 'file'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSetRequestMutation(baseOptions?: Apollo.MutationHookOptions<SetRequestMutation, SetRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRequestMutation, SetRequestMutationVariables>(SetRequestDocument, options);
      }
export type SetRequestMutationHookResult = ReturnType<typeof useSetRequestMutation>;
export type SetRequestMutationResult = Apollo.MutationResult<SetRequestMutation>;
export type SetRequestMutationOptions = Apollo.BaseMutationOptions<SetRequestMutation, SetRequestMutationVariables>;
export const EditContentRequestDocument = gql`
    mutation EditContentRequest($id: String!, $request: EditContentRequestInput, $file: Upload, $message: String) {
  EditRequest(id: $id, request: $request, file: $file, message: $message)
}
    `;
export type EditContentRequestMutationFn = Apollo.MutationFunction<EditContentRequestMutation, EditContentRequestMutationVariables>;

/**
 * __useEditContentRequestMutation__
 *
 * To run a mutation, you first call `useEditContentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContentRequestMutation, { data, loading, error }] = useEditContentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      request: // value for 'request'
 *      file: // value for 'file'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useEditContentRequestMutation(baseOptions?: Apollo.MutationHookOptions<EditContentRequestMutation, EditContentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditContentRequestMutation, EditContentRequestMutationVariables>(EditContentRequestDocument, options);
      }
export type EditContentRequestMutationHookResult = ReturnType<typeof useEditContentRequestMutation>;
export type EditContentRequestMutationResult = Apollo.MutationResult<EditContentRequestMutation>;
export type EditContentRequestMutationOptions = Apollo.BaseMutationOptions<EditContentRequestMutation, EditContentRequestMutationVariables>;
export const ReassignRequestDocument = gql`
    mutation ReassignRequest($id: String!, $assignedToId: String!, $message: String) {
  ReassignRequest(id: $id, assignedToId: $assignedToId, message: $message)
}
    `;
export type ReassignRequestMutationFn = Apollo.MutationFunction<ReassignRequestMutation, ReassignRequestMutationVariables>;

/**
 * __useReassignRequestMutation__
 *
 * To run a mutation, you first call `useReassignRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignRequestMutation, { data, loading, error }] = useReassignRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assignedToId: // value for 'assignedToId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useReassignRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReassignRequestMutation, ReassignRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignRequestMutation, ReassignRequestMutationVariables>(ReassignRequestDocument, options);
      }
export type ReassignRequestMutationHookResult = ReturnType<typeof useReassignRequestMutation>;
export type ReassignRequestMutationResult = Apollo.MutationResult<ReassignRequestMutation>;
export type ReassignRequestMutationOptions = Apollo.BaseMutationOptions<ReassignRequestMutation, ReassignRequestMutationVariables>;
export const TakeOwnershipDocument = gql`
    mutation TakeOwnership($id: String!, $message: String) {
  TakeOwnership(id: $id, message: $message)
}
    `;
export type TakeOwnershipMutationFn = Apollo.MutationFunction<TakeOwnershipMutation, TakeOwnershipMutationVariables>;

/**
 * __useTakeOwnershipMutation__
 *
 * To run a mutation, you first call `useTakeOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeOwnershipMutation, { data, loading, error }] = useTakeOwnershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useTakeOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TakeOwnershipMutation, TakeOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TakeOwnershipMutation, TakeOwnershipMutationVariables>(TakeOwnershipDocument, options);
      }
export type TakeOwnershipMutationHookResult = ReturnType<typeof useTakeOwnershipMutation>;
export type TakeOwnershipMutationResult = Apollo.MutationResult<TakeOwnershipMutation>;
export type TakeOwnershipMutationOptions = Apollo.BaseMutationOptions<TakeOwnershipMutation, TakeOwnershipMutationVariables>;
export const CloseRequestDocument = gql`
    mutation CloseRequest($id: String!, $input: CloseContentRequestInput!) {
  CloseRequest(id: $id, input: $input)
}
    `;
export type CloseRequestMutationFn = Apollo.MutationFunction<CloseRequestMutation, CloseRequestMutationVariables>;

/**
 * __useCloseRequestMutation__
 *
 * To run a mutation, you first call `useCloseRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeRequestMutation, { data, loading, error }] = useCloseRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseRequestMutation(baseOptions?: Apollo.MutationHookOptions<CloseRequestMutation, CloseRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseRequestMutation, CloseRequestMutationVariables>(CloseRequestDocument, options);
      }
export type CloseRequestMutationHookResult = ReturnType<typeof useCloseRequestMutation>;
export type CloseRequestMutationResult = Apollo.MutationResult<CloseRequestMutation>;
export type CloseRequestMutationOptions = Apollo.BaseMutationOptions<CloseRequestMutation, CloseRequestMutationVariables>;
export const VerifyRequestDocument = gql`
    mutation VerifyRequest($id: String, $message: String) {
  VerifyRequest(id: $id, message: $message)
}
    `;
export type VerifyRequestMutationFn = Apollo.MutationFunction<VerifyRequestMutation, VerifyRequestMutationVariables>;

/**
 * __useVerifyRequestMutation__
 *
 * To run a mutation, you first call `useVerifyRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyRequestMutation, { data, loading, error }] = useVerifyRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useVerifyRequestMutation(baseOptions?: Apollo.MutationHookOptions<VerifyRequestMutation, VerifyRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyRequestMutation, VerifyRequestMutationVariables>(VerifyRequestDocument, options);
      }
export type VerifyRequestMutationHookResult = ReturnType<typeof useVerifyRequestMutation>;
export type VerifyRequestMutationResult = Apollo.MutationResult<VerifyRequestMutation>;
export type VerifyRequestMutationOptions = Apollo.BaseMutationOptions<VerifyRequestMutation, VerifyRequestMutationVariables>;
export const AssignResourceToRequestDocument = gql`
    mutation AssignResourceToRequest($id: String, $message: String, $modeller: UserInput) {
  AssignResourceToRequest(id: $id, message: $message, modeller: $modeller)
}
    `;
export type AssignResourceToRequestMutationFn = Apollo.MutationFunction<AssignResourceToRequestMutation, AssignResourceToRequestMutationVariables>;

/**
 * __useAssignResourceToRequestMutation__
 *
 * To run a mutation, you first call `useAssignResourceToRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignResourceToRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignResourceToRequestMutation, { data, loading, error }] = useAssignResourceToRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *      modeller: // value for 'modeller'
 *   },
 * });
 */
export function useAssignResourceToRequestMutation(baseOptions?: Apollo.MutationHookOptions<AssignResourceToRequestMutation, AssignResourceToRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignResourceToRequestMutation, AssignResourceToRequestMutationVariables>(AssignResourceToRequestDocument, options);
      }
export type AssignResourceToRequestMutationHookResult = ReturnType<typeof useAssignResourceToRequestMutation>;
export type AssignResourceToRequestMutationResult = Apollo.MutationResult<AssignResourceToRequestMutation>;
export type AssignResourceToRequestMutationOptions = Apollo.BaseMutationOptions<AssignResourceToRequestMutation, AssignResourceToRequestMutationVariables>;
export const UploadAttachmentToRequestDocument = gql`
    mutation UploadAttachmentToRequest($id: String, $message: String, $file: Upload) {
  UploadAttachmentToRequest(id: $id, message: $message, file: $file)
}
    `;
export type UploadAttachmentToRequestMutationFn = Apollo.MutationFunction<UploadAttachmentToRequestMutation, UploadAttachmentToRequestMutationVariables>;

/**
 * __useUploadAttachmentToRequestMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentToRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentToRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentToRequestMutation, { data, loading, error }] = useUploadAttachmentToRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAttachmentToRequestMutation(baseOptions?: Apollo.MutationHookOptions<UploadAttachmentToRequestMutation, UploadAttachmentToRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAttachmentToRequestMutation, UploadAttachmentToRequestMutationVariables>(UploadAttachmentToRequestDocument, options);
      }
export type UploadAttachmentToRequestMutationHookResult = ReturnType<typeof useUploadAttachmentToRequestMutation>;
export type UploadAttachmentToRequestMutationResult = Apollo.MutationResult<UploadAttachmentToRequestMutation>;
export type UploadAttachmentToRequestMutationOptions = Apollo.BaseMutationOptions<UploadAttachmentToRequestMutation, UploadAttachmentToRequestMutationVariables>;
export const FinalReviewRequestDocument = gql`
    mutation FinalReviewRequest($id: String, $message: String) {
  FinalReviewRequest(id: $id, message: $message)
}
    `;
export type FinalReviewRequestMutationFn = Apollo.MutationFunction<FinalReviewRequestMutation, FinalReviewRequestMutationVariables>;

/**
 * __useFinalReviewRequestMutation__
 *
 * To run a mutation, you first call `useFinalReviewRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalReviewRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalReviewRequestMutation, { data, loading, error }] = useFinalReviewRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useFinalReviewRequestMutation(baseOptions?: Apollo.MutationHookOptions<FinalReviewRequestMutation, FinalReviewRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalReviewRequestMutation, FinalReviewRequestMutationVariables>(FinalReviewRequestDocument, options);
      }
export type FinalReviewRequestMutationHookResult = ReturnType<typeof useFinalReviewRequestMutation>;
export type FinalReviewRequestMutationResult = Apollo.MutationResult<FinalReviewRequestMutation>;
export type FinalReviewRequestMutationOptions = Apollo.BaseMutationOptions<FinalReviewRequestMutation, FinalReviewRequestMutationVariables>;
export const MarkDevelopedDocument = gql`
    mutation MarkDeveloped($id: String, $message: String) {
  MarkDeveloped(id: $id, message: $message)
}
    `;
export type MarkDevelopedMutationFn = Apollo.MutationFunction<MarkDevelopedMutation, MarkDevelopedMutationVariables>;

/**
 * __useMarkDevelopedMutation__
 *
 * To run a mutation, you first call `useMarkDevelopedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDevelopedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDevelopedMutation, { data, loading, error }] = useMarkDevelopedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useMarkDevelopedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDevelopedMutation, MarkDevelopedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDevelopedMutation, MarkDevelopedMutationVariables>(MarkDevelopedDocument, options);
      }
export type MarkDevelopedMutationHookResult = ReturnType<typeof useMarkDevelopedMutation>;
export type MarkDevelopedMutationResult = Apollo.MutationResult<MarkDevelopedMutation>;
export type MarkDevelopedMutationOptions = Apollo.BaseMutationOptions<MarkDevelopedMutation, MarkDevelopedMutationVariables>;
export const RejectRequestDocument = gql`
    mutation RejectRequest($id: String, $message: String) {
  RejectRequest(id: $id, message: $message)
}
    `;
export type RejectRequestMutationFn = Apollo.MutationFunction<RejectRequestMutation, RejectRequestMutationVariables>;

/**
 * __useRejectRequestMutation__
 *
 * To run a mutation, you first call `useRejectRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestMutation, { data, loading, error }] = useRejectRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRejectRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectRequestMutation, RejectRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectRequestMutation, RejectRequestMutationVariables>(RejectRequestDocument, options);
      }
export type RejectRequestMutationHookResult = ReturnType<typeof useRejectRequestMutation>;
export type RejectRequestMutationResult = Apollo.MutationResult<RejectRequestMutation>;
export type RejectRequestMutationOptions = Apollo.BaseMutationOptions<RejectRequestMutation, RejectRequestMutationVariables>;
export const RecoverRequestDocument = gql`
    mutation RecoverRequest($id: String, $message: String) {
  RecoverRequest(id: $id, message: $message)
}
    `;
export type RecoverRequestMutationFn = Apollo.MutationFunction<RecoverRequestMutation, RecoverRequestMutationVariables>;

/**
 * __useRecoverRequestMutation__
 *
 * To run a mutation, you first call `useRecoverRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverRequestMutation, { data, loading, error }] = useRecoverRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRecoverRequestMutation(baseOptions?: Apollo.MutationHookOptions<RecoverRequestMutation, RecoverRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverRequestMutation, RecoverRequestMutationVariables>(RecoverRequestDocument, options);
      }
export type RecoverRequestMutationHookResult = ReturnType<typeof useRecoverRequestMutation>;
export type RecoverRequestMutationResult = Apollo.MutationResult<RecoverRequestMutation>;
export type RecoverRequestMutationOptions = Apollo.BaseMutationOptions<RecoverRequestMutation, RecoverRequestMutationVariables>;
export const CreateTagDocument = gql`
    mutation createTag($tag: TagInput) {
  CreateTag(item: $tag)
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const ArchiveTagListDocument = gql`
    mutation archiveTagList($ids: [String]) {
  ArchiveTagList(ids: $ids)
}
    `;
export type ArchiveTagListMutationFn = Apollo.MutationFunction<ArchiveTagListMutation, ArchiveTagListMutationVariables>;

/**
 * __useArchiveTagListMutation__
 *
 * To run a mutation, you first call `useArchiveTagListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTagListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTagListMutation, { data, loading, error }] = useArchiveTagListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useArchiveTagListMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTagListMutation, ArchiveTagListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTagListMutation, ArchiveTagListMutationVariables>(ArchiveTagListDocument, options);
      }
export type ArchiveTagListMutationHookResult = ReturnType<typeof useArchiveTagListMutation>;
export type ArchiveTagListMutationResult = Apollo.MutationResult<ArchiveTagListMutation>;
export type ArchiveTagListMutationOptions = Apollo.BaseMutationOptions<ArchiveTagListMutation, ArchiveTagListMutationVariables>;
export const RestoreTagListDocument = gql`
    mutation restoreTagList($ids: [String]) {
  RestoreTagList(ids: $ids)
}
    `;
export type RestoreTagListMutationFn = Apollo.MutationFunction<RestoreTagListMutation, RestoreTagListMutationVariables>;

/**
 * __useRestoreTagListMutation__
 *
 * To run a mutation, you first call `useRestoreTagListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTagListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTagListMutation, { data, loading, error }] = useRestoreTagListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreTagListMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTagListMutation, RestoreTagListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTagListMutation, RestoreTagListMutationVariables>(RestoreTagListDocument, options);
      }
export type RestoreTagListMutationHookResult = ReturnType<typeof useRestoreTagListMutation>;
export type RestoreTagListMutationResult = Apollo.MutationResult<RestoreTagListMutation>;
export type RestoreTagListMutationOptions = Apollo.BaseMutationOptions<RestoreTagListMutation, RestoreTagListMutationVariables>;
export const GetTagTypesDocument = gql`
    query getTagTypes {
  TagTypes
}
    `;

/**
 * __useGetTagTypesQuery__
 *
 * To run a query within a React component, call `useGetTagTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTagTypesQuery, GetTagTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagTypesQuery, GetTagTypesQueryVariables>(GetTagTypesDocument, options);
      }
export function useGetTagTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagTypesQuery, GetTagTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagTypesQuery, GetTagTypesQueryVariables>(GetTagTypesDocument, options);
        }
// @ts-ignore
export function useGetTagTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagTypesQuery, GetTagTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagTypesQuery, GetTagTypesQueryVariables>;
export function useGetTagTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagTypesQuery, GetTagTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagTypesQuery | undefined, GetTagTypesQueryVariables>;
export function useGetTagTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagTypesQuery, GetTagTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagTypesQuery, GetTagTypesQueryVariables>(GetTagTypesDocument, options);
        }
export type GetTagTypesQueryHookResult = ReturnType<typeof useGetTagTypesQuery>;
export type GetTagTypesLazyQueryHookResult = ReturnType<typeof useGetTagTypesLazyQuery>;
export type GetTagTypesSuspenseQueryHookResult = ReturnType<typeof useGetTagTypesSuspenseQuery>;
export type GetTagTypesQueryResult = Apollo.QueryResult<GetTagTypesQuery, GetTagTypesQueryVariables>;
export const GetTagListWithTypeDocument = gql`
    query getTagListWithType($contains: String, $type: String, $after: String) {
  TagList(
    after: $after
    where: {and: [{name: {contains: $contains}}, {type: {contains: $type}}]}
  ) {
    nodes {
      ...tagProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${TagPropsFragmentDoc}`;

/**
 * __useGetTagListWithTypeQuery__
 *
 * To run a query within a React component, call `useGetTagListWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagListWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagListWithTypeQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      type: // value for 'type'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTagListWithTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>(GetTagListWithTypeDocument, options);
      }
export function useGetTagListWithTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>(GetTagListWithTypeDocument, options);
        }
// @ts-ignore
export function useGetTagListWithTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>;
export function useGetTagListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagListWithTypeQuery | undefined, GetTagListWithTypeQueryVariables>;
export function useGetTagListWithTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>(GetTagListWithTypeDocument, options);
        }
export type GetTagListWithTypeQueryHookResult = ReturnType<typeof useGetTagListWithTypeQuery>;
export type GetTagListWithTypeLazyQueryHookResult = ReturnType<typeof useGetTagListWithTypeLazyQuery>;
export type GetTagListWithTypeSuspenseQueryHookResult = ReturnType<typeof useGetTagListWithTypeSuspenseQuery>;
export type GetTagListWithTypeQueryResult = Apollo.QueryResult<GetTagListWithTypeQuery, GetTagListWithTypeQueryVariables>;
export const GetTagListDocument = gql`
    query getTagList($contains: String, $after: String) {
  TagList(
    after: $after
    where: {or: [{name: {contains: $contains}}, {type: {contains: $contains}}]}
  ) {
    nodes {
      ...tagProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${TagPropsFragmentDoc}`;

/**
 * __useGetTagListQuery__
 *
 * To run a query within a React component, call `useGetTagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTagListQuery(baseOptions?: Apollo.QueryHookOptions<GetTagListQuery, GetTagListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagListQuery, GetTagListQueryVariables>(GetTagListDocument, options);
      }
export function useGetTagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagListQuery, GetTagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagListQuery, GetTagListQueryVariables>(GetTagListDocument, options);
        }
// @ts-ignore
export function useGetTagListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagListQuery, GetTagListQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagListQuery, GetTagListQueryVariables>;
export function useGetTagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagListQuery, GetTagListQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagListQuery | undefined, GetTagListQueryVariables>;
export function useGetTagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagListQuery, GetTagListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagListQuery, GetTagListQueryVariables>(GetTagListDocument, options);
        }
export type GetTagListQueryHookResult = ReturnType<typeof useGetTagListQuery>;
export type GetTagListLazyQueryHookResult = ReturnType<typeof useGetTagListLazyQuery>;
export type GetTagListSuspenseQueryHookResult = ReturnType<typeof useGetTagListSuspenseQuery>;
export type GetTagListQueryResult = Apollo.QueryResult<GetTagListQuery, GetTagListQueryVariables>;
export const GetArchivedTagListDocument = gql`
    query getArchivedTagList($contains: String, $after: String) {
  ArchivedTagList(
    after: $after
    where: {or: [{name: {contains: $contains}}, {type: {contains: $contains}}]}
  ) {
    nodes {
      ...tagProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${TagPropsFragmentDoc}`;

/**
 * __useGetArchivedTagListQuery__
 *
 * To run a query within a React component, call `useGetArchivedTagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedTagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedTagListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetArchivedTagListQuery(baseOptions?: Apollo.QueryHookOptions<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>(GetArchivedTagListDocument, options);
      }
export function useGetArchivedTagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>(GetArchivedTagListDocument, options);
        }
// @ts-ignore
export function useGetArchivedTagListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>): Apollo.UseSuspenseQueryResult<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>;
export function useGetArchivedTagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>): Apollo.UseSuspenseQueryResult<GetArchivedTagListQuery | undefined, GetArchivedTagListQueryVariables>;
export function useGetArchivedTagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>(GetArchivedTagListDocument, options);
        }
export type GetArchivedTagListQueryHookResult = ReturnType<typeof useGetArchivedTagListQuery>;
export type GetArchivedTagListLazyQueryHookResult = ReturnType<typeof useGetArchivedTagListLazyQuery>;
export type GetArchivedTagListSuspenseQueryHookResult = ReturnType<typeof useGetArchivedTagListSuspenseQuery>;
export type GetArchivedTagListQueryResult = Apollo.QueryResult<GetArchivedTagListQuery, GetArchivedTagListQueryVariables>;
export const GetTagDocument = gql`
    query getTag($id: String) {
  Tag(id: $id) {
    ...tagProps
  }
}
    ${TagPropsFragmentDoc}`;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTagQuery(baseOptions?: Apollo.QueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
      }
export function useGetTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
// @ts-ignore
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagQuery, GetTagQueryVariables>;
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>): Apollo.UseSuspenseQueryResult<GetTagQuery | undefined, GetTagQueryVariables>;
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagSuspenseQueryHookResult = ReturnType<typeof useGetTagSuspenseQuery>;
export type GetTagQueryResult = Apollo.QueryResult<GetTagQuery, GetTagQueryVariables>;
export const CreateUniclassDocument = gql`
    mutation createUniclass($uniclass: UniclassInput) {
  CreateUniclass(item: $uniclass)
}
    `;
export type CreateUniclassMutationFn = Apollo.MutationFunction<CreateUniclassMutation, CreateUniclassMutationVariables>;

/**
 * __useCreateUniclassMutation__
 *
 * To run a mutation, you first call `useCreateUniclassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUniclassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUniclassMutation, { data, loading, error }] = useCreateUniclassMutation({
 *   variables: {
 *      uniclass: // value for 'uniclass'
 *   },
 * });
 */
export function useCreateUniclassMutation(baseOptions?: Apollo.MutationHookOptions<CreateUniclassMutation, CreateUniclassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUniclassMutation, CreateUniclassMutationVariables>(CreateUniclassDocument, options);
      }
export type CreateUniclassMutationHookResult = ReturnType<typeof useCreateUniclassMutation>;
export type CreateUniclassMutationResult = Apollo.MutationResult<CreateUniclassMutation>;
export type CreateUniclassMutationOptions = Apollo.BaseMutationOptions<CreateUniclassMutation, CreateUniclassMutationVariables>;
export const DeleteUniclassesDocument = gql`
    mutation deleteUniclasses($ids: [String]) {
  DeleteUniclassList(ids: $ids)
}
    `;
export type DeleteUniclassesMutationFn = Apollo.MutationFunction<DeleteUniclassesMutation, DeleteUniclassesMutationVariables>;

/**
 * __useDeleteUniclassesMutation__
 *
 * To run a mutation, you first call `useDeleteUniclassesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUniclassesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUniclassesMutation, { data, loading, error }] = useDeleteUniclassesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteUniclassesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUniclassesMutation, DeleteUniclassesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUniclassesMutation, DeleteUniclassesMutationVariables>(DeleteUniclassesDocument, options);
      }
export type DeleteUniclassesMutationHookResult = ReturnType<typeof useDeleteUniclassesMutation>;
export type DeleteUniclassesMutationResult = Apollo.MutationResult<DeleteUniclassesMutation>;
export type DeleteUniclassesMutationOptions = Apollo.BaseMutationOptions<DeleteUniclassesMutation, DeleteUniclassesMutationVariables>;
export const GetUniclassesDocument = gql`
    query getUniclasses($contains: String, $after: String) {
  UniclassList(after: $after, where: {name: {contains: $contains}}) {
    nodes {
      ...uniclassProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${UniclassPropsFragmentDoc}`;

/**
 * __useGetUniclassesQuery__
 *
 * To run a query within a React component, call `useGetUniclassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniclassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniclassesQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUniclassesQuery(baseOptions?: Apollo.QueryHookOptions<GetUniclassesQuery, GetUniclassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniclassesQuery, GetUniclassesQueryVariables>(GetUniclassesDocument, options);
      }
export function useGetUniclassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniclassesQuery, GetUniclassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniclassesQuery, GetUniclassesQueryVariables>(GetUniclassesDocument, options);
        }
// @ts-ignore
export function useGetUniclassesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUniclassesQuery, GetUniclassesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUniclassesQuery, GetUniclassesQueryVariables>;
export function useGetUniclassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniclassesQuery, GetUniclassesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUniclassesQuery | undefined, GetUniclassesQueryVariables>;
export function useGetUniclassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniclassesQuery, GetUniclassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniclassesQuery, GetUniclassesQueryVariables>(GetUniclassesDocument, options);
        }
export type GetUniclassesQueryHookResult = ReturnType<typeof useGetUniclassesQuery>;
export type GetUniclassesLazyQueryHookResult = ReturnType<typeof useGetUniclassesLazyQuery>;
export type GetUniclassesSuspenseQueryHookResult = ReturnType<typeof useGetUniclassesSuspenseQuery>;
export type GetUniclassesQueryResult = Apollo.QueryResult<GetUniclassesQuery, GetUniclassesQueryVariables>;
export const GetUniclassDocument = gql`
    query getUniclass($id: String) {
  Uniclass(id: $id) {
    ...uniclassProps
  }
}
    ${UniclassPropsFragmentDoc}`;

/**
 * __useGetUniclassQuery__
 *
 * To run a query within a React component, call `useGetUniclassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniclassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniclassQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUniclassQuery(baseOptions?: Apollo.QueryHookOptions<GetUniclassQuery, GetUniclassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniclassQuery, GetUniclassQueryVariables>(GetUniclassDocument, options);
      }
export function useGetUniclassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniclassQuery, GetUniclassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniclassQuery, GetUniclassQueryVariables>(GetUniclassDocument, options);
        }
// @ts-ignore
export function useGetUniclassSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUniclassQuery, GetUniclassQueryVariables>): Apollo.UseSuspenseQueryResult<GetUniclassQuery, GetUniclassQueryVariables>;
export function useGetUniclassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniclassQuery, GetUniclassQueryVariables>): Apollo.UseSuspenseQueryResult<GetUniclassQuery | undefined, GetUniclassQueryVariables>;
export function useGetUniclassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniclassQuery, GetUniclassQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniclassQuery, GetUniclassQueryVariables>(GetUniclassDocument, options);
        }
export type GetUniclassQueryHookResult = ReturnType<typeof useGetUniclassQuery>;
export type GetUniclassLazyQueryHookResult = ReturnType<typeof useGetUniclassLazyQuery>;
export type GetUniclassSuspenseQueryHookResult = ReturnType<typeof useGetUniclassSuspenseQuery>;
export type GetUniclassQueryResult = Apollo.QueryResult<GetUniclassQuery, GetUniclassQueryVariables>;
export const UploadContentDocument = gql`
    mutation uploadContent($libraryId: String, $version: ContentVersionInput, $fileName: String, $thumbnailName: String, $tagIds: [String], $overwrite: Boolean!) {
  Library(id: $libraryId) {
    uploadContent(version: $version, tagIds: $tagIds, overwrite: $overwrite) {
      id
      setFile(name: $fileName)
      setThumbnail(name: $thumbnailName)
    }
  }
}
    `;
export type UploadContentMutationFn = Apollo.MutationFunction<UploadContentMutation, UploadContentMutationVariables>;

/**
 * __useUploadContentMutation__
 *
 * To run a mutation, you first call `useUploadContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadContentMutation, { data, loading, error }] = useUploadContentMutation({
 *   variables: {
 *      libraryId: // value for 'libraryId'
 *      version: // value for 'version'
 *      fileName: // value for 'fileName'
 *      thumbnailName: // value for 'thumbnailName'
 *      tagIds: // value for 'tagIds'
 *      overwrite: // value for 'overwrite'
 *   },
 * });
 */
export function useUploadContentMutation(baseOptions?: Apollo.MutationHookOptions<UploadContentMutation, UploadContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadContentMutation, UploadContentMutationVariables>(UploadContentDocument, options);
      }
export type UploadContentMutationHookResult = ReturnType<typeof useUploadContentMutation>;
export type UploadContentMutationResult = Apollo.MutationResult<UploadContentMutation>;
export type UploadContentMutationOptions = Apollo.BaseMutationOptions<UploadContentMutation, UploadContentMutationVariables>;
export const SetContentTypeThumbnailDocument = gql`
    mutation setContentTypeThumbnail($contentId: String, $typeId: String, $name: String) {
  Content(id: $contentId) {
    setTypeThumbnail(typeId: $typeId, name: $name)
  }
}
    `;
export type SetContentTypeThumbnailMutationFn = Apollo.MutationFunction<SetContentTypeThumbnailMutation, SetContentTypeThumbnailMutationVariables>;

/**
 * __useSetContentTypeThumbnailMutation__
 *
 * To run a mutation, you first call `useSetContentTypeThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContentTypeThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContentTypeThumbnailMutation, { data, loading, error }] = useSetContentTypeThumbnailMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      typeId: // value for 'typeId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetContentTypeThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<SetContentTypeThumbnailMutation, SetContentTypeThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContentTypeThumbnailMutation, SetContentTypeThumbnailMutationVariables>(SetContentTypeThumbnailDocument, options);
      }
export type SetContentTypeThumbnailMutationHookResult = ReturnType<typeof useSetContentTypeThumbnailMutation>;
export type SetContentTypeThumbnailMutationResult = Apollo.MutationResult<SetContentTypeThumbnailMutation>;
export type SetContentTypeThumbnailMutationOptions = Apollo.BaseMutationOptions<SetContentTypeThumbnailMutation, SetContentTypeThumbnailMutationVariables>;
export const SetContentThumbnailDocument = gql`
    mutation setContentThumbnail($contentId: String, $name: String) {
  Content(id: $contentId) {
    setThumbnail(name: $name)
  }
}
    `;
export type SetContentThumbnailMutationFn = Apollo.MutationFunction<SetContentThumbnailMutation, SetContentThumbnailMutationVariables>;

/**
 * __useSetContentThumbnailMutation__
 *
 * To run a mutation, you first call `useSetContentThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContentThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContentThumbnailMutation, { data, loading, error }] = useSetContentThumbnailMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetContentThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<SetContentThumbnailMutation, SetContentThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContentThumbnailMutation, SetContentThumbnailMutationVariables>(SetContentThumbnailDocument, options);
      }
export type SetContentThumbnailMutationHookResult = ReturnType<typeof useSetContentThumbnailMutation>;
export type SetContentThumbnailMutationResult = Apollo.MutationResult<SetContentThumbnailMutation>;
export type SetContentThumbnailMutationOptions = Apollo.BaseMutationOptions<SetContentThumbnailMutation, SetContentThumbnailMutationVariables>;
export const GetApplicationNameListDocument = gql`
    query getApplicationNameList {
  ApplicationNameList
}
    `;

/**
 * __useGetApplicationNameListQuery__
 *
 * To run a query within a React component, call `useGetApplicationNameListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationNameListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationNameListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplicationNameListQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>(GetApplicationNameListDocument, options);
      }
export function useGetApplicationNameListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>(GetApplicationNameListDocument, options);
        }
// @ts-ignore
export function useGetApplicationNameListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>;
export function useGetApplicationNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationNameListQuery | undefined, GetApplicationNameListQueryVariables>;
export function useGetApplicationNameListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>(GetApplicationNameListDocument, options);
        }
export type GetApplicationNameListQueryHookResult = ReturnType<typeof useGetApplicationNameListQuery>;
export type GetApplicationNameListLazyQueryHookResult = ReturnType<typeof useGetApplicationNameListLazyQuery>;
export type GetApplicationNameListSuspenseQueryHookResult = ReturnType<typeof useGetApplicationNameListSuspenseQuery>;
export type GetApplicationNameListQueryResult = Apollo.QueryResult<GetApplicationNameListQuery, GetApplicationNameListQueryVariables>;
export const GetCategoryListDocument = gql`
    query getCategoryList {
  CategoryList
}
    `;

/**
 * __useGetCategoryListQuery__
 *
 * To run a query within a React component, call `useGetCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoryListQuery, GetCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryListQuery, GetCategoryListQueryVariables>(GetCategoryListDocument, options);
      }
export function useGetCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryListQuery, GetCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryListQuery, GetCategoryListQueryVariables>(GetCategoryListDocument, options);
        }
// @ts-ignore
export function useGetCategoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoryListQuery, GetCategoryListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryListQuery, GetCategoryListQueryVariables>;
export function useGetCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryListQuery, GetCategoryListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryListQuery | undefined, GetCategoryListQueryVariables>;
export function useGetCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryListQuery, GetCategoryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryListQuery, GetCategoryListQueryVariables>(GetCategoryListDocument, options);
        }
export type GetCategoryListQueryHookResult = ReturnType<typeof useGetCategoryListQuery>;
export type GetCategoryListLazyQueryHookResult = ReturnType<typeof useGetCategoryListLazyQuery>;
export type GetCategoryListSuspenseQueryHookResult = ReturnType<typeof useGetCategoryListSuspenseQuery>;
export type GetCategoryListQueryResult = Apollo.QueryResult<GetCategoryListQuery, GetCategoryListQueryVariables>;
export const GetSubCategoryListDocument = gql`
    query getSubCategoryList {
  SubCategoryList
}
    `;

/**
 * __useGetSubCategoryListQuery__
 *
 * To run a query within a React component, call `useGetSubCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>(GetSubCategoryListDocument, options);
      }
export function useGetSubCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>(GetSubCategoryListDocument, options);
        }
// @ts-ignore
export function useGetSubCategoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>;
export function useGetSubCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubCategoryListQuery | undefined, GetSubCategoryListQueryVariables>;
export function useGetSubCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>(GetSubCategoryListDocument, options);
        }
export type GetSubCategoryListQueryHookResult = ReturnType<typeof useGetSubCategoryListQuery>;
export type GetSubCategoryListLazyQueryHookResult = ReturnType<typeof useGetSubCategoryListLazyQuery>;
export type GetSubCategoryListSuspenseQueryHookResult = ReturnType<typeof useGetSubCategoryListSuspenseQuery>;
export type GetSubCategoryListQueryResult = Apollo.QueryResult<GetSubCategoryListQuery, GetSubCategoryListQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  Me {
    id
    name
    email
    role
    discipline
    createdTime
    updatedTime
    createdById
    createdBy {
      id
      name
    }
    dynamicData {
      id
      name
      type
      ownerId
      sharedById
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
// @ts-ignore
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($role: UserRoleEnum, $after: String, $order: [UserSortInput!]) {
  UserList(after: $after, where: {role: {eq: $role}}, order: $order) {
    nodes {
      id
      name
      email
      role
      discipline
      updatedTime
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      role: // value for 'role'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUsersWithoutRoleDocument = gql`
    query GetUsersWithoutRole($contains: String, $after: String, $order: [UserSortInput!]) {
  UserList(after: $after, where: {email: {contains: $contains}}, order: $order) {
    nodes {
      id
      name
      email
      role
      discipline
      updatedTime
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetUsersWithoutRoleQuery__
 *
 * To run a query within a React component, call `useGetUsersWithoutRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWithoutRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWithoutRoleQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetUsersWithoutRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>(GetUsersWithoutRoleDocument, options);
      }
export function useGetUsersWithoutRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>(GetUsersWithoutRoleDocument, options);
        }
// @ts-ignore
export function useGetUsersWithoutRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>;
export function useGetUsersWithoutRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersWithoutRoleQuery | undefined, GetUsersWithoutRoleQueryVariables>;
export function useGetUsersWithoutRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>(GetUsersWithoutRoleDocument, options);
        }
export type GetUsersWithoutRoleQueryHookResult = ReturnType<typeof useGetUsersWithoutRoleQuery>;
export type GetUsersWithoutRoleLazyQueryHookResult = ReturnType<typeof useGetUsersWithoutRoleLazyQuery>;
export type GetUsersWithoutRoleSuspenseQueryHookResult = ReturnType<typeof useGetUsersWithoutRoleSuspenseQuery>;
export type GetUsersWithoutRoleQueryResult = Apollo.QueryResult<GetUsersWithoutRoleQuery, GetUsersWithoutRoleQueryVariables>;
export const GetMembersDocument = gql`
    query GetMembers($role: UserRoleEnum, $after: String, $contains: String, $order: [UserSortInput!]) {
  UserList(
    after: $after
    where: {and: [{role: {neq: $role}}, {name: {contains: $contains}}]}
    order: $order
  ) {
    nodes {
      id
      name
      email
      role
      discipline
      updatedTime
      createdTime
      createdById
      createdBy {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      role: // value for 'role'
 *      after: // value for 'after'
 *      contains: // value for 'contains'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
// @ts-ignore
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMembersQuery, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMembersQuery | undefined, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersSuspenseQueryHookResult = ReturnType<typeof useGetMembersSuspenseQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const CountUsersDocument = gql`
    query countUsers {
  UserCount
}
    `;

/**
 * __useCountUsersQuery__
 *
 * To run a query within a React component, call `useCountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountUsersQuery(baseOptions?: Apollo.QueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
      }
export function useCountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
// @ts-ignore
export function useCountUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>): Apollo.UseSuspenseQueryResult<CountUsersQuery, CountUsersQueryVariables>;
export function useCountUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>): Apollo.UseSuspenseQueryResult<CountUsersQuery | undefined, CountUsersQueryVariables>;
export function useCountUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
export type CountUsersQueryHookResult = ReturnType<typeof useCountUsersQuery>;
export type CountUsersLazyQueryHookResult = ReturnType<typeof useCountUsersLazyQuery>;
export type CountUsersSuspenseQueryHookResult = ReturnType<typeof useCountUsersSuspenseQuery>;
export type CountUsersQueryResult = Apollo.QueryResult<CountUsersQuery, CountUsersQueryVariables>;
export const GetUsersShortDocument = gql`
    query getUsersShort {
  UserList(first: 10000) {
    nodes {
      id
      name
      createdTime
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetUsersShortQuery__
 *
 * To run a query within a React component, call `useGetUsersShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersShortQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersShortQuery, GetUsersShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersShortQuery, GetUsersShortQueryVariables>(GetUsersShortDocument, options);
      }
export function useGetUsersShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersShortQuery, GetUsersShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersShortQuery, GetUsersShortQueryVariables>(GetUsersShortDocument, options);
        }
// @ts-ignore
export function useGetUsersShortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersShortQuery, GetUsersShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersShortQuery, GetUsersShortQueryVariables>;
export function useGetUsersShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersShortQuery, GetUsersShortQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersShortQuery | undefined, GetUsersShortQueryVariables>;
export function useGetUsersShortSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersShortQuery, GetUsersShortQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersShortQuery, GetUsersShortQueryVariables>(GetUsersShortDocument, options);
        }
export type GetUsersShortQueryHookResult = ReturnType<typeof useGetUsersShortQuery>;
export type GetUsersShortLazyQueryHookResult = ReturnType<typeof useGetUsersShortLazyQuery>;
export type GetUsersShortSuspenseQueryHookResult = ReturnType<typeof useGetUsersShortSuspenseQuery>;
export type GetUsersShortQueryResult = Apollo.QueryResult<GetUsersShortQuery, GetUsersShortQueryVariables>;
export const AdminOfLibrariesDocument = gql`
    query AdminOfLibraries($clientId: String) {
  Me {
    adminOfLibraries(clientId: $clientId) {
      ...libraryProps
    }
  }
}
    ${LibraryPropsFragmentDoc}`;

/**
 * __useAdminOfLibrariesQuery__
 *
 * To run a query within a React component, call `useAdminOfLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOfLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOfLibrariesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAdminOfLibrariesQuery(baseOptions?: Apollo.QueryHookOptions<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>(AdminOfLibrariesDocument, options);
      }
export function useAdminOfLibrariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>(AdminOfLibrariesDocument, options);
        }
// @ts-ignore
export function useAdminOfLibrariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>;
export function useAdminOfLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminOfLibrariesQuery | undefined, AdminOfLibrariesQueryVariables>;
export function useAdminOfLibrariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>(AdminOfLibrariesDocument, options);
        }
export type AdminOfLibrariesQueryHookResult = ReturnType<typeof useAdminOfLibrariesQuery>;
export type AdminOfLibrariesLazyQueryHookResult = ReturnType<typeof useAdminOfLibrariesLazyQuery>;
export type AdminOfLibrariesSuspenseQueryHookResult = ReturnType<typeof useAdminOfLibrariesSuspenseQuery>;
export type AdminOfLibrariesQueryResult = Apollo.QueryResult<AdminOfLibrariesQuery, AdminOfLibrariesQueryVariables>;
export const SetGlobalAdminDocument = gql`
    mutation setGlobalAdmin($id: String, $discipline: DisciplineEnum!) {
  SetAdmin(id: $id, discipline: $discipline)
}
    `;
export type SetGlobalAdminMutationFn = Apollo.MutationFunction<SetGlobalAdminMutation, SetGlobalAdminMutationVariables>;

/**
 * __useSetGlobalAdminMutation__
 *
 * To run a mutation, you first call `useSetGlobalAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalAdminMutation, { data, loading, error }] = useSetGlobalAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useSetGlobalAdminMutation(baseOptions?: Apollo.MutationHookOptions<SetGlobalAdminMutation, SetGlobalAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGlobalAdminMutation, SetGlobalAdminMutationVariables>(SetGlobalAdminDocument, options);
      }
export type SetGlobalAdminMutationHookResult = ReturnType<typeof useSetGlobalAdminMutation>;
export type SetGlobalAdminMutationResult = Apollo.MutationResult<SetGlobalAdminMutation>;
export type SetGlobalAdminMutationOptions = Apollo.BaseMutationOptions<SetGlobalAdminMutation, SetGlobalAdminMutationVariables>;
export const SetUserRoleDocument = gql`
    mutation setUserRole($id: String, $role: UserRoleEnum, $discipline: DisciplineEnum) {
  SetUserRole(id: $id, role: $role, discipline: $discipline)
}
    `;
export type SetUserRoleMutationFn = Apollo.MutationFunction<SetUserRoleMutation, SetUserRoleMutationVariables>;

/**
 * __useSetUserRoleMutation__
 *
 * To run a mutation, you first call `useSetUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRoleMutation, { data, loading, error }] = useSetUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useSetUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetUserRoleMutation, SetUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRoleDocument, options);
      }
export type SetUserRoleMutationHookResult = ReturnType<typeof useSetUserRoleMutation>;
export type SetUserRoleMutationResult = Apollo.MutationResult<SetUserRoleMutation>;
export type SetUserRoleMutationOptions = Apollo.BaseMutationOptions<SetUserRoleMutation, SetUserRoleMutationVariables>;
export const DeleteGlobalUserRoleDocument = gql`
    mutation deleteGlobalUserRole($id: String) {
  DeleteUserRole(id: $id)
}
    `;
export type DeleteGlobalUserRoleMutationFn = Apollo.MutationFunction<DeleteGlobalUserRoleMutation, DeleteGlobalUserRoleMutationVariables>;

/**
 * __useDeleteGlobalUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalUserRoleMutation, { data, loading, error }] = useDeleteGlobalUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGlobalUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGlobalUserRoleMutation, DeleteGlobalUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGlobalUserRoleMutation, DeleteGlobalUserRoleMutationVariables>(DeleteGlobalUserRoleDocument, options);
      }
export type DeleteGlobalUserRoleMutationHookResult = ReturnType<typeof useDeleteGlobalUserRoleMutation>;
export type DeleteGlobalUserRoleMutationResult = Apollo.MutationResult<DeleteGlobalUserRoleMutation>;
export type DeleteGlobalUserRoleMutationOptions = Apollo.BaseMutationOptions<DeleteGlobalUserRoleMutation, DeleteGlobalUserRoleMutationVariables>;
export const GetMyDynamicDataDocument = gql`
    query getMyDynamicData {
  Me {
    dynamicData {
      id
      name
      description
      type
      ownerId
      sharedById
      data
      setData
      createdTime
      updatedTime
    }
  }
}
    `;

/**
 * __useGetMyDynamicDataQuery__
 *
 * To run a query within a React component, call `useGetMyDynamicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDynamicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDynamicDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDynamicDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>(GetMyDynamicDataDocument, options);
      }
export function useGetMyDynamicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>(GetMyDynamicDataDocument, options);
        }
// @ts-ignore
export function useGetMyDynamicDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>;
export function useGetMyDynamicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyDynamicDataQuery | undefined, GetMyDynamicDataQueryVariables>;
export function useGetMyDynamicDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>(GetMyDynamicDataDocument, options);
        }
export type GetMyDynamicDataQueryHookResult = ReturnType<typeof useGetMyDynamicDataQuery>;
export type GetMyDynamicDataLazyQueryHookResult = ReturnType<typeof useGetMyDynamicDataLazyQuery>;
export type GetMyDynamicDataSuspenseQueryHookResult = ReturnType<typeof useGetMyDynamicDataSuspenseQuery>;
export type GetMyDynamicDataQueryResult = Apollo.QueryResult<GetMyDynamicDataQuery, GetMyDynamicDataQueryVariables>;
export const SetMyDynamicDataDocument = gql`
    mutation setMyDynamicData($userId: String, $data: DynamicDataInput) {
  User(id: $userId) {
    setDynamicData(data: $data)
  }
}
    `;
export type SetMyDynamicDataMutationFn = Apollo.MutationFunction<SetMyDynamicDataMutation, SetMyDynamicDataMutationVariables>;

/**
 * __useSetMyDynamicDataMutation__
 *
 * To run a mutation, you first call `useSetMyDynamicDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyDynamicDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyDynamicDataMutation, { data, loading, error }] = useSetMyDynamicDataMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetMyDynamicDataMutation(baseOptions?: Apollo.MutationHookOptions<SetMyDynamicDataMutation, SetMyDynamicDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyDynamicDataMutation, SetMyDynamicDataMutationVariables>(SetMyDynamicDataDocument, options);
      }
export type SetMyDynamicDataMutationHookResult = ReturnType<typeof useSetMyDynamicDataMutation>;
export type SetMyDynamicDataMutationResult = Apollo.MutationResult<SetMyDynamicDataMutation>;
export type SetMyDynamicDataMutationOptions = Apollo.BaseMutationOptions<SetMyDynamicDataMutation, SetMyDynamicDataMutationVariables>;
export const DeleteMyDynamicDataDocument = gql`
    mutation deleteMyDynamicData($userId: String, $ids: [String]) {
  User(id: $userId) {
    deleteDynamicData(ids: $ids)
  }
}
    `;
export type DeleteMyDynamicDataMutationFn = Apollo.MutationFunction<DeleteMyDynamicDataMutation, DeleteMyDynamicDataMutationVariables>;

/**
 * __useDeleteMyDynamicDataMutation__
 *
 * To run a mutation, you first call `useDeleteMyDynamicDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyDynamicDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyDynamicDataMutation, { data, loading, error }] = useDeleteMyDynamicDataMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMyDynamicDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMyDynamicDataMutation, DeleteMyDynamicDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMyDynamicDataMutation, DeleteMyDynamicDataMutationVariables>(DeleteMyDynamicDataDocument, options);
      }
export type DeleteMyDynamicDataMutationHookResult = ReturnType<typeof useDeleteMyDynamicDataMutation>;
export type DeleteMyDynamicDataMutationResult = Apollo.MutationResult<DeleteMyDynamicDataMutation>;
export type DeleteMyDynamicDataMutationOptions = Apollo.BaseMutationOptions<DeleteMyDynamicDataMutation, DeleteMyDynamicDataMutationVariables>;
export const GetPreviewFeatureUsersDocument = gql`
    query getPreviewFeatureUsers {
  UserList(first: 10000) {
    nodes {
      id
      name
      email
      role
      dynamicData {
        id
        type
        ownerId
        sharedById
      }
    }
  }
}
    `;

/**
 * __useGetPreviewFeatureUsersQuery__
 *
 * To run a query within a React component, call `useGetPreviewFeatureUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewFeatureUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewFeatureUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreviewFeatureUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>(GetPreviewFeatureUsersDocument, options);
      }
export function useGetPreviewFeatureUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>(GetPreviewFeatureUsersDocument, options);
        }
// @ts-ignore
export function useGetPreviewFeatureUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>;
export function useGetPreviewFeatureUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewFeatureUsersQuery | undefined, GetPreviewFeatureUsersQueryVariables>;
export function useGetPreviewFeatureUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>(GetPreviewFeatureUsersDocument, options);
        }
export type GetPreviewFeatureUsersQueryHookResult = ReturnType<typeof useGetPreviewFeatureUsersQuery>;
export type GetPreviewFeatureUsersLazyQueryHookResult = ReturnType<typeof useGetPreviewFeatureUsersLazyQuery>;
export type GetPreviewFeatureUsersSuspenseQueryHookResult = ReturnType<typeof useGetPreviewFeatureUsersSuspenseQuery>;
export type GetPreviewFeatureUsersQueryResult = Apollo.QueryResult<GetPreviewFeatureUsersQuery, GetPreviewFeatureUsersQueryVariables>;
export const SharePreviewFeatureDocument = gql`
    mutation sharePreviewFeature($ownerId: String, $dynamicDataId: String, $targetUserId: String) {
  User(id: $ownerId) {
    shareDynamicData(dynamicDataId: $dynamicDataId, targetUserId: $targetUserId)
  }
}
    `;
export type SharePreviewFeatureMutationFn = Apollo.MutationFunction<SharePreviewFeatureMutation, SharePreviewFeatureMutationVariables>;

/**
 * __useSharePreviewFeatureMutation__
 *
 * To run a mutation, you first call `useSharePreviewFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePreviewFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePreviewFeatureMutation, { data, loading, error }] = useSharePreviewFeatureMutation({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      dynamicDataId: // value for 'dynamicDataId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useSharePreviewFeatureMutation(baseOptions?: Apollo.MutationHookOptions<SharePreviewFeatureMutation, SharePreviewFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SharePreviewFeatureMutation, SharePreviewFeatureMutationVariables>(SharePreviewFeatureDocument, options);
      }
export type SharePreviewFeatureMutationHookResult = ReturnType<typeof useSharePreviewFeatureMutation>;
export type SharePreviewFeatureMutationResult = Apollo.MutationResult<SharePreviewFeatureMutation>;
export type SharePreviewFeatureMutationOptions = Apollo.BaseMutationOptions<SharePreviewFeatureMutation, SharePreviewFeatureMutationVariables>;
export const RevokePreviewFeatureDocument = gql`
    mutation revokePreviewFeature($ownerId: String, $dynamicDataId: String, $targetUserId: String) {
  User(id: $ownerId) {
    revokeDynamicData(dynamicDataId: $dynamicDataId, targetUserId: $targetUserId)
  }
}
    `;
export type RevokePreviewFeatureMutationFn = Apollo.MutationFunction<RevokePreviewFeatureMutation, RevokePreviewFeatureMutationVariables>;

/**
 * __useRevokePreviewFeatureMutation__
 *
 * To run a mutation, you first call `useRevokePreviewFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokePreviewFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokePreviewFeatureMutation, { data, loading, error }] = useRevokePreviewFeatureMutation({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      dynamicDataId: // value for 'dynamicDataId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useRevokePreviewFeatureMutation(baseOptions?: Apollo.MutationHookOptions<RevokePreviewFeatureMutation, RevokePreviewFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokePreviewFeatureMutation, RevokePreviewFeatureMutationVariables>(RevokePreviewFeatureDocument, options);
      }
export type RevokePreviewFeatureMutationHookResult = ReturnType<typeof useRevokePreviewFeatureMutation>;
export type RevokePreviewFeatureMutationResult = Apollo.MutationResult<RevokePreviewFeatureMutation>;
export type RevokePreviewFeatureMutationOptions = Apollo.BaseMutationOptions<RevokePreviewFeatureMutation, RevokePreviewFeatureMutationVariables>;
export const CreateVbisDocument = gql`
    mutation createVBIS($vbis: VBISInput) {
  CreateVBIS(item: $vbis)
}
    `;
export type CreateVbisMutationFn = Apollo.MutationFunction<CreateVbisMutation, CreateVbisMutationVariables>;

/**
 * __useCreateVbisMutation__
 *
 * To run a mutation, you first call `useCreateVbisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVbisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVbisMutation, { data, loading, error }] = useCreateVbisMutation({
 *   variables: {
 *      vbis: // value for 'vbis'
 *   },
 * });
 */
export function useCreateVbisMutation(baseOptions?: Apollo.MutationHookOptions<CreateVbisMutation, CreateVbisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVbisMutation, CreateVbisMutationVariables>(CreateVbisDocument, options);
      }
export type CreateVbisMutationHookResult = ReturnType<typeof useCreateVbisMutation>;
export type CreateVbisMutationResult = Apollo.MutationResult<CreateVbisMutation>;
export type CreateVbisMutationOptions = Apollo.BaseMutationOptions<CreateVbisMutation, CreateVbisMutationVariables>;
export const DeleteVbisListDocument = gql`
    mutation deleteVBISList($ids: [String]) {
  DeleteVBISList(ids: $ids)
}
    `;
export type DeleteVbisListMutationFn = Apollo.MutationFunction<DeleteVbisListMutation, DeleteVbisListMutationVariables>;

/**
 * __useDeleteVbisListMutation__
 *
 * To run a mutation, you first call `useDeleteVbisListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVbisListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVbisListMutation, { data, loading, error }] = useDeleteVbisListMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteVbisListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVbisListMutation, DeleteVbisListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVbisListMutation, DeleteVbisListMutationVariables>(DeleteVbisListDocument, options);
      }
export type DeleteVbisListMutationHookResult = ReturnType<typeof useDeleteVbisListMutation>;
export type DeleteVbisListMutationResult = Apollo.MutationResult<DeleteVbisListMutation>;
export type DeleteVbisListMutationOptions = Apollo.BaseMutationOptions<DeleteVbisListMutation, DeleteVbisListMutationVariables>;
export const GetVbisListDocument = gql`
    query getVBISList($contains: String, $after: String) {
  VBISList(after: $after, where: {name: {contains: $contains}}) {
    nodes {
      ...vbisProps
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${VbisPropsFragmentDoc}`;

/**
 * __useGetVbisListQuery__
 *
 * To run a query within a React component, call `useGetVbisListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVbisListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVbisListQuery({
 *   variables: {
 *      contains: // value for 'contains'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetVbisListQuery(baseOptions?: Apollo.QueryHookOptions<GetVbisListQuery, GetVbisListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVbisListQuery, GetVbisListQueryVariables>(GetVbisListDocument, options);
      }
export function useGetVbisListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVbisListQuery, GetVbisListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVbisListQuery, GetVbisListQueryVariables>(GetVbisListDocument, options);
        }
// @ts-ignore
export function useGetVbisListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVbisListQuery, GetVbisListQueryVariables>): Apollo.UseSuspenseQueryResult<GetVbisListQuery, GetVbisListQueryVariables>;
export function useGetVbisListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVbisListQuery, GetVbisListQueryVariables>): Apollo.UseSuspenseQueryResult<GetVbisListQuery | undefined, GetVbisListQueryVariables>;
export function useGetVbisListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVbisListQuery, GetVbisListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVbisListQuery, GetVbisListQueryVariables>(GetVbisListDocument, options);
        }
export type GetVbisListQueryHookResult = ReturnType<typeof useGetVbisListQuery>;
export type GetVbisListLazyQueryHookResult = ReturnType<typeof useGetVbisListLazyQuery>;
export type GetVbisListSuspenseQueryHookResult = ReturnType<typeof useGetVbisListSuspenseQuery>;
export type GetVbisListQueryResult = Apollo.QueryResult<GetVbisListQuery, GetVbisListQueryVariables>;
export const GetVbisDocument = gql`
    query getVBIS($id: String) {
  VBIS(id: $id) {
    ...vbisProps
  }
}
    ${VbisPropsFragmentDoc}`;

/**
 * __useGetVbisQuery__
 *
 * To run a query within a React component, call `useGetVbisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVbisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVbisQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVbisQuery(baseOptions?: Apollo.QueryHookOptions<GetVbisQuery, GetVbisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVbisQuery, GetVbisQueryVariables>(GetVbisDocument, options);
      }
export function useGetVbisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVbisQuery, GetVbisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVbisQuery, GetVbisQueryVariables>(GetVbisDocument, options);
        }
// @ts-ignore
export function useGetVbisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVbisQuery, GetVbisQueryVariables>): Apollo.UseSuspenseQueryResult<GetVbisQuery, GetVbisQueryVariables>;
export function useGetVbisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVbisQuery, GetVbisQueryVariables>): Apollo.UseSuspenseQueryResult<GetVbisQuery | undefined, GetVbisQueryVariables>;
export function useGetVbisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVbisQuery, GetVbisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVbisQuery, GetVbisQueryVariables>(GetVbisDocument, options);
        }
export type GetVbisQueryHookResult = ReturnType<typeof useGetVbisQuery>;
export type GetVbisLazyQueryHookResult = ReturnType<typeof useGetVbisLazyQuery>;
export type GetVbisSuspenseQueryHookResult = ReturnType<typeof useGetVbisSuspenseQuery>;
export type GetVbisQueryResult = Apollo.QueryResult<GetVbisQuery, GetVbisQueryVariables>;